// Media Gallery export: FAQs

// ✅ ONCE-ONLY LINES (copy once per file/snippet — skip if you already have these):
window.MEDIA_GALLERY_SETS = window.MEDIA_GALLERY_SETS || {};

// ✅ MEDIA SET BLOCK (copy this to add/replace just this set):
window.MEDIA_GALLERY_SETS["BrandHeroVideo"] = [
  {
    "heading": "",
    "subheading": "",
    "heading_justify": "center",
    "custom_template_id": "mg-custom-template--18365026828422__c_media_gallery_H9TbwA-0",
    "custom_html": "<style>\n  /* The Modal_Free2DayShipping (background) */\n  .modal_Free2DayShipping {\n    display: none;\n    /* Hidden by default */\n    position: fixed;\n    /* Stay in place */\n    z-index: 1;\n    /* Sit on top */\n    padding-top: 100px;\n    /* Location of the box */\n    left: 0;\n    top: 0;\n    width: 100%;\n    /* Full width */\n    height: 100%;\n    /* Full height */\n    overflow: auto;\n    /* Enable scroll if needed */\n    background-color: rgb(0, 0, 0);\n    /* Fallback color */\n    background-color: rgba(0, 0, 0, 0.4);\n    /* Black w/ opacity */\n    z-index: 100;\n  }\n\n  /* Modal_Free2DayShipping Content */\n  .modal_Free2DayShipping-content {\n    background-color: #fefefe;\n    margin: auto;\n    padding: 20px;\n    border: 1px solid rgb(0, 0, 0);\n    width: fit-content;\n  }\n\n  /* The Close_Free2DayShipping Button */\n  .close_Free2DayShipping {\n    color: #aaaaaa;\n    float: right;\n    font-size: 28px;\n    font-weight: bold;\n  }\n\n  .close_Free2DayShipping:hover,\n  .close_Free2DayShipping:focus {\n    color: #000;\n    text-decoration: none;\n    cursor: pointer;\n  }\n\n  .centerAll {\n    margin: auto;\n    width: fit-content;\n  }\n\n  .myBtn_Free2DayShipping {\n    height: fit-content;\n    width: auto;\n    max-width: 100%;\n    max-height: auto;\n  }\n\n  .myBtn_Banner {\n    width: 100%;\n    background: rgb(44, 44, 44);\n    height: fit-content;\n  }\n\n  @media (max-width:999px) {\n    .myBtn_Free2DayShipping {\n    height: fit-content;\n    width: auto;\n    max-width: 100%;\n    max-height: auto;\n  }\n</style>\n<div class=\"myBtn_Banner\">\n  <div class=\"centerAll\">\n    <button id=\"myBtn_Free2DayShipping\" class=\"myBtn_Free2DayShipping\">\n      <img src=\"https://cdn.shopify.com/s/files/1/0066/5993/2278/files/2-Day-Shipping-Banner.png?v=1670627137\">\n    </button>\n  </div>\n</div>\n<!-- The Modal_Free2DayShipping -->\n<div id=\"myModal_Free2DayShipping\" class=\"modal_Free2DayShipping\">\n  <!-- Modal_Free2DayShipping content -->\n  <div class=\"modal_Free2DayShipping-content\">\n    <span class=\"close_Free2DayShipping\">&times;</span>\n    <p>\n      <H3>Free 2 Day Shipping applies on the following:</H3>\n      <ul>\n        <li>Applies to shipments within the contiguous United States (lower 48 states) only, excluding Alaska and Hawaii.</li>\n        <li>Available on orders over $50 (before taxes).</li>\n        <li>FedEx 2‑Day shipping is not available for oversized or heavy orders. Larger orders may need to ship by alternate methods such as FedEx Home Delivery, which can take up to 5 business days, depending on your location. You will be notified via email. </li>\n        <li>Please allow one business day for processing.</li>\n        <li>Orders place on the weekend will be processed the next business day</li>\n        <li>Not applicable for wholesale customers</li>\n        <li>Not available for shipments to P.O. Boxes.</li>\n      </ul>\n    </p>\n    <br>\n    <p>\n      <H3>We also ship to the following countries:</H3>\n      <ul>\n        <li>Canada, Mexico, All of Central & South America</li>\n        <li>UK, France, Germany and all of Europe</li>\n        <li>Japan, South Korea, Australia, New Zeland</li>\n        <li>Many countries in Africa</li>\n        <li>and many more...</li>\n      </ul>\n      <i>shipping cost and speed vary</i>\n    </p>\n  </div>\n</div>\n\n<script>\n  // Get the modal_Free2DayShipping\n  var modal_Free2DayShipping = document.getElementById(\"myModal_Free2DayShipping\");\n\n  // Get the button that opens the modal_Free2DayShipping\n  var btn = document.getElementById(\"myBtn_Free2DayShipping\");\n\n  // Get the <span> element that close_Free2DayShippings the modal_Free2DayShipping\n  var span = document.getElementsByClassName(\"close_Free2DayShipping\")[0];\n\n  // When the user clicks the button, open the modal_Free2DayShipping\n  btn.onclick = function () {\n    modal_Free2DayShipping.style.display = \"block\";\n  }\n\n  // When the user clicks on <span> (x), close_Free2DayShipping the modal_Free2DayShipping\n  span.onclick = function () {\n    modal_Free2DayShipping.style.display = \"none\";\n  }\n\n  // When the user clicks anywhere outside of the modal_Free2DayShipping, close_Free2DayShipping it\n  window.onclick = function (event) {\n    if (event.target == modal_Free2DayShipping) {\n      modal_Free2DayShipping.style.display = \"none\";\n    }\n  }\n</script>\n",
    "custom_width_desktop_percent": 100,
    "custom_width_mobile_percent": 100,
    "custom_max_width_px": "0",
    "img_ratio": "1:1",
    "row_height": 0,
    "fit_row": false,
    "margin_top": 0,
    "margin_bottom": 0,
    "collapsed": false,
    "show_more_text": "Show more",
    "show_less_text": "Show less",
    "row_toggle_border_style": "solid",
    "accordion": false,
    "accordion_marker": false,
    "accordion_title": "",
    "accordion_subheading": "",
    "accordion_hide_title_when_open": false,
    "accordion_hide_subheading_when_open": false,
    "accordion_title_center": false,
    "accordion_start_open": false,
    "accordion_allow_multiple": false,
    "accordion_bg_color": "#ffffff",
    "accordion_shadow_pct": 8,
    "accordion_shadow_style": "raised",
    "accordion_width_mobile_percent": 100,
    "accordion_width_desktop_percent": 100,
    "accordion_max_width_px": 0,
    "accordion_group": "",
    "accordion_always_open": false,
    "videos": []
  },
  {
    "heading": "",
    "subheading": "",
    "img_ratio": "1:1",
    "row_height": 0,
    "fit_row": false,
    "margin_top": 0,
    "margin_bottom": 0,
    "collapsed": false,
    "show_more_text": "Show more",
    "show_less_text": "Show less",
    "row_toggle_border_style": "solid",
    "accordion": false,
    "accordion_title": "",
    "accordion_subheading": "",
    "accordion_hide_title_when_open": false,
    "accordion_hide_subheading_when_open": false,
    "accordion_title_center": false,
    "accordion_start_open": false,
    "accordion_allow_multiple": false,
    "accordion_bg_color": "#ffffff",
    "accordion_shadow_pct": 8,
    "accordion_shadow_style": "raised",
    "accordion_width_mobile_percent": 100,
    "accordion_width_desktop_percent": 100,
    "accordion_max_width_px": 0,
    "accordion_group": "",
    "accordion_always_open": false,
    "videos": [
      {
        "type": "video",
        "hero": true,
        "hero_autoplay_preview": true,
        "hero_show_play_badge": true,
        "hero_show_play_button": true,
        "open_full_video_text": "",
        "title": "",
        "heading_html": "",
        "subheading_html": "",
        "alt": "",
        "url": "https://cdn.shopify.com/videos/c/o/v/1e9b95721358467dba9c5bb57141841d.mp4",
        "start_time": "",
        "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/vlcsnap-2025-11-04-19h05m08s419_633d5b2a-55db-4a2c-b13a-6fad474dc3d5.png?v=1774305066",
        "hero_width_desktop_pct": 100,
        "hero_width_mobile_pct": 100,
        "hero_max_width_desktop_px": 0,
        "hero_height_desktop_px": 700,
        "hero_height_mobile_px": 0,
        "margin_top": 0,
        "margin_bottom": 0,
        "ratio_override": "16:9",
        "vjust": "center",
        "html_desc": "",
        "desc_html": null,
        "end_behavior": "loop",
        "cta": {
          "href": null,
          "text": "Shop Now",
          "thumb_text": ""
        }
      }
    ]
  }
];

// ✅ MEDIA SET BLOCK (copy this to add/replace just this set):
window.MEDIA_GALLERY_SETS["FAQs"] = [
  {
    "heading": "<h1>Frequently Asked Questions</h1>",
    "subheading": "",
    "img_ratio": "4:5",
    "row_height": 0,
    "fit_row": false,
    "margin_top": 0,
    "margin_bottom": 60,
    "collapsed": false,
    "show_more_text": "Show more",
    "show_less_text": "Show less",
    "row_toggle_border_style": "solid",
    "accordion": false,
    "accordion_title": "",
    "accordion_subheading": "",
    "accordion_hide_title_when_open": false,
    "accordion_hide_subheading_when_open": false,
    "accordion_title_center": false,
    "accordion_start_open": false,
    "accordion_allow_multiple": false,
    "accordion_bg_color": "#ffffff",
    "accordion_shadow_pct": 8,
    "accordion_shadow_style": "raised",
    "accordion_group": "",
    "accordion_always_open": false,
    "videos": [
      {
        "type": "video",
        "title": "Does It Feel Like Wood?",
        "alt": "Does It Feel Like Wood?",
        "url": "https://vimeo.com/935133272",
        "start_time": "",
        "thumbnail": "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/78d37ca1-1618-4b9f-be97-2702f5a61695.gif?ClientID=sulu&Date=1770885616&Signature=105431823734266a8e52006e61840d0c77c8230b",
        "scale": 100,
        "title_wrap": false,
        "ratio_override": "",
        "vjust": "center",
        "html_desc": "",
        "desc_html": null,
        "end_behavior": "next",
        "cta": {
          "href": null,
          "text": "Shop Now",
          "thumb_text": ""
        }
      },
      {
        "type": "video",
        "title": "Creating Knots?",
        "alt": "Creating Knots?",
        "url": "https://vimeo.com/1055326646",
        "start_time": "",
        "thumbnail": "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/6c1f428c-5de5-48cd-9320-7de1e3ce665d.gif?ClientID=sulu&Date=1770888439&Signature=c970bd25f24e5e0659f1f8f8c74b8bf9ab4c36e5",
        "scale": 100,
        "title_wrap": false,
        "ratio_override": "",
        "vjust": "center",
        "html_desc": "",
        "desc_html": null,
        "end_behavior": "next",
        "cta": {
          "href": null,
          "text": "Shop Now",
          "thumb_text": ""
        }
      },
      {
        "type": "video",
        "title": "Sanding Required?",
        "alt": "Sanding Required?",
        "url": "https://vimeo.com/1010180276",
        "start_time": "",
        "thumbnail": "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/52f7dd61-8554-459e-9040-116f2cadf735.gif?ClientID=sulu&Date=1771084222&Signature=7f1ecf246cbb5e826a192cf8d0a3b738fe150c98",
        "scale": 100,
        "title_wrap": false,
        "ratio_override": "",
        "vjust": "center",
        "html_desc": "",
        "desc_html": null,
        "end_behavior": "next",
        "cta": {
          "href": null,
          "text": "Shop Now",
          "thumb_text": ""
        }
      },
      {
        "type": "video",
        "title": "Rustic or Weathered Technique?",
        "alt": "Rustic or Weathered Technique?",
        "url": "https://vimeo.com/937414554",
        "start_time": "",
        "thumbnail": "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/156ab3aa-b523-4c04-8b0e-c5711663cf3c.gif?ClientID=sulu&Date=1770890550&Signature=89af9173e941d3b581383d06c75ed54b8b539118",
        "scale": 100,
        "title_wrap": false,
        "ratio_override": "",
        "vjust": "center",
        "html_desc": "",
        "desc_html": null,
        "end_behavior": "next",
        "cta": {
          "href": null,
          "text": "Shop Now",
          "thumb_text": ""
        }
      }
    ]
  }
];

// ✅ MEDIA SET BLOCK (copy this to add/replace just this set):
window.MEDIA_GALLERY_SETS["TipsTechniques"] = [
  {
    "heading": "<h1>Tips & Techniques</h1>",
    "subheading": "",
    "img_ratio": "16:9",
    "row_height": 0,
    "fit_row": false,
    "margin_top": 0,
    "margin_bottom": 60,
    "collapsed": false,
    "show_more_text": "Show more",
    "show_less_text": "Show less",
    "row_toggle_border_style": "solid",
    "accordion": false,
    "accordion_title": "",
    "accordion_subheading": "",
    "accordion_hide_title_when_open": false,
    "accordion_hide_subheading_when_open": false,
    "accordion_title_center": false,
    "accordion_start_open": false,
    "accordion_allow_multiple": false,
    "accordion_bg_color": "#ffffff",
    "accordion_shadow_pct": 8,
    "accordion_shadow_style": "raised",
    "accordion_group": "",
    "accordion_always_open": false,
    "videos": [
      {
        "type": "video",
        "title": "Do a Sample Piece",
        "alt": "Do a Sample Piece",
        "url": "https://vimeo.com/1117979068?fl=ls&fe=ec",
        "start_time": "",
        "thumbnail": "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/14bc09b3-385d-4d4d-a866-78d7c3e61ab3.gif?ClientID=sulu&Date=1770887075&Signature=fa7693bfba1d2403e3748f2b273c3216e6d41400",
        "scale": 100,
        "title_wrap": false,
        "ratio_override": "16:9",
        "vjust": "center",
        "html_desc": "",
        "desc_html": null,
        "end_behavior": "next",
        "cta": {
          "href": null,
          "text": "Shop Now",
          "thumb_text": ""
        }
      }
    ]
  },
  {
    "heading": "",
    "subheading": "",
    "img_ratio": "4:5",
    "row_height": 0,
    "fit_row": false,
    "margin_top": 0,
    "margin_bottom": 0,
    "collapsed": false,
    "show_more_text": "Show more",
    "show_less_text": "Show less",
    "row_toggle_border_style": "solid",
    "accordion": false,
    "accordion_title": "",
    "accordion_subheading": "",
    "accordion_hide_title_when_open": false,
    "accordion_hide_subheading_when_open": false,
    "accordion_title_center": false,
    "accordion_start_open": false,
    "accordion_allow_multiple": false,
    "accordion_bg_color": "#ffffff",
    "accordion_shadow_pct": 8,
    "accordion_shadow_style": "raised",
    "accordion_group": "",
    "accordion_always_open": false,
    "videos": [
      {
        "type": "video",
        "title": "Grained or Smooth Finish",
        "alt": "Grained or Smooth Finish",
        "url": "https://vimeo.com/876765262",
        "start_time": "",
        "thumbnail": "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/77c46d3d-8adc-4233-aa92-6a1e9e722949.gif?ClientID=sulu&Date=1770886744&Signature=119d727b590dd5d991b8900f967ec80855377520",
        "scale": 100,
        "title_wrap": false,
        "ratio_override": "",
        "vjust": "center",
        "html_desc": "",
        "desc_html": null,
        "end_behavior": "next",
        "cta": {
          "href": null,
          "text": "Shop Now",
          "thumb_text": ""
        }
      },
      {
        "type": "video",
        "title": "Creating Knots",
        "alt": "Creating Knots",
        "url": "https://vimeo.com/1055326646",
        "start_time": "",
        "thumbnail": "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/6c1f428c-5de5-48cd-9320-7de1e3ce665d.gif?ClientID=sulu&Date=1770888439&Signature=c970bd25f24e5e0659f1f8f8c74b8bf9ab4c36e5",
        "scale": 100,
        "title_wrap": false,
        "ratio_override": "",
        "vjust": "center",
        "html_desc": "",
        "desc_html": null,
        "end_behavior": "next",
        "cta": {
          "href": null,
          "text": "Shop Now",
          "thumb_text": ""
        }
      },
      {
        "type": "video",
        "title": "Rustic or Weathered Technique",
        "alt": "Rustic or Weathered Technique",
        "url": "https://vimeo.com/937414554",
        "start_time": "",
        "thumbnail": "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/156ab3aa-b523-4c04-8b0e-c5711663cf3c.gif?ClientID=sulu&Date=1770890550&Signature=89af9173e941d3b581383d06c75ed54b8b539118",
        "scale": 100,
        "title_wrap": false,
        "ratio_override": "",
        "vjust": "center",
        "html_desc": "",
        "desc_html": null,
        "end_behavior": "next",
        "cta": {
          "href": null,
          "text": "Shop Now",
          "thumb_text": ""
        }
      }
    ]
  },
  {
    "heading": "<h2></h2><h2>How-to Use the Graining Tool</h2>",
    "subheading": "",
    "img_ratio": "16:9",
    "row_height": 0,
    "fit_row": false,
    "margin_top": 0,
    "margin_bottom": 0,
    "collapsed": false,
    "show_more_text": "Graining Instructions",
    "show_less_text": "Hide Graining Instructions",
    "row_toggle_border_style": "solid",
    "accordion": false,
    "accordion_title": "",
    "accordion_subheading": "",
    "accordion_hide_title_when_open": false,
    "accordion_hide_subheading_when_open": false,
    "accordion_title_center": false,
    "accordion_start_open": false,
    "accordion_allow_multiple": false,
    "accordion_bg_color": "#ffffff",
    "accordion_shadow_pct": 8,
    "accordion_shadow_style": "raised",
    "accordion_group": "",
    "accordion_always_open": false,
    "videos": [
      {
        "type": "video",
        "title": "Detailed Graining Instructions",
        "alt": "Detailed Graining Instructions",
        "url": "https://vimeo.com/949990144",
        "start_time": "",
        "thumbnail": "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/a61c09d6-4a4d-4aad-9e5d-f8213957b551.gif?ClientID=sulu&Date=1770889266&Signature=629f3fa1159090dd05edd4e20949b69600b3ae6b",
        "scale": 100,
        "title_wrap": false,
        "ratio_override": "16:9",
        "vjust": "center",
        "html_desc": "",
        "desc_html": null,
        "end_behavior": "next",
        "cta": {
          "href": null,
          "text": "Shop Now",
          "thumb_text": ""
        }
      }
    ]
  },
  {
    "heading": "<h1>Using Wood Filler</h1>",
    "subheading": "",
    "img_ratio": "16:9",
    "row_height": 0,
    "fit_row": false,
    "margin_top": 0,
    "margin_bottom": 0,
    "collapsed": false,
    "show_more_text": "Show more",
    "show_less_text": "Show less",
    "row_toggle_border_style": "solid",
    "accordion": false,
    "accordion_title": "",
    "accordion_subheading": "",
    "accordion_hide_title_when_open": false,
    "accordion_hide_subheading_when_open": false,
    "accordion_title_center": false,
    "accordion_start_open": false,
    "accordion_allow_multiple": false,
    "accordion_bg_color": "#ffffff",
    "accordion_shadow_pct": 8,
    "accordion_shadow_style": "raised",
    "accordion_group": "",
    "accordion_always_open": false,
    "videos": [
      {
        "type": "video",
        "title": "Works over Wood Filler",
        "alt": "Works over Wood Filler",
        "url": "https://vimeo.com/1167692291",
        "start_time": "",
        "thumbnail": "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/e9d14ad3-100b-4df1-9f4f-cef8c87af38f.gif?ClientID=sulu&Date=1771933124&Signature=35c628811fd169188b948e75c0ed365d40e37f17",
        "scale": 100,
        "title_wrap": false,
        "ratio_override": "",
        "vjust": "center",
        "html_desc": "",
        "desc_html": null,
        "end_behavior": "next",
        "cta": {
          "href": null,
          "text": "Shop Now",
          "thumb_text": ""
        }
      }
    ]
  }
];

window.MEDIA_GALLERY_SETS["RealLiquidWood"] = [
  {
    "heading": "<h1>Real Liquid Wood</h1>",
    "subheading": "<p>Go Beyond Faux with a Genuine Wood Finish</p>",
    "img_ratio": "1:1",
    "row_height": 0,
    "fit_row": false,
    "margin_top": 0,
    "margin_bottom": 0,
    "collapsed": false,
    "show_more_text": "Show more",
    "show_less_text": "Show less",
    "row_toggle_border_style": "solid",
    "swatch_row": false,
    "row_justify": "center",
    "heading_justify": "center",
    "accordion": false,
    "accordion_title": "",
    "accordion_subheading": "",
    "accordion_hide_title_when_open": false,
    "accordion_hide_subheading_when_open": false,
    "accordion_title_center": false,
    "accordion_start_open": false,
    "accordion_allow_multiple": false,
    "accordion_bg_color": "#ffffff",
    "accordion_shadow_pct": 8,
    "accordion_shadow_style": "raised",
    "accordion_width_mobile_percent": 100,
    "accordion_width_desktop_percent": 100,
    "accordion_max_width_px": 0,
    "accordion_group": "",
    "accordion_always_open": false,
    "videos": [
      {
        "type": "image",
        "title": "Looks & Feels Like Real Wood",
        "alt": "Looks & Feels Like Real Wood",
        "thumbnail": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/GenuineWood_6ea52a21-da55-4f12-a396-6cccc1adbf1b.png?v=1685138992&width=2000",
        "heading_html": "<p>Authentic Wood Finish</p>",
        "title_html": "<p>Looks & Feels Like Real Wood</p>",
        "image_desc_html": "<p>Go Beyond Faux wood paint with our...</p>",
        "image_desc_justify": "center",
        "image_more_desc_html": "<p>patented liquid wood technology. It looks and feels like wood because it contains over 60% recycled wood fibers. Get the warm, natural look of wood on any hard surface, without the cost and hassle of traditional woodwork, thanks to Retique It®!</p>",
        "learn_more_html": "<p>more</p>",
        "show_learn_more_button": false,
        "show_learn_more_link": true,
        "html_desc": "",
        "desc_html": "<p>patented liquid wood technology. It looks and feels like wood because it contains over 60% recycled wood fibers. Get the warm, natural look of wood on any hard surface, without the cost and hassle of traditional woodwork, thanks to Retique It®!</p>",
        "cta": {
          "href": null,
          "text": "Shop"
        }
      },
      {
        "type": "image",
        "title": "Finish with over 60% Recycled Wood",
        "alt": "Finish with over 60% Recycled Wood",
        "thumbnail": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/EcodFriendly.png?v=1685138405&width=2000",
        "heading_html": "<p><strong>Stainable & Sustainable</strong></p>",
        "title_html": "<p>Finish with over 60% Recycled Wood</p>",
        "image_desc_html": "<p>Retique It® is the hassle-free way to...</p>",
        "image_desc_justify": "center",
        "image_more_desc_html": "<p>get that perfect wood finish without any fuss! with our eco-friendly, water-based formula, there are no offensive odors, making it easy to use even in confined spaces. Because Retique It® contains recycled wood fibers, it can be stained like any wood surface. When you're finished, clean-up is a breeze with just soap and water!</p>",
        "learn_more_html": "<p>more</p>",
        "show_learn_more_button": false,
        "show_learn_more_link": true,
        "html_desc": "",
        "desc_html": "<p>get that perfect wood finish without any fuss! with our eco-friendly, water-based formula, there are no offensive odors, making it easy to use even in confined spaces. Because Retique It® contains recycled wood fibers, it can be stained like any wood surface. When you're finished, clean-up is a breeze with just soap and water!</p>",
        "cta": {
          "href": null,
          "text": "Shop"
        }
      },
      {
        "type": "image",
        "title": "Save Time & Money",
        "alt": "Save Time & Money",
        "thumbnail": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/NoStrippingRequired_435d20e0-84d8-4863-9412-774ce0319429.png?v=1685138406&width=2000",
        "heading_html": "<p><strong>No Stripping Required</strong></p>",
        "title_html": "<p><strong>Save Time & Money</strong></p>",
        "image_desc_html": "<p>No need to sand or strip off...</p>",
        "image_desc_justify": "center",
        "image_more_desc_html": "<p>old finishes or surfaces. Just apply Retique It® right over any painted or finished surface. Our wood-based primers and stains let you add a layer of actual wood to virtually any hard surface.</p>",
        "learn_more_html": "<p>more</p>",
        "show_learn_more_button": false,
        "show_learn_more_link": true,
        "html_desc": "",
        "desc_html": "<p>old finishes or surfaces. Just apply Retique It® right over any painted or finished surface. Our wood-based primers and stains let you add a layer of actual wood to virtually any hard surface.</p>",
        "cta": {
          "href": null,
          "text": "Shop"
        }
      },
      {
        "type": "image",
        "title": "Interior / Exterior",
        "alt": "Interior / Exterior",
        "thumbnail": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/DurabilityShield_f6492089-7d0c-41c2-b2c8-3d65a2adced6.png?v=1685138992&width=2000",
        "heading_html": "<p><strong>Extreme Durability</strong></p>",
        "title_html": "<p><strong>Interior / Exterior</strong></p>",
        "image_desc_html": "<p>Durable enough for decking, ,...</p>",
        "image_desc_justify": "center",
        "image_more_desc_html": "<p>flooring and countertops, yet perfect for furniture and cabinets, as well. Waterproof, scratch-resistant, and kid-tested, Retique It® adheres to almost any hard surface, so you can have a durable wood finish inside and outside!</p>",
        "learn_more_html": "<p>more</p>",
        "show_learn_more_button": false,
        "show_learn_more_link": true,
        "html_desc": "",
        "desc_html": "<p>flooring and countertops, yet perfect for furniture and cabinets, as well. Waterproof, scratch-resistant, and kid-tested, Retique It® adheres to almost any hard surface, so you can have a durable wood finish inside and outside!</p>",
        "cta": {
          "href": null,
          "text": "Shop"
        }
      },
      {
        "type": "image",
        "title": "Wood Finish Anywhere",
        "alt": "Wood Finish Anywhere",
        "thumbnail": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/AnySurface.png?v=1685139673&width=2000",
        "heading_html": "<p><strong>Any Surface Imaginable</strong></p>",
        "title_html": "<p><strong>Wood Finish Anywhere</strong></p>",
        "image_desc_html": "<p>If you can dream it, you can Retique... </p>",
        "image_desc_justify": "center",
        "image_more_desc_html": "<p> It® Transform virtually any hard surface into an authentic wood surface. Whether it was originally painted, stained, wood, metal, MDF, concrete, plastic, or drywall. Retique It® has been used on furniture, cabinets, tables, countertops, front doors, garage doors, shutters, porches & more...</p>",
        "learn_more_html": "<p>more</p>",
        "show_learn_more_button": false,
        "show_learn_more_link": true,
        "html_desc": "",
        "desc_html": "<p> It® Transform virtually any hard surface into an authentic wood surface. Whether it was originally painted, stained, wood, metal, MDF, concrete, plastic, or drywall. Retique It® has been used on furniture, cabinets, tables, countertops, front doors, garage doors, shutters, porches & more...</p>",
        "cta": {
          "href": null,
          "text": "Shop"
        }
      }
    ]
  }
];


// ✅ MEDIA SET BLOCK (copy this to add/replace just this set):
window.MEDIA_GALLERY_SETS["GrainedWoodFinishesGalleryCTA"] = [
  {
    "heading": "<h1>Grained Wood Demos</h1>",
    "subheading": "",
    "img_ratio": "4:5",
    "row_height": 0,
    "fit_row": false,
    "margin_top": 0,
    "margin_bottom": 0,
    "collapsed": false,
    "show_more_text": "Show more",
    "show_less_text": "Show less",
    "row_toggle_border_style": "solid",
    "accordion": false,
    "accordion_title": "",
    "accordion_subheading": "",
    "accordion_hide_title_when_open": false,
    "accordion_hide_subheading_when_open": false,
    "accordion_title_center": false,
    "accordion_start_open": false,
    "accordion_allow_multiple": false,
    "accordion_bg_color": "#ffffff",
    "accordion_shadow_pct": 8,
    "accordion_shadow_style": "raised",
    "accordion_group": "",
    "accordion_always_open": false,
    "videos": [
      {
        "type": "video",
        "title": "Five Oak Finishes",
        "alt": "Five Oak Finishes",
        "url": "https://vimeo.com/1164866660",
        "start_time": "",
        "thumbnail": "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/b2b12816-32c0-4f40-aefa-8086d88f8914.gif?ClientID=sulu&Date=1771028306&Signature=a8c7696a9aba849a695d3ee45f7b756be7a3a412",
        "scale": 100,
        "title_wrap": false,
        "ratio_override": "",
        "vjust": "center",
        "html_desc": "",
        "desc_html": null,
        "end_behavior": "next",
        "cta": {
          "href": "https://retique.com/products/woodnfinish_white-oak_l",
          "text": "Shop Now",
          "thumb_text": "Shop Now"
        }
      },
      {
        "type": "video",
        "title": "Pickled Oak",
        "alt": "Pickled Oak",
        "url": "https://vimeo.com/1055284014",
        "start_time": "",
        "thumbnail": "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/80f23421-97a2-4a9e-a28e-ec36d91cd292.gif?ClientID=sulu&Date=1770888585&Signature=12eef8b1f97280fe5fe575fd9d4ca8f86f8d29af",
        "scale": 100,
        "title_wrap": false,
        "ratio_override": "",
        "vjust": "center",
        "html_desc": "",
        "desc_html": null,
        "end_behavior": "next",
        "cta": {
          "href": "https://retique.com/products/woodnfinish_white-oak_l",
          "text": "Shop Pickled Oak Kits",
          "thumb_text": "Shop Now"
        }
      },
      {
        "type": "video",
        "title": "Barn Wood",
        "alt": "Barn Wood",
        "url": "https://vimeo.com/1055317823",
        "start_time": "",
        "thumbnail": "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/0bdaad2b-2fd3-4b69-b058-ea51c9f08599.gif?ClientID=sulu&Date=1770888622&Signature=c2d320eda57b1708919b0a6339a7b7d33fd5a4dd",
        "scale": 100,
        "title_wrap": false,
        "ratio_override": "",
        "vjust": "center",
        "html_desc": "",
        "desc_html": null,
        "end_behavior": "next",
        "cta": {
          "href": "https://retique.com/products/woodnfinish_barn-wood_l",
          "text": "Shop Now",
          "thumb_text": "Shop Now"
        }
      },
      {
        "type": "video",
        "title": "White Oak / Sun Bleached",
        "alt": "White Oak / Sun Bleached",
        "url": "https://vimeo.com/1094873442",
        "start_time": "",
        "thumbnail": "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/e904372e-9513-4227-a7c2-56c600f9c4b0.gif?ClientID=sulu&Date=1770890074&Signature=e904e16aa46264dc8c9bb948b464a125d65f590a",
        "scale": 100,
        "title_wrap": false,
        "ratio_override": "",
        "vjust": "center",
        "html_desc": "",
        "desc_html": null,
        "end_behavior": "next",
        "cta": {
          "href": "https://retique.com/products/woodnfinish_white-oak_l",
          "text": "Shop Now",
          "thumb_text": "Shop Now"
        }
      },
      {
        "type": "video",
        "title": "French Oak",
        "alt": "French Oak",
        "url": "https://vimeo.com/1055319435",
        "start_time": "",
        "thumbnail": "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/fa83117a-8fb1-486d-a8b1-f15b0854296e.gif?ClientID=sulu&Date=1770888691&Signature=d8ba6eaaf656c7e97e260b1e67e9f6f9cca54568",
        "scale": 100,
        "title_wrap": false,
        "ratio_override": "",
        "vjust": "center",
        "html_desc": "",
        "desc_html": null,
        "end_behavior": "next",
        "cta": {
          "href": "https://retique.com/products/woodnfinish_french-oak_l",
          "text": "Shop Now",
          "thumb_text": "Shop Now"
        }
      },
      {
        "type": "video",
        "title": "Dark Oak, Weathered Wood & White Wash",
        "alt": "Dark Oak, Weathered Wood & White Wash",
        "url": "https://vimeo.com/1055324192",
        "start_time": "",
        "thumbnail": "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/1f5f3744-2ffb-4214-aea8-34d1b753b988.gif?ClientID=sulu&Date=1770888660&Signature=f703b516da6f5b5361267a432a3f2c4ed689bcce",
        "scale": 100,
        "title_wrap": false,
        "ratio_override": "",
        "vjust": "center",
        "html_desc": "",
        "desc_html": null,
        "end_behavior": "next",
        "cta": {
          "href": "https://retique.com/products/woodnfinish_dark-oak_",
          "text": "Shop Now",
          "thumb_text": "Shop Now"
        }
      },
      {
        "type": "video",
        "title": "Black Walnut",
        "alt": "Black Walnut",
        "url": "https://vimeo.com/1055321744",
        "start_time": "",
        "thumbnail": "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/693bfcf9-b2a2-48a6-bde1-201cdc9f7cfa.gif?ClientID=sulu&Date=1770888760&Signature=b16708dd087cb70822184f6588af94dd904817c8",
        "scale": 100,
        "title_wrap": false,
        "ratio_override": "",
        "vjust": "center",
        "html_desc": "",
        "desc_html": null,
        "end_behavior": "next",
        "cta": {
          "href": "https://retique.com/products/woodnfinish_black-walnut_l",
          "text": "Shop Now",
          "thumb_text": "Shop Now"
        }
      },
      {
        "type": "video",
        "title": "Harbor Gray",
        "alt": "Harbor Gray",
        "url": "https://vimeo.com/1095056708",
        "start_time": "",
        "thumbnail": "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/f6f8fa17-c2f1-4a5d-9d24-3b3b4bd3ccfe.gif?ClientID=sulu&Date=1770889536&Signature=d9e7c9feba5fab42d26906d6a60b988266a8fa64",
        "scale": 100,
        "title_wrap": false,
        "ratio_override": "",
        "vjust": "center",
        "html_desc": "",
        "desc_html": null,
        "end_behavior": "next",
        "cta": {
          "href": null,
          "text": "Shop Now",
          "thumb_text": ""
        }
      }
    ]
  }
];

// ✅ MEDIA SET BLOCK (copy this to add/replace just this set):
window.MEDIA_GALLERY_SETS["FrenchOakTechnique"] = [
  {
    "heading": "",
    "subheading": "",
    "img_ratio": "1:1",
    "row_height": 0,
    "fit_row": false,
    "collapsed": false,
    "show_more_text": "Show more",
    "show_less_text": "Show less",
    "row_toggle_border_style": "solid",
    "accordion": true,
    "accordion_marker": true,
    "accordion_title": "<h1>The French Oak Kit</h1>",
    "accordion_subheading": "<p></p><p>French Oak is a Technique which uses Barn Wood Wood'n Stain and White Wash Gel Stain Alternative to accomplish this beautiful finish!</p>",
    "accordion_hide_title_when_open": false,
    "accordion_hide_subheading_when_open": false,
    "accordion_title_center": true,
    "accordion_start_open": true,
    "accordion_allow_multiple": false,
    "accordion_bg_color": "#ffffff",
    "accordion_shadow_pct": 8,
    "accordion_shadow_style": "raised",
    "accordion_width_mobile_percent": 100,
    "accordion_width_desktop_percent": 100,
    "accordion_max_width_px": "0",
    "accordion_group": "accordion_RYBxzU",
    "accordion_always_open": true,
    "videos": []
  },
  {
    "heading": "",
    "subheading": "",
    "img_ratio": "1:1",
    "row_height": 0,
    "fit_row": false,
    "margin_top": 0,
    "margin_bottom": 0,
    "collapsed": false,
    "show_more_text": "Show more",
    "show_less_text": "Show less",
    "row_toggle_border_style": "solid",
    "accordion": false,
    "accordion_title": "<h1>The French Oak Kit</h1>",
    "accordion_subheading": "<p></p><p>French Oak is a Technique which uses Barn Wood Wood'n Stain and White Wash Gel Stain Alternative to accomplish this beautiful finish!</p>",
    "accordion_hide_title_when_open": false,
    "accordion_hide_subheading_when_open": false,
    "accordion_title_center": true,
    "accordion_start_open": true,
    "accordion_allow_multiple": false,
    "accordion_bg_color": "#ffffff",
    "accordion_shadow_pct": 8,
    "accordion_shadow_style": "raised",
    "accordion_width_mobile_percent": 100,
    "accordion_width_desktop_percent": 100,
    "accordion_max_width_px": "0",
    "accordion_group": "accordion_RYBxzU",
    "accordion_always_open": true,
    "videos": [
      {
        "type": "video",
        "title": "The French Oak Technique Explained",
        "alt": "The French Oak Technique Explained",
        "url": "https://vimeo.com/941267455",
        "start_time": "",
        "thumbnail": "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/25d66fa9-88da-4774-9c3e-8b3b2a642a3a.gif?ClientID=sulu&Date=1774734316&Signature=6de40448d817d38a10ddf57dd1e299b780b59f7b",
        "scale": 60,
        "title_wrap": false,
        "ratio_override": "9:16",
        "vjust": "top",
        "html_desc": "",
        "desc_html": null,
        "end_behavior": "loop",
        "cta": {
          "href": null,
          "text": "Shop Now",
          "thumb_text": ""
        }
      }
    ]
  },
  {
    "heading": "",
    "subheading": "",
    "img_ratio": "1:1",
    "row_height": 0,
    "fit_row": false,
    "collapsed": false,
    "show_more_text": "Show more",
    "show_less_text": "Show less",
    "row_toggle_border_style": "solid",
    "accordion": true,
    "accordion_marker": true,
    "accordion_title": "<h1>Frequently Asked Questions</h1>",
    "accordion_subheading": "",
    "accordion_hide_title_when_open": true,
    "accordion_hide_subheading_when_open": true,
    "accordion_title_center": true,
    "accordion_start_open": true,
    "accordion_allow_multiple": false,
    "accordion_bg_color": "#ffffff",
    "accordion_shadow_pct": 8,
    "accordion_shadow_style": "raised",
    "accordion_width_mobile_percent": 100,
    "accordion_width_desktop_percent": 100,
    "accordion_max_width_px": "0",
    "accordion_group": "accordion_YBPyMc",
    "accordion_always_open": true,
    "videos": []
  },
  {
    "heading": "<h1>Frequently Asked Questions</h1>",
    "subheading": "",
    "img_ratio": "4:5",
    "row_height": 0,
    "fit_row": false,
    "margin_top": 0,
    "margin_bottom": 60,
    "collapsed": false,
    "show_more_text": "Show more",
    "show_less_text": "Show less",
    "row_toggle_border_style": "solid",
    "accordion": false,
    "accordion_title": "<h1>Frequently Asked Questions</h1>",
    "accordion_subheading": "",
    "accordion_hide_title_when_open": false,
    "accordion_hide_subheading_when_open": false,
    "accordion_title_center": true,
    "accordion_start_open": true,
    "accordion_allow_multiple": false,
    "accordion_bg_color": "#ffffff",
    "accordion_shadow_pct": 8,
    "accordion_shadow_style": "raised",
    "accordion_group": "",
    "accordion_always_open": true,
    "videos": [
      {
        "type": "video",
        "title": "Does It Feel Like Wood?",
        "alt": "Does It Feel Like Wood?",
        "url": "https://vimeo.com/935133272",
        "start_time": "",
        "thumbnail": "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/78d37ca1-1618-4b9f-be97-2702f5a61695.gif?ClientID=sulu&Date=1770885616&Signature=105431823734266a8e52006e61840d0c77c8230b",
        "scale": 100,
        "title_wrap": false,
        "ratio_override": "",
        "vjust": "center",
        "html_desc": "",
        "desc_html": null,
        "end_behavior": "next",
        "cta": {
          "href": null,
          "text": "Shop Now",
          "thumb_text": ""
        }
      },
      {
        "type": "video",
        "title": "Creating Knots?",
        "alt": "Creating Knots?",
        "url": "https://vimeo.com/1055326646",
        "start_time": "",
        "thumbnail": "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/6c1f428c-5de5-48cd-9320-7de1e3ce665d.gif?ClientID=sulu&Date=1770888439&Signature=c970bd25f24e5e0659f1f8f8c74b8bf9ab4c36e5",
        "scale": 100,
        "title_wrap": false,
        "ratio_override": "",
        "vjust": "center",
        "html_desc": "",
        "desc_html": null,
        "end_behavior": "next",
        "cta": {
          "href": null,
          "text": "Shop Now",
          "thumb_text": ""
        }
      },
      {
        "type": "video",
        "title": "Sanding Required?",
        "alt": "Sanding Required?",
        "url": "https://vimeo.com/1010180276",
        "start_time": "",
        "thumbnail": "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/52f7dd61-8554-459e-9040-116f2cadf735.gif?ClientID=sulu&Date=1771084222&Signature=7f1ecf246cbb5e826a192cf8d0a3b738fe150c98",
        "scale": 100,
        "title_wrap": false,
        "ratio_override": "",
        "vjust": "center",
        "html_desc": "",
        "desc_html": null,
        "end_behavior": "next",
        "cta": {
          "href": null,
          "text": "Shop Now",
          "thumb_text": ""
        }
      },
      {
        "type": "video",
        "title": "Rustic or Weathered Technique?",
        "alt": "Rustic or Weathered Technique?",
        "url": "https://vimeo.com/937414554",
        "start_time": "",
        "thumbnail": "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/156ab3aa-b523-4c04-8b0e-c5711663cf3c.gif?ClientID=sulu&Date=1770890550&Signature=89af9173e941d3b581383d06c75ed54b8b539118",
        "scale": 100,
        "title_wrap": false,
        "ratio_override": "",
        "vjust": "center",
        "html_desc": "",
        "desc_html": null,
        "end_behavior": "next",
        "cta": {
          "href": null,
          "text": "Shop Now",
          "thumb_text": ""
        }
      }
    ]
  },
  {
    "heading": "",
    "subheading": "",
    "img_ratio": "1:1",
    "row_height": 0,
    "fit_row": false,
    "collapsed": false,
    "show_more_text": "Show more",
    "show_less_text": "Show less",
    "row_toggle_border_style": "solid",
    "accordion": true,
    "accordion_marker": true,
    "accordion_title": "<h1>Tips & Techniques</h1>",
    "accordion_subheading": "",
    "accordion_hide_title_when_open": true,
    "accordion_hide_subheading_when_open": true,
    "accordion_title_center": true,
    "accordion_start_open": true,
    "accordion_allow_multiple": false,
    "accordion_bg_color": "#ffffff",
    "accordion_shadow_pct": 8,
    "accordion_shadow_style": "raised",
    "accordion_width_mobile_percent": 100,
    "accordion_width_desktop_percent": 100,
    "accordion_max_width_px": "0",
    "accordion_group": "accordion_6kb3bh",
    "accordion_always_open": true,
    "videos": []
  },
  {
    "heading": "<h1>Tips & Techniques</h1>",
    "subheading": "",
    "img_ratio": "16:9",
    "row_height": 0,
    "fit_row": false,
    "margin_top": 0,
    "margin_bottom": 60,
    "collapsed": false,
    "show_more_text": "Show more",
    "show_less_text": "Show less",
    "row_toggle_border_style": "solid",
    "accordion": false,
    "accordion_title": "<h1>Tips & Techniques</h1>",
    "accordion_subheading": "",
    "accordion_hide_title_when_open": false,
    "accordion_hide_subheading_when_open": false,
    "accordion_title_center": true,
    "accordion_start_open": true,
    "accordion_allow_multiple": false,
    "accordion_bg_color": "#ffffff",
    "accordion_shadow_pct": 8,
    "accordion_shadow_style": "raised",
    "accordion_group": "",
    "accordion_always_open": true,
    "videos": [
      {
        "type": "video",
        "title": "Do a Sample Piece",
        "alt": "Do a Sample Piece",
        "url": "https://vimeo.com/1117979068?fl=ls&fe=ec",
        "start_time": "",
        "thumbnail": "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/14bc09b3-385d-4d4d-a866-78d7c3e61ab3.gif?ClientID=sulu&Date=1770887075&Signature=fa7693bfba1d2403e3748f2b273c3216e6d41400",
        "scale": 100,
        "title_wrap": false,
        "ratio_override": "16:9",
        "vjust": "center",
        "html_desc": "",
        "desc_html": null,
        "end_behavior": "next",
        "cta": {
          "href": null,
          "text": "Shop Now",
          "thumb_text": ""
        }
      }
    ]
  },
  {
    "heading": "",
    "subheading": "",
    "img_ratio": "4:5",
    "row_height": 0,
    "fit_row": false,
    "margin_top": 0,
    "margin_bottom": 0,
    "collapsed": false,
    "show_more_text": "Show more",
    "show_less_text": "Show less",
    "row_toggle_border_style": "solid",
    "accordion": false,
    "accordion_title": "<h1>Tips & Techniques</h1>",
    "accordion_subheading": "",
    "accordion_hide_title_when_open": false,
    "accordion_hide_subheading_when_open": false,
    "accordion_title_center": true,
    "accordion_start_open": true,
    "accordion_allow_multiple": false,
    "accordion_bg_color": "#ffffff",
    "accordion_shadow_pct": 8,
    "accordion_shadow_style": "raised",
    "accordion_group": "",
    "accordion_always_open": true,
    "videos": [
      {
        "type": "video",
        "title": "Grained or Smooth Finish",
        "alt": "Grained or Smooth Finish",
        "url": "https://vimeo.com/876765262",
        "start_time": "",
        "thumbnail": "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/77c46d3d-8adc-4233-aa92-6a1e9e722949.gif?ClientID=sulu&Date=1770886744&Signature=119d727b590dd5d991b8900f967ec80855377520",
        "scale": 100,
        "title_wrap": false,
        "ratio_override": "",
        "vjust": "center",
        "html_desc": "",
        "desc_html": null,
        "end_behavior": "next",
        "cta": {
          "href": null,
          "text": "Shop Now",
          "thumb_text": ""
        }
      },
      {
        "type": "video",
        "title": "Creating Knots",
        "alt": "Creating Knots",
        "url": "https://vimeo.com/1055326646",
        "start_time": "",
        "thumbnail": "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/6c1f428c-5de5-48cd-9320-7de1e3ce665d.gif?ClientID=sulu&Date=1770888439&Signature=c970bd25f24e5e0659f1f8f8c74b8bf9ab4c36e5",
        "scale": 100,
        "title_wrap": false,
        "ratio_override": "",
        "vjust": "center",
        "html_desc": "",
        "desc_html": null,
        "end_behavior": "next",
        "cta": {
          "href": null,
          "text": "Shop Now",
          "thumb_text": ""
        }
      },
      {
        "type": "video",
        "title": "Rustic or Weathered Technique",
        "alt": "Rustic or Weathered Technique",
        "url": "https://vimeo.com/937414554",
        "start_time": "",
        "thumbnail": "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/156ab3aa-b523-4c04-8b0e-c5711663cf3c.gif?ClientID=sulu&Date=1770890550&Signature=89af9173e941d3b581383d06c75ed54b8b539118",
        "scale": 100,
        "title_wrap": false,
        "ratio_override": "",
        "vjust": "center",
        "html_desc": "",
        "desc_html": null,
        "end_behavior": "next",
        "cta": {
          "href": null,
          "text": "Shop Now",
          "thumb_text": ""
        }
      }
    ]
  },
  {
    "heading": "<h2></h2><h2>How-to Use the Graining Tool</h2>",
    "subheading": "",
    "img_ratio": "16:9",
    "row_height": 0,
    "fit_row": false,
    "margin_top": 0,
    "margin_bottom": 0,
    "collapsed": false,
    "show_more_text": "Graining Instructions",
    "show_less_text": "Hide Graining Instructions",
    "row_toggle_border_style": "solid",
    "accordion": false,
    "accordion_title": "<h1>Tips & Techniques</h1>",
    "accordion_subheading": "",
    "accordion_hide_title_when_open": false,
    "accordion_hide_subheading_when_open": false,
    "accordion_title_center": true,
    "accordion_start_open": true,
    "accordion_allow_multiple": false,
    "accordion_bg_color": "#ffffff",
    "accordion_shadow_pct": 8,
    "accordion_shadow_style": "raised",
    "accordion_group": "",
    "accordion_always_open": true,
    "videos": [
      {
        "type": "video",
        "title": "Detailed Graining Instructions",
        "alt": "Detailed Graining Instructions",
        "url": "https://vimeo.com/949990144",
        "start_time": "",
        "thumbnail": "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/a61c09d6-4a4d-4aad-9e5d-f8213957b551.gif?ClientID=sulu&Date=1770889266&Signature=629f3fa1159090dd05edd4e20949b69600b3ae6b",
        "scale": 100,
        "title_wrap": false,
        "ratio_override": "16:9",
        "vjust": "center",
        "html_desc": "",
        "desc_html": null,
        "end_behavior": "next",
        "cta": {
          "href": null,
          "text": "Shop Now",
          "thumb_text": ""
        }
      }
    ]
  },
  {
    "heading": "<h1>Using Wood Filler</h1>",
    "subheading": "",
    "img_ratio": "16:9",
    "row_height": 0,
    "fit_row": false,
    "margin_top": 0,
    "margin_bottom": 0,
    "collapsed": false,
    "show_more_text": "Show more",
    "show_less_text": "Show less",
    "row_toggle_border_style": "solid",
    "accordion": false,
    "accordion_title": "<h1>Tips & Techniques</h1>",
    "accordion_subheading": "",
    "accordion_hide_title_when_open": false,
    "accordion_hide_subheading_when_open": false,
    "accordion_title_center": true,
    "accordion_start_open": true,
    "accordion_allow_multiple": false,
    "accordion_bg_color": "#ffffff",
    "accordion_shadow_pct": 8,
    "accordion_shadow_style": "raised",
    "accordion_group": "",
    "accordion_always_open": true,
    "videos": [
      {
        "type": "video",
        "title": "Works over Wood Filler",
        "alt": "Works over Wood Filler",
        "url": "https://vimeo.com/1167692291",
        "start_time": "",
        "thumbnail": "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/e9d14ad3-100b-4df1-9f4f-cef8c87af38f.gif?ClientID=sulu&Date=1771933124&Signature=35c628811fd169188b948e75c0ed365d40e37f17",
        "scale": 100,
        "title_wrap": false,
        "ratio_override": "",
        "vjust": "center",
        "html_desc": "",
        "desc_html": null,
        "end_behavior": "next",
        "cta": {
          "href": null,
          "text": "Shop Now",
          "thumb_text": ""
        }
      }
    ]
  }
];

// ✅ MEDIA SET BLOCK (copy this to add/replace just this set):
window.MEDIA_GALLERY_SETS["WhiteOakTechnique"] = [
  {
    "heading": "",
    "subheading": "",
    "img_ratio": "1:1",
    "row_height": 0,
    "fit_row": false,
    "collapsed": false,
    "show_more_text": "Show more",
    "show_less_text": "Show less",
    "row_toggle_border_style": "solid",
    "accordion": true,
    "accordion_marker": true,
    "accordion_title": "<h1>The White Oak Kit</h1>",
    "accordion_subheading": "<p></p><p>White Oak is a Technique which uses Pickled Oak Wood'n Stain and Bleached Wood Wood'n Primer to accomplish this beautiful finish!</p>",
    "accordion_hide_title_when_open": false,
    "accordion_hide_subheading_when_open": false,
    "accordion_title_center": true,
    "accordion_start_open": true,
    "accordion_allow_multiple": false,
    "accordion_bg_color": "#ffffff",
    "accordion_shadow_pct": 8,
    "accordion_shadow_style": "raised",
    "accordion_width_mobile_percent": 100,
    "accordion_width_desktop_percent": 100,
    "accordion_max_width_px": "0",
    "accordion_group": "accordion_nMGkD9",
    "accordion_always_open": true,
    "videos": []
  },
  {
    "heading": "",
    "subheading": "",
    "img_ratio": "1:1",
    "row_height": 0,
    "fit_row": false,
    "margin_top": 0,
    "margin_bottom": 0,
    "collapsed": false,
    "show_more_text": "Show more",
    "show_less_text": "Show less",
    "row_toggle_border_style": "solid",
    "accordion": false,
    "accordion_title": "<h1>The White Oak Kit</h1>",
    "accordion_subheading": "<p></p><p>White Oak is a Technique which uses Pickled Oak Wood'n Stain and Bleached Wood Wood'n Primer to accomplish this beautiful finish!</p>",
    "accordion_hide_title_when_open": false,
    "accordion_hide_subheading_when_open": false,
    "accordion_title_center": true,
    "accordion_start_open": true,
    "accordion_allow_multiple": false,
    "accordion_bg_color": "#ffffff",
    "accordion_shadow_pct": 8,
    "accordion_shadow_style": "raised",
    "accordion_width_mobile_percent": 100,
    "accordion_width_desktop_percent": 100,
    "accordion_max_width_px": "0",
    "accordion_group": "accordion_nMGkD9",
    "accordion_always_open": true,
    "videos": [
      {
        "type": "video",
        "title": "White Oak Kits Explained",
        "alt": "White Oak Kits Explained",
        "url": "https://vimeo.com/938365254",
        "start_time": "",
        "thumbnail": "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/5b828de0-7f6c-49c4-88f3-7b9e53fcadf1.gif?ClientID=sulu&Date=1774734777&Signature=13b1e0a4956ca2962ad81fbffb2ee7f715cd55b7",
        "scale": 60,
        "title_wrap": false,
        "ratio_override": "9:16",
        "vjust": "top",
        "html_desc": "",
        "desc_html": null,
        "end_behavior": "loop",
        "cta": {
          "href": null,
          "text": "Shop Now",
          "thumb_text": ""
        }
      }
    ]
  },
  {
    "heading": "",
    "subheading": "",
    "img_ratio": "1:1",
    "row_height": 0,
    "fit_row": false,
    "collapsed": false,
    "show_more_text": "Show more",
    "show_less_text": "Show less",
    "row_toggle_border_style": "solid",
    "accordion": true,
    "accordion_marker": true,
    "accordion_title": "<h1>Frequently Asked Questions</h1>",
    "accordion_subheading": "",
    "accordion_hide_title_when_open": true,
    "accordion_hide_subheading_when_open": true,
    "accordion_title_center": true,
    "accordion_start_open": true,
    "accordion_allow_multiple": false,
    "accordion_bg_color": "#ffffff",
    "accordion_shadow_pct": 8,
    "accordion_shadow_style": "raised",
    "accordion_width_mobile_percent": 100,
    "accordion_width_desktop_percent": 100,
    "accordion_max_width_px": "0",
    "accordion_group": "accordion_AMFA8D",
    "accordion_always_open": true,
    "videos": []
  },
  {
    "heading": "<h1>Frequently Asked Questions</h1>",
    "subheading": "",
    "img_ratio": "4:5",
    "row_height": 0,
    "fit_row": false,
    "margin_top": 0,
    "margin_bottom": 60,
    "collapsed": false,
    "show_more_text": "Show more",
    "show_less_text": "Show less",
    "row_toggle_border_style": "solid",
    "accordion": false,
    "accordion_title": "<h1>Frequently Asked Questions</h1>",
    "accordion_subheading": "",
    "accordion_hide_title_when_open": false,
    "accordion_hide_subheading_when_open": false,
    "accordion_title_center": true,
    "accordion_start_open": true,
    "accordion_allow_multiple": false,
    "accordion_bg_color": "#ffffff",
    "accordion_shadow_pct": 8,
    "accordion_shadow_style": "raised",
    "accordion_group": "",
    "accordion_always_open": true,
    "videos": [
      {
        "type": "video",
        "title": "Does It Feel Like Wood?",
        "alt": "Does It Feel Like Wood?",
        "url": "https://vimeo.com/935133272",
        "start_time": "",
        "thumbnail": "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/78d37ca1-1618-4b9f-be97-2702f5a61695.gif?ClientID=sulu&Date=1770885616&Signature=105431823734266a8e52006e61840d0c77c8230b",
        "scale": 100,
        "title_wrap": false,
        "ratio_override": "",
        "vjust": "center",
        "html_desc": "",
        "desc_html": null,
        "end_behavior": "next",
        "cta": {
          "href": null,
          "text": "Shop Now",
          "thumb_text": ""
        }
      },
      {
        "type": "video",
        "title": "Creating Knots?",
        "alt": "Creating Knots?",
        "url": "https://vimeo.com/1055326646",
        "start_time": "",
        "thumbnail": "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/6c1f428c-5de5-48cd-9320-7de1e3ce665d.gif?ClientID=sulu&Date=1770888439&Signature=c970bd25f24e5e0659f1f8f8c74b8bf9ab4c36e5",
        "scale": 100,
        "title_wrap": false,
        "ratio_override": "",
        "vjust": "center",
        "html_desc": "",
        "desc_html": null,
        "end_behavior": "next",
        "cta": {
          "href": null,
          "text": "Shop Now",
          "thumb_text": ""
        }
      },
      {
        "type": "video",
        "title": "Sanding Required?",
        "alt": "Sanding Required?",
        "url": "https://vimeo.com/1010180276",
        "start_time": "",
        "thumbnail": "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/52f7dd61-8554-459e-9040-116f2cadf735.gif?ClientID=sulu&Date=1771084222&Signature=7f1ecf246cbb5e826a192cf8d0a3b738fe150c98",
        "scale": 100,
        "title_wrap": false,
        "ratio_override": "",
        "vjust": "center",
        "html_desc": "",
        "desc_html": null,
        "end_behavior": "next",
        "cta": {
          "href": null,
          "text": "Shop Now",
          "thumb_text": ""
        }
      },
      {
        "type": "video",
        "title": "Rustic or Weathered Technique?",
        "alt": "Rustic or Weathered Technique?",
        "url": "https://vimeo.com/937414554",
        "start_time": "",
        "thumbnail": "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/156ab3aa-b523-4c04-8b0e-c5711663cf3c.gif?ClientID=sulu&Date=1770890550&Signature=89af9173e941d3b581383d06c75ed54b8b539118",
        "scale": 100,
        "title_wrap": false,
        "ratio_override": "",
        "vjust": "center",
        "html_desc": "",
        "desc_html": null,
        "end_behavior": "next",
        "cta": {
          "href": null,
          "text": "Shop Now",
          "thumb_text": ""
        }
      }
    ]
  },
  {
    "heading": "",
    "subheading": "",
    "img_ratio": "1:1",
    "row_height": 0,
    "fit_row": false,
    "collapsed": false,
    "show_more_text": "Show more",
    "show_less_text": "Show less",
    "row_toggle_border_style": "solid",
    "accordion": true,
    "accordion_marker": true,
    "accordion_title": "<h1>Tips & Techniques</h1>",
    "accordion_subheading": "",
    "accordion_hide_title_when_open": true,
    "accordion_hide_subheading_when_open": true,
    "accordion_title_center": true,
    "accordion_start_open": true,
    "accordion_allow_multiple": false,
    "accordion_bg_color": "#ffffff",
    "accordion_shadow_pct": 8,
    "accordion_shadow_style": "raised",
    "accordion_width_mobile_percent": 100,
    "accordion_width_desktop_percent": 100,
    "accordion_max_width_px": "0",
    "accordion_group": "accordion_dLwG7t",
    "accordion_always_open": true,
    "videos": []
  },
  {
    "heading": "<h1>Tips & Techniques</h1>",
    "subheading": "",
    "img_ratio": "16:9",
    "row_height": 0,
    "fit_row": false,
    "margin_top": 0,
    "margin_bottom": 60,
    "collapsed": false,
    "show_more_text": "Show more",
    "show_less_text": "Show less",
    "row_toggle_border_style": "solid",
    "accordion": false,
    "accordion_title": "<h1>Tips & Techniques</h1>",
    "accordion_subheading": "",
    "accordion_hide_title_when_open": false,
    "accordion_hide_subheading_when_open": false,
    "accordion_title_center": true,
    "accordion_start_open": true,
    "accordion_allow_multiple": false,
    "accordion_bg_color": "#ffffff",
    "accordion_shadow_pct": 8,
    "accordion_shadow_style": "raised",
    "accordion_group": "",
    "accordion_always_open": true,
    "videos": [
      {
        "type": "video",
        "title": "Do a Sample Piece",
        "alt": "Do a Sample Piece",
        "url": "https://vimeo.com/1117979068?fl=ls&fe=ec",
        "start_time": "",
        "thumbnail": "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/14bc09b3-385d-4d4d-a866-78d7c3e61ab3.gif?ClientID=sulu&Date=1770887075&Signature=fa7693bfba1d2403e3748f2b273c3216e6d41400",
        "scale": 100,
        "title_wrap": false,
        "ratio_override": "16:9",
        "vjust": "center",
        "html_desc": "",
        "desc_html": null,
        "end_behavior": "next",
        "cta": {
          "href": null,
          "text": "Shop Now",
          "thumb_text": ""
        }
      }
    ]
  },
  {
    "heading": "",
    "subheading": "",
    "img_ratio": "4:5",
    "row_height": 0,
    "fit_row": false,
    "margin_top": 0,
    "margin_bottom": 0,
    "collapsed": false,
    "show_more_text": "Show more",
    "show_less_text": "Show less",
    "row_toggle_border_style": "solid",
    "accordion": false,
    "accordion_title": "<h1>Tips & Techniques</h1>",
    "accordion_subheading": "",
    "accordion_hide_title_when_open": false,
    "accordion_hide_subheading_when_open": false,
    "accordion_title_center": true,
    "accordion_start_open": true,
    "accordion_allow_multiple": false,
    "accordion_bg_color": "#ffffff",
    "accordion_shadow_pct": 8,
    "accordion_shadow_style": "raised",
    "accordion_group": "",
    "accordion_always_open": true,
    "videos": [
      {
        "type": "video",
        "title": "Grained or Smooth Finish",
        "alt": "Grained or Smooth Finish",
        "url": "https://vimeo.com/876765262",
        "start_time": "",
        "thumbnail": "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/77c46d3d-8adc-4233-aa92-6a1e9e722949.gif?ClientID=sulu&Date=1770886744&Signature=119d727b590dd5d991b8900f967ec80855377520",
        "scale": 100,
        "title_wrap": false,
        "ratio_override": "",
        "vjust": "center",
        "html_desc": "",
        "desc_html": null,
        "end_behavior": "next",
        "cta": {
          "href": null,
          "text": "Shop Now",
          "thumb_text": ""
        }
      },
      {
        "type": "video",
        "title": "Creating Knots",
        "alt": "Creating Knots",
        "url": "https://vimeo.com/1055326646",
        "start_time": "",
        "thumbnail": "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/6c1f428c-5de5-48cd-9320-7de1e3ce665d.gif?ClientID=sulu&Date=1770888439&Signature=c970bd25f24e5e0659f1f8f8c74b8bf9ab4c36e5",
        "scale": 100,
        "title_wrap": false,
        "ratio_override": "",
        "vjust": "center",
        "html_desc": "",
        "desc_html": null,
        "end_behavior": "next",
        "cta": {
          "href": null,
          "text": "Shop Now",
          "thumb_text": ""
        }
      },
      {
        "type": "video",
        "title": "Rustic or Weathered Technique",
        "alt": "Rustic or Weathered Technique",
        "url": "https://vimeo.com/937414554",
        "start_time": "",
        "thumbnail": "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/156ab3aa-b523-4c04-8b0e-c5711663cf3c.gif?ClientID=sulu&Date=1770890550&Signature=89af9173e941d3b581383d06c75ed54b8b539118",
        "scale": 100,
        "title_wrap": false,
        "ratio_override": "",
        "vjust": "center",
        "html_desc": "",
        "desc_html": null,
        "end_behavior": "next",
        "cta": {
          "href": null,
          "text": "Shop Now",
          "thumb_text": ""
        }
      }
    ]
  },
  {
    "heading": "<h2></h2><h2>How-to Use the Graining Tool</h2>",
    "subheading": "",
    "img_ratio": "16:9",
    "row_height": 0,
    "fit_row": false,
    "margin_top": 0,
    "margin_bottom": 0,
    "collapsed": false,
    "show_more_text": "Graining Instructions",
    "show_less_text": "Hide Graining Instructions",
    "row_toggle_border_style": "solid",
    "accordion": false,
    "accordion_title": "<h1>Tips & Techniques</h1>",
    "accordion_subheading": "",
    "accordion_hide_title_when_open": false,
    "accordion_hide_subheading_when_open": false,
    "accordion_title_center": true,
    "accordion_start_open": true,
    "accordion_allow_multiple": false,
    "accordion_bg_color": "#ffffff",
    "accordion_shadow_pct": 8,
    "accordion_shadow_style": "raised",
    "accordion_group": "",
    "accordion_always_open": true,
    "videos": [
      {
        "type": "video",
        "title": "Detailed Graining Instructions",
        "alt": "Detailed Graining Instructions",
        "url": "https://vimeo.com/949990144",
        "start_time": "",
        "thumbnail": "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/a61c09d6-4a4d-4aad-9e5d-f8213957b551.gif?ClientID=sulu&Date=1770889266&Signature=629f3fa1159090dd05edd4e20949b69600b3ae6b",
        "scale": 100,
        "title_wrap": false,
        "ratio_override": "16:9",
        "vjust": "center",
        "html_desc": "",
        "desc_html": null,
        "end_behavior": "next",
        "cta": {
          "href": null,
          "text": "Shop Now",
          "thumb_text": ""
        }
      }
    ]
  },
  {
    "heading": "<h1>Using Wood Filler</h1>",
    "subheading": "",
    "img_ratio": "16:9",
    "row_height": 0,
    "fit_row": false,
    "margin_top": 0,
    "margin_bottom": 0,
    "collapsed": false,
    "show_more_text": "Show more",
    "show_less_text": "Show less",
    "row_toggle_border_style": "solid",
    "accordion": false,
    "accordion_title": "<h1>Tips & Techniques</h1>",
    "accordion_subheading": "",
    "accordion_hide_title_when_open": false,
    "accordion_hide_subheading_when_open": false,
    "accordion_title_center": true,
    "accordion_start_open": true,
    "accordion_allow_multiple": false,
    "accordion_bg_color": "#ffffff",
    "accordion_shadow_pct": 8,
    "accordion_shadow_style": "raised",
    "accordion_group": "",
    "accordion_always_open": true,
    "videos": [
      {
        "type": "video",
        "title": "Works over Wood Filler",
        "alt": "Works over Wood Filler",
        "url": "https://vimeo.com/1167692291",
        "start_time": "",
        "thumbnail": "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/e9d14ad3-100b-4df1-9f4f-cef8c87af38f.gif?ClientID=sulu&Date=1771933124&Signature=35c628811fd169188b948e75c0ed365d40e37f17",
        "scale": 100,
        "title_wrap": false,
        "ratio_override": "",
        "vjust": "center",
        "html_desc": "",
        "desc_html": null,
        "end_behavior": "next",
        "cta": {
          "href": null,
          "text": "Shop Now",
          "thumb_text": ""
        }
      }
    ]
  }
];

// ✅ MEDIA SET BLOCK (copy this to add/replace just this set):
window.MEDIA_GALLERY_SETS["Cabinets"] = [
  {
    "heading": "<h1>Cabinets</h1>",
    "subheading": "",
    "img_ratio": "4:5",
    "row_height": 0,
    "fit_row": false,
    "margin_top": 0,
    "margin_bottom": 60,
    "collapsed": false,
    "show_more_text": "Show more",
    "show_less_text": "Show less",
    "row_toggle_border_style": "solid",
    "accordion": false,
    "accordion_title": "",
    "accordion_subheading": "",
    "accordion_hide_title_when_open": false,
    "accordion_hide_subheading_when_open": false,
    "accordion_title_center": false,
    "accordion_start_open": false,
    "accordion_allow_multiple": false,
    "accordion_bg_color": "#ffffff",
    "accordion_shadow_pct": 8,
    "accordion_shadow_style": "raised",
    "accordion_group": "",
    "accordion_always_open": false,
    "videos": [
      {
        "type": "video",
        "title": "Thermofoil Cabinets",
        "alt": "Thermofoil Cabinets",
        "url": "https://vimeo.com/1164537276?share=copy&fl=sv&fe=ci",
        "start_time": "",
        "thumbnail": "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/d394259d-83a1-4c5e-97ba-89dba8f32a5d.gif?ClientID=sulu&Date=1771589470&Signature=c10e56c0e8419a6cd5b9268c6caeae870bc7c389",
        "scale": 100,
        "title_wrap": false,
        "ratio_override": "",
        "vjust": "center",
        "html_desc": "",
        "desc_html": null,
        "end_behavior": "next",
        "cta": {
          "href": null,
          "text": "Shop Now",
          "thumb_text": ""
        }
      },
      {
        "type": "video",
        "title": "Orangy Oak Smooth",
        "alt": "Orangy Oak Smooth",
        "url": "https://vimeo.com/1164525010?share=copy&fl=sv&fe=ci",
        "start_time": "",
        "thumbnail": "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/371901d4-ca20-40e6-9918-daf602963ab7.gif?ClientID=sulu&Date=1771589688&Signature=4622307d91edeff0871d2eead5c39c0e0074b120",
        "scale": 100,
        "title_wrap": false,
        "ratio_override": "",
        "vjust": "center",
        "html_desc": "",
        "desc_html": null,
        "end_behavior": "next",
        "cta": {
          "href": null,
          "text": "Shop Now",
          "thumb_text": ""
        }
      },
      {
        "type": "video",
        "title": "From White to Blonde",
        "alt": "From White to Blonde",
        "url": "https://vimeo.com/1166765443?share=copy&fl=sv&fe=ci",
        "start_time": "",
        "thumbnail": "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/589d3544-72cf-41e2-b9f6-0370245663b4.gif?ClientID=sulu&Date=1771613402&Signature=d7b0c400f9b93022602537d7d8811435c2fc85a4",
        "scale": 100,
        "title_wrap": false,
        "ratio_override": "",
        "vjust": "center",
        "html_desc": "",
        "desc_html": null,
        "end_behavior": "next",
        "cta": {
          "href": null,
          "text": "Shop Now",
          "thumb_text": ""
        }
      },
      {
        "type": "video",
        "title": "Laminate Cabinets",
        "alt": "Laminate Cabinets",
        "url": "https://vimeo.com/1164534857",
        "start_time": "",
        "thumbnail": "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/ef0d4a9c-6c6b-4699-88e3-14a2b8331544.gif?ClientID=sulu&Date=1771613686&Signature=b71701c9c5fe7ef98ddc35c08bfc6ce640ad6252",
        "scale": 100,
        "title_wrap": false,
        "ratio_override": "",
        "vjust": "center",
        "html_desc": "",
        "desc_html": null,
        "end_behavior": "next",
        "cta": {
          "href": null,
          "text": "Shop Now",
          "thumb_text": ""
        }
      },
      {
        "type": "video",
        "title": "Orangy Oak, No!",
        "alt": "Orangy Oak, No!",
        "url": "https://vimeo.com/1165036944",
        "start_time": "",
        "thumbnail": "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/c8c5220a-68c4-4749-8a28-e219fc365e7f.gif?ClientID=sulu&Date=1771613560&Signature=ba812a7554a8ab7fc91a5f95fe7de46323c7173b",
        "scale": 100,
        "title_wrap": false,
        "ratio_override": "",
        "vjust": "center",
        "html_desc": "<p>Same stain color… three completely different wood finishes:<br/><br/>✨ Light Wood (white oak feel)<br/>🌊 Bleached Wood (bright + coastal)<br/>🤎 Dark Wood (warm + modern)<br/><br/>And here’s the best part… I used the same stain on all three<br/>Minwax® Jacobean Penetrating Stain (yellow can)…<br/><br/>the Wood’n Primer base coat is what changes the final look.<br/><br/>Retique It® Liquid Wood Coatings Wood’n Primer gives you an authentic wood finish with over 60% wood once dry… made with recycled wood ♻️… and it works on MDF, laminate, metal, plastic… even previously painted cabinets.<br/><br/>Which wood finish would you choose?<br/><a href=\"https://www.instagram.com/reel/DULnDetDul7/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==\" title=\"https://www.instagram.com/reel/DULnDetDul7/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==\">See Instagram Post</a><br/><br/></p>",
        "desc_html": null,
        "end_behavior": "next",
        "cta": {
          "href": null,
          "text": "Shop Now",
          "thumb_text": ""
        }
      },
      {
        "type": "video",
        "title": "Orangy Oak Grained",
        "alt": "Orangy Oak Grained",
        "url": "https://vimeo.com/938294879?share=copy&fl=sv&fe=ci",
        "start_time": "",
        "thumbnail": "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/182de6f8-54a0-47fd-a8ae-c8fd8cd3ec35.gif?ClientID=sulu&Date=1771589825&Signature=3c229504025f7400852122bf03db431201b259ae",
        "scale": 100,
        "title_wrap": false,
        "ratio_override": "",
        "vjust": "center",
        "html_desc": "",
        "desc_html": null,
        "end_behavior": "next",
        "cta": {
          "href": null,
          "text": "Shop Now",
          "thumb_text": ""
        }
      },
      {
        "type": "video",
        "title": "Built-in Cabinets",
        "alt": "Built-in Cabinets",
        "url": "https://vimeo.com/1167113792",
        "start_time": "",
        "thumbnail": "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/df0f38cc-fb02-488a-baa9-c91b78802bd6.gif?ClientID=sulu&Date=1772528037&Signature=6edeaedac9c7b0f539f7331fc2d716e343793f18",
        "scale": 100,
        "title_wrap": false,
        "ratio_override": "",
        "vjust": "center",
        "html_desc": "<p><a href=\"https://www.instagram.com/crafty.custom.home/\" target=\"_blank\">@crafty.custom.home</a> Follow me as I transform these boring grey mudroom built-ins into a gorgeous faux white oak. Trust me, you won’t even be able to tell it’s not real wood. This product is THAT GOOD. <a href=\"https://www.instagram.com/retiqueliquidwood/\" target=\"_blank\">@retiqueliquidwood</a></p>",
        "desc_html": null,
        "end_behavior": "next",
        "cta": {
          "href": null,
          "text": "Shop Now",
          "thumb_text": ""
        }
      },
      {
        "type": "video",
        "title": "Cabinet Makeover",
        "alt": "Cabinet Makeover",
        "url": "https://vimeo.com/1169312746",
        "start_time": "",
        "thumbnail": "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/fcb701c8-b37b-4d55-b3bb-3dff482b3a20.gif?ClientID=sulu&Date=1772377137&Signature=7c4da0d1d31d7b08d2f079fb81044c92f5252e12",
        "scale": 100,
        "title_wrap": false,
        "ratio_override": "",
        "vjust": "center",
        "html_desc": "<p><a href=\"https://www.instagram.com/p/DUUNl4dDgAN/\" target=\"_blank\">@Just.Jenica.DIY</a> gave her kitchen a stunning blonde wood makeover using Retique It’s Light Wood Primer and a regular stain.</p><ul><li>No graining tool needed</li><li>Authentic real wood finish</li><li>Durable and long lasting</li><li>Over 60% real wood</li></ul><p>These cabinets turned out absolutely beautiful.</p>",
        "desc_html": null,
        "end_behavior": "next",
        "cta": {
          "href": null,
          "text": "Shop Now",
          "thumb_text": ""
        }
      },
      {
        "type": "video",
        "title": "Blonde Wood Cabinets",
        "alt": "Blonde Wood Cabinets",
        "url": "https://vimeo.com/1078017079",
        "start_time": "",
        "thumbnail": "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/e36a1948-617a-48d1-868f-40d322c7efba.gif?ClientID=sulu&Date=1774288585&Signature=3918c32608b1d638b629da030340d3c56b780ec3",
        "scale": 100,
        "title_wrap": false,
        "ratio_override": "",
        "vjust": "top",
        "html_desc": "<p>Put a wood finish over your cabinets has never been easier. Just paint it, stain it and love it. Look at the blond wood finish.</p>",
        "desc_html": null,
        "end_behavior": "next",
        "cta": {
          "href": null,
          "text": "Shop Now",
          "thumb_text": ""
        }
      }
    ]
  }
];

// ✅ MEDIA SET BLOCK (copy this to add/replace just this set):
window.MEDIA_GALLERY_SETS["Cabinets"] = [
  {
    "heading": "<h1><br/><br/>Cabinets</h1>",
    "subheading": "",
    "img_ratio": "4:5",
    "row_height": 0,
    "fit_row": false,
    "collapsed": false,
    "show_more_text": "Show more",
    "show_less_text": "Show less",
    "accordion": false,
    "accordion_title": "",
    "accordion_subheading": "",
    "accordion_title_center": false,
    "accordion_start_open": false,
    "accordion_allow_multiple": false,
    "accordion_bg_color": "#ffffff",
    "accordion_shadow_pct": 8,
    "accordion_group": "",
    "accordion_always_open": false,
    "videos": [
      {
        "type": "video",
        "title": "Thermofoil Cabinets",
        "alt": "Thermofoil Cabinets",
        "url": "https://vimeo.com/1164537276?share=copy&fl=sv&fe=ci",
        "start_time": "",
        "thumbnail": "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/d394259d-83a1-4c5e-97ba-89dba8f32a5d.gif?ClientID=sulu&Date=1771589470&Signature=c10e56c0e8419a6cd5b9268c6caeae870bc7c389",
        "scale": 100,
        "title_wrap": false,
        "ratio_override": "",
        "vjust": "center",
        "html_desc": "",
        "desc_html": null,
        "end_behavior": "next",
        "cta": {
          "href": null,
          "text": "Shop Now",
          "thumb_text": ""
        }
      },
      {
        "type": "video",
        "title": "Orangy Oak Smooth",
        "alt": "Orangy Oak Smooth",
        "url": "https://vimeo.com/1164525010?share=copy&fl=sv&fe=ci",
        "start_time": "",
        "thumbnail": "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/371901d4-ca20-40e6-9918-daf602963ab7.gif?ClientID=sulu&Date=1771589688&Signature=4622307d91edeff0871d2eead5c39c0e0074b120",
        "scale": 100,
        "title_wrap": false,
        "ratio_override": "",
        "vjust": "center",
        "html_desc": "",
        "desc_html": null,
        "end_behavior": "next",
        "cta": {
          "href": null,
          "text": "Shop Now",
          "thumb_text": ""
        }
      },
      {
        "type": "video",
        "title": "From White to Blonde",
        "alt": "From White to Blonde",
        "url": "https://vimeo.com/1166765443?share=copy&fl=sv&fe=ci",
        "start_time": "",
        "thumbnail": "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/589d3544-72cf-41e2-b9f6-0370245663b4.gif?ClientID=sulu&Date=1771613402&Signature=d7b0c400f9b93022602537d7d8811435c2fc85a4",
        "scale": 100,
        "title_wrap": false,
        "ratio_override": "",
        "vjust": "center",
        "html_desc": "",
        "desc_html": null,
        "end_behavior": "next",
        "cta": {
          "href": null,
          "text": "Shop Now",
          "thumb_text": ""
        }
      },
      {
        "type": "video",
        "title": "Laminate Cabinets",
        "alt": "Laminate Cabinets",
        "url": "https://vimeo.com/1164534857",
        "start_time": "",
        "thumbnail": "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/ef0d4a9c-6c6b-4699-88e3-14a2b8331544.gif?ClientID=sulu&Date=1771613686&Signature=b71701c9c5fe7ef98ddc35c08bfc6ce640ad6252",
        "scale": 100,
        "title_wrap": false,
        "ratio_override": "",
        "vjust": "center",
        "html_desc": "",
        "desc_html": null,
        "end_behavior": "next",
        "cta": {
          "href": null,
          "text": "Shop Now",
          "thumb_text": ""
        }
      },
      {
        "type": "video",
        "title": "Orangy Oak, No!",
        "alt": "Orangy Oak, No!",
        "url": "https://vimeo.com/1165036944",
        "start_time": "",
        "thumbnail": "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/c8c5220a-68c4-4749-8a28-e219fc365e7f.gif?ClientID=sulu&Date=1771613560&Signature=ba812a7554a8ab7fc91a5f95fe7de46323c7173b",
        "scale": 100,
        "title_wrap": false,
        "ratio_override": "",
        "vjust": "center",
        "html_desc": "<p>Same stain color… three completely different wood finishes:<br/><br/>✨ Light Wood (white oak feel)<br/>🌊 Bleached Wood (bright + coastal)<br/>🤎 Dark Wood (warm + modern)<br/><br/>And here’s the best part… I used the same stain on all three<br/>Minwax® Jacobean Penetrating Stain (yellow can)…<br/><br/>the Wood’n Primer base coat is what changes the final look.<br/><br/>Retique It® Liquid Wood Coatings Wood’n Primer gives you an authentic wood finish with over 60% wood once dry… made with recycled wood ♻️… and it works on MDF, laminate, metal, plastic… even previously painted cabinets.<br/><br/>Which wood finish would you choose?<br/><a href=\"https://www.instagram.com/reel/DULnDetDul7/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==\" title=\"https://www.instagram.com/reel/DULnDetDul7/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==\">See Instagram Post</a><br/><br/></p>",
        "desc_html": null,
        "end_behavior": "next",
        "cta": {
          "href": null,
          "text": "Shop Now",
          "thumb_text": ""
        }
      },
      {
        "type": "video",
        "title": "Orangy Oak Grained",
        "alt": "Orangy Oak Grained",
        "url": "https://vimeo.com/938294879?share=copy&fl=sv&fe=ci",
        "start_time": "",
        "thumbnail": "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/182de6f8-54a0-47fd-a8ae-c8fd8cd3ec35.gif?ClientID=sulu&Date=1771589825&Signature=3c229504025f7400852122bf03db431201b259ae",
        "scale": 100,
        "title_wrap": false,
        "ratio_override": "",
        "vjust": "center",
        "html_desc": "",
        "desc_html": null,
        "end_behavior": "next",
        "cta": {
          "href": null,
          "text": "Shop Now",
          "thumb_text": ""
        }
      },
      {
        "type": "video",
        "title": "Built-in Cabinets",
        "alt": "Built-in Cabinets",
        "url": "https://vimeo.com/1167113792",
        "start_time": "",
        "thumbnail": "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/df0f38cc-fb02-488a-baa9-c91b78802bd6.gif?ClientID=sulu&Date=1772528037&Signature=6edeaedac9c7b0f539f7331fc2d716e343793f18",
        "scale": 100,
        "title_wrap": false,
        "ratio_override": "",
        "vjust": "center",
        "html_desc": "<p><a href=\"https://www.instagram.com/crafty.custom.home/\" target=\"_blank\">@crafty.custom.home</a> Follow me as I transform these boring grey mudroom built-ins into a gorgeous faux white oak. Trust me, you won’t even be able to tell it’s not real wood. This product is THAT GOOD. <a href=\"https://www.instagram.com/retiqueliquidwood/\" target=\"_blank\">@retiqueliquidwood</a></p>",
        "desc_html": null,
        "end_behavior": "next",
        "cta": {
          "href": null,
          "text": "Shop Now",
          "thumb_text": ""
        }
      },
      {
        "type": "video",
        "title": "Cabinet Makeover",
        "alt": "Cabinet Makeover",
        "url": "https://vimeo.com/1169312746",
        "start_time": "",
        "thumbnail": "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/fcb701c8-b37b-4d55-b3bb-3dff482b3a20.gif?ClientID=sulu&Date=1772377137&Signature=7c4da0d1d31d7b08d2f079fb81044c92f5252e12",
        "scale": 100,
        "title_wrap": false,
        "ratio_override": "",
        "vjust": "center",
        "html_desc": "<p><a href=\"https://www.instagram.com/p/DUUNl4dDgAN/\" target=\"_blank\">@Just.Jenica.DIY</a> gave her kitchen a stunning blonde wood makeover using Retique It’s Light Wood Primer and a regular stain.</p><ul><li>No graining tool needed</li><li>Authentic real wood finish</li><li>Durable and long lasting</li><li>Over 60% real wood</li></ul><p>These cabinets turned out absolutely beautiful.</p>",
        "desc_html": null,
        "end_behavior": "next",
        "cta": {
          "href": null,
          "text": "Shop Now",
          "thumb_text": ""
        }
      }
    ]
  }
];

// ✅ MEDIA SET BLOCK (copy this to add/replace just this set):
window.MEDIA_GALLERY_SETS["Countertops"] = [
  {
    "heading": "<h1>Countertops</h1>",
    "subheading": "",
    "img_ratio": "4:5",
    "row_height": 0,
    "fit_row": false,
    "margin_top": 0,
    "margin_bottom": 0,
    "collapsed": false,
    "show_more_text": "Show more",
    "show_less_text": "Show less",
    "row_toggle_border_style": "solid",
    "accordion": false,
    "accordion_title": "",
    "accordion_subheading": "",
    "accordion_hide_title_when_open": false,
    "accordion_hide_subheading_when_open": false,
    "accordion_title_center": false,
    "accordion_start_open": false,
    "accordion_allow_multiple": false,
    "accordion_bg_color": "#ffffff",
    "accordion_shadow_pct": 8,
    "accordion_shadow_style": "raised",
    "accordion_group": "",
    "accordion_always_open": false,
    "videos": [
      {
        "type": "video",
        "title": "Formica",
        "alt": "Formica",
        "url": "https://vimeo.com/1166928191",
        "start_time": "",
        "thumbnail": "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/45cfff8b-e785-4a85-9751-c3b303ddc984.gif?ClientID=sulu&Date=1771705701&Signature=e9015c30405f3efec2cb83e37233b41d79007e43",
        "scale": 100,
        "title_wrap": false,
        "ratio_override": "",
        "vjust": "center",
        "html_desc": "",
        "desc_html": null,
        "end_behavior": "next",
        "cta": {
          "href": null,
          "text": "Shop Now",
          "thumb_text": ""
        }
      },
      {
        "type": "video",
        "title": "Epoxy / Faux Marble",
        "alt": "Epoxy / Faux Marble",
        "url": "https://vimeo.com/1027855055",
        "start_time": "",
        "thumbnail": "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/3b561090-04ed-4a5f-a017-bee8e0d0ec95.gif?ClientID=sulu&Date=1771610582&Signature=9ed38ab55e71c47286c665ef1ed40ec4d7567b06",
        "scale": 100,
        "title_wrap": false,
        "ratio_override": "",
        "vjust": "center",
        "html_desc": "",
        "desc_html": null,
        "end_behavior": "next",
        "cta": {
          "href": null,
          "text": "Shop Now",
          "thumb_text": ""
        }
      },
      {
        "type": "video",
        "title": "Granite",
        "alt": "Granite",
        "url": "https://vimeo.com/936335265",
        "start_time": "",
        "thumbnail": "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/a1901a3a-971b-4bc4-bac4-2910d42983a0.gif?ClientID=sulu&Date=1771589954&Signature=763e53dc5effcd2340923ae4e958453205ad179e",
        "scale": 100,
        "title_wrap": false,
        "ratio_override": "",
        "vjust": "center",
        "html_desc": "",
        "desc_html": null,
        "end_behavior": "next",
        "cta": {
          "href": null,
          "text": "Shop Now",
          "thumb_text": ""
        }
      },
      {
        "type": "video",
        "title": "Granite Renovation",
        "alt": "Granite Renovation",
        "url": "https://vimeo.com/1169150641",
        "start_time": "",
        "thumbnail": "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/7db3b29b-fec2-40b6-99d5-a5c4984c6b59.gif?ClientID=sulu&Date=1772295772&Signature=1f1cc60a699d1a9f59a256f77eb5c043f7f3b90f",
        "scale": 100,
        "title_wrap": false,
        "ratio_override": "",
        "vjust": "center",
        "html_desc": "",
        "desc_html": null,
        "end_behavior": "next",
        "cta": {
          "href": null,
          "text": "Shop Now",
          "thumb_text": ""
        }
      },
      {
        "type": "video",
        "title": "Faux Butcher Block",
        "alt": "Faux Butcher Block",
        "url": "https://vimeo.com/1169153208",
        "start_time": "",
        "thumbnail": "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/1b9ac7ed-02d5-4cf0-9d5e-d091ba83b34a.gif?ClientID=sulu&Date=1772298430&Signature=3b2bfc49ca308fcc9707fd8ddbaf3e6026008136",
        "scale": 100,
        "title_wrap": false,
        "ratio_override": "",
        "vjust": "center",
        "html_desc": "",
        "desc_html": null,
        "end_behavior": "next",
        "cta": {
          "href": null,
          "text": "Shop Now",
          "thumb_text": ""
        }
      },
      {
        "type": "video",
        "title": "Restaurant Countertop",
        "alt": "Restaurant Countertop",
        "url": "https://vimeo.com/1169157499",
        "start_time": "",
        "thumbnail": "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/8bad3cb4-6dc3-41c7-9845-7c8083384d32.gif?ClientID=sulu&Date=1772298325&Signature=417bc050b0d39d7ed595142b6cdb67db936b023d",
        "scale": 100,
        "title_wrap": false,
        "ratio_override": "",
        "vjust": "center",
        "html_desc": "",
        "desc_html": null,
        "end_behavior": "next",
        "cta": {
          "href": null,
          "text": "Shop Now",
          "thumb_text": ""
        }
      },
      {
        "type": "video",
        "title": "Formica to Butcherblock",
        "alt": "Formica to Butcherblock",
        "url": "https://vimeo.com/1169012174",
        "start_time": "",
        "thumbnail": "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/f348970d-3e83-4049-b98b-9af869912662.gif?ClientID=sulu&Date=1772303730&Signature=b7bfa92d2fbb3e7fddde8b10d9f4c881048a1c45",
        "scale": 100,
        "title_wrap": false,
        "ratio_override": "",
        "vjust": "center",
        "html_desc": "<p><a href=\"https://www.instagram.com/reel/DRuou-QkUb0/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==\" title=\"https://www.instagram.com/reel/DRuou-QkUb0/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==\">@thrifted_byjazz</a><br/>DAY 1: KITCHEN RENOVATION (again)!!!! 👷🏻‍♀️🏠🍳 ft. <a href=\"https://www.instagram.com/retiqueliquidwood/\">@retiqueliquidwood</a></p>",
        "desc_html": null,
        "end_behavior": "next",
        "cta": {
          "href": null,
          "text": "Shop Now",
          "thumb_text": ""
        }
      }
    ]
  }
];
window.MEDIA_GALLERY_SETS["UltimateGuideVideoPopup"] = [
  {
    "heading": "<h1>The Ultimate Guide</h1>",
    "subheading": "<h4>To Wood Graining With Retique It®</h4>",
    "heading_justify": "center",
    "custom_template_id": "mg-custom-template--18637804470406__cmg_media_gallery_hMQUd8-0",
    "custom_html": "<br><br><br>",
    "custom_width_desktop_percent": 100,
    "custom_width_mobile_percent": 100,
    "custom_max_width_px": "0",
    "img_ratio": "1:1",
    "row_height": 0,
    "fit_row": false,
    "margin_top": 0,
    "margin_bottom": 0,
    "collapsed": false,
    "show_more_text": "Show more",
    "show_less_text": "Show less",
    "row_toggle_border_style": "solid",
    "accordion": false,
    "accordion_marker": false,
    "accordion_title": "",
    "accordion_subheading": "",
    "accordion_hide_title_when_open": false,
    "accordion_hide_subheading_when_open": false,
    "accordion_title_center": false,
    "accordion_start_open": false,
    "accordion_allow_multiple": false,
    "accordion_bg_color": "#ffffff",
    "accordion_shadow_pct": 8,
    "accordion_shadow_style": "raised",
    "accordion_width_mobile_percent": 100,
    "accordion_width_desktop_percent": 100,
    "accordion_max_width_px": 0,
    "accordion_group": "",
    "accordion_always_open": false,
    "videos": []
  },
  {
    "heading": "<h1>Kitchen Cabinets</h1>",
    "subheading": "",
    "img_ratio": "1:1",
    "row_height": 0,
    "fit_row": false,
    "margin_top": 0,
    "margin_bottom": 0,
    "collapsed": false,
    "show_more_text": "Show more",
    "show_less_text": "Show less",
    "row_toggle_border_style": "solid",
    "swatch_row": false,
    "row_justify": "center",
    "heading_justify": "center",
    "accordion": false,
    "accordion_title": "",
    "accordion_subheading": "",
    "accordion_hide_title_when_open": false,
    "accordion_hide_subheading_when_open": false,
    "accordion_title_center": false,
    "accordion_start_open": false,
    "accordion_allow_multiple": false,
    "accordion_bg_color": "#ffffff",
    "accordion_shadow_pct": 8,
    "accordion_shadow_style": "raised",
    "accordion_width_mobile_percent": 100,
    "accordion_width_desktop_percent": 100,
    "accordion_max_width_px": 0,
    "accordion_group": "",
    "accordion_always_open": false,
    "videos": [
      {
        "type": "video",
        "hero": true,
        "hero_autoplay_preview": true,
        "hero_show_play_badge": true,
        "hero_show_play_button": true,
        "open_full_video_text": "Watch Full Video",
        "title": "",
        "heading_html": "",
        "subheading_html": "",
        "alt": "",
        "url": "https://vimeo.com/1015855316",
        "start_time": "",
        "thumbnail": "",
        "hero_width_desktop_pct": 0,
        "hero_width_mobile_pct": 96,
        "hero_max_width_desktop_px": 1000,
        "hero_height_desktop_px": 0,
        "hero_height_mobile_px": 0,
        "margin_top": 0,
        "margin_bottom": 50,
        "ratio_override": "16:9",
        "vjust": "center",
        "html_desc": "",
        "desc_html": null,
        "end_behavior": "next",
        "cta": {
          "href": null,
          "text": "Shop Now",
          "thumb_text": ""
        }
      }
    ]
  },
  {
    "heading": "<h1>Kitchen Countertops</h1>",
    "subheading": "",
    "img_ratio": "1:1",
    "row_height": 0,
    "fit_row": false,
    "margin_top": 0,
    "margin_bottom": 0,
    "collapsed": false,
    "show_more_text": "Show more",
    "show_less_text": "Show less",
    "row_toggle_border_style": "solid",
    "swatch_row": false,
    "row_justify": "center",
    "heading_justify": "center",
    "accordion": false,
    "accordion_title": "",
    "accordion_subheading": "",
    "accordion_hide_title_when_open": false,
    "accordion_hide_subheading_when_open": false,
    "accordion_title_center": false,
    "accordion_start_open": false,
    "accordion_allow_multiple": false,
    "accordion_bg_color": "#ffffff",
    "accordion_shadow_pct": 8,
    "accordion_shadow_style": "raised",
    "accordion_width_mobile_percent": 100,
    "accordion_width_desktop_percent": 100,
    "accordion_max_width_px": 0,
    "accordion_group": "",
    "accordion_always_open": false,
    "videos": [
      {
        "type": "video",
        "hero": true,
        "hero_autoplay_preview": true,
        "hero_show_play_badge": true,
        "hero_show_play_button": true,
        "open_full_video_text": "Watch Full Video",
        "title": "",
        "heading_html": "",
        "subheading_html": "",
        "alt": "",
        "url": "https://vimeo.com/1015855921",
        "start_time": "",
        "thumbnail": "",
        "hero_width_desktop_pct": 0,
        "hero_width_mobile_pct": 96,
        "hero_max_width_desktop_px": 1000,
        "hero_height_desktop_px": 0,
        "hero_height_mobile_px": 0,
        "margin_top": 0,
        "margin_bottom": 50,
        "ratio_override": "16:9",
        "vjust": "center",
        "html_desc": "",
        "desc_html": null,
        "end_behavior": "next",
        "cta": {
          "href": null,
          "text": "Shop Now",
          "thumb_text": ""
        }
      }
    ]
  },
  {
    "heading": "<h1>Front Doors</h1>",
    "subheading": "",
    "img_ratio": "1:1",
    "row_height": 0,
    "fit_row": false,
    "margin_top": 0,
    "margin_bottom": 0,
    "collapsed": false,
    "show_more_text": "Show more",
    "show_less_text": "Show less",
    "row_toggle_border_style": "solid",
    "swatch_row": false,
    "row_justify": "center",
    "heading_justify": "center",
    "accordion": false,
    "accordion_title": "",
    "accordion_subheading": "",
    "accordion_hide_title_when_open": false,
    "accordion_hide_subheading_when_open": false,
    "accordion_title_center": false,
    "accordion_start_open": false,
    "accordion_allow_multiple": false,
    "accordion_bg_color": "#ffffff",
    "accordion_shadow_pct": 8,
    "accordion_shadow_style": "raised",
    "accordion_width_mobile_percent": 100,
    "accordion_width_desktop_percent": 100,
    "accordion_max_width_px": 0,
    "accordion_group": "",
    "accordion_always_open": false,
    "videos": [
      {
        "type": "video",
        "hero": true,
        "hero_autoplay_preview": true,
        "hero_show_play_badge": true,
        "hero_show_play_button": true,
        "open_full_video_text": "Watch Full Video",
        "title": "",
        "heading_html": "",
        "subheading_html": "",
        "alt": "",
        "url": "https://vimeo.com/1015856090",
        "start_time": "",
        "thumbnail": "",
        "hero_width_desktop_pct": 0,
        "hero_width_mobile_pct": 96,
        "hero_max_width_desktop_px": 1000,
        "hero_height_desktop_px": 0,
        "hero_height_mobile_px": 0,
        "margin_top": 0,
        "margin_bottom": 0,
        "ratio_override": "16:9",
        "vjust": "center",
        "html_desc": "",
        "desc_html": null,
        "end_behavior": "next",
        "cta": {
          "href": null,
          "text": "Shop Now",
          "thumb_text": ""
        }
      }
    ]
  },
  {
    "heading": "<h1>Fireplace Mantels</h1>",
    "subheading": "",
    "img_ratio": "1:1",
    "row_height": 0,
    "fit_row": false,
    "margin_top": 0,
    "margin_bottom": 0,
    "collapsed": false,
    "show_more_text": "Show more",
    "show_less_text": "Show less",
    "row_toggle_border_style": "solid",
    "swatch_row": false,
    "row_justify": "center",
    "heading_justify": "center",
    "accordion": false,
    "accordion_title": "",
    "accordion_subheading": "",
    "accordion_hide_title_when_open": false,
    "accordion_hide_subheading_when_open": false,
    "accordion_title_center": false,
    "accordion_start_open": false,
    "accordion_allow_multiple": false,
    "accordion_bg_color": "#ffffff",
    "accordion_shadow_pct": 8,
    "accordion_shadow_style": "raised",
    "accordion_width_mobile_percent": 100,
    "accordion_width_desktop_percent": 100,
    "accordion_max_width_px": 0,
    "accordion_group": "",
    "accordion_always_open": false,
    "videos": [
      {
        "type": "video",
        "hero": true,
        "hero_autoplay_preview": true,
        "hero_show_play_badge": true,
        "hero_show_play_button": true,
        "open_full_video_text": "Watch Full Video",
        "title": "",
        "heading_html": "",
        "subheading_html": "",
        "alt": "",
        "url": "https://vimeo.com/1015856258",
        "start_time": "",
        "thumbnail": "",
        "hero_width_desktop_pct": 0,
        "hero_width_mobile_pct": 96,
        "hero_max_width_desktop_px": 1000,
        "hero_height_desktop_px": 0,
        "hero_height_mobile_px": 0,
        "margin_top": 0,
        "margin_bottom": 0,
        "ratio_override": "16:9",
        "vjust": "center",
        "html_desc": "",
        "desc_html": null,
        "end_behavior": "next",
        "cta": {
          "href": null,
          "text": "Shop Now",
          "thumb_text": ""
        }
      }
    ]
  },
  {
    "heading": "",
    "subheading": "",
    "img_ratio": "1:1",
    "row_height": 0,
    "fit_row": false,
    "margin_top": 0,
    "margin_bottom": 0,
    "collapsed": false,
    "show_more_text": "Show more",
    "show_less_text": "Show less",
    "row_toggle_border_style": "solid",
    "swatch_row": false,
    "row_justify": "center",
    "heading_justify": "center",
    "accordion": false,
    "accordion_title": "",
    "accordion_subheading": "",
    "accordion_hide_title_when_open": false,
    "accordion_hide_subheading_when_open": false,
    "accordion_title_center": false,
    "accordion_start_open": false,
    "accordion_allow_multiple": false,
    "accordion_bg_color": "#ffffff",
    "accordion_shadow_pct": 8,
    "accordion_shadow_style": "raised",
    "accordion_width_mobile_percent": 100,
    "accordion_width_desktop_percent": 100,
    "accordion_max_width_px": 0,
    "accordion_group": "",
    "accordion_always_open": false,
    "videos": [
      {
        "type": "product",
        "title": "The Ultimate Guide to Wood Graining with Retique It®",
        "alt": "Digital guide by Retique It® showcasing wood graining techniques and tips for achieving realistic wood finishes.",
        "thumbnail": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/The_Ultimate_Guide.jpg?v=1751986494&width=2000",
        "thumb_mode": "default",
        "product_image_number": 0,
        "product_url": "/products/retique-it-wood-graining-made-simple-a-beginners-video-guide",
        "product_id": 7044752375942,
        "lai_review_count_info": {
          "rate1": 0,
          "rate2": 0,
          "rate3": 0,
          "rate4": 0,
          "rate5": 2,
          "total": 2,
          "average": 5,
          "product_shopify_id": "7044752375942"
        },
        "show_price": true,
        "show_reviews": true,
        "shop_button_cta_type": "below_title",
        "shop_button_style": "theme_default",
        "price": "$79.99",
        "price_num": 79.99,
        "available": true,
        "scale": 100,
        "vjust": "top",
        "html_desc": "",
        "desc_html": "",
        "margin_top": 0,
        "margin_bottom": 0,
        "open_set_key": "",
        "learn_more_text": "Learn More",
        "cta": {
          "href": null,
          "text": "Shop"
        }
      }
    ]
  }
];
window.MEDIA_GALLERY_SETS["Highlighted"] = [
  {
    "heading": "<h1>Highlighted Reels</h1>",
    "subheading": "",
    "img_ratio": "4:5",
    "row_height": 0,
    "fit_row": false,
    "margin_top": 0,
    "margin_bottom": 0,
    "collapsed": false,
    "show_more_text": "Show more",
    "show_less_text": "Show less",
    "row_toggle_border_style": "solid",
    "swatch_row": false,
    "row_justify": "center",
    "heading_justify": "center",
    "accordion": false,
    "accordion_title": "",
    "accordion_subheading": "",
    "accordion_content": "",
    "accordion_hide_title_when_open": false,
    "accordion_hide_subheading_when_open": false,
    "accordion_hide_subheading_when_closed": false,
    "accordion_title_center": false,
    "accordion_start_open": false,
    "accordion_allow_multiple": false,
    "accordion_bg_color": "#ffffff",
    "accordion_shadow_pct": 8,
    "accordion_shadow_style": "raised",
    "accordion_width_mobile_percent": 100,
    "accordion_width_desktop_percent": 100,
    "accordion_max_width_px": 0,
    "accordion_group": "",
    "accordion_always_open": false,
    "videos": [
      {
        "type": "video",
        "title": "Granite Countertops",
        "alt": "Granite Countertops",
        "url": "https://vimeo.com/936335265",
        "start_time": "",
        "thumbnail": "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/a1901a3a-971b-4bc4-bac4-2910d42983a0.gif?ClientID=sulu&Date=1771589954&Signature=763e53dc5effcd2340923ae4e958453205ad179e",
        "scale": 100,
        "title_wrap": false,
        "ratio_override": "",
        "vjust": "center",
        "html_desc": "<p>Over three years later, and Maria’s countertops are still going strong! 💪✨ She transformed her granite into a stunning Dark Oak wood finish using the Retique It Dark Oak Countertop Kit, and she LOVES it. 🍩</p><p>Maria from Heartland Bagels (<a href=\"https://www.instagram.com/maria_heartlandbagels2/\" target=\"_blank\">@maria_heartlandbagels2</a>) is known for her gorgeous custom donuts, but her kitchen is just as sweet! And before the haters jump in—yes, this finish is durable, stainable, and can be removed if desired. But after a year of daily use, she wouldn’t change a thing!</p><p>Would you try this in your kitchen? 👀 </p>",
        "desc_html": null,
        "end_behavior": "next",
        "cta": {
          "href": "https://retique.com/products/countertopkit_dark-oak_l_tripletique",
          "text": "Shop Now",
          "thumb_text": "Shop Now"
        }
      },
      {
        "type": "video",
        "title": "Built-in Cabinets",
        "alt": "Built-in Cabinets",
        "url": "https://vimeo.com/1167113792",
        "start_time": "",
        "thumbnail": "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/df0f38cc-fb02-488a-baa9-c91b78802bd6.gif?ClientID=sulu&Date=1772020058&Signature=c59d096f5e6beb9dc228e377e604544211677d96",
        "scale": 100,
        "title_wrap": false,
        "ratio_override": "",
        "vjust": "center",
        "html_desc": "<p><a href=\"https://www.instagram.com/crafty.custom.home/\" target=\"_blank\">@crafty.custom.home</a> Follow me as I transform these boring grey mudroom built-ins into a gorgeous faux white oak. Trust me, you won’t even be able to tell it’s not real wood. This product is THAT GOOD. <a href=\"https://www.instagram.com/retiqueliquidwood/\" target=\"_blank\">@retiqueliquidwood</a></p>",
        "desc_html": null,
        "end_behavior": "next",
        "cta": {
          "href": "https://retique.com/products/cabinetkitsmooth_white-oak_m",
          "text": "Shop Now",
          "thumb_text": "Shop Now"
        }
      },
      {
        "type": "video",
        "title": "17 Steel Doors",
        "alt": "17 Steel Doors",
        "url": "https://vimeo.com/937062372",
        "start_time": "",
        "thumbnail": "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/187fee14-ed90-4ae2-9010-9eec0c1e066b.gif?ClientID=sulu&Date=1771589265&Signature=d365690adeef55e22c4c071e43bb101fc61b4d2c",
        "scale": 100,
        "title_wrap": false,
        "ratio_override": "",
        "vjust": "center",
        "html_desc": "<p>This country church wanted to ditch the boring steel doors and give them a stunning, custom, weathered wood look—and we made it happen with the Retique It® Weathered Wood Door Kit! 🔥</p><p>✨ How we did it:</p><p>✅ Two coats of Light Wood Wood’n Primer as the base</p><p>✅ Stained with Weathered Wood Wood’n Stain for rich, brownish-gray undertones 🌾</p><p>✅ Applied another coat of Light Wood Wood’n Primer and, while STILL WET, swiped the graining tool for that real wood grain effect 🔄</p><p>✅ Final stain coat with Weathered Wood gel stain alternative for that perfect rustic, high-end finish</p><p>💯 This authentic wood finish contains over 60% recycled wood and works on almost ANY surface! Doors, decks, garages, furniture, countertops, cabinets—you name it! Interior & exterior projects? Covered. 💪<br/><br/><a href=\"https://www.instagram.com/retiqueliquidwood?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==\" target=\"_blank\"><strong>Original Instagram Reel</strong></a></p>",
        "desc_html": null,
        "end_behavior": "next",
        "cta": {
          "href": "https://retique.com/products/doorkit_weathered-wood_m",
          "text": "Shop Now",
          "thumb_text": "Shop Now"
        }
      },
      {
        "type": "video",
        "title": "Over Wood Filler",
        "alt": "Over Wood Filler",
        "url": "https://vimeo.com/1166930164",
        "start_time": "",
        "thumbnail": "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/966d2753-3aed-4a84-b262-9c5a94d20af2.gif?ClientID=sulu&Date=1771764333&Signature=07a6a7e1bcde887456c07b2ff2c34576ecf0ea29",
        "scale": 100,
        "title_wrap": false,
        "ratio_override": "",
        "vjust": "center",
        "html_desc": "",
        "desc_html": null,
        "end_behavior": "next",
        "cta": {
          "href": "https://retique.com/products/smoothfinish_pecan_l",
          "text": "Shop Now",
          "thumb_text": "Shop Now"
        }
      },
      {
        "type": "video",
        "title": "Railings",
        "alt": "Railings",
        "url": "https://vimeo.com/1169833148",
        "start_time": "",
        "thumbnail": "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/cab3795d-a1be-4b55-b741-6df4e7b61aa4.gif?ClientID=sulu&Date=1772526305&Signature=ccc559821e6b4918c57de6af5a4ec8694052fb15",
        "scale": 100,
        "title_wrap": false,
        "ratio_override": "",
        "vjust": "center",
        "html_desc": "<p><a href=\"https://www.instagram.com/reel/DDW1LrupVn0/?utm_source=ig_web_copy_link&igsh=NTc4MTIwNjQ2YQ==\" target=\"_blank\">@wazhomedecor</a> BIG Staircase REVEAL!! And there was NO SANDING!! I can’t believe the new MODERN look to my staircase with liquid wood! </p><p>Be sure to check out all of <a href=\"https://www.instagram.com/retiqueliquidwood?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==\" target=\"_blank\">@retiqueliquidwood</a> stain choices. The options are endless! </p><p>I used Retique It Wood n Primer on everything. Two coats on the railing and one on the spindles. I then used Wood n Stain Barnwood and a paint brush to give the railing the streak look. For the spindles, I used a black gel. Finished everything with a coat of matte sealer. </p><p>What do you think?</p>",
        "desc_html": null,
        "end_behavior": "next",
        "cta": {
          "href": "https://retique.com/products/woodnfinish_pickled-oak_l",
          "text": "Shop Now",
          "thumb_text": "Shop Now"
        }
      },
      {
        "type": "video",
        "title": "Thermofoil Cabinets",
        "alt": "Thermofoil Cabinets",
        "url": "https://vimeo.com/1164537276?share=copy&fl=sv&fe=ci",
        "start_time": "",
        "thumbnail": "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/d394259d-83a1-4c5e-97ba-89dba8f32a5d.gif?ClientID=sulu&Date=1771589470&Signature=c10e56c0e8419a6cd5b9268c6caeae870bc7c389",
        "scale": 100,
        "title_wrap": false,
        "ratio_override": "",
        "vjust": "center",
        "html_desc": "",
        "desc_html": null,
        "end_behavior": "next",
        "cta": {
          "href": "https://retique.com/products/woodn-primer?variant=39283645513862",
          "text": "Shop Now",
          "thumb_text": "Shop Now"
        }
      },
      {
        "type": "video",
        "title": "Fireplace Mantel",
        "alt": "Fireplace Mantel",
        "url": "https://vimeo.com/1166929647",
        "start_time": "",
        "thumbnail": "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/6219db73-84ba-4303-aa8d-3785fe26c57f.gif?ClientID=sulu&Date=1771613219&Signature=37d52902e28ddc2b529120e287739346cad76735",
        "scale": 100,
        "title_wrap": false,
        "ratio_override": "",
        "vjust": "center",
        "html_desc": "",
        "desc_html": null,
        "end_behavior": "next",
        "cta": {
          "href": "https://retique.com/products/fireplacekit_barn-wood_m",
          "text": "Shop Now",
          "thumb_text": "Shop Now"
        }
      },
      {
        "type": "video",
        "title": "Veneer",
        "alt": "Veneer",
        "url": "https://vimeo.com/1164848422",
        "start_time": "",
        "thumbnail": "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/acaf1756-02b8-475e-b22c-805a24d6fc8f.gif?ClientID=sulu&Date=1771610285&Signature=8e7195afe6a38c4ec0d674f434c763921ab09660",
        "scale": 100,
        "title_wrap": false,
        "ratio_override": "",
        "vjust": "center",
        "html_desc": "<p><a href=\"https://www.instagram.com/reel/DPEKZnHDhi1/?utm_source=ig_web_copy_link&igsh=NTc4MTIwNjQ2YQ==\" title=\"https://www.instagram.com/reel/DPEKZnHDhi1/?utm_source=ig_web_copy_link&igsh=NTc4MTIwNjQ2YQ==\">@retiqueliquidwood</a> You know you are a DIY addict when a beach view is not enough… you just have to fix the furniture too 😅<br/><br/>This table was peeling, bubbling, and not even real wood. I asked the owner if I could redo it and the transformation is absolutely stunning 🪵💛<br/><br/>I used the Retique It Sun Bleach Kit to put a fresh coat of wood on it. It delivers an authentic wood finish with over 60 percent real wood and makes any surface look amazing.<br/><br/>Comment Beach and I will DM you the step-by-step instructions for this makeover, the Sun Bleach Kit I used, our free fall guide, and details about the gorgeous Spaggia Beach House in Destin 🏖️<br/><br/></p>",
        "desc_html": null,
        "end_behavior": "next",
        "cta": {
          "href": "https://retique.com/products/tabletopkit_white-wash_m_tripletique",
          "text": "Shop Now",
          "thumb_text": "Shop Now"
        }
      },
      {
        "type": "video",
        "title": "Stairs",
        "alt": "Stairs",
        "url": "https://vimeo.com/935130237",
        "start_time": "",
        "thumbnail": "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/84dd7725-270c-4d26-a214-c09f149466a2.gif?ClientID=sulu&Date=1771590112&Signature=6e4860d1704df8e4fd70cf2d90a87da743e23c9b",
        "scale": 100,
        "title_wrap": false,
        "ratio_override": "",
        "vjust": "center",
        "html_desc": "",
        "desc_html": null,
        "end_behavior": "next",
        "cta": {
          "href": "/products/woodnfinish_pickled-oak_l",
          "text": "Shop Now",
          "thumb_text": "Shop Now"
        }
      },
      {
        "type": "video",
        "title": "Prosthetic Leg",
        "alt": "Prosthetic Leg",
        "url": "https://vimeo.com/1168999275",
        "start_time": "",
        "thumbnail": "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/a4993a55-65b7-4984-85a9-c5acc756014d.gif?ClientID=sulu&Date=1772232314&Signature=30b8042b5c539f43fc4457304a3f08f9627f3d85",
        "scale": 100,
        "title_wrap": false,
        "ratio_override": "",
        "vjust": "center",
        "html_desc": "<p>His wife wanted to see what Retique It could do… and he wasn’t convinced.<br/><br/>Then he watched us apply our Liquid Wood coating and create a real wood finish right in front of him.<br/><br/>By the end of the demo at Orgill Orlando, he asked us to turn his prosthetic into Black Walnut.<br/><br/>From skeptic → believer.<br/><br/>Now they’re bringing Retique It into their store.<br/>It’s always about the people. 🤎</p><p><a href=\"https://www.instagram.com/reel/DU4P0vsjre8/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==\" title=\"https://www.instagram.com/reel/DU4P0vsjre8/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==\">Original Instagram Reel</a><br/><br/></p>",
        "desc_html": null,
        "end_behavior": "next",
        "cta": {
          "href": null,
          "text": "Shop Now",
          "thumb_text": ""
        }
      },
      {
        "type": "video",
        "title": "You can do this",
        "alt": "You can do this",
        "url": "https://vimeo.com/1169004909",
        "start_time": "",
        "thumbnail": "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/fcdd5b78-db86-463c-b4f2-1a995e40d24a.gif?ClientID=sulu&Date=1772233630&Signature=8ae775775b25cf0a69cee145902806f52205057b",
        "scale": 100,
        "title_wrap": false,
        "ratio_override": "",
        "vjust": "center",
        "html_desc": "<p>First time wood graining… and look what they created 👀🪵<br/><br/>Retique It is a real wood finish coating that you can paint, stain, and grain for beautiful texture and depth.<br/><br/>Would you try this?<br/><a href=\"https://www.instagram.com/reel/DUwlb5LDlDV/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==\" title=\"https://www.instagram.com/reel/DUwlb5LDlDV/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==\">@retiqueliquidwood Instagram Post</a></p>",
        "desc_html": null,
        "end_behavior": "next",
        "cta": {
          "href": null,
          "text": "Shop Now",
          "thumb_text": ""
        }
      }
    ]
  }
];



// ✅ MEDIA SET BLOCK (copy this to add/replace just this set):
window.MEDIA_GALLERY_SETS["Tabletops"] = [
  {
    "heading": "<h1><strong>Tabletops</strong></h1>",
    "subheading": "",
    "img_ratio": "4:5",
    "row_height": 0,
    "fit_row": false,
    "margin_top": 0,
    "margin_bottom": 0,
    "collapsed": false,
    "show_more_text": "Show more",
    "show_less_text": "Show less",
    "row_toggle_border_style": "solid",
    "accordion": false,
    "accordion_title": "",
    "accordion_subheading": "",
    "accordion_hide_title_when_open": false,
    "accordion_hide_subheading_when_open": false,
    "accordion_title_center": false,
    "accordion_start_open": false,
    "accordion_allow_multiple": false,
    "accordion_bg_color": "#ffffff",
    "accordion_shadow_pct": 8,
    "accordion_shadow_style": "raised",
    "accordion_group": "",
    "accordion_always_open": false,
    "videos": [
      {
        "type": "video",
        "title": "Damaged Veneer Table",
        "alt": "Damaged Veneer Table",
        "url": "https://vimeo.com/1164848422",
        "start_time": "",
        "thumbnail": "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/acaf1756-02b8-475e-b22c-805a24d6fc8f.gif?ClientID=sulu&Date=1771610285&Signature=8e7195afe6a38c4ec0d674f434c763921ab09660",
        "scale": 100,
        "title_wrap": false,
        "ratio_override": "",
        "vjust": "center",
        "html_desc": "<p>You know you are a DIY addict when a beach view is not enough… you just have to fix the furniture too 😅</p><p>This table was peeling, bubbling, and not even real wood. I asked the owner if I could redo it and the transformation is absolutely stunning 🪵💛</p><p>I used the Retique It Sun Bleach Kit to put a fresh coat of wood on it. It delivers an authentic wood finish with over 60 percent real wood and makes any surface look amazing.</p><p>Comment Beach and I will DM you the step-by-step instructions for this makeover, the Sun Bleach Kit I used, our free fall guide, and details about the gorgeous Spaggia Beach House in Destin 🏖️</p><p><a href=\"https://www.instagram.com/reel/DPEKZnHDhi1/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==\" target=\"_blank\">Original Instagram Post @retiqueliquidwood</a></p>",
        "desc_html": null,
        "end_behavior": "next",
        "cta": {
          "href": null,
          "text": "Shop Now",
          "thumb_text": ""
        }
      },
      {
        "type": "video",
        "title": "Sun Bleached Table",
        "alt": "Sun Bleached Table",
        "url": "https://vimeo.com/1169838475",
        "start_time": "",
        "thumbnail": "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/9f434628-68db-457a-8f2f-c82c09958c05.gif?ClientID=sulu&Date=1772527703&Signature=8dfab77c7c94352d125ead15ecca68951f22d15a",
        "scale": 100,
        "title_wrap": false,
        "ratio_override": "",
        "vjust": "center",
        "html_desc": "<p><a href=\"https://www.instagram.com/reel/C8fCYW3xMxg/?utm_source=ig_web_copy_link&igsh=NTc4MTIwNjQ2YQ==\" target=\"_blank\">@retiqueliquidwood</a>Introducing our new Sun Bleached Wood Finish Kit—a journey into tranquility and DIY therapy. </p><p>Watch as ordinary furniture undergoes a serene transformation, bringing a sense of calm and accomplishment to your space. 🌞🪵✨<br/><br/></p>",
        "desc_html": null,
        "end_behavior": "next",
        "cta": {
          "href": null,
          "text": "Shop Now",
          "thumb_text": ""
        }
      },
      {
        "type": "video",
        "title": "Pickled Oak Table",
        "alt": "Pickled Oak Table",
        "url": "https://vimeo.com/876696735",
        "start_time": "",
        "thumbnail": "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/41f2b246-9203-43b6-bce7-c5685ea9fdf9.gif?ClientID=sulu&Date=1772303915&Signature=7c2b8965ff9f6346e15d50e5563988a0aa7ab95e",
        "scale": 100,
        "title_wrap": false,
        "ratio_override": "",
        "vjust": "center",
        "html_desc": "<p><a href=\"https://www.instagram.com/reel/CykBIjzAxTF/?utm_source=ig_web_copy_link&igsh=NTc4MTIwNjQ2YQ==\" target=\"_blank\">@retiqueliquidwood</a> Retique It's Pickled Oak Kit is trending for Fall this year. 🍁🍂</p><p>Your kit comes with everything you need, including our patented Liquid Wood coatings that contain over 60% recycled ♻️ wood fibers!</p>",
        "desc_html": null,
        "end_behavior": "next",
        "cta": {
          "href": null,
          "text": "Shop Now",
          "thumb_text": ""
        }
      },
      {
        "type": "video",
        "title": "Black Walnut Table",
        "alt": "Black Walnut Table",
        "url": "https://vimeo.com/1169173004",
        "start_time": "",
        "thumbnail": "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/46ed9fdd-3658-4f34-9f64-13d29388f76d.gif?ClientID=sulu&Date=1772304484&Signature=03dd735dbbe9bbcaacb4d656fd284a37aa9b40e2",
        "scale": 100,
        "title_wrap": false,
        "ratio_override": "",
        "vjust": "center",
        "html_desc": "",
        "desc_html": null,
        "end_behavior": "next",
        "cta": {
          "href": null,
          "text": "Shop Now",
          "thumb_text": ""
        }
      },
      {
        "type": "video",
        "title": "Pickled Oak/Barn Wood",
        "alt": "Pickled Oak/Barn Wood",
        "url": "https://vimeo.com/1169173545",
        "start_time": "",
        "thumbnail": "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/21c378f8-72df-4db0-9770-4fe02654a3d6.gif?ClientID=sulu&Date=1772457067&Signature=a19e62cbfc5965196733658499871da90b641ab8",
        "scale": 100,
        "title_wrap": false,
        "ratio_override": "",
        "vjust": "center",
        "html_desc": "<p><a href=\"https://www.instagram.com/reel/CzUi1GjRxYc/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==\" target=\"_blank\">@retiqueliquidwood</a> Added the Retique It Barn Wood Gel Stain Alternative after using the Pickled Oak kit.</p><p>I also used Retique It Midnight Black for the legs and apron. Hope you enjoyed this transformation!🥰</p>",
        "desc_html": null,
        "end_behavior": "next",
        "cta": {
          "href": null,
          "text": "Shop Now",
          "thumb_text": ""
        }
      },
      {
        "type": "video",
        "title": "Dark Finish Table",
        "alt": "Dark Finish Table",
        "url": "https://vimeo.com/1169320470",
        "start_time": "",
        "thumbnail": "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/d9bc594d-8a00-4927-afa5-4499fa9d8a75.gif?ClientID=sulu&Date=1772380183&Signature=d0e34624c3941b8857a17e16362413aecfe7c1ed",
        "scale": 100,
        "title_wrap": false,
        "ratio_override": "",
        "vjust": "center",
        "html_desc": "<p><a href=\"https://www.instagram.com/reel/DSN2L3SEfQq/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==\" target=\"_blank\">@lizzy_lud</a> Just in time for the holidays! 🤎🎄🪵</p><p><a href=\"https://www.instagram.com/retiqueliquidwood/\" target=\"_blank\">@retiqueliquidwood</a> strikes again! Our dining room table has been “worn in” by our three littles and now it’s been given new life. I sanded, primed, painted (+ used the graining tool) with liquid wood, then I stained.</p><p><br/></p><p>We can’t wait to use this beautiful table on Christmas! And speaking of- Merry Christmas and happy everything to all! May your table be overflowing with loved ones and special moments this holiday season. Cheers! 🍷</p><p><br/></p><p>Comment “Table” for a list of products used! As always, thanks for being here! https://liketk.it/5FHU0</p>",
        "desc_html": null,
        "end_behavior": "next",
        "cta": {
          "href": null,
          "text": "Shop Now",
          "thumb_text": ""
        }
      },
      {
        "type": "video",
        "title": "French Oak Table",
        "alt": "French Oak Table",
        "url": "https://vimeo.com/1169848390",
        "start_time": "",
        "thumbnail": "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/0680d3a8-0fc7-407f-9b17-518ecf9eaa69.gif?ClientID=sulu&Date=1772530266&Signature=8f65571041aef899d158e8c30a9cefb309983840",
        "scale": 100,
        "title_wrap": false,
        "ratio_override": "",
        "vjust": "center",
        "html_desc": "<p><a href=\"https://www.instagram.com/reel/CtAVyD2OUxk/?utm_source=ig_web_copy_link&igsh=NTc4MTIwNjQ2YQ==\" target=\"_blank\">@retiqueliquidwood</a> This is seriously the longest tabletop I've ever redone! I finished it before dinner, too! </p><p>✨️Special thanks to @rachellillardrealtor for helping us share this awesome tabletop transformation </p><p>We used the Retique It French Oak Tabletop kit to give this table a gorgeous, lighter, beachy wood finish.</p><p>Remembered that Retique It Kits come with everything you need to transform almost any solid surface in your home . . .even works on exterior projects as well.</p><p>Retique It Liquid Wood coatings contain over 60% recycled wood fibers.  So you're actually applying a layer of real wood to the surface, and it's Stainable and Sustainable. . . . No VOCs, too.</p>",
        "desc_html": null,
        "end_behavior": "next",
        "cta": {
          "href": null,
          "text": "Shop Now",
          "thumb_text": ""
        }
      },
      {
        "type": "video",
        "title": "Grain Direction Change",
        "alt": "Grain Direction Change",
        "url": "https://vimeo.com/1169310692",
        "start_time": "",
        "thumbnail": "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/f94e5fe2-3b35-4eed-98d1-f523b3f1651f.gif?ClientID=sulu&Date=1772376250&Signature=03465b6f28628af174b0c82149c3a946a5cceb20",
        "scale": 100,
        "title_wrap": false,
        "ratio_override": "",
        "vjust": "center",
        "html_desc": "<p><a href=\"https://www.instagram.com/reel/DT8DwKZjqvB/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==\" target=\"_blank\">@julie.urwin.home</a> Old table, new grain direction. 🪵🔄Custom grain change + warm tones to match the chairs—modern twist achieved!</p><p>Then vs now: 5 years ago, days of heavy sanding from black to light stain (never satisfied).</p><p>Now: Just a light sand + Retique It (no stripping drama). Much easier way to real, stainable wood.</p><p>What do you think—love the easier method? Who’s trying Retique It next?</p>",
        "desc_html": null,
        "end_behavior": "next",
        "cta": {
          "href": null,
          "text": "Shop Now",
          "thumb_text": ""
        }
      },
      {
        "type": "video",
        "title": "Grained Wood Chairs",
        "alt": "Grained Wood Chairs",
        "url": "https://vimeo.com/1169314158",
        "start_time": "",
        "thumbnail": "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/a683865b-4edd-4ff3-ab1c-0c282008c68e.gif?ClientID=sulu&Date=1772377730&Signature=c094db091aaf185f659fa399155cba6eec2f9cfe",
        "scale": 100,
        "title_wrap": false,
        "ratio_override": "",
        "vjust": "center",
        "html_desc": "<p><a href=\"https://www.instagram.com/reel/DT0OtgLjuNU/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==\" target=\"_blank\">@julie.urwin.home</a> Reviving these tired white chairs back to beautiful natural wood! 🙌 After my bench glow-up, I couldn’t resist matching the set.</p><p>Step 1: Retique It Liquid Wood – turns any painted surface into real, stainable wood (no stripping or sanding needed!).</p><p>Step 2: Minwax Weathered Oak stain for that warm, aged tone.</p><p>Step 3: White wash to soften and highlight the grain. Yes, that’s an old broom 🧹 on the white chairs! 🤣. The 2 chairs with black-stained legs blended right in with the bench using the same graining tool - now it’s a cohesive crew!</p><p>Obsessed with how the weathered oak + white wash gives that rustic-yet-refined vibe.</p><p>Are you inspired to try <a href=\"https://www.instagram.com/retiqueliquidwood/\" target=\"_blank\">@retiqueliquidwood</a> ?</p>",
        "desc_html": null,
        "end_behavior": "next",
        "cta": {
          "href": null,
          "text": "Shop Now",
          "thumb_text": ""
        }
      },
      {
        "type": "video",
        "title": "Table Bench",
        "alt": "Table Bench",
        "url": "https://vimeo.com/1169320698",
        "start_time": "",
        "thumbnail": "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/cd90185a-7e29-48a9-b530-8463eeeacd77.gif?ClientID=sulu&Date=1772391066&Signature=23d68a35d1e02377f1bea7501cb056d6f1078e13",
        "scale": 100,
        "title_wrap": false,
        "ratio_override": "",
        "vjust": "center",
        "html_desc": "<p><a href=\"https://www.instagram.com/reel/DTvuuSFEb3b/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==\" target=\"_blank\">@lizzy_lud_</a> This bench was looking so blah… until <a href=\"https://www.instagram.com/retiqueliquidwood/\" target=\"_blank\">@retiqueliquidwood</a> turned it into a showstopper! Real wood fibers for authentic grain, one coat, quick dry, stain for depth—zero hassle! 💫 old bench - flip win! Table and chairs glow-up next? Would you try this? Comment below 👇</p>",
        "desc_html": null,
        "end_behavior": "next",
        "cta": {
          "href": null,
          "text": "Shop Now",
          "thumb_text": ""
        }
      },
      {
        "type": "video",
        "title": "White Wash Table",
        "alt": "White Wash Table",
        "url": "https://vimeo.com/1169005825",
        "start_time": "",
        "thumbnail": "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/fb2b38d0-8c4e-4c6a-88f6-47dc4d3e8f83.gif?ClientID=sulu&Date=1772401928&Signature=a5374eeed7021f12c2a70d1e4e300bb5497814df",
        "scale": 100,
        "title_wrap": false,
        "ratio_override": "",
        "vjust": "center",
        "html_desc": "<p>This table was tired… now it’s ready to party. 🥳</p><p>I used the White Wash Grain Finish Kit by Retique It—an all-in-one kit with everything you need (even the brush and graining tool).</p><p>Two coats of Light Wood’n Primer, grained and brushed on White Wash Wood’n Stain, then sealed with White Wash Gel Stain Alternative. Done in a day!</p><p>Want the exact kit I used? Just type “White Wash” below and we’ll DM you the link + a free Spring Guide with inspo and tips. Perfect for tables, patios, even exterior projects!</p><p><a href=\"https://www.instagram.com/reel/DJ5ZBBUu6r-/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==\" target=\"_blank\">Original Instagram Post @retiqueliquidwood</a></p>",
        "desc_html": null,
        "end_behavior": "next",
        "cta": {
          "href": null,
          "text": "Shop Now",
          "thumb_text": ""
        }
      }
    ]
  }
];

// ✅ MEDIA SET BLOCK (copy this to add/replace just this set):
window.MEDIA_GALLERY_SETS["Doors"] = [
  {
    "heading": "<h1>Doors</h1>",
    "subheading": "",
    "img_ratio": "4:5",
    "row_height": 0,
    "fit_row": false,
    "margin_top": 0,
    "margin_bottom": 60,
    "collapsed": false,
    "show_more_text": "Show more",
    "show_less_text": "Show less",
    "row_toggle_border_style": "solid",
    "accordion": false,
    "accordion_title": "",
    "accordion_subheading": "",
    "accordion_hide_title_when_open": false,
    "accordion_hide_subheading_when_open": false,
    "accordion_title_center": false,
    "accordion_start_open": false,
    "accordion_allow_multiple": false,
    "accordion_bg_color": "#ffffff",
    "accordion_shadow_pct": 8,
    "accordion_shadow_style": "raised",
    "accordion_group": "",
    "accordion_always_open": false,
    "videos": [
      {
        "type": "video",
        "title": "17 Steel Doors",
        "alt": "17 Steel Doors",
        "url": "https://vimeo.com/937062372",
        "start_time": "",
        "thumbnail": "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/187fee14-ed90-4ae2-9010-9eec0c1e066b.gif?ClientID=sulu&Date=1772400180&Signature=7bcebc590fce92de86e19f6940415253bc371bd6",
        "scale": 100,
        "title_wrap": false,
        "ratio_override": "",
        "vjust": "center",
        "html_desc": "<p>This country church wanted to ditch the boring steel doors and give them a stunning, custom, weathered wood look—and we made it happen with the Retique It® Weathered Wood Door Kit! 🔥</p><p>✨ How we did it:</p><p>✅ Two coats of Light Wood Wood’n Primer as the base</p><p>✅ Stained with Weathered Wood Wood’n Stain for rich, brownish-gray undertones 🌾</p><p>✅ Applied another coat of Light Wood Wood’n Primer and, while STILL WET, swiped the graining tool for that real wood grain effect 🔄</p><p>✅ Final stain coat with Weathered Wood gel stain alternative for that perfect rustic, high-end finish</p><p>💯 This authentic wood finish contains over 60% recycled wood and works on almost ANY surface! Doors, decks, garages, furniture, countertops, cabinets—you name it! Interior & exterior projects? Covered. 💪<br/><br/><a href=\"https://www.instagram.com/retiqueliquidwood?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==\" target=\"_blank\"><strong>Original Instagram Reel</strong></a></p>",
        "desc_html": null,
        "end_behavior": "next",
        "cta": {
          "href": null,
          "text": "Shop Now",
          "thumb_text": ""
        }
      },
      {
        "type": "video",
        "title": "Front Door Tutorial",
        "alt": "Front Door Tutorial",
        "url": "https://vimeo.com/1169316413",
        "start_time": "",
        "thumbnail": "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/e7744c35-0372-47f2-b265-ea6944580c94.gif?ClientID=sulu&Date=1772379747&Signature=f7712f79b1296a084fb1431355ae2b331fc6ba11",
        "scale": 100,
        "title_wrap": false,
        "ratio_override": "",
        "vjust": "center",
        "html_desc": "<p><a href=\"https://www.instagram.com/reel/DUD7ZjMDSEp/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==\" target=\"_blank\">@safarinatalia</a> okay, here it is 😮‍💨</p><p>the full front door tutorial, start to finish.</p><p>This project took A LOT of trial and error, so I cut this down to the most important steps and everything I learned while taking my front door from black to a wood finish without replacing it....and for under $200. 👏🏽</p><p>If you’re even thinking about doing this, save this for later 🤎</p><p><br/></p><p>home decor, home decor ideas, interior styling, interior design inspiration, cozy home, lived in home, warm neutral home, modern organic home, timeless interiors, home inspiration, diy home projects, diy tutorial, beginner diy, affordable diy, budget friendly home, weekend diy, front door makeover, front door diy, wood finish diy, faux wood door, liquid wood, retique it liquid wood, before and after home, home upgrades, home improvement, entryway inspiration, home exterior, home decor mom, mom creator, working from home mom, home creator, diy creator, content creator life, filming at home, everyday luxury, elevated home on a budget, intentional living, cozy lifestyle, design you can afford</p>",
        "desc_html": null,
        "end_behavior": "next",
        "cta": {
          "href": null,
          "text": "Shop Now",
          "thumb_text": ""
        }
      },
      {
        "type": "video",
        "title": "Front Door Makeover",
        "alt": "Front Door Makeover",
        "url": "https://vimeo.com/1169356084",
        "start_time": "",
        "thumbnail": "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/4f37f73d-13e1-4b8b-bd09-b549da23e01e.gif?ClientID=sulu&Date=1772394048&Signature=d1907854863d1fb8b94527a7729671dce8726126",
        "scale": 100,
        "title_wrap": false,
        "ratio_override": "",
        "vjust": "center",
        "html_desc": "<p>@<strong>marian.designerstouch </strong>I did this project over a few days. I love how it turned out so much! Everyone thinks I got a beautiful new wood door. I can’t say enough good things about Retique It liquid wood. The product was so forgiving and easy to work with.</p>",
        "desc_html": null,
        "end_behavior": "next",
        "cta": {
          "href": null,
          "text": "Shop Now",
          "thumb_text": ""
        }
      },
      {
        "type": "video",
        "title": "Garage Door",
        "alt": "Garage Door",
        "url": "https://vimeo.com/1169357623",
        "start_time": "",
        "thumbnail": "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/ae54036f-4cc6-4495-af9f-5a690410c591.gif?ClientID=sulu&Date=1772394023&Signature=11c32642ccc7f54f34a7a3ece1169f35ab4331ee",
        "scale": 100,
        "title_wrap": false,
        "ratio_override": "",
        "vjust": "center",
        "html_desc": "<p><a href=\"https://www.instagram.com/reel/Cl1wJfcJTMM/?utm_source=ig_web_copy_link&igsh=NTc4MTIwNjQ2YQ==\" target=\"_blank\">@abby_roadhome</a> I refaced my garage doors!! I LOVE the look of custom wooden garage doors but NOT the price.  I set out on a mission to create the look for less by making my own faux wood magnetic panels! I absolutely love the way they turned out!!! At about $300 per door, I think this was a DIY win! Full tutorial and product links are in my bio and story highlights. 🧡<br/><br/></p>",
        "desc_html": null,
        "end_behavior": "next",
        "cta": {
          "href": null,
          "text": "Shop Now",
          "thumb_text": ""
        }
      },
      {
        "type": "video",
        "title": "Weathered Technique",
        "alt": "Weathered Technique",
        "url": "https://vimeo.com/1169852011",
        "start_time": "",
        "thumbnail": "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/852225a7-013b-404c-b5b2-5f746bd8f85e.gif?ClientID=sulu&Date=1772531203&Signature=45d4bc3bf2367873b641273a44423c2aa3224686",
        "scale": 100,
        "title_wrap": false,
        "ratio_override": "",
        "vjust": "center",
        "html_desc": "<p><a href=\"https://www.instagram.com/reel/DN5kt5TDm3-/?utm_source=ig_web_copy_link&igsh=NTc4MTIwNjQ2YQ==\" target=\"_blank\">@retiqueliquidwood</a> From plain white ➝ soft weathered wood grain ✨</p><p>The weathered technique adds a lighter grain under the dark finish for that subtle, authentic look.</p><p>Retique It gives you an authentic wood finish with over 60% recycled wood. ♻️</p><p>Not too rustic. Not too dark. Just right.</p>",
        "desc_html": null,
        "end_behavior": "next",
        "cta": {
          "href": null,
          "text": "Shop Now",
          "thumb_text": ""
        }
      },
      {
        "type": "video",
        "title": "Barn Wood Front Door",
        "alt": "Barn Wood Front Door",
        "url": null,
        "start_time": "",
        "thumbnail": "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/b153a90c-b973-412b-951f-07405f93ec49.gif?ClientID=sulu&Date=1772402382&Signature=cf3ae9e3ca3e68f072f466d5808670e0ffccd337",
        "scale": 100,
        "title_wrap": false,
        "ratio_override": "",
        "vjust": "center",
        "html_desc": "<p><a href=\"https://www.instagram.com/reel/DJ__hDJtJy-/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==\" target=\"_blank\">@megandauphinee.living</a> I saved $5,000 by using @retiqueliquidwood on my front door 🤯</p><p>Does it look like real wood to you?</p><p>Would you try it??</p><p>Comment RETIQUE IT and I’ll send you my detailed blog post on all the steps to this project with links! 🙌🏼🙌🏼<br/><br/><br/></p>",
        "desc_html": null,
        "end_behavior": "next",
        "cta": {
          "href": null,
          "text": "Shop Now",
          "thumb_text": ""
        }
      }
    ]
  }
];

// ✅ MEDIA SET BLOCK (copy this to add/replace just this set):
window.MEDIA_GALLERY_SETS["Furniture"] = [
  {
    "heading": "<h1>Furniture</h1>",
    "subheading": "",
    "img_ratio": "4:5",
    "row_height": 0,
    "fit_row": false,
    "margin_top": 0,
    "margin_bottom": 0,
    "collapsed": false,
    "show_more_text": "Show more",
    "show_less_text": "Show less",
    "row_toggle_border_style": "solid",
    "accordion": false,
    "accordion_title": "",
    "accordion_subheading": "",
    "accordion_hide_title_when_open": false,
    "accordion_hide_subheading_when_open": false,
    "accordion_title_center": false,
    "accordion_start_open": false,
    "accordion_allow_multiple": false,
    "accordion_bg_color": "#ffffff",
    "accordion_shadow_pct": 8,
    "accordion_shadow_style": "raised",
    "accordion_group": "",
    "accordion_always_open": false,
    "videos": [
      {
        "type": "video",
        "title": "French Oak Dressor",
        "alt": "French Oak Dressor",
        "url": "https://vimeo.com/1169850343",
        "start_time": "",
        "thumbnail": "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/df7f3bb9-34c7-473d-92bc-bf647af1f5c5.gif?ClientID=sulu&Date=1772530777&Signature=d5df979e059b55f7551727a012306e3d470cbadf",
        "scale": 100,
        "title_wrap": false,
        "ratio_override": "",
        "vjust": "center",
        "html_desc": "<p><a href=\"https://www.instagram.com/reel/CrgJTsEuu9v/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==\" target=\"_blank\">@retiqueliquidwood</a> Watch the full process of how I transformed my great-grandfather's old dresser.</p><p>I used Retique It's French Oak Multipurpose Kit for the new wood finish and Retique It's Midnight Black.</p><p>French Oak and Midnight Black can't get better than that!</p>",
        "desc_html": null,
        "end_behavior": "next",
        "cta": {
          "href": null,
          "text": "Shop Now",
          "thumb_text": ""
        }
      },
      {
        "type": "video",
        "title": "Damaged Veneer Buffet",
        "alt": "Damaged Veneer Buffet",
        "url": "https://vimeo.com/1169313473",
        "start_time": "",
        "thumbnail": "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/8f43fca3-d079-43d1-bc88-201e6dff520e.gif?ClientID=sulu&Date=1772377418&Signature=22a01be193baf341095f49936200e3699b483300",
        "scale": 100,
        "title_wrap": false,
        "ratio_override": "",
        "vjust": "center",
        "html_desc": "<p><a href=\"https://www.instagram.com/reel/DUGJ7vckbmj/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==\" target=\"_blank\">@thisflipskisarah</a> Some people might cringe, but this piece was too damaged to save as-is (and I forgot to take good video 😬).</p><p>Faux wood meant I could try to give it a wood look and hopefully end up in a new home instead of a landfill. I hope that’s a design win. 🤎</p>",
        "desc_html": null,
        "end_behavior": "next",
        "cta": {
          "href": null,
          "text": "Shop Now",
          "thumb_text": ""
        }
      },
      {
        "type": "video",
        "title": "Desk",
        "alt": "Desk",
        "url": "https://vimeo.com/1169836063",
        "start_time": "",
        "thumbnail": "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/6efca97f-6310-4b0e-875b-ad4e6a206a05.gif?ClientID=sulu&Date=1772527785&Signature=7bddcd2df1c32b8157373d25063ec0faf527c702",
        "scale": 100,
        "title_wrap": false,
        "ratio_override": "",
        "vjust": "center",
        "html_desc": "<p><a href=\"https://www.instagram.com/reel/DDXi16bxyph/?utm_source=ig_web_copy_link&igsh=NTc4MTIwNjQ2YQ==\" target=\"_blank\">@maison_lya.dc</a> I finally finished my son’s desk! This was a really fun project and totally worth it to see how happy he was😊</p><p>Products I used:</p><p>1. Retique’It Wood Primer - Light</p><p>2. Retique’It Wood Stain - Drift Wood</p><p>3. Retique Tripletique Top Coat</p><p>4. Sherwin Williams Iron Ore</p><p>5. Hobby Lobby Hardware</p>",
        "desc_html": null,
        "end_behavior": "next",
        "cta": {
          "href": null,
          "text": "Shop Now",
          "thumb_text": ""
        }
      },
      {
        "type": "video",
        "title": "Dressor",
        "alt": "Dressor",
        "url": "https://vimeo.com/1169359165",
        "start_time": "",
        "thumbnail": "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/69a919b3-bb36-45a8-b359-ebe2b3f45fd8.gif?ClientID=sulu&Date=1772394640&Signature=4e2b09f603463b26221a699f38e20569646bb685",
        "scale": 100,
        "title_wrap": false,
        "ratio_override": "",
        "vjust": "center",
        "html_desc": "<p><a href=\"https://www.instagram.com/reel/Cux147xMZG7/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==\" target=\"_blank\">@flippedbyabbey</a> This is the best furniture flipping hack ever! I painted on REAL wood with @retiqueliquidwood</p>",
        "desc_html": null,
        "end_behavior": "next",
        "cta": {
          "href": null,
          "text": "Shop Now",
          "thumb_text": ""
        }
      },
      {
        "type": "video",
        "title": "Black Finishes",
        "alt": "Black Finishes",
        "url": "https://vimeo.com/838049704",
        "start_time": "",
        "thumbnail": "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/24eaf49b-3a93-46e5-b68f-db9e62ce98e1.gif?ClientID=sulu&Date=1774293371&Signature=87fa5e5fbc3bd4eeee260c996b1ae3b28207f685",
        "scale": 100,
        "title_wrap": false,
        "ratio_override": "",
        "vjust": "top",
        "html_desc": "<p>Retique It can take a painted black finished piece and turn it into a beautiful blonde wood finish!</p>",
        "desc_html": null,
        "end_behavior": "next",
        "cta": {
          "href": null,
          "text": "Shop Now",
          "thumb_text": ""
        }
      }
    ]
  }
];

// ✅ MEDIA SET BLOCK (copy this to add/replace just this set):
window.MEDIA_GALLERY_SETS["StairsRailings"] = [
  {
    "heading": "<h1>Stairs & Railings</h1>",
    "subheading": "",
    "img_ratio": "4:5",
    "row_height": 0,
    "fit_row": false,
    "margin_top": 0,
    "margin_bottom": 0,
    "collapsed": false,
    "show_more_text": "Show more",
    "show_less_text": "Show less",
    "row_toggle_border_style": "solid",
    "accordion": false,
    "accordion_title": "",
    "accordion_subheading": "",
    "accordion_hide_title_when_open": false,
    "accordion_hide_subheading_when_open": false,
    "accordion_title_center": false,
    "accordion_start_open": false,
    "accordion_allow_multiple": false,
    "accordion_bg_color": "#ffffff",
    "accordion_shadow_pct": 8,
    "accordion_shadow_style": "raised",
    "accordion_group": "",
    "accordion_always_open": false,
    "videos": [
      {
        "type": "video",
        "title": "Stair Treads",
        "alt": "Stair Treads",
        "url": "https://vimeo.com/935130237",
        "start_time": "",
        "thumbnail": "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/84dd7725-270c-4d26-a214-c09f149466a2.gif?ClientID=sulu&Date=1771590112&Signature=6e4860d1704df8e4fd70cf2d90a87da743e23c9b",
        "scale": 100,
        "title_wrap": false,
        "ratio_override": "",
        "vjust": "center",
        "html_desc": "",
        "desc_html": null,
        "end_behavior": "next",
        "cta": {
          "href": null,
          "text": "Shop Now",
          "thumb_text": ""
        }
      },
      {
        "type": "video",
        "title": "Stair Case",
        "alt": "Stair Case",
        "url": "https://vimeo.com/1169833148",
        "start_time": "",
        "thumbnail": "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/cab3795d-a1be-4b55-b741-6df4e7b61aa4.gif?ClientID=sulu&Date=1772526455&Signature=f6f2f78e9676190ef14cc8f233bc10c6b5b85899",
        "scale": 100,
        "title_wrap": false,
        "ratio_override": "",
        "vjust": "center",
        "html_desc": "<p><a href=\"https://www.instagram.com/reel/DDW1LrupVn0/?utm_source=ig_web_copy_link&igsh=NTc4MTIwNjQ2YQ==\" target=\"_blank\">@wazhomedecor</a> BIG Staircase REVEAL!! And there was NO SANDING!! I can’t believe the new MODERN look to my staircase with liquid wood! </p><p>Be sure to check out all of <a href=\"https://www.instagram.com/retiqueliquidwood?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==\" target=\"_blank\">@retiqueliquidwood</a> stain choices. The options are endless! </p><p>I used Retique It Wood n Primer on everything. Two coats on the railing and one on the spindles. I then used Wood n Stain Barnwood and a paint brush to give the railing the streak look. For the spindles, I used a black gel. Finished everything with a coat of matte sealer. </p><p><br/></p><p>What do you think?</p>",
        "desc_html": null,
        "end_behavior": "next",
        "cta": {
          "href": null,
          "text": "Shop Now",
          "thumb_text": ""
        }
      },
      {
        "type": "video",
        "title": "Stair Railings",
        "alt": "Stair Railings",
        "url": "https://vimeo.com/1169846491",
        "start_time": "",
        "thumbnail": "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/2112247b-61fb-4237-a08b-35c5b176e908.gif?ClientID=sulu&Date=1772530120&Signature=aa6c90d3b999b38a6433cb266ff991572ccdc0d2",
        "scale": 100,
        "title_wrap": false,
        "ratio_override": "",
        "vjust": "center",
        "html_desc": "<p><a href=\"https://www.instagram.com/reel/Cx-fEcxgLgQ/?utm_source=ig_web_copy_link&igsh=NTc4MTIwNjQ2YQ==\" target=\"_blank\">@retiqueliquidwood</a> Sanding and stripping down these 100-year-old stair railings wasn't even an option. So i went right over them with Retique It and used the Dark Pecan Grained Multipurpose Kit. </p><p><br/></p><p>Remember, Retique It's liquid wood coatings in the kit contain over 60% recycled ♻️ wood fibers. So, I was actually able to apply a new layer of wood right over the paint in under 2 hours. �</p>",
        "desc_html": null,
        "end_behavior": "next",
        "cta": {
          "href": null,
          "text": "Shop Now",
          "thumb_text": ""
        }
      }
    ]
  }
];

// ✅ MEDIA SET BLOCK (copy this to add/replace just this set):
window.MEDIA_GALLERY_SETS["MoreProjects"] = [
  {
    "heading": "<h1>More Projects</h1>",
    "subheading": "",
    "img_ratio": "4:5",
    "row_height": 0,
    "fit_row": false,
    "margin_top": 0,
    "margin_bottom": 0,
    "collapsed": false,
    "show_more_text": "Show more",
    "show_less_text": "Show less",
    "row_toggle_border_style": "solid",
    "accordion": false,
    "accordion_title": "",
    "accordion_subheading": "",
    "accordion_hide_title_when_open": false,
    "accordion_hide_subheading_when_open": false,
    "accordion_title_center": false,
    "accordion_start_open": false,
    "accordion_allow_multiple": false,
    "accordion_bg_color": "#ffffff",
    "accordion_shadow_pct": 8,
    "accordion_shadow_style": "raised",
    "accordion_group": "",
    "accordion_always_open": false,
    "videos": [
      {
        "type": "video",
        "title": "Fireplace Mantel",
        "alt": "Fireplace Mantel",
        "url": "https://vimeo.com/1166929647",
        "start_time": "",
        "thumbnail": "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/5c59903b-a45f-4310-b658-b5e420884db9.gif?ClientID=sulu&Date=1772528987&Signature=6516ea15555f1f1944d3bb18e5fdff87455e3ad3",
        "scale": 100,
        "title_wrap": false,
        "ratio_override": "",
        "vjust": "center",
        "html_desc": "",
        "desc_html": null,
        "end_behavior": "next",
        "cta": {
          "href": null,
          "text": "Shop Now",
          "thumb_text": ""
        }
      },
      {
        "type": "video",
        "title": "Mirror",
        "alt": "Mirror",
        "url": "https://vimeo.com/1169839765",
        "start_time": "",
        "thumbnail": "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/26f39045-8667-4f39-b5ea-5ec27a1de3f5.gif?ClientID=sulu&Date=1772528212&Signature=a9074de2ead6961d8affa1db9260d7d21d83fb51",
        "scale": 100,
        "title_wrap": false,
        "ratio_override": "",
        "vjust": "center",
        "html_desc": "<p><a href=\"https://www.instagram.com/reel/DHMAj7IxvH5/?utm_source=ig_web_copy_link&igsh=NTc4MTIwNjQ2YQ==\" target=\"_blank\">@retiqueliquidwood</a></p><p>✨ From cheap old veneer to Pickled Oak—just like that! ✨</p><p>Want to get this look? Comment SPRING below, and I’ll send you:</p><p>✅ The Pickled Oak Grain Finish Kit (plus all kit options!)</p><p>✅ A FREE interactive Spring Guide packed with wood finish inspiration, tutorials, and trending looks!</p>",
        "desc_html": null,
        "end_behavior": "next",
        "cta": {
          "href": null,
          "text": "Shop Now",
          "thumb_text": ""
        }
      },
      {
        "type": "video",
        "title": "Wood Beams",
        "alt": "Wood Beams",
        "url": "https://vimeo.com/1169374555",
        "start_time": "",
        "thumbnail": "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/d7933b95-bc0e-4950-b704-665d0b2d818b.gif?ClientID=sulu&Date=1772401104&Signature=00cb7413c132db2e8d35008642157ef97833ea54",
        "scale": 100,
        "title_wrap": false,
        "ratio_override": "",
        "vjust": "center",
        "html_desc": "<p>These beams started as drywall.</p><p>With Liquid Wood, you can create an authentic wood finish with over 60% wood.</p><p>It looks like wood.</p><p>It feels like wood.</p><p>Because it is wood.</p><p>Would you have guessed this was drywall?<br/><br/>Original Instagram Post @retiqueliquidwood</p>",
        "desc_html": null,
        "end_behavior": "next",
        "cta": {
          "href": null,
          "text": "Shop Now",
          "thumb_text": ""
        }
      },
      {
        "type": "video",
        "title": "Metal Vents",
        "alt": "Metal Vents",
        "url": "https://vimeo.com/1169311198",
        "start_time": "",
        "thumbnail": "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/a86fad20-351a-4c67-8e02-736b15044d15.gif?ClientID=sulu&Date=1772376274&Signature=15b52dccc184d1278f3150ebfc006d5f56bd642d",
        "scale": 100,
        "title_wrap": false,
        "ratio_override": "",
        "vjust": "center",
        "html_desc": "<p>Builder grade floor vents were not it.</p><p>So instead of replacing them, I gave them a new wood surface.✨</p><p>This is the Pickled Oak kit. It creates an authentic wood finish with over 60 percent real wood fibers and was custom matched to my floors.</p><p>Ten minutes. No replacements. Whole house next.</p><p>They finally belong here.<br/><a href=\"https://www.instagram.com/reel/DT1VhM3jq5n/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==\" target=\"_blank\">Original Instagram Post @retiqueliquidwood</a></p>",
        "desc_html": null,
        "end_behavior": "next",
        "cta": {
          "href": null,
          "text": "Shop Now",
          "thumb_text": ""
        }
      },
      {
        "type": "video",
        "title": "Canvas Art",
        "alt": "Canvas Art",
        "url": "https://vimeo.com/1166764988",
        "start_time": "",
        "thumbnail": "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/a420283e-bf47-474f-99f1-e243c9208a6d.gif?ClientID=sulu&Date=1771612917&Signature=56fc1499793a152ba2eb8a6e40b096fb662f6232",
        "scale": 100,
        "title_wrap": false,
        "ratio_override": "",
        "vjust": "center",
        "html_desc": "",
        "desc_html": null,
        "end_behavior": "next",
        "cta": {
          "href": null,
          "text": "Shop Now",
          "thumb_text": ""
        }
      },
      {
        "type": "video",
        "title": "Plastic Vase",
        "alt": "Plastic Vase",
        "url": "https://vimeo.com/1169376434",
        "start_time": "",
        "thumbnail": "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/88bd00af-a924-401b-a783-bb74f130376d.gif?ClientID=sulu&Date=1772401936&Signature=4f791ac1eb68784dda1edfb25644ae179bd564ae",
        "scale": 100,
        "title_wrap": false,
        "ratio_override": "",
        "vjust": "center",
        "html_desc": "<p>Comment FALL to get our free Fall Guide . . . Packed with cozy project inspo, trending wood finishes, and easy DIY ideas you’ll actually want to try!</p><p><br/></p><p>This $5 plastic pink thrift-store vase? Nobody wanted her.</p><p>But I saw potential. 😏</p><p>A little Pickled Oak magic from Retique It… and now she looks like she came straight out of a designer boutique. ✨</p><p><br/></p><p>Skip the plastic look. Put a fresh coat of wood on it. 💁‍♀️</p><p><a href=\"https://www.instagram.com/reel/DQnV6ddjhI6/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==\" target=\"_blank\">Original Instagram Post @retiqueliquidwood</a></p>",
        "desc_html": null,
        "end_behavior": "next",
        "cta": {
          "href": null,
          "text": "Shop Now",
          "thumb_text": ""
        }
      }
    ]
  }
];

// ✅ MEDIA SET BLOCK (copy this to add/replace just this set):
window.MEDIA_GALLERY_SETS["SmoothFinishes"] = [
  {
    "heading": "<h1></h1><h1>Smooth Finishes</h1>",
    "subheading": "",
    "img_ratio": "4:5",
    "row_height": 0,
    "fit_row": false,
    "collapsed": false,
    "show_more_text": "Show more",
    "show_less_text": "Show less",
    "accordion": false,
    "accordion_title": "",
    "accordion_subheading": "",
    "accordion_title_center": false,
    "accordion_start_open": false,
    "accordion_allow_multiple": false,
    "accordion_bg_color": "#ffffff",
    "accordion_shadow_pct": 8,
    "accordion_group": "",
    "accordion_always_open": false,
    "videos": [
      {
        "type": "video",
        "title": "Blonde Wood Cabinets",
        "alt": "Blonde Wood Cabinets",
        "url": "https://vimeo.com/1078017079",
        "start_time": "",
        "thumbnail": "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/e36a1948-617a-48d1-868f-40d322c7efba.gif?ClientID=sulu&Date=1774288240&Signature=01df75774fdff074807e0ebe48d774d44777a441",
        "scale": 100,
        "title_wrap": false,
        "ratio_override": "",
        "vjust": "top",
        "html_desc": "<p>Put a wood finish over your cabinets has never been easier. Just paint it, stain it and love it. Look at the blond wood finish.<br/><br/></p>",
        "desc_html": null,
        "end_behavior": "next",
        "cta": {
          "href": null,
          "text": "Shop Now",
          "thumb_text": ""
        }
      },
      {
        "type": "video",
        "title": "Black to Blonde Finish",
        "alt": "Black to Blonde Finish",
        "url": "https://vimeo.com/838049704",
        "start_time": "",
        "thumbnail": "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/24eaf49b-3a93-46e5-b68f-db9e62ce98e1.gif?ClientID=sulu&Date=1774293137&Signature=27f396259bd384846c305b7c62b40702036014f5",
        "scale": 100,
        "title_wrap": false,
        "ratio_override": "",
        "vjust": "top",
        "html_desc": "<p>Retique It can take a painted black finished piece and turn it into a beautiful blonde wood finish!</p>",
        "desc_html": null,
        "end_behavior": "next",
        "cta": {
          "href": null,
          "text": "Shop Now",
          "thumb_text": ""
        }
      },
      {
        "type": "video",
        "title": "Cabinets",
        "alt": "Cabinets",
        "url": "https://vimeo.com/1167113792",
        "start_time": "",
        "thumbnail": "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/df0f38cc-fb02-488a-baa9-c91b78802bd6.gif?ClientID=sulu&Date=1772020058&Signature=c59d096f5e6beb9dc228e377e604544211677d96",
        "scale": 100,
        "title_wrap": false,
        "ratio_override": "",
        "vjust": "top",
        "html_desc": "<p><a href=\"https://www.instagram.com/crafty.custom.home/\" target=\"_blank\">@crafty.custom.home</a> Follow me as I transform these boring grey mudroom built-ins into a gorgeous faux white oak. Trust me, you won’t even be able to tell it’s not real wood. This product is THAT GOOD. <a href=\"https://www.instagram.com/retiqueliquidwood/\" target=\"_blank\">@retiqueliquidwood</a></p>",
        "desc_html": null,
        "end_behavior": "next",
        "cta": {
          "href": null,
          "text": "Shop Now",
          "thumb_text": ""
        }
      },
      {
        "type": "video",
        "title": "Dressers",
        "alt": "Dressers",
        "url": "https://vimeo.com/1169359165",
        "start_time": "",
        "thumbnail": "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/69a919b3-bb36-45a8-b359-ebe2b3f45fd8.gif?ClientID=sulu&Date=1772394640&Signature=4e2b09f603463b26221a699f38e20569646bb685",
        "scale": 100,
        "title_wrap": false,
        "ratio_override": "",
        "vjust": "top",
        "html_desc": "<p><a href=\"https://www.instagram.com/reel/Cux147xMZG7/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==\" target=\"_blank\">@flippedbyabbey</a> This is the best furniture flipping hack ever! I painted on REAL wood with @retiqueliquidwood</p>",
        "desc_html": null,
        "end_behavior": "next",
        "cta": {
          "href": null,
          "text": "Shop Now",
          "thumb_text": ""
        }
      },
      {
        "type": "video",
        "title": "White Cabinets are out",
        "alt": "White Cabinets are out",
        "url": "https://vimeo.com/1166765443",
        "start_time": "",
        "thumbnail": "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/589d3544-72cf-41e2-b9f6-0370245663b4.gif?ClientID=sulu&Date=1774288849&Signature=05da01c94725b0c12711de0699fe1d3d089cc346",
        "scale": 100,
        "title_wrap": false,
        "ratio_override": "",
        "vjust": "top",
        "html_desc": "",
        "desc_html": null,
        "end_behavior": "next",
        "cta": {
          "href": null,
          "text": "Shop Now",
          "thumb_text": ""
        }
      }
    ]
  }
];

// ✅ MEDIA SET BLOCK (copy this to add/replace just this set):
window.MEDIA_GALLERY_SETS["GrainedFinishes"] = [
  {
    "heading": "<h1><br/>Grained Finishes</h1>",
    "subheading": "",
    "img_ratio": "4:5",
    "row_height": 0,
    "fit_row": false,
    "collapsed": false,
    "show_more_text": "Show more",
    "show_less_text": "Show less",
    "accordion": false,
    "accordion_title": "",
    "accordion_subheading": "",
    "accordion_title_center": false,
    "accordion_start_open": false,
    "accordion_allow_multiple": false,
    "accordion_bg_color": "#ffffff",
    "accordion_shadow_pct": 8,
    "accordion_group": "",
    "accordion_always_open": false,
    "videos": [
      {
        "type": "video",
        "title": "The Secret is Retique It",
        "alt": "The Secret is Retique It",
        "url": "https://vimeo.com/1169149703",
        "start_time": "",
        "thumbnail": "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/aaf56bed-070f-43e9-9974-41f49267dd0a.gif?ClientID=sulu&Date=1774289014&Signature=ffde62751dbf23329dfe2dfbbf82328b14a2ebac",
        "scale": 100,
        "title_wrap": false,
        "ratio_override": "",
        "vjust": "top",
        "html_desc": "<p>Transform your home with the magic of Retique It! Watch as these stunning DIY projects come to life, turning ordinary surfaces into extraordinary masterpieces. The secret to achieving these beautiful home transformations? It’s all in the details… The secret is Retique It. 🌿 Our patented formula contains over 60% recycled wood fibers, making it not just beautiful, but sustainable too. 🏡🔑<br/><br/></p>",
        "desc_html": null,
        "end_behavior": "next",
        "cta": {
          "href": null,
          "text": "Shop Now",
          "thumb_text": ""
        }
      },
      {
        "type": "video",
        "title": "Granite Countertops",
        "alt": "Granite Countertops",
        "url": "https://vimeo.com/936335265",
        "start_time": "",
        "thumbnail": "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/a1901a3a-971b-4bc4-bac4-2910d42983a0.gif?ClientID=sulu&Date=1771589954&Signature=763e53dc5effcd2340923ae4e958453205ad179e",
        "scale": 100,
        "title_wrap": false,
        "ratio_override": "",
        "vjust": "center",
        "html_desc": "<p>Over three years later, and Maria’s countertops are still going strong! 💪✨ She transformed her granite into a stunning Dark Oak wood finish using the Retique It Dark Oak Countertop Kit, and she LOVES it. 🍩</p><p>Maria from Heartland Bagels (<a href=\"https://www.instagram.com/maria_heartlandbagels2/\" target=\"_blank\">@maria_heartlandbagels2</a>) is known for her gorgeous custom donuts, but her kitchen is just as sweet! And before the haters jump in—yes, this finish is durable, stainable, and can be removed if desired. But after a year of daily use, she wouldn’t change a thing!</p><p>Would you try this in your kitchen? 👀 </p>",
        "desc_html": null,
        "end_behavior": "next",
        "cta": {
          "href": "https://retique.com/products/countertopkit_dark-oak_l_tripletique",
          "text": "Shop Now",
          "thumb_text": "Shop Now"
        }
      },
      {
        "type": "video",
        "title": "17 Steel Doors",
        "alt": "17 Steel Doors",
        "url": "https://vimeo.com/937062372",
        "start_time": "",
        "thumbnail": "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/187fee14-ed90-4ae2-9010-9eec0c1e066b.gif?ClientID=sulu&Date=1771589265&Signature=d365690adeef55e22c4c071e43bb101fc61b4d2c",
        "scale": 100,
        "title_wrap": false,
        "ratio_override": "",
        "vjust": "center",
        "html_desc": "<p>This country church wanted to ditch the boring steel doors and give them a stunning, custom, weathered wood look—and we made it happen with the Retique It® Weathered Wood Door Kit! 🔥</p><p>✨ How we did it:</p><p>✅ Two coats of Light Wood Wood’n Primer as the base</p><p>✅ Stained with Weathered Wood Wood’n Stain for rich, brownish-gray undertones 🌾</p><p>✅ Applied another coat of Light Wood Wood’n Primer and, while STILL WET, swiped the graining tool for that real wood grain effect 🔄</p><p>✅ Final stain coat with Weathered Wood gel stain alternative for that perfect rustic, high-end finish</p><p>💯 This authentic wood finish contains over 60% recycled wood and works on almost ANY surface! Doors, decks, garages, furniture, countertops, cabinets—you name it! Interior & exterior projects? Covered. 💪<br/><br/><a href=\"https://www.instagram.com/retiqueliquidwood?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==\" target=\"_blank\"><strong>Original Instagram Reel</strong></a></p>",
        "desc_html": null,
        "end_behavior": "next",
        "cta": {
          "href": "https://retique.com/products/doorkit_weathered-wood_m",
          "text": "Shop Now",
          "thumb_text": "Shop Now"
        }
      },
      {
        "type": "video",
        "title": "Railings",
        "alt": "Railings",
        "url": "https://vimeo.com/1169846491",
        "start_time": "",
        "thumbnail": "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/2112247b-61fb-4237-a08b-35c5b176e908.gif?ClientID=sulu&Date=1774289086&Signature=94906be2cc209f6e3a535b41c694e62f9626ebcd",
        "scale": 100,
        "title_wrap": false,
        "ratio_override": "",
        "vjust": "center",
        "html_desc": "<p><a href=\"https://www.instagram.com/reel/Cx-fEcxgLgQ/?utm_source=ig_web_copy_link&igsh=NTc4MTIwNjQ2YQ==\" target=\"_blank\">@retiqueliquidwood</a> Sanding and stripping down these 100-year-old stair railings wasn't even an option. So i went right over them with Retique It and used the Dark Pecan Grained Multipurpose Kit. </p><p></p><p>Remember, Retique It's liquid wood coatings in the kit contain over 60% recycled ♻️ wood fibers. So, I was actually able to apply a new layer of wood right over the paint in under 2 hours. �</p>",
        "desc_html": null,
        "end_behavior": "next",
        "cta": {
          "href": "https://retique.com/products/woodnfinish_pickled-oak_l",
          "text": "Shop Now",
          "thumb_text": "Shop Now"
        }
      },
      {
        "type": "video",
        "title": "Fireplace Mantels",
        "alt": "Fireplace Mantels",
        "url": "https://vimeo.com/1166929647",
        "start_time": "",
        "thumbnail": "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/6219db73-84ba-4303-aa8d-3785fe26c57f.gif?ClientID=sulu&Date=1771613219&Signature=37d52902e28ddc2b529120e287739346cad76735",
        "scale": 100,
        "title_wrap": false,
        "ratio_override": "",
        "vjust": "center",
        "html_desc": "",
        "desc_html": null,
        "end_behavior": "next",
        "cta": {
          "href": "https://retique.com/products/fireplacekit_barn-wood_m",
          "text": "Shop Now",
          "thumb_text": "Shop Now"
        }
      },
      {
        "type": "video",
        "title": "Veneer Tables",
        "alt": "Veneer Tables",
        "url": "https://vimeo.com/1164848422",
        "start_time": "",
        "thumbnail": "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/acaf1756-02b8-475e-b22c-805a24d6fc8f.gif?ClientID=sulu&Date=1771610285&Signature=8e7195afe6a38c4ec0d674f434c763921ab09660",
        "scale": 100,
        "title_wrap": false,
        "ratio_override": "",
        "vjust": "center",
        "html_desc": "<p><a href=\"https://www.instagram.com/reel/DPEKZnHDhi1/?utm_source=ig_web_copy_link&igsh=NTc4MTIwNjQ2YQ==\" title=\"https://www.instagram.com/reel/DPEKZnHDhi1/?utm_source=ig_web_copy_link&igsh=NTc4MTIwNjQ2YQ==\">@retiqueliquidwood</a> You know you are a DIY addict when a beach view is not enough… you just have to fix the furniture too 😅<br/><br/>This table was peeling, bubbling, and not even real wood. I asked the owner if I could redo it and the transformation is absolutely stunning 🪵💛<br/><br/>I used the Retique It Sun Bleach Kit to put a fresh coat of wood on it. It delivers an authentic wood finish with over 60 percent real wood and makes any surface look amazing.<br/><br/>Comment Beach and I will DM you the step-by-step instructions for this makeover, the Sun Bleach Kit I used, our free fall guide, and details about the gorgeous Spaggia Beach House in Destin 🏖️<br/><br/></p>",
        "desc_html": null,
        "end_behavior": "next",
        "cta": {
          "href": "https://retique.com/products/tabletopkit_white-wash_m_tripletique",
          "text": "Shop Now",
          "thumb_text": "Shop Now"
        }
      },
      {
        "type": "video",
        "title": "Stairs",
        "alt": "Stairs",
        "url": "https://vimeo.com/935130237",
        "start_time": "",
        "thumbnail": "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/84dd7725-270c-4d26-a214-c09f149466a2.gif?ClientID=sulu&Date=1771590112&Signature=6e4860d1704df8e4fd70cf2d90a87da743e23c9b",
        "scale": 100,
        "title_wrap": false,
        "ratio_override": "",
        "vjust": "center",
        "html_desc": "",
        "desc_html": null,
        "end_behavior": "next",
        "cta": {
          "href": "/products/woodnfinish_pickled-oak_l",
          "text": "Shop Now",
          "thumb_text": "Shop Now"
        }
      },
      {
        "type": "video",
        "title": "Even Prosthetic Legs",
        "alt": "Even Prosthetic Legs",
        "url": "https://vimeo.com/1168999275",
        "start_time": "",
        "thumbnail": "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/a4993a55-65b7-4984-85a9-c5acc756014d.gif?ClientID=sulu&Date=1772232314&Signature=30b8042b5c539f43fc4457304a3f08f9627f3d85",
        "scale": 100,
        "title_wrap": false,
        "ratio_override": "",
        "vjust": "center",
        "html_desc": "<p>His wife wanted to see what Retique It could do… and he wasn’t convinced.<br/><br/>Then he watched us apply our Liquid Wood coating and create a real wood finish right in front of him.<br/><br/>By the end of the demo at Orgill Orlando, he asked us to turn his prosthetic into Black Walnut.<br/><br/>From skeptic → believer.<br/><br/>Now they’re bringing Retique It into their store.<br/>It’s always about the people. 🤎</p><p><a href=\"https://www.instagram.com/reel/DU4P0vsjre8/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==\" title=\"https://www.instagram.com/reel/DU4P0vsjre8/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==\">Original Instagram Reel</a><br/><br/></p>",
        "desc_html": null,
        "end_behavior": "next",
        "cta": {
          "href": null,
          "text": "Shop Now",
          "thumb_text": ""
        }
      },
      {
        "type": "video",
        "title": "You can do this",
        "alt": "You can do this",
        "url": "https://vimeo.com/1169004909",
        "start_time": "",
        "thumbnail": "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/fcdd5b78-db86-463c-b4f2-1a995e40d24a.gif?ClientID=sulu&Date=1772233630&Signature=8ae775775b25cf0a69cee145902806f52205057b",
        "scale": 100,
        "title_wrap": false,
        "ratio_override": "",
        "vjust": "center",
        "html_desc": "<p>First time wood graining… and look what they created 👀🪵<br/><br/>Retique It is a real wood finish coating that you can paint, stain, and grain for beautiful texture and depth.<br/><br/>Would you try this?<br/><a href=\"https://www.instagram.com/reel/DUwlb5LDlDV/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==\" title=\"https://www.instagram.com/reel/DUwlb5LDlDV/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==\">@retiqueliquidwood Instagram Post</a></p>",
        "desc_html": null,
        "end_behavior": "next",
        "cta": {
          "href": null,
          "text": "Shop Now",
          "thumb_text": ""
        }
      }
    ]
  }
];

window.MEDIA_GALLERY_SETS["StepsSmoothFinishes"] = [
  {
    "heading": "<p>Retique It® Liquid Wood Coatings</p>",
    "subheading": "<h1>Smooth Wood Finishes</h1>",
    "heading_justify": "center",
    "custom_template_id": "mg-custom-template--18541426475142__c_media_gallery_Gg4wG3-0",
    "custom_html": "<center>\nStep-By-Step\n</center>\n<style>\r\n  .heading {\r\n    margin-bottom: 8px;\r\n  }\r\n\r\n  .clsReadMore {\r\n    box-shadow: 0px 1px 0px 0px #3e7327;\r\n    background: linear-gradient(to bottom, #77b55a 5%, #72b352 100%);\r\n    background-color: #77b55a;\r\n    border-radius: 15px;\r\n    border: 2px solid #4b8f29;\r\n    display: inline-block;\r\n    cursor: pointer;\r\n    color: #ffffff;\r\n    font-size: 14px;\r\n    font-weight: bold;\r\n    padding: 12px 16px;\r\n    text-decoration: none;\r\n    text-shadow: 0px 1px 0px #5b8a3c;\r\n  }\r\n\r\n  .clsReadMore:hover {\r\n    background: linear-gradient(to bottom, #72b352 5%, #77b55a 100%);\r\n    background-color: #72b352;\r\n  }\r\n\r\n  .clsReadMore:active {\r\n    position: relative;\r\n    top: 1px;\r\n  }\r\n\r\n  .vidDiv {\r\n    margin: auto;\r\n    max-width: 100%;\r\n    width: fit-content;\r\n    padding-top: 10px;\r\n    padding-bottom: 10px;\r\n  }\r\n\r\n  .centerAll {\r\n    margin: auto;\r\n    width: fit-content;\r\n  }\r\n\r\n  .finalCoats {\r\n    text-align: center;\r\n    Width: 32%;\r\n    display: inline-block;\r\n  }\r\n\r\n  .Prep {\r\n    content: var(--Prep);\r\n  }\r\n\r\n  .Step-Prep {\r\n    content: var(--Step-Prep);\r\n  }\r\n\r\n    .Step-Sand {\r\n    content: var(--Step-Sand);\r\n  }\r\n\r\n    .Step-Wash {\r\n    content: var(--Step-Wash);\r\n  }\r\n\r\n  .Step-Tape {\r\n    content: var(--Step-Tape);\r\n  }\r\n\r\n  .Step-Prime {\r\n    content: var(--Step-Prime);\r\n  }\r\n\r\n  .Step-Prime-Image {\r\n    content: var(--Step-Prime-Image);\r\n  }\r\n\r\n  .Step-Grain {\r\n    content: var(--Step-Grain);\r\n  }\r\n\r\n    .Step-WashTools {\r\n    content: var(--Step-WashTools);\r\n  }\r\n\r\n  .Step-Paint {\r\n    content: var(--Step-Paint);\r\n  }\r\n\r\n    .Step-Paint-Image {\r\n    content: var(--Step-Paint-Image);\r\n  }\r\n\r\n  .Step-Stain {\r\n    content: var(--Step-Stain);\r\n  }\r\n\r\n  .Step-WoodnStain {\r\n    content: var(--Step-WoodnStain);\r\n  }\r\n  \r\n  .Step-GelStain {\r\n    content: var(--Step-GelStain);\r\n  }\r\n\r\n  .Step-Stain-Image {\r\n    content: var(--Step-Stain-Image);\r\n  }\r\n\r\n  .Step-Seal {\r\n    content: var(--Step-Seal);\r\n  }\r\n\r\n  .Step-Love {\r\n    content: var(--Step-Love);\r\n  }\r\n\r\n  .Step-Love-Image {\r\n    content: var(--Step-Love-Image);\r\n  }\r\n\r\n  .Step-FinalResult {\r\n    content: var(--Step-FinalResult);\r\n  }\r\n\r\n  .Demo-Vimeo-ID {\r\n    content: var(--Demo-Vimeo-ID);\r\n  }\r\n\r\n  .Finish01 {\r\n    content: var(--Finish01);\r\n  }\r\n\r\n  .Finish02 {\r\n    content: var(--Finish02);\r\n  }\r\n\r\n  .Finish03 {\r\n    content: var(--Finish03);\r\n  }\r\n\r\n  .Finish01_Text:before {\r\n    content: var(--Finish01_Text);\r\n  }\r\n\r\n  .Finish02_Text:before {\r\n    content: var(--Finish02_Text);\r\n  }\r\n\r\n  .Finish03_Text:before {\r\n    content: var(--Finish03_Text);\r\n  }\r\n\r\n  .Name_of_Primer::before {\r\n    content: var(--Name_of_Primer);\r\n  }\r\n\r\n  .Color_of_Stain::before {\r\n    content: var(--Color_of_Stain);\r\n  }\r\n\r\n  .Kit_Type::before {\r\n    content: var(--Kit_Type);\r\n  }\r\n\r\n  .Name_of_Stain::before {\r\n    content: var(--Name_of_Stain);\r\n  }\r\n\r\n  .Name_of_Sealer::before {\r\n    content: var(--Name_of_Sealer);\r\n  }\r\n\r\n  .divTitle::before {\r\n    content: var(--Title);\r\n  }\r\n\r\n  .GelStainName::before {\r\n    content: var(--NameGelStain);\r\n  }\r\n  \r\n  #CoatsOfWoodnStain::before {\r\n    content: var(--CoatsOfWoodnStain)\r\n  }\r\n</style>\r\n<script>\r\n  function ReadMoreButton(btnCTRL, CTRLname, varReadMore = 'Read more', varReadLess = 'Read less') {\r\n    try {\r\n      var moreText = document.getElementById(CTRLname);\r\n      var btnText = btnCTRL;\r\n\r\n      if (moreText.style.display === \"none\") {\r\n        btnText.innerHTML = \"Read less\";\r\n        moreText.style.display = \"block\";\r\n      } else {\r\n        btnText.innerHTML = \"Read more\";\r\n        moreText.style.display = \"none\";\r\n      }\r\n    } catch (error) {\r\n      alert(error);\r\n    }\r\n  }\r\n\r\n  function jump(hash) {\r\n    var element_to_scroll_to = document.getElementById('moreSteps');\r\n    element_to_scroll_to.scrollIntoView();\r\n  }\r\n</script>\r\n\n<br>",
    "custom_width_desktop_percent": 100,
    "custom_width_mobile_percent": 100,
    "custom_max_width_px": "0",
    "img_ratio": "1:1",
    "row_height": 0,
    "fit_row": false,
    "margin_top": 0,
    "margin_bottom": 0,
    "collapsed": false,
    "show_more_text": "Show more",
    "show_less_text": "Show less",
    "row_toggle_border_style": "solid",
    "accordion": false,
    "accordion_marker": false,
    "accordion_title": "",
    "accordion_subheading": "",
    "accordion_hide_title_when_open": false,
    "accordion_hide_subheading_when_open": false,
    "accordion_title_center": true,
    "accordion_start_open": false,
    "accordion_allow_multiple": false,
    "accordion_bg_color": "#f5f5f5",
    "accordion_shadow_pct": 8,
    "accordion_shadow_style": "raised",
    "accordion_width_mobile_percent": 100,
    "accordion_width_desktop_percent": 100,
    "accordion_max_width_px": 0,
    "accordion_group": "",
    "accordion_always_open": false,
    "videos": []
  },
  {
    "heading": "",
    "subheading": "",
    "img_ratio": "1:1",
    "row_height": 0,
    "fit_row": false,
    "collapsed": false,
    "show_more_text": "Show more",
    "show_less_text": "Show less",
    "row_toggle_border_style": "solid",
    "accordion": true,
    "accordion_marker": true,
    "accordion_title": "<h1>Prep</h1>",
    "accordion_subheading": "",
    "accordion_hide_title_when_open": false,
    "accordion_hide_subheading_when_open": false,
    "accordion_title_center": true,
    "accordion_start_open": true,
    "accordion_allow_multiple": false,
    "accordion_bg_color": "#f5f5f5",
    "accordion_shadow_pct": 8,
    "accordion_shadow_style": "raised",
    "accordion_width_mobile_percent": 100,
    "accordion_width_desktop_percent": 100,
    "accordion_max_width_px": 0,
    "accordion_group": "accordion_E8XP37",
    "accordion_always_open": true,
    "videos": []
  },
  {
    "heading": "",
    "subheading": "",
    "img_ratio": "1:1",
    "row_height": 0,
    "fit_row": false,
    "margin_top": 0,
    "margin_bottom": 0,
    "collapsed": false,
    "show_more_text": "Show more",
    "show_less_text": "Show less",
    "row_toggle_border_style": "solid",
    "swatch_row": false,
    "row_justify": "center",
    "heading_justify": "center",
    "accordion": false,
    "accordion_title": "<h1>Prep</h1>",
    "accordion_subheading": "",
    "accordion_hide_title_when_open": false,
    "accordion_hide_subheading_when_open": false,
    "accordion_title_center": true,
    "accordion_start_open": true,
    "accordion_allow_multiple": false,
    "accordion_bg_color": "#f5f5f5",
    "accordion_shadow_pct": 8,
    "accordion_shadow_style": "raised",
    "accordion_width_mobile_percent": 100,
    "accordion_width_desktop_percent": 100,
    "accordion_max_width_px": 0,
    "accordion_group": "accordion_E8XP37",
    "accordion_always_open": true,
    "videos": [
      {
        "type": "video",
        "hero": true,
        "hero_autoplay_preview": false,
        "hero_show_play_badge": true,
        "hero_show_play_button": true,
        "open_full_video_text": "",
        "title": "Degrease, Scuff Sand, Wash",
        "heading_html": "<h2><em>Degrease, Scuff Sand, Wash</em></h2>",
        "subheading_html": "",
        "alt": "Degrease, Scuff Sand, Wash",
        "url": "https://vimeo.com/841018134",
        "start_time": "",
        "thumbnail": "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/17fd2ad4-0242-41fe-b5bd-cb2e1adc8a08.gif?ClientID=vimeo-core-prod&Date=1689212416&Signature=a70f1ca19df5f1ccb421d5591f4c0a9353e1db94",
        "hero_width_desktop_pct": 0,
        "hero_width_mobile_pct": 0,
        "hero_max_width_desktop_px": 0,
        "hero_height_desktop_px": 0,
        "hero_height_mobile_px": 0,
        "margin_top": 0,
        "margin_bottom": 0,
        "ratio_override": "16:9",
        "vjust": "center",
        "html_desc": "",
        "desc_html": null,
        "end_behavior": "loop",
        "cta": {
          "href": null,
          "text": "Shop Now",
          "thumb_text": ""
        }
      }
    ]
  },
  {
    "heading": "",
    "subheading": "",
    "img_ratio": "1:1",
    "row_height": 0,
    "fit_row": false,
    "margin_top": 0,
    "margin_bottom": 0,
    "collapsed": true,
    "show_more_text": "More",
    "show_less_text": "Less",
    "row_toggle_border_style": "solid",
    "accordion": false,
    "accordion_title": "<h1>Prep</h1>",
    "accordion_subheading": "",
    "accordion_hide_title_when_open": false,
    "accordion_hide_subheading_when_open": false,
    "accordion_title_center": true,
    "accordion_start_open": true,
    "accordion_allow_multiple": false,
    "accordion_bg_color": "#f5f5f5",
    "accordion_shadow_pct": 8,
    "accordion_shadow_style": "raised",
    "accordion_width_mobile_percent": 100,
    "accordion_width_desktop_percent": 100,
    "accordion_max_width_px": 0,
    "accordion_group": "accordion_E8XP37",
    "accordion_always_open": true,
    "videos": []
  },
  {
    "heading": "",
    "subheading": "",
    "heading_justify": "center",
    "custom_template_id": "mg-custom-template--18541426475142__c_media_gallery_Gg4wG3-1",
    "custom_html": "<div class=\"centerAll InfoSubPanel\">\n            <ul style=\"max-width: 650px;\">\n                <li>Wipe Down with denatured alcohol mixed with water or with Krud Kutter®</li>\n                <div class=\"centerAll\">\n                    <b style=\"color:red;\"><i>NEVER USE TSP PRODUCTS</i></b>\n                </div>\n                <div class=\"centerAll\">\n                    <i style=\"font-size: small;\">(TSP will cause wood based coatings to not adhere properly)</i>\n                </div>\n                <li>\n                    Scuff sand: Lightly sand the surface epecially if it is slick or glossy to give the Primer greater\n                    adheasion.\n                </li>\n                <li>\n                    Wash the surface with Dawn® Dish Soap and rinse thoroughly<br>\n                    with warm water until the surface is squeaky clean\n                </li>\n            </ul>\n        </div>",
    "custom_width_desktop_percent": 100,
    "custom_width_mobile_percent": 100,
    "custom_max_width_px": "0",
    "img_ratio": "1:1",
    "row_height": 0,
    "fit_row": false,
    "margin_top": 0,
    "margin_bottom": 0,
    "collapsed": false,
    "show_more_text": "Show more",
    "show_less_text": "Show less",
    "row_toggle_border_style": "solid",
    "accordion": false,
    "accordion_marker": false,
    "accordion_title": "<h1>Prep</h1>",
    "accordion_subheading": "",
    "accordion_hide_title_when_open": false,
    "accordion_hide_subheading_when_open": false,
    "accordion_title_center": true,
    "accordion_start_open": true,
    "accordion_allow_multiple": false,
    "accordion_bg_color": "#f5f5f5",
    "accordion_shadow_pct": 8,
    "accordion_shadow_style": "raised",
    "accordion_width_mobile_percent": 100,
    "accordion_width_desktop_percent": 100,
    "accordion_max_width_px": 0,
    "accordion_group": "accordion_E8XP37",
    "accordion_always_open": true,
    "videos": []
  },
  {
    "heading": "",
    "subheading": "",
    "img_ratio": "1:1",
    "row_height": 0,
    "fit_row": false,
    "collapsed": false,
    "show_more_text": "Show more",
    "show_less_text": "Show less",
    "row_toggle_border_style": "solid",
    "accordion": true,
    "accordion_marker": true,
    "accordion_title": "<h1>Prime</h1>",
    "accordion_subheading": "",
    "accordion_hide_title_when_open": false,
    "accordion_hide_subheading_when_open": false,
    "accordion_title_center": true,
    "accordion_start_open": true,
    "accordion_allow_multiple": false,
    "accordion_bg_color": "#f5f5f5",
    "accordion_shadow_pct": 8,
    "accordion_shadow_style": "raised",
    "accordion_width_mobile_percent": 100,
    "accordion_width_desktop_percent": 100,
    "accordion_max_width_px": 0,
    "accordion_group": "accordion_d4Rpnr",
    "accordion_always_open": true,
    "videos": []
  },
  {
    "heading": "",
    "subheading": "",
    "img_ratio": "1:1",
    "row_height": 0,
    "fit_row": false,
    "margin_top": 0,
    "margin_bottom": 0,
    "collapsed": false,
    "show_more_text": "Show more",
    "show_less_text": "Show less",
    "row_toggle_border_style": "solid",
    "swatch_row": false,
    "row_justify": "center",
    "heading_justify": "center",
    "accordion": false,
    "accordion_title": "<h1>Prime</h1>",
    "accordion_subheading": "",
    "accordion_hide_title_when_open": false,
    "accordion_hide_subheading_when_open": false,
    "accordion_title_center": true,
    "accordion_start_open": true,
    "accordion_allow_multiple": false,
    "accordion_bg_color": "#f5f5f5",
    "accordion_shadow_pct": 8,
    "accordion_shadow_style": "raised",
    "accordion_width_mobile_percent": 100,
    "accordion_width_desktop_percent": 100,
    "accordion_max_width_px": 0,
    "accordion_group": "accordion_d4Rpnr",
    "accordion_always_open": true,
    "videos": [
      {
        "type": "video",
        "hero": true,
        "hero_autoplay_preview": false,
        "hero_show_play_badge": true,
        "hero_show_play_button": true,
        "open_full_video_text": "",
        "title": "Apply 2 Coats of Wood'n Primer",
        "heading_html": "<h2>Apply 2 Coats of Wood'n Primer</h2>",
        "subheading_html": "",
        "alt": "Apply 2 Coats of Wood'n Primer",
        "url": "https://vimeo.com/841018134?share=copy&fl=sv&fe=ci#t=7",
        "start_time": "",
        "thumbnail": "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/21734b5a-f90a-4320-860f-e1ca7d1ad25d.gif?ClientID=vimeo-core-prod&Date=1689212426&Signature=dfaf9f770499cb3711050070fa07f7d6a85783df",
        "hero_width_desktop_pct": 0,
        "hero_width_mobile_pct": 0,
        "hero_max_width_desktop_px": 0,
        "hero_height_desktop_px": 0,
        "hero_height_mobile_px": 0,
        "margin_top": 0,
        "margin_bottom": 0,
        "ratio_override": "16:9",
        "vjust": "center",
        "html_desc": "",
        "desc_html": null,
        "end_behavior": "loop",
        "cta": {
          "href": null,
          "text": "Shop Now",
          "thumb_text": ""
        }
      }
    ]
  },
  {
    "heading": "",
    "subheading": "",
    "img_ratio": "1:1",
    "row_height": 0,
    "fit_row": false,
    "margin_top": 0,
    "margin_bottom": 0,
    "collapsed": true,
    "show_more_text": "More",
    "show_less_text": "Less",
    "row_toggle_border_style": "solid",
    "accordion": false,
    "accordion_title": "<h1>Prime</h1>",
    "accordion_subheading": "",
    "accordion_hide_title_when_open": false,
    "accordion_hide_subheading_when_open": false,
    "accordion_title_center": true,
    "accordion_start_open": true,
    "accordion_allow_multiple": false,
    "accordion_bg_color": "#f5f5f5",
    "accordion_shadow_pct": 8,
    "accordion_shadow_style": "raised",
    "accordion_width_mobile_percent": 100,
    "accordion_width_desktop_percent": 100,
    "accordion_max_width_px": 0,
    "accordion_group": "accordion_d4Rpnr",
    "accordion_always_open": true,
    "videos": []
  },
  {
    "heading": "",
    "subheading": "",
    "heading_justify": "center",
    "custom_template_id": "mg-custom-template--18541426475142__c_media_gallery_Gg4wG3-2",
    "custom_html": "<div class=\"centerAll InfoSubPanel\">\n      <ul class=\"InfoSubPanelText\">\n        <li>\n          Brush, roll or spray on 2 coats of <b class=\"Name_of_Primer\"></b><br>\n          <center style=\"color:red; font-size:x-small;\">\n            If you use a roller, be sure to run a brush through it, while still wet,in long even strokes\n          </center>\n        </li>\n        <li>\n          Make final brush strokes long in the direction you want the grain. If you rolled it<br>on you will need to run\n          the brush through it afterward while still wet.\n        </li>\n        <li>Clean your brush/equipment while you give the project 2 hours to dry completely.</li>\n        <li>\n          If you are limited on time, then use a blow dryer.<br>\n          <i style=\"font-size: small;\"\n            >(Dry time may take as little as 5 minutes with the use of a blow dryer on high heat)</i\n          >\n        </li>\n      </ul>\n    </div>",
    "custom_width_desktop_percent": 100,
    "custom_width_mobile_percent": 100,
    "custom_max_width_px": "0",
    "img_ratio": "1:1",
    "row_height": 0,
    "fit_row": false,
    "margin_top": 0,
    "margin_bottom": 0,
    "collapsed": false,
    "show_more_text": "Show more",
    "show_less_text": "Show less",
    "row_toggle_border_style": "solid",
    "accordion": false,
    "accordion_marker": false,
    "accordion_title": "<h1>Prime</h1>",
    "accordion_subheading": "",
    "accordion_hide_title_when_open": false,
    "accordion_hide_subheading_when_open": false,
    "accordion_title_center": true,
    "accordion_start_open": true,
    "accordion_allow_multiple": false,
    "accordion_bg_color": "#f5f5f5",
    "accordion_shadow_pct": 8,
    "accordion_shadow_style": "raised",
    "accordion_width_mobile_percent": 100,
    "accordion_width_desktop_percent": 100,
    "accordion_max_width_px": 0,
    "accordion_group": "accordion_d4Rpnr",
    "accordion_always_open": true,
    "videos": []
  },
  {
    "heading": "",
    "subheading": "",
    "img_ratio": "1:1",
    "row_height": 0,
    "fit_row": false,
    "collapsed": false,
    "show_more_text": "Show more",
    "show_less_text": "Show less",
    "row_toggle_border_style": "solid",
    "accordion": true,
    "accordion_marker": true,
    "accordion_title": "<h1>Stain</h1>",
    "accordion_subheading": "",
    "accordion_hide_title_when_open": false,
    "accordion_hide_subheading_when_open": false,
    "accordion_title_center": true,
    "accordion_start_open": true,
    "accordion_allow_multiple": false,
    "accordion_bg_color": "#f5f5f5",
    "accordion_shadow_pct": 8,
    "accordion_shadow_style": "raised",
    "accordion_width_mobile_percent": 100,
    "accordion_width_desktop_percent": 100,
    "accordion_max_width_px": 0,
    "accordion_group": "accordion_MxD6wm",
    "accordion_always_open": true,
    "videos": []
  },
  {
    "heading": "",
    "subheading": "",
    "img_ratio": "1:1",
    "row_height": 0,
    "fit_row": false,
    "margin_top": 0,
    "margin_bottom": 0,
    "collapsed": false,
    "show_more_text": "Show more",
    "show_less_text": "Show less",
    "row_toggle_border_style": "solid",
    "accordion": false,
    "accordion_title": "<h1>Stain</h1>",
    "accordion_subheading": "",
    "accordion_hide_title_when_open": false,
    "accordion_hide_subheading_when_open": false,
    "accordion_title_center": true,
    "accordion_start_open": true,
    "accordion_allow_multiple": false,
    "accordion_bg_color": "#f5f5f5",
    "accordion_shadow_pct": 8,
    "accordion_shadow_style": "raised",
    "accordion_width_mobile_percent": 100,
    "accordion_width_desktop_percent": 100,
    "accordion_max_width_px": 0,
    "accordion_group": "accordion_MxD6wm",
    "accordion_always_open": true,
    "videos": [
      {
        "type": "video",
        "hero": true,
        "hero_autoplay_preview": false,
        "hero_show_play_badge": true,
        "hero_show_play_button": true,
        "open_full_video_text": "",
        "title": "",
        "heading_html": "",
        "subheading_html": "",
        "alt": "",
        "url": "https://vimeo.com/841018134?share=copy&fl=sv&fe=ci#t=14",
        "start_time": "",
        "thumbnail": "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/3adb4f93-bf0f-4879-8302-cf332ca1e090.gif?ClientID=sulu&Date=1778193653&Signature=06d4c17d1582df8cc6e2e897cdca9c1775273664",
        "hero_width_desktop_pct": 0,
        "hero_width_mobile_pct": 0,
        "hero_max_width_desktop_px": 0,
        "hero_height_desktop_px": 0,
        "hero_height_mobile_px": 0,
        "margin_top": 0,
        "margin_bottom": 0,
        "ratio_override": "16:9",
        "vjust": "center",
        "html_desc": "",
        "desc_html": null,
        "end_behavior": "loop",
        "cta": {
          "href": null,
          "text": "Shop Now",
          "thumb_text": ""
        }
      }
    ]
  },
  {
    "heading": "",
    "subheading": "",
    "heading_justify": "center",
    "custom_template_id": "mg-custom-template--18541426475142__c_media_gallery_Gg4wG3-3",
    "custom_html": "<h3 style=\"text-align: center;\">\n  Apply 1 to 3 coats of Gel Stain Alternative \n  <sup style=\"font-weight:300; opacity:0.6; font-size:0.7em;\">(Optional)</sup>\n</h3>\n<br>",
    "custom_width_desktop_percent": 100,
    "custom_width_mobile_percent": 100,
    "custom_max_width_px": "0",
    "img_ratio": "1:1",
    "row_height": 0,
    "fit_row": false,
    "margin_top": 0,
    "margin_bottom": 0,
    "collapsed": false,
    "show_more_text": "Show more",
    "show_less_text": "Show less",
    "row_toggle_border_style": "solid",
    "accordion": false,
    "accordion_marker": false,
    "accordion_title": "<h1>Stain</h1>",
    "accordion_subheading": "",
    "accordion_hide_title_when_open": false,
    "accordion_hide_subheading_when_open": false,
    "accordion_title_center": true,
    "accordion_start_open": true,
    "accordion_allow_multiple": false,
    "accordion_bg_color": "#f5f5f5",
    "accordion_shadow_pct": 8,
    "accordion_shadow_style": "raised",
    "accordion_width_mobile_percent": 100,
    "accordion_width_desktop_percent": 100,
    "accordion_max_width_px": 0,
    "accordion_group": "accordion_MxD6wm",
    "accordion_always_open": true,
    "videos": []
  },
  {
    "heading": "",
    "subheading": "",
    "img_ratio": "1:1",
    "row_height": 0,
    "fit_row": false,
    "margin_top": 0,
    "margin_bottom": 0,
    "collapsed": true,
    "show_more_text": "More",
    "show_less_text": "Less",
    "row_toggle_border_style": "solid",
    "accordion": false,
    "accordion_title": "<h1>Stain</h1>",
    "accordion_subheading": "",
    "accordion_hide_title_when_open": false,
    "accordion_hide_subheading_when_open": false,
    "accordion_title_center": true,
    "accordion_start_open": true,
    "accordion_allow_multiple": false,
    "accordion_bg_color": "#f5f5f5",
    "accordion_shadow_pct": 8,
    "accordion_shadow_style": "raised",
    "accordion_width_mobile_percent": 100,
    "accordion_width_desktop_percent": 100,
    "accordion_max_width_px": 0,
    "accordion_group": "accordion_MxD6wm",
    "accordion_always_open": true,
    "videos": []
  },
  {
    "heading": "",
    "subheading": "",
    "heading_justify": "center",
    "custom_template_id": "mg-custom-template--18541426475142__c_media_gallery_Gg4wG3-4",
    "custom_html": "<div class=\"heading h3 centerAll\">\n  <br>\n  <b>Apply Gel Stain</b> <sup><i>Alternative</i></sup>\n</div>\n<center><i style=\"font-size:xx-small;\">This step is optional</i><br></center>\n<br>\n<div class=\"centerAll\">\n  <ul style=\"max-width: 650px;\">\n    <li>Apply 1 to 3 coats of Gel Stain Alternative, as desired.</li>\n    <li>You can use a brush, sponge or lint free cloth like a clean sock\n      <br><i>Keep working the stain until all speckles are gone.</i>\n    </li>\n    <li>Make your final swipes long in the direction you want the grain.</li>\n    <li>Allow each coat 2 hours to dry. You can use a blow dryer to speed up dry time to a little as 5\n      minutes.<br>\n\n    </li>\n  </ul>\n</div>",
    "custom_width_desktop_percent": 100,
    "custom_width_mobile_percent": 100,
    "custom_max_width_px": "0",
    "img_ratio": "1:1",
    "row_height": 0,
    "fit_row": false,
    "margin_top": 0,
    "margin_bottom": 0,
    "collapsed": false,
    "show_more_text": "Show more",
    "show_less_text": "Show less",
    "row_toggle_border_style": "solid",
    "accordion": false,
    "accordion_marker": false,
    "accordion_title": "<h1>Stain</h1>",
    "accordion_subheading": "",
    "accordion_hide_title_when_open": false,
    "accordion_hide_subheading_when_open": false,
    "accordion_title_center": true,
    "accordion_start_open": true,
    "accordion_allow_multiple": false,
    "accordion_bg_color": "#f5f5f5",
    "accordion_shadow_pct": 8,
    "accordion_shadow_style": "raised",
    "accordion_width_mobile_percent": 100,
    "accordion_width_desktop_percent": 100,
    "accordion_max_width_px": 0,
    "accordion_group": "accordion_MxD6wm",
    "accordion_always_open": true,
    "videos": []
  },
  {
    "heading": "",
    "subheading": "",
    "img_ratio": "1:1",
    "row_height": 0,
    "fit_row": false,
    "collapsed": false,
    "show_more_text": "Show more",
    "show_less_text": "Show less",
    "row_toggle_border_style": "solid",
    "accordion": true,
    "accordion_marker": true,
    "accordion_title": "<h1>Seal</h1>",
    "accordion_subheading": "",
    "accordion_hide_title_when_open": false,
    "accordion_hide_subheading_when_open": false,
    "accordion_title_center": true,
    "accordion_start_open": true,
    "accordion_allow_multiple": false,
    "accordion_bg_color": "#f5f5f5",
    "accordion_shadow_pct": 8,
    "accordion_shadow_style": "raised",
    "accordion_width_mobile_percent": 100,
    "accordion_width_desktop_percent": 100,
    "accordion_max_width_px": 0,
    "accordion_group": "accordion_zqnBgc",
    "accordion_always_open": true,
    "videos": []
  },
  {
    "heading": "",
    "subheading": "",
    "img_ratio": "1:1",
    "row_height": 0,
    "fit_row": false,
    "margin_top": 0,
    "margin_bottom": 0,
    "collapsed": false,
    "show_more_text": "Show more",
    "show_less_text": "Show less",
    "row_toggle_border_style": "solid",
    "swatch_row": false,
    "row_justify": "center",
    "heading_justify": "center",
    "accordion": false,
    "accordion_title": "<h1>Seal</h1>",
    "accordion_subheading": "",
    "accordion_hide_title_when_open": false,
    "accordion_hide_subheading_when_open": false,
    "accordion_title_center": true,
    "accordion_start_open": true,
    "accordion_allow_multiple": false,
    "accordion_bg_color": "#f5f5f5",
    "accordion_shadow_pct": 8,
    "accordion_shadow_style": "raised",
    "accordion_width_mobile_percent": 100,
    "accordion_width_desktop_percent": 100,
    "accordion_max_width_px": 0,
    "accordion_group": "accordion_zqnBgc",
    "accordion_always_open": true,
    "videos": [
      {
        "type": "video",
        "hero": true,
        "hero_autoplay_preview": false,
        "hero_show_play_badge": false,
        "hero_show_play_button": false,
        "open_full_video_text": "",
        "title": "Topcoat is optional depending on the project.",
        "heading_html": "<h3><em>Topcoat is optional depending on the project.</em></h3>",
        "subheading_html": "",
        "alt": "Topcoat is optional depending on the project.",
        "url": null,
        "start_time": "",
        "thumbnail": "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/995b3a4c-356b-4609-975c-efcd12356526.gif?ClientID=sulu&Date=1778193653&Signature=b5d87f32dc3e36dbced37b2861f8aaf697ba72f0",
        "hero_width_desktop_pct": 0,
        "hero_width_mobile_pct": 0,
        "hero_max_width_desktop_px": 0,
        "hero_height_desktop_px": 0,
        "hero_height_mobile_px": 0,
        "margin_top": 0,
        "margin_bottom": 0,
        "ratio_override": "16:9",
        "vjust": "center",
        "html_desc": "",
        "desc_html": null,
        "end_behavior": "next",
        "cta": {
          "href": null,
          "text": "Shop Now",
          "thumb_text": ""
        }
      }
    ]
  },
  {
    "heading": "",
    "subheading": "",
    "img_ratio": "4:5",
    "row_height": 0,
    "fit_row": true,
    "margin_top": 0,
    "margin_bottom": 0,
    "collapsed": true,
    "show_more_text": "More",
    "show_less_text": "Less",
    "row_toggle_border_style": "solid",
    "accordion": false,
    "accordion_title": "<h1>Seal</h1>",
    "accordion_subheading": "",
    "accordion_hide_title_when_open": false,
    "accordion_hide_subheading_when_open": false,
    "accordion_title_center": true,
    "accordion_start_open": true,
    "accordion_allow_multiple": false,
    "accordion_bg_color": "#f5f5f5",
    "accordion_shadow_pct": 8,
    "accordion_shadow_style": "raised",
    "accordion_width_mobile_percent": 100,
    "accordion_width_desktop_percent": 100,
    "accordion_max_width_px": 0,
    "accordion_group": "accordion_zqnBgc",
    "accordion_always_open": true,
    "videos": []
  },
  {
    "heading": "",
    "subheading": "",
    "heading_justify": "center",
    "custom_template_id": "mg-custom-template--18541426475142__c_media_gallery_Gg4wG3-5",
    "custom_html": "<div id=\"Top_Coat_Optional_WoodnStain\" class=\"centerAll\">\n  <div style=\"display:flex; justify-content:center; gap:40px; flex-wrap:nowrap;\">\n\n    <div style=\"white-space:nowrap;\">\n      <b>Topcoat Required</b><br>\n      <ul>\n        <li>Countertops</li>\n        <li>Tabletops</li>\n        <li>Flooring</li>\n        <li>Porches</li>\n        <li>Decking</li>\n      </ul>\n    </div>\n\n    <div style=\"white-space:nowrap;\">\n      <b>Topcoat Optional</b><br>\n      <ul>\n        <li>Fireplaces</li>\n        <li>Cabinets</li>\n        <li>Buffets</li>\n        <li>Dressers</li>\n        <li>Molding</li>\n      </ul>\n    </div>\n\n  </div>\n</div>",
    "custom_width_desktop_percent": 100,
    "custom_width_mobile_percent": 100,
    "custom_max_width_px": "0",
    "img_ratio": "1:1",
    "row_height": 0,
    "fit_row": false,
    "margin_top": 0,
    "margin_bottom": 0,
    "collapsed": false,
    "show_more_text": "Show more",
    "show_less_text": "Show less",
    "row_toggle_border_style": "solid",
    "accordion": false,
    "accordion_marker": false,
    "accordion_title": "<h1>Seal</h1>",
    "accordion_subheading": "",
    "accordion_hide_title_when_open": false,
    "accordion_hide_subheading_when_open": false,
    "accordion_title_center": true,
    "accordion_start_open": true,
    "accordion_allow_multiple": false,
    "accordion_bg_color": "#f5f5f5",
    "accordion_shadow_pct": 8,
    "accordion_shadow_style": "raised",
    "accordion_width_mobile_percent": 100,
    "accordion_width_desktop_percent": 100,
    "accordion_max_width_px": 0,
    "accordion_group": "accordion_zqnBgc",
    "accordion_always_open": true,
    "videos": []
  }
];
window.MEDIA_GALLERY_SETS["StepsGrainedFinishes"] = [
  {
    "heading": "<p>Retique It® Liquid Wood Coatings</p>",
    "subheading": "<h1>Wood Graining</h1>",
    "heading_justify": "center",
    "custom_template_id": "mg-custom-template--18365028532358__c_media_gallery_7kcH4m-0",
    "custom_html": "<center>\nStep-By-Step\n</center>\n<style>\n  .heading {\n    margin-bottom: 8px;\n  }\n\n  .clsReadMore {\n    box-shadow: 0px 1px 0px 0px #3e7327;\n    background: linear-gradient(to bottom, #77b55a 5%, #72b352 100%);\n    background-color: #77b55a;\n    border-radius: 15px;\n    border: 2px solid #4b8f29;\n    display: inline-block;\n    cursor: pointer;\n    color: #ffffff;\n    font-size: 14px;\n    font-weight: bold;\n    padding: 12px 16px;\n    text-decoration: none;\n    text-shadow: 0px 1px 0px #5b8a3c;\n  }\n\n  .clsReadMore:hover {\n    background: linear-gradient(to bottom, #72b352 5%, #77b55a 100%);\n    background-color: #72b352;\n  }\n\n  .clsReadMore:active {\n    position: relative;\n    top: 1px;\n  }\n\n  .vidDiv {\n    margin: auto;\n    max-width: 100%;\n    width: fit-content;\n    padding-top: 10px;\n    padding-bottom: 10px;\n  }\n\n  .centerAll {\n    margin: auto;\n    width: fit-content;\n  }\n\n  .finalCoats {\n    text-align: center;\n    Width: 32%;\n    display: inline-block;\n  }\n\n  .Prep {\n    content: var(--Prep);\n  }\n\n  .Step-Prep {\n    content: var(--Step-Prep);\n  }\n\n    .Step-Sand {\n    content: var(--Step-Sand);\n  }\n\n    .Step-Wash {\n    content: var(--Step-Wash);\n  }\n\n  .Step-Tape {\n    content: var(--Step-Tape);\n  }\n\n  .Step-Prime {\n    content: var(--Step-Prime);\n  }\n\n  .Step-Prime-Image {\n    content: var(--Step-Prime-Image);\n  }\n\n  .Step-Grain {\n    content: var(--Step-Grain);\n  }\n\n    .Step-WashTools {\n    content: var(--Step-WashTools);\n  }\n\n  .Step-Paint {\n    content: var(--Step-Paint);\n  }\n\n    .Step-Paint-Image {\n    content: var(--Step-Paint-Image);\n  }\n\n  .Step-Stain {\n    content: var(--Step-Stain);\n  }\n\n  .Step-WoodnStain {\n    content: var(--Step-WoodnStain);\n  }\n  \n  .Step-GelStain {\n    content: var(--Step-GelStain);\n  }\n\n  .Step-Stain-Image {\n    content: var(--Step-Stain-Image);\n  }\n\n  .Step-Seal {\n    content: var(--Step-Seal);\n  }\n\n  .Step-Love {\n    content: var(--Step-Love);\n  }\n\n  .Step-Love-Image {\n    content: var(--Step-Love-Image);\n  }\n\n  .Step-FinalResult {\n    content: var(--Step-FinalResult);\n  }\n\n  .Demo-Vimeo-ID {\n    content: var(--Demo-Vimeo-ID);\n  }\n\n  .Finish01 {\n    content: var(--Finish01);\n  }\n\n  .Finish02 {\n    content: var(--Finish02);\n  }\n\n  .Finish03 {\n    content: var(--Finish03);\n  }\n\n  .Finish01_Text:before {\n    content: var(--Finish01_Text);\n  }\n\n  .Finish02_Text:before {\n    content: var(--Finish02_Text);\n  }\n\n  .Finish03_Text:before {\n    content: var(--Finish03_Text);\n  }\n\n  .Name_of_Primer::before {\n    content: var(--Name_of_Primer);\n  }\n\n  .Color_of_Stain::before {\n    content: var(--Color_of_Stain);\n  }\n\n  .Kit_Type::before {\n    content: var(--Kit_Type);\n  }\n\n  .Name_of_Stain::before {\n    content: var(--Name_of_Stain);\n  }\n\n  .Name_of_Sealer::before {\n    content: var(--Name_of_Sealer);\n  }\n\n  .divTitle::before {\n    content: var(--Title);\n  }\n\n  .GelStainName::before {\n    content: var(--NameGelStain);\n  }\n  \n  #CoatsOfWoodnStain::before {\n    content: var(--CoatsOfWoodnStain)\n  }\n</style>\n<script>\n  function ReadMoreButton(btnCTRL, CTRLname, varReadMore = 'Read more', varReadLess = 'Read less') {\n    try {\n      var moreText = document.getElementById(CTRLname);\n      var btnText = btnCTRL;\n\n      if (moreText.style.display === \"none\") {\n        btnText.innerHTML = \"Read less\";\n        moreText.style.display = \"block\";\n      } else {\n        btnText.innerHTML = \"Read more\";\n        moreText.style.display = \"none\";\n      }\n    } catch (error) {\n      alert(error);\n    }\n  }\n\n  function jump(hash) {\n    var element_to_scroll_to = document.getElementById('moreSteps');\n    element_to_scroll_to.scrollIntoView();\n  }\n</script>\n\n<br>",
    "custom_width_desktop_percent": 100,
    "custom_width_mobile_percent": 100,
    "custom_max_width_px": "0",
    "img_ratio": "1:1",
    "row_height": 0,
    "fit_row": false,
    "margin_top": 0,
    "margin_bottom": 0,
    "collapsed": false,
    "show_more_text": "Show more",
    "show_less_text": "Show less",
    "row_toggle_border_style": "solid",
    "accordion": false,
    "accordion_marker": false,
    "accordion_title": "",
    "accordion_subheading": "",
    "accordion_hide_title_when_open": false,
    "accordion_hide_subheading_when_open": false,
    "accordion_title_center": true,
    "accordion_start_open": false,
    "accordion_allow_multiple": false,
    "accordion_bg_color": "#f5f5f5",
    "accordion_shadow_pct": 8,
    "accordion_shadow_style": "raised",
    "accordion_width_mobile_percent": 100,
    "accordion_width_desktop_percent": 100,
    "accordion_max_width_px": 0,
    "accordion_group": "",
    "accordion_always_open": false,
    "videos": []
  },
  {
    "heading": "",
    "subheading": "",
    "img_ratio": "16:9",
    "row_height": 0,
    "fit_row": true,
    "collapsed": false,
    "show_more_text": "Show more",
    "show_less_text": "Show less",
    "row_toggle_border_style": "solid",
    "accordion": true,
    "accordion_marker": true,
    "accordion_title": "<h1>Prep</h1>",
    "accordion_subheading": "",
    "accordion_hide_title_when_open": false,
    "accordion_hide_subheading_when_open": false,
    "accordion_title_center": true,
    "accordion_start_open": true,
    "accordion_allow_multiple": false,
    "accordion_bg_color": "#f5f5f5",
    "accordion_shadow_pct": 8,
    "accordion_shadow_style": "raised",
    "accordion_width_mobile_percent": 100,
    "accordion_width_desktop_percent": 100,
    "accordion_max_width_px": "0",
    "accordion_group": "accordion_8RJadh",
    "accordion_always_open": true,
    "videos": []
  },
  {
    "heading": "",
    "subheading": "",
    "img_ratio": "1:1",
    "row_height": 0,
    "fit_row": false,
    "margin_top": 0,
    "margin_bottom": 0,
    "collapsed": false,
    "show_more_text": "Show more",
    "show_less_text": "Show less",
    "row_toggle_border_style": "solid",
    "swatch_row": false,
    "row_justify": "center",
    "heading_justify": "center",
    "accordion": false,
    "accordion_title": "<h1>Prep</h1>",
    "accordion_subheading": "",
    "accordion_hide_title_when_open": false,
    "accordion_hide_subheading_when_open": false,
    "accordion_title_center": true,
    "accordion_start_open": true,
    "accordion_allow_multiple": false,
    "accordion_bg_color": "#f5f5f5",
    "accordion_shadow_pct": 8,
    "accordion_shadow_style": "raised",
    "accordion_width_mobile_percent": 100,
    "accordion_width_desktop_percent": 100,
    "accordion_max_width_px": "0",
    "accordion_group": "accordion_8RJadh",
    "accordion_always_open": true,
    "videos": [
      {
        "type": "video",
        "hero": true,
        "hero_autoplay_preview": false,
        "hero_show_play_badge": true,
        "hero_show_play_button": true,
        "open_full_video_text": "",
        "title": "Degrease, Scuff Sand, Wash",
        "heading_html": "<h2><em>Degrease, Scuff Sand, Wash</em></h2>",
        "subheading_html": "",
        "alt": "Degrease, Scuff Sand, Wash",
        "url": "https://vimeo.com/766195508?share=copy&fl=sv&fe=ci#t=36",
        "start_time": "",
        "thumbnail": "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/ddd3c480-704f-4e7f-b0bb-d4a04f93c3c4.gif?ClientID=vimeo-core-prod&Date=1687896686&Signature=25eb0532c9e917792122142f8904eb8f2761b787",
        "hero_width_desktop_pct": 0,
        "hero_width_mobile_pct": 0,
        "hero_max_width_desktop_px": 0,
        "hero_height_desktop_px": 0,
        "hero_height_mobile_px": 0,
        "margin_top": 0,
        "margin_bottom": 0,
        "ratio_override": "16:9",
        "vjust": "center",
        "html_desc": "",
        "desc_html": null,
        "end_behavior": "loop",
        "cta": {
          "href": null,
          "text": "Shop Now",
          "thumb_text": ""
        }
      }
    ]
  },
  {
    "heading": "",
    "subheading": "",
    "img_ratio": "1:1",
    "row_height": 0,
    "fit_row": false,
    "margin_top": 0,
    "margin_bottom": 0,
    "collapsed": true,
    "show_more_text": "More",
    "show_less_text": "Less",
    "row_toggle_border_style": "solid",
    "accordion": false,
    "accordion_title": "<h1>Prep</h1>",
    "accordion_subheading": "",
    "accordion_hide_title_when_open": false,
    "accordion_hide_subheading_when_open": false,
    "accordion_title_center": true,
    "accordion_start_open": true,
    "accordion_allow_multiple": false,
    "accordion_bg_color": "#f5f5f5",
    "accordion_shadow_pct": 8,
    "accordion_shadow_style": "raised",
    "accordion_width_mobile_percent": 100,
    "accordion_width_desktop_percent": 100,
    "accordion_max_width_px": "0",
    "accordion_group": "accordion_8RJadh",
    "accordion_always_open": true,
    "videos": []
  },
  {
    "heading": "",
    "subheading": "",
    "heading_justify": "center",
    "custom_template_id": "mg-custom-template--18365028532358__c_media_gallery_7kcH4m-1",
    "custom_html": "<style>\n  .section {\n    text-align: center;\n    margin: 2rem auto;\n  }\n\n  .responsive-img {\n    width: 100%;\n    max-width: 600px;\n    height: auto;\n    display: block;\n    margin: 1rem auto;\n  }\n\n  .content {\n    max-width: 650px;\n    margin: 0 auto;\n    text-align: left;\n  }\n\n  .content ul {\n    padding-left: 1.2rem;\n  }\n\n  .warning {\n    text-align: center;\n    color: red;\n    font-weight: bold;\n    margin: 0.5rem 0;\n  }\n\n  .warning-sub {\n    text-align: center;\n    font-size: 0.85rem;\n    opacity: 0.7;\n    margin-bottom: 0.5rem;\n  }\n</style>\n\n<!-- Top Image -->\n<div class=\"section\">\n  <img \n    src=\"https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Sun_Bleached_Table-Steps-Prep-Steps.jpg?width=400\"\n    class=\"responsive-img\"\n    alt=\"Prep Steps\"\n  >\n</div>\n\n<!-- Prep Steps -->\n<div class=\"section\">\n  <div class=\"content\">\n    <ul>\n      <li>Wipe down with denatured alcohol mixed with water or with Krud Kutter®.</li>\n    </ul>\n\n    <div class=\"warning\"><i>NEVER USE TSP PRODUCTS</i></div>\n    <div class=\"warning-sub\">(TSP will cause wood-based coatings to not adhere properly)</div>\n\n    <ul>\n      <li>\n        Scuff sand: Lightly sand the surface, especially if it is slick or glossy, to help the primer adhere properly.\n      </li>\n      <li>\n        Wash the surface with Dawn® Dish Soap and rinse thoroughly with warm water until the surface is squeaky clean.\n      </li>\n    </ul>\n  </div>\n</div>",
    "custom_width_desktop_percent": 100,
    "custom_width_mobile_percent": 100,
    "custom_max_width_px": "0",
    "img_ratio": "1:1",
    "row_height": 0,
    "fit_row": false,
    "margin_top": 0,
    "margin_bottom": 0,
    "collapsed": false,
    "show_more_text": "Show more",
    "show_less_text": "Show less",
    "row_toggle_border_style": "solid",
    "accordion": false,
    "accordion_marker": false,
    "accordion_title": "<h1>Prep</h1>",
    "accordion_subheading": "",
    "accordion_hide_title_when_open": false,
    "accordion_hide_subheading_when_open": false,
    "accordion_title_center": true,
    "accordion_start_open": true,
    "accordion_allow_multiple": false,
    "accordion_bg_color": "#f5f5f5",
    "accordion_shadow_pct": 8,
    "accordion_shadow_style": "raised",
    "accordion_width_mobile_percent": 100,
    "accordion_width_desktop_percent": 100,
    "accordion_max_width_px": "0",
    "accordion_group": "accordion_8RJadh",
    "accordion_always_open": true,
    "videos": []
  },
  {
    "heading": "",
    "subheading": "",
    "img_ratio": "1:1",
    "row_height": 0,
    "fit_row": false,
    "collapsed": false,
    "show_more_text": "Show more",
    "show_less_text": "Show less",
    "row_toggle_border_style": "solid",
    "accordion": true,
    "accordion_marker": true,
    "accordion_title": "<h1>Prime</h1>",
    "accordion_subheading": "",
    "accordion_hide_title_when_open": false,
    "accordion_hide_subheading_when_open": false,
    "accordion_title_center": true,
    "accordion_start_open": true,
    "accordion_allow_multiple": false,
    "accordion_bg_color": "#f5f5f5",
    "accordion_shadow_pct": 8,
    "accordion_shadow_style": "raised",
    "accordion_width_mobile_percent": 100,
    "accordion_width_desktop_percent": 100,
    "accordion_max_width_px": "0",
    "accordion_group": "accordion_Vbjk4V",
    "accordion_always_open": true,
    "videos": []
  },
  {
    "heading": "",
    "subheading": "",
    "img_ratio": "1:1",
    "row_height": 0,
    "fit_row": false,
    "margin_top": 0,
    "margin_bottom": 0,
    "collapsed": false,
    "show_more_text": "Show more",
    "show_less_text": "Show less",
    "row_toggle_border_style": "solid",
    "swatch_row": false,
    "row_justify": "center",
    "heading_justify": "center",
    "accordion": false,
    "accordion_title": "<h1>Prime</h1>",
    "accordion_subheading": "",
    "accordion_hide_title_when_open": false,
    "accordion_hide_subheading_when_open": false,
    "accordion_title_center": true,
    "accordion_start_open": true,
    "accordion_allow_multiple": false,
    "accordion_bg_color": "#f5f5f5",
    "accordion_shadow_pct": 8,
    "accordion_shadow_style": "raised",
    "accordion_width_mobile_percent": 100,
    "accordion_width_desktop_percent": 100,
    "accordion_max_width_px": "0",
    "accordion_group": "accordion_Vbjk4V",
    "accordion_always_open": true,
    "videos": [
      {
        "type": "video",
        "hero": true,
        "hero_autoplay_preview": false,
        "hero_show_play_badge": true,
        "hero_show_play_button": true,
        "open_full_video_text": "",
        "title": "Apply 2 Coats of Wood'n Primer",
        "heading_html": "<h2>Apply 2 Coats of Wood'n Primer</h2>",
        "subheading_html": "",
        "alt": "Apply 2 Coats of Wood'n Primer",
        "url": "https://vimeo.com/766195508?share=copy&fl=sv&fe=ci#t=50",
        "start_time": "",
        "thumbnail": "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/b9cae2ff-6775-41b8-851d-67e165a2926d.gif?ClientID=vimeo-core-prod&Date=1687901677&Signature=806a7cdd0642b791fdaa2456574823b883e9a51d",
        "hero_width_desktop_pct": 0,
        "hero_width_mobile_pct": 0,
        "hero_max_width_desktop_px": 0,
        "hero_height_desktop_px": 0,
        "hero_height_mobile_px": 0,
        "margin_top": 0,
        "margin_bottom": 0,
        "ratio_override": "16:9",
        "vjust": "center",
        "html_desc": "",
        "desc_html": null,
        "end_behavior": "loop",
        "cta": {
          "href": null,
          "text": "Shop Now",
          "thumb_text": ""
        }
      }
    ]
  },
  {
    "heading": "",
    "subheading": "",
    "img_ratio": "1:1",
    "row_height": 0,
    "fit_row": false,
    "margin_top": 0,
    "margin_bottom": 0,
    "collapsed": true,
    "show_more_text": "More",
    "show_less_text": "Less",
    "row_toggle_border_style": "solid",
    "accordion": false,
    "accordion_title": "<h1>Prime</h1>",
    "accordion_subheading": "",
    "accordion_hide_title_when_open": false,
    "accordion_hide_subheading_when_open": false,
    "accordion_title_center": true,
    "accordion_start_open": true,
    "accordion_allow_multiple": false,
    "accordion_bg_color": "#f5f5f5",
    "accordion_shadow_pct": 8,
    "accordion_shadow_style": "raised",
    "accordion_width_mobile_percent": 100,
    "accordion_width_desktop_percent": 100,
    "accordion_max_width_px": "0",
    "accordion_group": "accordion_Vbjk4V",
    "accordion_always_open": true,
    "videos": []
  },
  {
    "heading": "",
    "subheading": "",
    "heading_justify": "center",
    "custom_template_id": "mg-custom-template--18365028532358__c_media_gallery_7kcH4m-2",
    "custom_html": "<style>\n  .section {\n    text-align: center;\n    margin: 2rem auto;\n  }\n\n  .responsive-img {\n    width: 100%;\n    max-width: 600px;\n    height: auto;\n    display: block;\n    margin: 1rem auto;\n  }\n\n  .content {\n    max-width: 650px;\n    margin: 0 auto;\n    text-align: left;\n  }\n\n  .content ul {\n    padding-left: 1.2rem;\n  }\n\n  .tip {\n    color: red;\n    font-size: 0.85rem;\n    margin-top: 0.4rem;\n  }\n\n  .sub-note {\n    font-size: 0.85rem;\n    opacity: 0.7;\n  }\n</style>\n\n<!-- Top Image -->\n<div class=\"section\">\n  <img \n    src=\"https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Sun_Bleached_Table-Steps-Prime-Steps.jpg?width=400\"\n    class=\"responsive-img\"\n    alt=\"Prime Steps\"\n  >\n</div>\n\n<!-- Prime Steps -->\n<div class=\"section\">\n  <div class=\"content\">\n    <ul>\n      <li>\n        Brush, roll, or spray on 2 coats of <b class=\"Name_of_Primer\"></b>.\n        <div class=\"tip\">\n          If using a roller, lightly run a brush through the surface while still wet using long, even strokes.\n        </div>\n      </li>\n\n      <li>\n        Make final brush strokes long in the direction you want the grain. If rolled, follow with a brush while still wet.\n      </li>\n\n      <li>\n        Clean your brush/equipment while allowing the project 2 hours to dry completely.\n      </li>\n\n      <li>\n        If you are limited on time, use a blow dryer.\n        <div class=\"sub-note\">\n          (Dry time may take as little as 5 minutes using a blow dryer on high heat)\n        </div>\n      </li>\n    </ul>\n  </div>\n</div>",
    "custom_width_desktop_percent": 100,
    "custom_width_mobile_percent": 100,
    "custom_max_width_px": "0",
    "img_ratio": "1:1",
    "row_height": 0,
    "fit_row": false,
    "margin_top": 0,
    "margin_bottom": 0,
    "collapsed": false,
    "show_more_text": "Show more",
    "show_less_text": "Show less",
    "row_toggle_border_style": "solid",
    "accordion": false,
    "accordion_marker": false,
    "accordion_title": "<h1>Prime</h1>",
    "accordion_subheading": "",
    "accordion_hide_title_when_open": false,
    "accordion_hide_subheading_when_open": false,
    "accordion_title_center": true,
    "accordion_start_open": true,
    "accordion_allow_multiple": false,
    "accordion_bg_color": "#f5f5f5",
    "accordion_shadow_pct": 8,
    "accordion_shadow_style": "raised",
    "accordion_width_mobile_percent": 100,
    "accordion_width_desktop_percent": 100,
    "accordion_max_width_px": "0",
    "accordion_group": "accordion_Vbjk4V",
    "accordion_always_open": true,
    "videos": []
  },
  {
    "heading": "",
    "subheading": "",
    "img_ratio": "16:9",
    "row_height": 0,
    "fit_row": false,
    "collapsed": false,
    "show_more_text": "Show more",
    "show_less_text": "Show less",
    "row_toggle_border_style": "solid",
    "accordion": true,
    "accordion_marker": true,
    "accordion_title": "<h1>Grain</h1>",
    "accordion_subheading": "",
    "accordion_hide_title_when_open": false,
    "accordion_hide_subheading_when_open": false,
    "accordion_title_center": true,
    "accordion_start_open": true,
    "accordion_allow_multiple": false,
    "accordion_bg_color": "#f5f5f5",
    "accordion_shadow_pct": 8,
    "accordion_shadow_style": "raised",
    "accordion_width_mobile_percent": 100,
    "accordion_width_desktop_percent": 100,
    "accordion_max_width_px": "0",
    "accordion_group": "accordion_DpVQ7Q",
    "accordion_always_open": true,
    "videos": []
  },
  {
    "heading": "",
    "subheading": "",
    "img_ratio": "1:1",
    "row_height": 0,
    "fit_row": false,
    "margin_top": 0,
    "margin_bottom": 0,
    "collapsed": false,
    "show_more_text": "Show more",
    "show_less_text": "Show less",
    "row_toggle_border_style": "solid",
    "swatch_row": false,
    "row_justify": "center",
    "heading_justify": "center",
    "accordion": false,
    "accordion_title": "<h1>Grain</h1>",
    "accordion_subheading": "",
    "accordion_hide_title_when_open": false,
    "accordion_hide_subheading_when_open": false,
    "accordion_title_center": true,
    "accordion_start_open": true,
    "accordion_allow_multiple": false,
    "accordion_bg_color": "#f5f5f5",
    "accordion_shadow_pct": 8,
    "accordion_shadow_style": "raised",
    "accordion_width_mobile_percent": 100,
    "accordion_width_desktop_percent": 100,
    "accordion_max_width_px": "0",
    "accordion_group": "accordion_DpVQ7Q",
    "accordion_always_open": true,
    "videos": [
      {
        "type": "video",
        "hero": true,
        "hero_autoplay_preview": false,
        "hero_show_play_badge": true,
        "hero_show_play_button": true,
        "open_full_video_text": "",
        "title": "Grain Wood'n Stain",
        "heading_html": "<h2>Grain Wood'n Stain</h2>",
        "subheading_html": "<p><em>(One thin coat in plank sized sections)</em></p>",
        "alt": "Grain Wood'n Stain",
        "url": "https://vimeo.com/766195508?share=copy&fl=sv&fe=ci#t=91",
        "start_time": "",
        "thumbnail": "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/a913eaea-dafd-42ad-a468-cb1a3188e135.gif?ClientID=sulu&Date=1718978758&Signature=cdf5d5b12b3f63c692623f3363e221a18436357c",
        "hero_width_desktop_pct": 0,
        "hero_width_mobile_pct": 0,
        "hero_max_width_desktop_px": 0,
        "hero_height_desktop_px": 0,
        "hero_height_mobile_px": 0,
        "margin_top": 0,
        "margin_bottom": 0,
        "ratio_override": "16:9",
        "vjust": "center",
        "html_desc": "",
        "desc_html": null,
        "end_behavior": "loop",
        "cta": {
          "href": null,
          "text": "Shop Now",
          "thumb_text": ""
        }
      }
    ]
  },
  {
    "heading": "",
    "subheading": "",
    "img_ratio": "1:1",
    "row_height": 0,
    "fit_row": false,
    "margin_top": 0,
    "margin_bottom": 0,
    "collapsed": true,
    "show_more_text": "More",
    "show_less_text": "Less",
    "row_toggle_border_style": "solid",
    "accordion": false,
    "accordion_title": "<h1>Grain</h1>",
    "accordion_subheading": "",
    "accordion_hide_title_when_open": false,
    "accordion_hide_subheading_when_open": false,
    "accordion_title_center": true,
    "accordion_start_open": true,
    "accordion_allow_multiple": false,
    "accordion_bg_color": "#f5f5f5",
    "accordion_shadow_pct": 8,
    "accordion_shadow_style": "raised",
    "accordion_width_mobile_percent": 100,
    "accordion_width_desktop_percent": 100,
    "accordion_max_width_px": "0",
    "accordion_group": "accordion_DpVQ7Q",
    "accordion_always_open": true,
    "videos": []
  },
  {
    "heading": "",
    "subheading": "",
    "heading_justify": "center",
    "custom_template_id": "mg-custom-template--18365028532358__c_media_gallery_7kcH4m-3",
    "custom_html": "<style>\n  .centerAll {\n    text-align: center;\n    margin: 1rem auto;\n  }\n\n  .responsive-img {\n    width: 100%;\n    max-width: 500px;\n    height: auto;\n    display: block;\n    margin: 0 auto;\n  }\n\n  .note {\n    font-size: 0.85rem;\n    max-width: 600px;\n  }\n\n  .steps-list {\n    display: inline-block;\n    text-align: left;\n    max-width: 600px;\n    padding-left: 1.2rem;\n  }\n</style>\n\n<!-- Top Image (Updated) -->\n<div class=\"centerAll\">\n  <img \n    src=\"https://cdn.shopify.com/s/files/1/0066/5993/2278/files/FrenchOakCountertop-Steps-Grain-Steps.jpg?width=400\"\n    class=\"responsive-img\"\n    alt=\"French Oak Countertop Graining Steps\"\n  >\n</div>\n\n<div class=\"centerAll note\">\n  <i>\n    If you want a smooth finish, skip this step. Follow the Smooth Finish Kit Instructions instead.\n  </i>\n</div>\n\n<div class=\"centerAll\">\n  <ul class=\"steps-list\">\n    <li>Brush on a thin coat of <b>Wood'n Stain</b>™ in plank size sections</li>\n    <li>Pull the graining tool through each section while coat is still wet</li>\n    <li>If you don't like the grain, apply another coat of Wood'n Stain over that section and grain it again</li>\n    <li>Wash your brush and graining tools thoroughly.</li>\n  </ul>\n</div>",
    "custom_width_desktop_percent": 100,
    "custom_width_mobile_percent": 100,
    "custom_max_width_px": "0",
    "img_ratio": "1:1",
    "row_height": 0,
    "fit_row": false,
    "margin_top": 0,
    "margin_bottom": 0,
    "collapsed": false,
    "show_more_text": "Show more",
    "show_less_text": "Show less",
    "row_toggle_border_style": "solid",
    "accordion": false,
    "accordion_marker": false,
    "accordion_title": "<h1>Grain</h1>",
    "accordion_subheading": "",
    "accordion_hide_title_when_open": false,
    "accordion_hide_subheading_when_open": false,
    "accordion_title_center": true,
    "accordion_start_open": true,
    "accordion_allow_multiple": false,
    "accordion_bg_color": "#f5f5f5",
    "accordion_shadow_pct": 8,
    "accordion_shadow_style": "raised",
    "accordion_width_mobile_percent": 100,
    "accordion_width_desktop_percent": 100,
    "accordion_max_width_px": "0",
    "accordion_group": "accordion_DpVQ7Q",
    "accordion_always_open": true,
    "videos": []
  },
  {
    "heading": "",
    "subheading": "",
    "img_ratio": "1:1",
    "row_height": 0,
    "fit_row": false,
    "collapsed": false,
    "show_more_text": "Show more",
    "show_less_text": "Show less",
    "row_toggle_border_style": "solid",
    "accordion": true,
    "accordion_marker": true,
    "accordion_title": "<h1>Stain</h1>",
    "accordion_subheading": "",
    "accordion_hide_title_when_open": false,
    "accordion_hide_subheading_when_open": false,
    "accordion_title_center": true,
    "accordion_start_open": true,
    "accordion_allow_multiple": false,
    "accordion_bg_color": "#f5f5f5",
    "accordion_shadow_pct": 8,
    "accordion_shadow_style": "raised",
    "accordion_width_mobile_percent": 100,
    "accordion_width_desktop_percent": 100,
    "accordion_max_width_px": "0",
    "accordion_group": "accordion_jzqrte",
    "accordion_always_open": true,
    "videos": []
  },
  {
    "heading": "",
    "subheading": "",
    "img_ratio": "1:1",
    "row_height": 0,
    "fit_row": false,
    "margin_top": 0,
    "margin_bottom": 0,
    "collapsed": false,
    "show_more_text": "Show more",
    "show_less_text": "Show less",
    "row_toggle_border_style": "solid",
    "swatch_row": false,
    "row_justify": "center",
    "heading_justify": "center",
    "accordion": false,
    "accordion_title": "<h1>Stain</h1>",
    "accordion_subheading": "",
    "accordion_hide_title_when_open": false,
    "accordion_hide_subheading_when_open": false,
    "accordion_title_center": true,
    "accordion_start_open": true,
    "accordion_allow_multiple": false,
    "accordion_bg_color": "#f5f5f5",
    "accordion_shadow_pct": 8,
    "accordion_shadow_style": "raised",
    "accordion_width_mobile_percent": 100,
    "accordion_width_desktop_percent": 100,
    "accordion_max_width_px": "0",
    "accordion_group": "accordion_jzqrte",
    "accordion_always_open": true,
    "videos": [
      {
        "type": "video",
        "hero": true,
        "hero_autoplay_preview": false,
        "hero_show_play_badge": true,
        "hero_show_play_button": true,
        "open_full_video_text": "",
        "title": "",
        "heading_html": "",
        "subheading_html": "",
        "alt": "",
        "url": "https://vimeo.com/766195508?share=copy&fl=sv&fe=ci",
        "start_time": "",
        "thumbnail": "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/80a91690-f34a-416c-9797-24146de0604e.gif?ClientID=sulu&Date=1718978872&Signature=61172414243e182d7ec05cb99e54d65225a2bc66",
        "hero_width_desktop_pct": 0,
        "hero_width_mobile_pct": 0,
        "hero_max_width_desktop_px": 0,
        "hero_height_desktop_px": 0,
        "hero_height_mobile_px": 0,
        "margin_top": 0,
        "margin_bottom": 0,
        "ratio_override": "16:9",
        "vjust": "center",
        "html_desc": "",
        "desc_html": null,
        "end_behavior": "loop",
        "cta": {
          "href": null,
          "text": "Shop Now",
          "thumb_text": ""
        }
      }
    ]
  },
  {
    "heading": "<h3>Stain over the Grained Finish</h3>",
    "subheading": "",
    "img_ratio": "1:1",
    "row_height": 0,
    "fit_row": false,
    "margin_top": 0,
    "margin_bottom": 0,
    "collapsed": true,
    "show_more_text": "More",
    "show_less_text": "Less",
    "row_toggle_border_style": "solid",
    "accordion": false,
    "accordion_title": "<h1>Stain</h1>",
    "accordion_subheading": "",
    "accordion_hide_title_when_open": false,
    "accordion_hide_subheading_when_open": false,
    "accordion_title_center": true,
    "accordion_start_open": true,
    "accordion_allow_multiple": false,
    "accordion_bg_color": "#f5f5f5",
    "accordion_shadow_pct": 8,
    "accordion_shadow_style": "raised",
    "accordion_width_mobile_percent": 100,
    "accordion_width_desktop_percent": 100,
    "accordion_max_width_px": "0",
    "accordion_group": "accordion_jzqrte",
    "accordion_always_open": true,
    "videos": []
  },
  {
    "heading": "",
    "subheading": "",
    "heading_justify": "center",
    "custom_template_id": "mg-custom-template--18365028532358__c_media_gallery_7kcH4m-4",
    "custom_html": "<style>\n  .section {\n    text-align: center;\n    margin: 2rem auto;\n  }\n\n  .section h3 {\n    margin-bottom: 0.3rem;\n  }\n\n  .optional-note {\n    font-size: 0.7rem;\n    opacity: 0.6;\n    margin-bottom: 1rem;\n  }\n\n  .responsive-img {\n    width: 100%;\n    max-width: 600px;\n    height: auto;\n    display: block;\n    margin: 1rem auto;\n  }\n\n  .content {\n    max-width: 650px;\n    margin: 0 auto;\n    text-align: left;\n  }\n\n  .content ul {\n    padding-left: 1.2rem;\n  }\n\n  .reminder {\n    color: red;\n    font-style: italic;\n    margin: 0.5rem 0;\n  }\n\n  .sub-note {\n    font-size: 0.85rem;\n    opacity: 0.7;\n  }\n</style>\n\n<!-- Top Image -->\n<div class=\"section\">\n  <img \n    src=\"https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Sun_Bleached_Table-WoodnStainIt-0and1coat.jpg?width=400\"\n    class=\"responsive-img\"\n    alt=\"Wood'n Stain Example\"\n  >\n</div>\n\n<!-- Wood'n Stain Section -->\n<div class=\"section\">\n  <h3><b>Apply Wood'n Stain</b></h3>\n  <div class=\"optional-note\"><i>This step is optional</i></div>\n\n  <img class=\"imgDiv Step-WoodnStain responsive-img\" alt=\"Apply Wood'n Stain\">\n\n  <div class=\"content\">\n    <ul>\n      <li>Apply 0 to 3 coats of Wood'n Stain. Each coat will make your project less rustic.</li>\n      <li>Make final strokes long, in the direction you want the grain.</li>\n    </ul>\n\n    <div class=\"reminder\">Reminder: Do not wipe back the stain like other stains.</div>\n\n    <ul>\n      <li>Clean your brush while you give the project 2 hours to dry completely.</li>\n      <li>\n        If you are limited on time, then use a blow dryer.\n        <div class=\"sub-note\">\n          (Dry time may take as little as 5 minutes with a blow dryer on high heat)\n        </div>\n      </li>\n    </ul>\n  </div>\n</div>\n\n<!-- Updated Image Above Gel Stain Section -->\n<div class=\"section\">\n  <img \n    src=\"https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Sun_Bleached_Table-GelStainIt.jpg?width=400\"\n    class=\"responsive-img\"\n    alt=\"Gel Stain Example\"\n  >\n</div>\n\n<!-- Gel Stain Section -->\n<div class=\"section\">\n  <h3>\n    <b>Apply Gel Stain</b>\n    <sup class=\"sub-note\">Alternative</sup>\n  </h3>\n  <div class=\"optional-note\"><i>This step is optional</i></div>\n\n  <img class=\"imgDiv Step-GelStain responsive-img\" alt=\"Apply Gel Stain\">\n\n  <div class=\"content\">\n    <ul>\n      <li>Apply 1 to 3 coats of Gel Stain Alternative, as desired.</li>\n      <li>\n        You can use a brush, sponge, or lint-free cloth (like a clean sock).\n        <div class=\"sub-note\">Keep working the stain until all speckles are gone.</div>\n      </li>\n      <li>Make your final swipes long in the direction you want the grain.</li>\n      <li>\n        Allow each coat 2 hours to dry. You can use a blow dryer to speed up dry time to as little as 5 minutes.\n      </li>\n    </ul>\n  </div>\n</div>",
    "custom_width_desktop_percent": 100,
    "custom_width_mobile_percent": 100,
    "custom_max_width_px": "0",
    "img_ratio": "1:1",
    "row_height": 0,
    "fit_row": false,
    "margin_top": 0,
    "margin_bottom": 0,
    "collapsed": false,
    "show_more_text": "Show more",
    "show_less_text": "Show less",
    "row_toggle_border_style": "solid",
    "accordion": false,
    "accordion_marker": false,
    "accordion_title": "<h1>Stain</h1>",
    "accordion_subheading": "",
    "accordion_hide_title_when_open": false,
    "accordion_hide_subheading_when_open": false,
    "accordion_title_center": true,
    "accordion_start_open": true,
    "accordion_allow_multiple": false,
    "accordion_bg_color": "#f5f5f5",
    "accordion_shadow_pct": 8,
    "accordion_shadow_style": "raised",
    "accordion_width_mobile_percent": 100,
    "accordion_width_desktop_percent": 100,
    "accordion_max_width_px": "0",
    "accordion_group": "accordion_jzqrte",
    "accordion_always_open": true,
    "videos": []
  },
  {
    "heading": "",
    "subheading": "",
    "img_ratio": "1:1",
    "row_height": 0,
    "fit_row": false,
    "collapsed": false,
    "show_more_text": "Show more",
    "show_less_text": "Show less",
    "row_toggle_border_style": "solid",
    "accordion": true,
    "accordion_marker": true,
    "accordion_title": "<h1>Seal</h1>",
    "accordion_subheading": "",
    "accordion_hide_title_when_open": false,
    "accordion_hide_subheading_when_open": false,
    "accordion_title_center": true,
    "accordion_start_open": true,
    "accordion_allow_multiple": false,
    "accordion_bg_color": "#f5f5f5",
    "accordion_shadow_pct": 8,
    "accordion_shadow_style": "raised",
    "accordion_width_mobile_percent": 100,
    "accordion_width_desktop_percent": 100,
    "accordion_max_width_px": "0",
    "accordion_group": "accordion_ibwrbb",
    "accordion_always_open": true,
    "videos": []
  },
  {
    "heading": "",
    "subheading": "",
    "img_ratio": "1:1",
    "row_height": 0,
    "fit_row": false,
    "margin_top": 0,
    "margin_bottom": 0,
    "collapsed": false,
    "show_more_text": "Show more",
    "show_less_text": "Show less",
    "row_toggle_border_style": "solid",
    "swatch_row": false,
    "row_justify": "center",
    "heading_justify": "center",
    "accordion": false,
    "accordion_title": "<h1>Seal</h1>",
    "accordion_subheading": "",
    "accordion_hide_title_when_open": false,
    "accordion_hide_subheading_when_open": false,
    "accordion_title_center": true,
    "accordion_start_open": true,
    "accordion_allow_multiple": false,
    "accordion_bg_color": "#f5f5f5",
    "accordion_shadow_pct": 8,
    "accordion_shadow_style": "raised",
    "accordion_width_mobile_percent": 100,
    "accordion_width_desktop_percent": 100,
    "accordion_max_width_px": "0",
    "accordion_group": "accordion_ibwrbb",
    "accordion_always_open": true,
    "videos": [
      {
        "type": "video",
        "hero": true,
        "hero_autoplay_preview": false,
        "hero_show_play_badge": false,
        "hero_show_play_button": false,
        "open_full_video_text": "",
        "title": "Topcoat is optional depending on the project.",
        "heading_html": "<h3><em>Topcoat is optional depending on the project.</em></h3>",
        "subheading_html": "",
        "alt": "Topcoat is optional depending on the project.",
        "url": null,
        "start_time": "",
        "thumbnail": "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/558d185f-44f7-4698-8449-1e571b89880a.gif?ClientID=sulu&Date=1718978917&Signature=3048c1973e67944a62b851b9725cd06b8ab8c614",
        "hero_width_desktop_pct": 0,
        "hero_width_mobile_pct": 0,
        "hero_max_width_desktop_px": 0,
        "hero_height_desktop_px": 0,
        "hero_height_mobile_px": 0,
        "margin_top": 0,
        "margin_bottom": 0,
        "ratio_override": "16:9",
        "vjust": "center",
        "html_desc": "",
        "desc_html": null,
        "end_behavior": "next",
        "cta": {
          "href": null,
          "text": "Shop Now",
          "thumb_text": ""
        }
      }
    ]
  },
  {
    "heading": "",
    "subheading": "",
    "img_ratio": "4:5",
    "row_height": 0,
    "fit_row": true,
    "margin_top": 0,
    "margin_bottom": 0,
    "collapsed": true,
    "show_more_text": "More",
    "show_less_text": "Less",
    "row_toggle_border_style": "solid",
    "accordion": false,
    "accordion_title": "<h1>Seal</h1>",
    "accordion_subheading": "",
    "accordion_hide_title_when_open": false,
    "accordion_hide_subheading_when_open": false,
    "accordion_title_center": true,
    "accordion_start_open": true,
    "accordion_allow_multiple": false,
    "accordion_bg_color": "#f5f5f5",
    "accordion_shadow_pct": 8,
    "accordion_shadow_style": "raised",
    "accordion_width_mobile_percent": 100,
    "accordion_width_desktop_percent": 100,
    "accordion_max_width_px": "0",
    "accordion_group": "accordion_ibwrbb",
    "accordion_always_open": true,
    "videos": []
  },
  {
    "heading": "",
    "subheading": "",
    "heading_justify": "center",
    "custom_template_id": "mg-custom-template--18365028532358__c_media_gallery_7kcH4m-5",
    "custom_html": "<div id=\"Top_Coat_Optional_WoodnStain\" class=\"centerAll\">\n  <div style=\"display:flex; justify-content:center; gap:40px; flex-wrap:nowrap;\">\n\n    <div style=\"white-space:nowrap;\">\n      <b>Topcoat Required</b><br>\n      <ul>\n        <li>Countertops</li>\n        <li>Tabletops</li>\n        <li>Flooring</li>\n        <li>Porches</li>\n        <li>Decking</li>\n      </ul>\n    </div>\n\n    <div style=\"white-space:nowrap;\">\n      <b>Topcoat Optional</b><br>\n      <ul>\n        <li>Fireplaces</li>\n        <li>Cabinets</li>\n        <li>Buffets</li>\n        <li>Dressers</li>\n        <li>Molding</li>\n      </ul>\n    </div>\n\n  </div>\n</div>",
    "custom_width_desktop_percent": 100,
    "custom_width_mobile_percent": 100,
    "custom_max_width_px": "0",
    "img_ratio": "1:1",
    "row_height": 0,
    "fit_row": false,
    "margin_top": 0,
    "margin_bottom": 0,
    "collapsed": false,
    "show_more_text": "Show more",
    "show_less_text": "Show less",
    "row_toggle_border_style": "solid",
    "accordion": false,
    "accordion_marker": false,
    "accordion_title": "<h1>Seal</h1>",
    "accordion_subheading": "",
    "accordion_hide_title_when_open": false,
    "accordion_hide_subheading_when_open": false,
    "accordion_title_center": true,
    "accordion_start_open": true,
    "accordion_allow_multiple": false,
    "accordion_bg_color": "#f5f5f5",
    "accordion_shadow_pct": 8,
    "accordion_shadow_style": "raised",
    "accordion_width_mobile_percent": 100,
    "accordion_width_desktop_percent": 100,
    "accordion_max_width_px": "0",
    "accordion_group": "accordion_ibwrbb",
    "accordion_always_open": true,
    "videos": []
  }
];
window.MEDIA_GALLERY_SETS["StepsLiquidWood"] = [
  {
    "heading": "<p>Retique It® Liquid Wood Coatings</p>",
    "subheading": "<h1>Smooth Wood Finishes</h1>",
    "heading_justify": "center",
    "custom_template_id": "mg-custom-template--18541426475142__c_media_gallery_Gg4wG3-0",
    "custom_html": "<center>\nStep-By-Step\n</center>\n<br>",
    "custom_width_desktop_percent": 100,
    "custom_width_mobile_percent": 100,
    "custom_max_width_px": "0",
    "img_ratio": "1:1",
    "row_height": 0,
    "fit_row": false,
    "margin_top": 0,
    "margin_bottom": 0,
    "collapsed": false,
    "show_more_text": "Show more",
    "show_less_text": "Show less",
    "row_toggle_border_style": "solid",
    "accordion": false,
    "accordion_marker": false,
    "accordion_title": "",
    "accordion_subheading": "",
    "accordion_hide_title_when_open": false,
    "accordion_hide_subheading_when_open": false,
    "accordion_title_center": true,
    "accordion_start_open": false,
    "accordion_allow_multiple": false,
    "accordion_bg_color": "#f5f5f5",
    "accordion_shadow_pct": 8,
    "accordion_shadow_style": "raised",
    "accordion_width_mobile_percent": 100,
    "accordion_width_desktop_percent": 100,
    "accordion_max_width_px": 0,
    "accordion_group": "",
    "accordion_always_open": false,
    "videos": []
  },
  {
    "heading": "",
    "subheading": "",
    "img_ratio": "1:1",
    "row_height": 0,
    "fit_row": false,
    "collapsed": false,
    "show_more_text": "Show more",
    "show_less_text": "Show less",
    "row_toggle_border_style": "solid",
    "accordion": true,
    "accordion_marker": true,
    "accordion_title": "<h1>Prep</h1>",
    "accordion_subheading": "",
    "accordion_hide_title_when_open": false,
    "accordion_hide_subheading_when_open": false,
    "accordion_title_center": true,
    "accordion_start_open": true,
    "accordion_allow_multiple": false,
    "accordion_bg_color": "#f5f5f5",
    "accordion_shadow_pct": 8,
    "accordion_shadow_style": "raised",
    "accordion_width_mobile_percent": 100,
    "accordion_width_desktop_percent": 100,
    "accordion_max_width_px": 0,
    "accordion_group": "accordion_E8XP37",
    "accordion_always_open": true,
    "videos": []
  },
  {
    "heading": "",
    "subheading": "",
    "img_ratio": "1:1",
    "row_height": 0,
    "fit_row": false,
    "margin_top": 0,
    "margin_bottom": 0,
    "collapsed": false,
    "show_more_text": "Show more",
    "show_less_text": "Show less",
    "row_toggle_border_style": "solid",
    "swatch_row": false,
    "row_justify": "center",
    "heading_justify": "center",
    "accordion": false,
    "accordion_title": "<h1>Prep</h1>",
    "accordion_subheading": "",
    "accordion_hide_title_when_open": false,
    "accordion_hide_subheading_when_open": false,
    "accordion_title_center": true,
    "accordion_start_open": true,
    "accordion_allow_multiple": false,
    "accordion_bg_color": "#f5f5f5",
    "accordion_shadow_pct": 8,
    "accordion_shadow_style": "raised",
    "accordion_width_mobile_percent": 100,
    "accordion_width_desktop_percent": 100,
    "accordion_max_width_px": 0,
    "accordion_group": "accordion_E8XP37",
    "accordion_always_open": true,
    "videos": [
      {
        "type": "video",
        "hero": true,
        "hero_autoplay_preview": false,
        "hero_show_play_badge": true,
        "hero_show_play_button": true,
        "open_full_video_text": "",
        "title": "Degrease, Scuff Sand, Wash",
        "heading_html": "<h2><em>Degrease, Scuff Sand, Wash</em></h2>",
        "subheading_html": "",
        "alt": "Degrease, Scuff Sand, Wash",
        "url": "https://vimeo.com/683257304",
        "quick_load_video_url": "",
        "prioritize_quick_load_video": false,
        "start_time": "",
        "thumbnail": "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/60febf82-3442-44ba-87ce-b37ee35a4d95.gif?ClientID=sulu&Date=1779186391&Signature=8509eafc7e015a85a0e425ff0f08274d307753c5",
        "hero_width_desktop_pct": 0,
        "hero_width_mobile_pct": 0,
        "hero_max_width_desktop_px": 0,
        "hero_height_desktop_px": 0,
        "hero_height_mobile_px": 0,
        "margin_top": 0,
        "margin_bottom": 0,
        "ratio_override": "16:9",
        "vjust": "center",
        "html_desc": "",
        "desc_html": null,
        "end_behavior": "loop",
        "cta": {
          "href": null,
          "text": "Shop Now",
          "thumb_text": ""
        }
      }
    ]
  },
  {
    "heading": "",
    "subheading": "",
    "img_ratio": "1:1",
    "row_height": 0,
    "fit_row": false,
    "margin_top": 0,
    "margin_bottom": 0,
    "collapsed": true,
    "show_more_text": "More",
    "show_less_text": "Less",
    "row_toggle_border_style": "solid",
    "accordion": false,
    "accordion_title": "<h1>Prep</h1>",
    "accordion_subheading": "",
    "accordion_hide_title_when_open": false,
    "accordion_hide_subheading_when_open": false,
    "accordion_title_center": true,
    "accordion_start_open": true,
    "accordion_allow_multiple": false,
    "accordion_bg_color": "#f5f5f5",
    "accordion_shadow_pct": 8,
    "accordion_shadow_style": "raised",
    "accordion_width_mobile_percent": 100,
    "accordion_width_desktop_percent": 100,
    "accordion_max_width_px": 0,
    "accordion_group": "accordion_E8XP37",
    "accordion_always_open": true,
    "videos": []
  },
  {
    "heading": "",
    "subheading": "",
    "heading_justify": "center",
    "custom_template_id": "mg-custom-template--18541426475142__c_media_gallery_Gg4wG3-1",
    "custom_html": "<div class=\"centerAll InfoSubPanel\">\n            <ul style=\"max-width: 650px;\">\n                <li>Wipe Down with denatured alcohol mixed with water or with Krud Kutter®</li>\n                <div class=\"centerAll\">\n                    <b style=\"color:red;\"><i>NEVER USE TSP PRODUCTS</i></b>\n                </div>\n                <div class=\"centerAll\">\n                    <i style=\"font-size: small;\">(TSP will cause wood based coatings to not adhere properly)</i>\n                </div>\n                <li>\n                    Scuff sand: Lightly sand the surface epecially if it is slick or glossy to give the Primer greater\n                    adheasion.\n                </li>\n                <li>\n                    Wash the surface with Dawn® Dish Soap and rinse thoroughly<br>\n                    with warm water until the surface is squeaky clean\n                </li>\n            </ul>\n        </div>",
    "custom_width_desktop_percent": 100,
    "custom_width_mobile_percent": 100,
    "custom_max_width_px": "0",
    "img_ratio": "1:1",
    "row_height": 0,
    "fit_row": false,
    "margin_top": 0,
    "margin_bottom": 0,
    "collapsed": false,
    "show_more_text": "Show more",
    "show_less_text": "Show less",
    "row_toggle_border_style": "solid",
    "accordion": false,
    "accordion_marker": false,
    "accordion_title": "<h1>Prep</h1>",
    "accordion_subheading": "",
    "accordion_hide_title_when_open": false,
    "accordion_hide_subheading_when_open": false,
    "accordion_title_center": true,
    "accordion_start_open": true,
    "accordion_allow_multiple": false,
    "accordion_bg_color": "#f5f5f5",
    "accordion_shadow_pct": 8,
    "accordion_shadow_style": "raised",
    "accordion_width_mobile_percent": 100,
    "accordion_width_desktop_percent": 100,
    "accordion_max_width_px": 0,
    "accordion_group": "accordion_E8XP37",
    "accordion_always_open": true,
    "videos": []
  },
  {
    "heading": "",
    "subheading": "",
    "img_ratio": "1:1",
    "row_height": 0,
    "fit_row": false,
    "collapsed": false,
    "show_more_text": "Show more",
    "show_less_text": "Show less",
    "row_toggle_border_style": "solid",
    "accordion": true,
    "accordion_marker": true,
    "accordion_title": "<h1>Prime</h1>",
    "accordion_subheading": "",
    "accordion_hide_title_when_open": false,
    "accordion_hide_subheading_when_open": false,
    "accordion_title_center": true,
    "accordion_start_open": true,
    "accordion_allow_multiple": false,
    "accordion_bg_color": "#f5f5f5",
    "accordion_shadow_pct": 8,
    "accordion_shadow_style": "raised",
    "accordion_width_mobile_percent": 100,
    "accordion_width_desktop_percent": 100,
    "accordion_max_width_px": 0,
    "accordion_group": "accordion_d4Rpnr",
    "accordion_always_open": true,
    "videos": []
  },
  {
    "heading": "",
    "subheading": "",
    "img_ratio": "1:1",
    "row_height": 0,
    "fit_row": false,
    "margin_top": 0,
    "margin_bottom": 0,
    "collapsed": false,
    "show_more_text": "Show more",
    "show_less_text": "Show less",
    "row_toggle_border_style": "solid",
    "swatch_row": false,
    "row_justify": "center",
    "heading_justify": "center",
    "accordion": false,
    "accordion_title": "<h1>Prime</h1>",
    "accordion_subheading": "",
    "accordion_hide_title_when_open": false,
    "accordion_hide_subheading_when_open": false,
    "accordion_title_center": true,
    "accordion_start_open": true,
    "accordion_allow_multiple": false,
    "accordion_bg_color": "#f5f5f5",
    "accordion_shadow_pct": 8,
    "accordion_shadow_style": "raised",
    "accordion_width_mobile_percent": 100,
    "accordion_width_desktop_percent": 100,
    "accordion_max_width_px": 0,
    "accordion_group": "accordion_d4Rpnr",
    "accordion_always_open": true,
    "videos": [
      {
        "type": "video",
        "hero": true,
        "hero_autoplay_preview": false,
        "hero_show_play_badge": true,
        "hero_show_play_button": true,
        "open_full_video_text": "",
        "title": "Apply 2 Coats of Liquid Wood",
        "heading_html": "<h2>Apply 2 Coats of Liquid Wood</h2>",
        "subheading_html": "",
        "alt": "Apply 2 Coats of Liquid Wood",
        "url": "https://vimeo.com/683257304#t=4",
        "quick_load_video_url": "",
        "prioritize_quick_load_video": false,
        "start_time": "",
        "thumbnail": "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/fe977615-8dcf-4ce8-aa18-4db4dcac14ae.gif?ClientID=sulu&Date=1779186391&Signature=de0590d3fb000ce2e23723b48713fc22ce1f8d63",
        "hero_width_desktop_pct": 0,
        "hero_width_mobile_pct": 0,
        "hero_max_width_desktop_px": 0,
        "hero_height_desktop_px": 0,
        "hero_height_mobile_px": 0,
        "margin_top": 0,
        "margin_bottom": 0,
        "ratio_override": "16:9",
        "vjust": "center",
        "html_desc": "",
        "desc_html": null,
        "end_behavior": "loop",
        "cta": {
          "href": null,
          "text": "Shop Now",
          "thumb_text": ""
        }
      }
    ]
  },
  {
    "heading": "",
    "subheading": "",
    "img_ratio": "1:1",
    "row_height": 0,
    "fit_row": false,
    "margin_top": 0,
    "margin_bottom": 0,
    "collapsed": true,
    "show_more_text": "More",
    "show_less_text": "Less",
    "row_toggle_border_style": "solid",
    "accordion": false,
    "accordion_title": "<h1>Prime</h1>",
    "accordion_subheading": "",
    "accordion_hide_title_when_open": false,
    "accordion_hide_subheading_when_open": false,
    "accordion_title_center": true,
    "accordion_start_open": true,
    "accordion_allow_multiple": false,
    "accordion_bg_color": "#f5f5f5",
    "accordion_shadow_pct": 8,
    "accordion_shadow_style": "raised",
    "accordion_width_mobile_percent": 100,
    "accordion_width_desktop_percent": 100,
    "accordion_max_width_px": 0,
    "accordion_group": "accordion_d4Rpnr",
    "accordion_always_open": true,
    "videos": []
  },
  {
    "heading": "",
    "subheading": "",
    "heading_justify": "center",
    "custom_template_id": "mg-custom-template--18541426475142__c_media_gallery_Gg4wG3-2",
    "custom_html": "<div class=\"centerAll InfoSubPanel\">\n      <ul class=\"InfoSubPanelText\">\n        <li>\n          Brush, roll or spray on 2 coats of Liquid Wood<br>\n            <i style=\"font-size: small;\">If you use a roller, be sure to run a brush through it, while still wet,in long even strokes</i>\n        </li>\n        <li>\n          Make final brush strokes long in the direction you want the grain. If you rolled it<br>on you will need to run\n          the brush through it afterward while still wet.\n        </li>\n        <li>Clean your brush/equipment while you give the project 2 hours to dry completely.</li>\n        <li>\n          If you are limited on time, then use a blow dryer.<br>\n          <i style=\"font-size: small;\"\n            >(Dry time may take as little as 5 minutes with the use of a blow dryer on high heat)</i\n          >\n        </li>\n      </ul>\n    </div>",
    "custom_width_desktop_percent": 100,
    "custom_width_mobile_percent": 100,
    "custom_max_width_px": "0",
    "img_ratio": "1:1",
    "row_height": 0,
    "fit_row": false,
    "margin_top": 0,
    "margin_bottom": 0,
    "collapsed": false,
    "show_more_text": "Show more",
    "show_less_text": "Show less",
    "row_toggle_border_style": "solid",
    "accordion": false,
    "accordion_marker": false,
    "accordion_title": "<h1>Prime</h1>",
    "accordion_subheading": "",
    "accordion_hide_title_when_open": false,
    "accordion_hide_subheading_when_open": false,
    "accordion_title_center": true,
    "accordion_start_open": true,
    "accordion_allow_multiple": false,
    "accordion_bg_color": "#f5f5f5",
    "accordion_shadow_pct": 8,
    "accordion_shadow_style": "raised",
    "accordion_width_mobile_percent": 100,
    "accordion_width_desktop_percent": 100,
    "accordion_max_width_px": 0,
    "accordion_group": "accordion_d4Rpnr",
    "accordion_always_open": true,
    "videos": []
  },
  {
    "heading": "",
    "subheading": "",
    "img_ratio": "1:1",
    "row_height": 0,
    "fit_row": false,
    "collapsed": false,
    "show_more_text": "Show more",
    "show_less_text": "Show less",
    "row_toggle_border_style": "solid",
    "accordion": true,
    "accordion_marker": true,
    "accordion_title": "<h1>Stain</h1>",
    "accordion_subheading": "",
    "accordion_hide_title_when_open": false,
    "accordion_hide_subheading_when_open": false,
    "accordion_title_center": true,
    "accordion_start_open": true,
    "accordion_allow_multiple": false,
    "accordion_bg_color": "#f5f5f5",
    "accordion_shadow_pct": 8,
    "accordion_shadow_style": "raised",
    "accordion_width_mobile_percent": 100,
    "accordion_width_desktop_percent": 100,
    "accordion_max_width_px": 0,
    "accordion_group": "accordion_MxD6wm",
    "accordion_always_open": true,
    "videos": []
  },
  {
    "heading": "",
    "subheading": "",
    "img_ratio": "1:1",
    "row_height": 0,
    "fit_row": false,
    "margin_top": 0,
    "margin_bottom": 0,
    "collapsed": false,
    "show_more_text": "Show more",
    "show_less_text": "Show less",
    "row_toggle_border_style": "solid",
    "swatch_row": false,
    "row_justify": "center",
    "heading_justify": "center",
    "accordion": false,
    "accordion_title": "<h1>Stain</h1>",
    "accordion_subheading": "",
    "accordion_hide_title_when_open": false,
    "accordion_hide_subheading_when_open": false,
    "accordion_title_center": true,
    "accordion_start_open": true,
    "accordion_allow_multiple": false,
    "accordion_bg_color": "#f5f5f5",
    "accordion_shadow_pct": 8,
    "accordion_shadow_style": "raised",
    "accordion_width_mobile_percent": 100,
    "accordion_width_desktop_percent": 100,
    "accordion_max_width_px": 0,
    "accordion_group": "accordion_MxD6wm",
    "accordion_always_open": true,
    "videos": [
      {
        "type": "video",
        "hero": true,
        "hero_autoplay_preview": false,
        "hero_show_play_badge": true,
        "hero_show_play_button": true,
        "open_full_video_text": "",
        "title": "Apply the Stain of your Choice",
        "heading_html": "<h3><strong>Apply the Stain of your Choice</strong></h3>",
        "subheading_html": "",
        "alt": "Apply the Stain of your Choice",
        "url": "https://vimeo.com/683257304?share=copy&fl=sv&fe=ci#t=11",
        "quick_load_video_url": "",
        "prioritize_quick_load_video": false,
        "start_time": "",
        "thumbnail": "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/6f3b734a-a8d8-4359-ad4f-3342e3810211.gif?ClientID=sulu&Date=1779186391&Signature=0f477a4d6f1e49a4edeef6beed865d54d0fca5bb",
        "hero_width_desktop_pct": 0,
        "hero_width_mobile_pct": 0,
        "hero_max_width_desktop_px": 0,
        "hero_height_desktop_px": 0,
        "hero_height_mobile_px": 0,
        "margin_top": 0,
        "margin_bottom": 0,
        "ratio_override": "16:9",
        "vjust": "center",
        "html_desc": "",
        "desc_html": null,
        "end_behavior": "loop",
        "cta": {
          "href": null,
          "text": "Shop Now",
          "thumb_text": ""
        }
      }
    ]
  },
  {
    "heading": "",
    "subheading": "",
    "img_ratio": "1:1",
    "row_height": 0,
    "fit_row": false,
    "margin_top": 0,
    "margin_bottom": 0,
    "collapsed": true,
    "show_more_text": "More",
    "show_less_text": "Less",
    "row_toggle_border_style": "solid",
    "accordion": false,
    "accordion_title": "<h1>Stain</h1>",
    "accordion_subheading": "",
    "accordion_hide_title_when_open": false,
    "accordion_hide_subheading_when_open": false,
    "accordion_title_center": true,
    "accordion_start_open": true,
    "accordion_allow_multiple": false,
    "accordion_bg_color": "#f5f5f5",
    "accordion_shadow_pct": 8,
    "accordion_shadow_style": "raised",
    "accordion_width_mobile_percent": 100,
    "accordion_width_desktop_percent": 100,
    "accordion_max_width_px": 0,
    "accordion_group": "accordion_MxD6wm",
    "accordion_always_open": true,
    "videos": []
  },
  {
    "heading": "",
    "subheading": "",
    "heading_justify": "center",
    "custom_template_id": "mg-custom-template--18541426475142__c_media_gallery_Gg4wG3-3",
    "custom_html": "<div class=\"heading h3 centerAll\">\n  <center>\n  <b>Apply Nearly Any Brand of Stain</b>\n  </center>\n</div>\n<center><i style=\"font-size:xx-small;\">This step is optional</i><br></center>\n<br>\n<div class=\"centerAll\">\n  <ul style=\"max-width: 650px;\">\n    <li>Follow directions from the manufacturer</li>\n    <li>Liquid Wood now works with Penetrating Stains, Gel Stain and wood stains alike</li>\n    <li>Make your final swipes long in the direction you want the grain.</li>\n  </ul>\n</div>",
    "custom_width_desktop_percent": 100,
    "custom_width_mobile_percent": 100,
    "custom_max_width_px": "0",
    "img_ratio": "1:1",
    "row_height": 0,
    "fit_row": false,
    "margin_top": 0,
    "margin_bottom": 0,
    "collapsed": false,
    "show_more_text": "Show more",
    "show_less_text": "Show less",
    "row_toggle_border_style": "solid",
    "accordion": false,
    "accordion_marker": false,
    "accordion_title": "<h1>Stain</h1>",
    "accordion_subheading": "",
    "accordion_hide_title_when_open": false,
    "accordion_hide_subheading_when_open": false,
    "accordion_title_center": true,
    "accordion_start_open": true,
    "accordion_allow_multiple": false,
    "accordion_bg_color": "#f5f5f5",
    "accordion_shadow_pct": 8,
    "accordion_shadow_style": "raised",
    "accordion_width_mobile_percent": 100,
    "accordion_width_desktop_percent": 100,
    "accordion_max_width_px": 0,
    "accordion_group": "accordion_MxD6wm",
    "accordion_always_open": true,
    "videos": []
  },
  {
    "heading": "",
    "subheading": "",
    "img_ratio": "1:1",
    "row_height": 0,
    "fit_row": false,
    "collapsed": false,
    "show_more_text": "Show more",
    "show_less_text": "Show less",
    "row_toggle_border_style": "solid",
    "accordion": true,
    "accordion_marker": true,
    "accordion_title": "<h1>Seal</h1>",
    "accordion_subheading": "",
    "accordion_hide_title_when_open": false,
    "accordion_hide_subheading_when_open": false,
    "accordion_title_center": true,
    "accordion_start_open": true,
    "accordion_allow_multiple": false,
    "accordion_bg_color": "#f5f5f5",
    "accordion_shadow_pct": 8,
    "accordion_shadow_style": "raised",
    "accordion_width_mobile_percent": 100,
    "accordion_width_desktop_percent": 100,
    "accordion_max_width_px": 0,
    "accordion_group": "accordion_zqnBgc",
    "accordion_always_open": true,
    "videos": []
  },
  {
    "heading": "",
    "subheading": "",
    "img_ratio": "1:1",
    "row_height": 0,
    "fit_row": false,
    "margin_top": 0,
    "margin_bottom": 0,
    "collapsed": false,
    "show_more_text": "Show more",
    "show_less_text": "Show less",
    "row_toggle_border_style": "solid",
    "swatch_row": false,
    "row_justify": "center",
    "heading_justify": "center",
    "accordion": false,
    "accordion_title": "<h1>Seal</h1>",
    "accordion_subheading": "",
    "accordion_hide_title_when_open": false,
    "accordion_hide_subheading_when_open": false,
    "accordion_title_center": true,
    "accordion_start_open": true,
    "accordion_allow_multiple": false,
    "accordion_bg_color": "#f5f5f5",
    "accordion_shadow_pct": 8,
    "accordion_shadow_style": "raised",
    "accordion_width_mobile_percent": 100,
    "accordion_width_desktop_percent": 100,
    "accordion_max_width_px": 0,
    "accordion_group": "accordion_zqnBgc",
    "accordion_always_open": true,
    "videos": [
      {
        "type": "video",
        "hero": true,
        "hero_autoplay_preview": false,
        "hero_show_play_badge": false,
        "hero_show_play_button": false,
        "open_full_video_text": "",
        "title": "Topcoat is optional depending on the project.",
        "heading_html": "<h3><em>Topcoat is optional depending on the project.</em></h3>",
        "subheading_html": "",
        "alt": "Topcoat is optional depending on the project.",
        "url": null,
        "quick_load_video_url": "",
        "prioritize_quick_load_video": false,
        "start_time": "",
        "thumbnail": "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/b98abe5e-9aee-4dfa-adb5-6f810a97bd54.gif?ClientID=sulu&Date=1779185671&Signature=4e7f5aa4489d951cd1c121d10bbc663fe9826610",
        "hero_width_desktop_pct": 0,
        "hero_width_mobile_pct": 0,
        "hero_max_width_desktop_px": 0,
        "hero_height_desktop_px": 0,
        "hero_height_mobile_px": 0,
        "margin_top": 0,
        "margin_bottom": 0,
        "ratio_override": "16:9",
        "vjust": "center",
        "html_desc": "",
        "desc_html": null,
        "end_behavior": "next",
        "cta": {
          "href": null,
          "text": "Shop Now",
          "thumb_text": ""
        }
      }
    ]
  },
  {
    "heading": "",
    "subheading": "",
    "img_ratio": "4:5",
    "row_height": 0,
    "fit_row": true,
    "margin_top": 0,
    "margin_bottom": 0,
    "collapsed": true,
    "show_more_text": "More",
    "show_less_text": "Less",
    "row_toggle_border_style": "solid",
    "accordion": false,
    "accordion_title": "<h1>Seal</h1>",
    "accordion_subheading": "",
    "accordion_hide_title_when_open": false,
    "accordion_hide_subheading_when_open": false,
    "accordion_title_center": true,
    "accordion_start_open": true,
    "accordion_allow_multiple": false,
    "accordion_bg_color": "#f5f5f5",
    "accordion_shadow_pct": 8,
    "accordion_shadow_style": "raised",
    "accordion_width_mobile_percent": 100,
    "accordion_width_desktop_percent": 100,
    "accordion_max_width_px": 0,
    "accordion_group": "accordion_zqnBgc",
    "accordion_always_open": true,
    "videos": []
  },
  {
    "heading": "",
    "subheading": "",
    "heading_justify": "center",
    "custom_template_id": "mg-custom-template--18541426475142__c_media_gallery_Gg4wG3-4",
    "custom_html": "<div id=\"Top_Coat_Optional_WoodnStain\" class=\"centerAll\">\n  <div style=\"display:flex; justify-content:center; gap:40px; flex-wrap:nowrap;\">\n\n    <div style=\"white-space:nowrap;\">\n      <b>Topcoat Recommended</b><br>\n      <ul>\n        <li>Countertops</li>\n        <li>Tabletops</li>\n        <li>Flooring</li>\n        <li>Porches</li>\n        <li>Decking</li>\n      </ul>\n    </div>\n\n    <div style=\"white-space:nowrap;\">\n      <b>Topcoat Optional</b><br>\n      <ul>\n        <li>Fireplaces</li>\n        <li>Cabinets</li>\n        <li>Buffets</li>\n        <li>Dressers</li>\n        <li>Molding</li>\n      </ul>\n    </div>\n\n  </div>\n</div>",
    "custom_width_desktop_percent": 100,
    "custom_width_mobile_percent": 100,
    "custom_max_width_px": "0",
    "img_ratio": "1:1",
    "row_height": 0,
    "fit_row": false,
    "margin_top": 0,
    "margin_bottom": 0,
    "collapsed": false,
    "show_more_text": "Show more",
    "show_less_text": "Show less",
    "row_toggle_border_style": "solid",
    "accordion": false,
    "accordion_marker": false,
    "accordion_title": "<h1>Seal</h1>",
    "accordion_subheading": "",
    "accordion_hide_title_when_open": false,
    "accordion_hide_subheading_when_open": false,
    "accordion_title_center": true,
    "accordion_start_open": true,
    "accordion_allow_multiple": false,
    "accordion_bg_color": "#f5f5f5",
    "accordion_shadow_pct": 8,
    "accordion_shadow_style": "raised",
    "accordion_width_mobile_percent": 100,
    "accordion_width_desktop_percent": 100,
    "accordion_max_width_px": 0,
    "accordion_group": "accordion_zqnBgc",
    "accordion_always_open": true,
    "videos": []
  }
];


// ✅ MEDIA SET BLOCK (copy this to add/replace just this set):
window.MEDIA_GALLERY_SETS["RealWoodBulletPoints"] = [
  {
    "heading": "<h1>Real Wood in Every Brushstroke</h1>",
    "subheading": "",
    "img_ratio": "1:1",
    "row_height": 0,
    "fit_row": false,
    "margin_top": 0,
    "margin_bottom": 0,
    "collapsed": false,
    "show_more_text": "Show more",
    "show_less_text": "Show less",
    "row_toggle_border_style": "solid",
    "accordion": false,
    "accordion_title": "",
    "accordion_subheading": "",
    "accordion_hide_title_when_open": false,
    "accordion_hide_subheading_when_open": false,
    "accordion_title_center": false,
    "accordion_start_open": false,
    "accordion_allow_multiple": false,
    "accordion_bg_color": "#ffffff",
    "accordion_shadow_pct": 8,
    "accordion_shadow_style": "raised",
    "accordion_width_mobile_percent": 100,
    "accordion_width_desktop_percent": 100,
    "accordion_max_width_px": 0,
    "accordion_group": "",
    "accordion_always_open": false,
    "videos": [
      {
        "type": "image",
        "title": "",
        "alt": "Authentic Wood Finish",
        "thumbnail": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/GenuineWood_6ea52a21-da55-4f12-a396-6cccc1adbf1b.png?v=1685138992&width=2000",
        "pad_t": "0",
        "scale": 100,
        "vjust": "top",
        "heading_html": "<h3>Authentic Wood Finish</h3>",
        "title_html": "",
        "image_desc_html": "<p>Looks & Feels Like Real Wood</p>",
        "image_desc_justify": "center",
        "image_more_desc_html": "<p>Go Beyond Faux with our patented liquid wood technology. It looks and feels like wood because it contains over 60% recycled wood fibers. Get the warm, natural look of wood on any hard surface, without the cost and hassle of traditional woodwork, thanks to Retique It®!<br/><br/></p>",
        "html_desc": "<p>Looks & Feels Like Real Wood</p>",
        "desc_html": "<p>Go Beyond Faux with our patented liquid wood technology. It looks and feels like wood because it contains over 60% recycled wood fibers. Get the warm, natural look of wood on any hard surface, without the cost and hassle of traditional woodwork, thanks to Retique It®!<br/><br/></p>",
        "cta": {
          "href": null,
          "text": "Shop"
        }
      },
      {
        "type": "image",
        "title": "",
        "alt": "Stainable & Sustainable",
        "thumbnail": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/EcodFriendly.png?v=1685138405&width=2000",
        "pad_t": "0",
        "scale": 100,
        "vjust": "top",
        "heading_html": "<h3>Stainable & Sustainable</h3>",
        "title_html": "",
        "image_desc_html": "<p>Contains Recycled Wood</p>",
        "image_desc_justify": "center",
        "image_more_desc_html": "<p>Retique It® is the hassle-free way to get that perfect wood finish without any fuss! With our eco-friendly, water-based formula, there are zero VOCs or offensive odors, making it easy to use even in confined spaces. Because Retique It® contains recycled wood fibers, it can be<a href=\"https://retique.com/blogs/gallery/stainable-and-sustainable-the-perfect-duo-for-your-next-diy-project\">stained</a>like any wood surface. When you're finished, clean-up is a breeze with just soap and water!<br/><br/></p>",
        "html_desc": "<p>Contains Recycled Wood</p>",
        "desc_html": "<p>Retique It® is the hassle-free way to get that perfect wood finish without any fuss! With our eco-friendly, water-based formula, there are zero VOCs or offensive odors, making it easy to use even in confined spaces. Because Retique It® contains recycled wood fibers, it can be<a href=\"https://retique.com/blogs/gallery/stainable-and-sustainable-the-perfect-duo-for-your-next-diy-project\">stained</a>like any wood surface. When you're finished, clean-up is a breeze with just soap and water!<br/><br/></p>",
        "cta": {
          "href": null,
          "text": "Shop"
        }
      },
      {
        "type": "image",
        "title": "",
        "alt": "No Sanding & Stripping",
        "thumbnail": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/NoStrippingRequired_517dd305-5221-401e-90a3-c4bbe932b4e6.png?v=1685138992&width=2000",
        "pad_t": "0",
        "scale": 100,
        "vjust": "top",
        "heading_html": "<h3>No Sanding & Stripping</h3>",
        "title_html": "",
        "image_desc_html": "<p>Off the Old Finish</p>",
        "image_desc_justify": "center",
        "image_more_desc_html": "<p>No need to sand or strip off old finishes or surfaces - just apply Retique It® right over any painted or finished surface. Our wood-based primers and stains let you add a layer of actual wood to virtually any hard surface.</p>",
        "html_desc": "<p>Off the Old Finish</p>",
        "desc_html": "<p>No need to sand or strip off old finishes or surfaces - just apply Retique It® right over any painted or finished surface. Our wood-based primers and stains let you add a layer of actual wood to virtually any hard surface.</p>",
        "cta": {
          "href": null,
          "text": "Shop"
        }
      },
      {
        "type": "image",
        "title": "",
        "alt": "Extreme Durability",
        "thumbnail": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/DurabilityShield_f6492089-7d0c-41c2-b2c8-3d65a2adced6.png?v=1685138992&width=2000",
        "pad_t": "0",
        "scale": 100,
        "vjust": "top",
        "heading_html": "<h3>Extreme Durability</h3>",
        "title_html": "",
        "image_desc_html": "<p><strong>Interior / Exterior</strong></p>",
        "image_desc_justify": "center",
        "image_more_desc_html": "<p><strong>Interior / Exterior</strong>Durable enough for decking, flooring, and countertops, yet perfect for furniture and cabinets, as well. Waterproof, scratch-resistant, and kid-tested, Retique It® adheres to almost any hard surface, so you can have a durable wood finish inside and outside!</p>",
        "html_desc": "<p><strong>Interior / Exterior</strong></p>",
        "desc_html": "<p><strong>Interior / Exterior</strong>Durable enough for decking, flooring, and countertops, yet perfect for furniture and cabinets, as well. Waterproof, scratch-resistant, and kid-tested, Retique It® adheres to almost any hard surface, so you can have a durable wood finish inside and outside!</p>",
        "cta": {
          "href": null,
          "text": "Shop"
        }
      },
      {
        "type": "image",
        "title": "",
        "alt": "Wood Finish Anywhere",
        "thumbnail": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/AnySurface.png?v=1685139673&width=2000",
        "pad_t": "0",
        "scale": 100,
        "vjust": "top",
        "heading_html": "<h3>Wood Finish Anywhere</h3>",
        "title_html": "",
        "image_desc_html": "<p>Works on Nearly Any Hard Surface</p>",
        "image_desc_justify": "center",
        "image_more_desc_html": "<p>If you can dream it, you can Retique It®. Transform virtually any hard surface into an authentic wood surface, whether it was originally painted, stained, wood, metal, MDF, concrete, plastic, or drywall. Retique It® has been used on furniture, cabinets, tables, countertops, front doors, garage doors, shutters, porches & more...</p>",
        "html_desc": "<p>Works on Nearly Any Hard Surface</p>",
        "desc_html": "<p>If you can dream it, you can Retique It®. Transform virtually any hard surface into an authentic wood surface, whether it was originally painted, stained, wood, metal, MDF, concrete, plastic, or drywall. Retique It® has been used on furniture, cabinets, tables, countertops, front doors, garage doors, shutters, porches & more...</p>",
        "cta": {
          "href": null,
          "text": "Shop"
        }
      }
    ]
  }
];

// ✅ MEDIA SET BLOCK (copy this to add/replace just this set):
window.MEDIA_GALLERY_SETS["SizeOptions"] = [
  {
    "heading": "",
    "subheading": "",
    "custom_template_id": "mg-custom-template--18365028532358__c_media_gallery_x8Pxqy-0",
    "custom_html": "<style>\n  .Small_Size_Options_Primary_Image {\n    content: var(--Small_Primary_Image);\n  }\n\n  .Medium_Size_Options_Primary_Image {\n    content: var(--Medium_Primary_Image);\n  }\n\n  .Large_Size_Options_Primary_Image {\n    content: var(--Large_Primary_Image);\n  }\n\n  .ExLarge_Size_Options_Primary_Image {\n    content: var(--ExLarge_Primary_Image);\n  }\n\n  .Small_Size_Options_Subtitle {\n    content: var(--Small_Subtitle);\n  }\n\n  .Medium_Size_Options_Subtitle {\n    content: var(--Medium_Subtitle);\n  }\n\n  .Large_Size_Options_Subtitle {\n    content: var(--Large_Subtitle);\n  }\n\n  .ExLarge_Size_Options_Subtitle {\n    content: var(--ExLarge_Subtitle);\n  }\n\n  .scrolls {\n    overflow-x: auto;\n    overflow-y: hidden;\n    white-space: nowrap;\n    vertical-align: top;\n  }\n\n  .scrolls img {\n    height: 500px;\n    width: auto;\n    display: inline-block;\n  }\n\n  .SizeDivSub {\n    display: none;\n    width: 300px;\n    height: auto;\n    justify-content: left;\n    padding-bottom: 10px;\n    font-size: medium;\n    vertical-align: top;\n    padding-right: 20px;\n  }\n\n  .div_Primary_Picture {\n    height: 150px;\n    width: 250px;\n    margin: auto;\n  }\n\n  .div_Primary_Picture img {\n    width: 80%;\n    height: auto;\n    max-height: 250px;\n  }\n\n  .Bullet_Points {\n    margin: auto;\n    text-align: left;\n    width: fit-content;\n    font-size: medium;\n  }\n\n  .Header {\n    font-weight: 900;\n    font-size: medium;\n  }\n\n  .clearfix {\n    overflow: auto;\n  }\n\n  .clearfix::after {\n    content: \"\";\n    clear: both;\n    display: table;\n  }\n\n  .Button_Text {\n    width: fit-content;\n    max-width: 100%;\n    text-align: left;\n    vertical-align: top;\n    font-weight: 600;\n    margin: auto;\n  }\n\n  @media screen and (max-width: 768px) {\n    .scrolls {\n      overflow-x: auto;\n      overflow-y: hidden;\n      white-space: nowrap;\n      vertical-align: top;\n    }\n\n    .scrolls img {\n      height: auto;\n      width: 100%;\n      display: inline-block;\n    }\n\n    .hideMobile {\n      display: none;\n    }\n\n    .showMobile {\n      display: block;\n    }\n\n    .SizeDivSub {\n      display: none;\n      width: 200px;\n      height: auto;\n      justify-content: left;\n      padding-right: 10px;\n      font-size: x-small;\n      vertical-align: top;\n    }\n\n    .div_Primary_Picture {\n      height: 100px;\n      width: 150px;\n      margin: auto;\n      vertical-align: top;\n    }\n\n    .Bullet_Points {\n      margin: auto;\n    text-align: left;\n      width: fit-content;\n      font-size: xx-small;\n      margin: auto;\n    }\n\n    .Button_Text {\n      width: fit-content;\n      max-width: 100%;\n      text-align: left;\n      vertical-align: top;\n      font-weight: 600;\n      margin: auto;\n    }\n\n    .Header {\n      font-weight: 500;\n      font-size: small;\n    }\n  }\n</style>\n<div class=\"heading h1 centerAll\">Size Options</div><br>\n<div style=\"width:fit-content;max-width:100%;margin:auto;overflow: none;\">\n  <div class=\"scrolls\">\n    <div style=\"width:fit-content;margin-left: auto; margin-right: auto;\"><button id=\"div_Inst2_Small\"\n        class=\"SizeDivSub\" onclick=\"navigate_size(Small_URL);\" style=\"display: none;\">\n        <center>\n          <div class=\"div_Primary_Picture\"><img class=\"Small_Size_Options_Primary_Image\"></div>\n          <p></p>\n          <div class=\"select Select_Button\"><a class=\"Button_Text\" id=\"Inst2_Small_Kit_Title\"></a></div>\n        </center>\n        <div id=\"div_Inst2_Small_Size_Options_Subtitle\" class=\"Small_Size_Options_Subtitle\"></div>\n        <ul id=\"ul_Small_Inst2_Bullets\" class=\"Bullet_Points\"></ul>\n      </button><button id=\"div_Inst2_Medium\" class=\"SizeDivSub\" onclick=\"navigate_size(Medium_URL);\"\n        style=\"display: none;\">\n        <center>\n          <div class=\"div_Primary_Picture\"><img class=\"Medium_Size_Options_Primary_Image\"></div>\n          <p></p>\n          <div class=\"select Select_Button\"><a class=\"Button_Text\" id=\"Inst2_Medium_Kit_Title\"></a></div>\n        </center>\n        <div id=\"div_Inst2_Medium_Size_Options_Subtitle\" class=\"Medium_Size_Options_Subtitle\"></div>\n        <ul id=\"ul_Medium_Inst2_Bullets\" class=\"Bullet_Points\"></ul>\n      </button><button id=\"div_Inst2_Large\" class=\"SizeDivSub\" onclick=\"navigate_size(Large_URL);\"\n        style=\"display:none;\">\n        <center>\n          <div class=\"div_Primary_Picture\"><img class=\"Large_Size_Options_Primary_Image\"></div>\n          <p></p>\n          <div class=\"select Select_Button\"><a class=\"Button_Text\" id=\"Inst2_Large_Kit_Title\"></a></div>\n        </center>\n        <div id=\"div_Inst2_Large_Size_Options_Subtitle\" class=\"Large_Size_Options_Subtitle\"></div>\n        <ul id=\"ul_Large_Inst2_Bullets\" class=\"Bullet_Points\"></ul>\n      </button><button id=\"div_Inst2_ExLarge\" class=\"SizeDivSub\" onclick=\"navigate_size(ExLarge_URL);\"\n        style=\"display:none;\">\n        <center>\n          <div class=\"div_Primary_Picture\"><img class=\"ExLarge_Size_Options_Primary_Image\"></div>\n          <p></p>\n          <div class=\"select Select_Button\"><a class=\"Button_Text\" id=\"Inst2_4xLarge_Kit_Title\"></a></div>\n        </center>\n        <div id=\"div_Inst2_ExLarge_Size_Options_Subtitle\" class=\"ExLarge_Size_Options_Subtitle\"></div>\n        <ul id=\"ul_ExLarge_Inst2_Bullets\" class=\"Bullet_Points\"></ul>\n      </button></div>\n  </div>\n</div>\n<script>\n  // Get the Modal_Size_Options_Popup\n  var Modal_Size_Options_Popup = document.getElementById(\"myModal_Size_Options_Popup\");\n\n  // Get the button that opens the Modal_Size_Options_Popup\n  var btn = document.getElementById(\"Btn_Size_Options_Popup\");\n\n  // Get the <span> element that close_Modal_Size_Options_Popups the Modal_Size_Options_Popup\n  var span = document.getElementsByClassName(\"close_Modal_Size_Options_Popup\")[0];\n\n  // When the user clicks the button, open the Modal_Size_Options_Popup\n  btn.onclick = function () {\n    Modal_Size_Options_Popup.style.display = \"block\";\n  }\n\n  // When the user clicks on <span> (x), close_Modal_Size_Options_Popup the Modal_Size_Options_Popup\n  span.onclick = function () {\n    Modal_Size_Options_Popup.style.display = \"none\";\n  }\n\n  // When the user clicks anywhere outside of the Modal_Size_Options_Popup, close_Modal_Size_Options_Popup it\n  window.onclick = function (event) {\n    if (event.target == Modal_Size_Options_Popup) {\n      Modal_Size_Options_Popup.style.display = \"none\";\n    }\n  }\n\n  var r = document.querySelector(':root');\n  var rs = getComputedStyle(r);\n  var Array_Inst2_Small_Kit_Titles = rs.getPropertyValue(\"--Small_Title\").split(',');\n  var Array_Inst2_Medium_Kit_Titles = rs.getPropertyValue(\"--Medium_Title\").split(',');\n  var Array_Inst2_Large_Kit_Titles = rs.getPropertyValue(\"--Large_Title\").split(',');\n  var Array_Inst2_4xLarge_Kit_Titles = rs.getPropertyValue(\"--ExLarge_Title\").split(',');\n  var Array_Small_Inst2_Bullets = rs.getPropertyValue('--Small_Bullets').split(',');\n  var Array_Medium_Inst2_Bullets = rs.getPropertyValue('--Medium_Bullets').split(',');\n  var Array_Large_Inst2_Bullets = rs.getPropertyValue('--Large_Bullets').split(',');\n  var Array_ExLarge_Inst2_Bullets = rs.getPropertyValue('--ExLarge_Bullets').split(',');\n  var Small_URL = rs.getPropertyValue('--Small_URL');\n  var Medium_URL = rs.getPropertyValue('--Medium_URL');\n  var Large_URL = rs.getPropertyValue('--Large_URL');\n  var ExLarge_URL = rs.getPropertyValue('--ExLarge_URL');\n  var Small_Title = rs.getPropertyValue('--Small_Title');\n  var Medium_Title = rs.getPropertyValue('--Medium_Title');\n  var Large_Title = rs.getPropertyValue('--Large_Title');\n  var ExLarge_Title = rs.getPropertyValue('--ExLarge_Title');\n\n  var URL_Size_Text = get_size_from_URL();\n  var Size_Text = '';\n  try {\n    switch (URL_Size_Text) {\n      case Small_URL:\n        Size_Text = Small_Title.split(',')[0];\n        if (Small_Title.split(',').length > 1) {\n          Size_Text += \" (\" + Small_Title.split(',')[1].trim() + \")\";\n        }\n        break;\n      case Medium_URL:\n        Size_Text = Medium_Title.split(',')[0];\n        if (Medium_Title.split(',').length > 1) {\n          Size_Text += \" (\" + Medium_Title.split(',')[1].trim() + \")\";\n        }\n        break;\n      case Large_URL:\n        Size_Text = Large_Title.split(',')[0];\n        if (Large_Title.split(',').length > 1) {\n          Size_Text += \" (\" + Large_Title.split(',')[1].trim() + \")\";\n        }\n        break;\n      case ExLarge_URL:\n        Size_Text = ExLarge_Title.split(',')[0];\n        if (ExLarge_Title.split(',').length > 1) {\n          Size_Text += \" (\" + ExLarge_Title.split(',')[1].trim() + \")\";\n        }\n        break;\n    }\n\n  } catch (error) {\n    alert(error);\n  }\n  document.querySelector('#Btn_Size_Options_Popup').innerHTML = Size_Text + document.querySelector('#Btn_Size_Options_Popup').innerHTML;\n\n\n  //Column 1\n  if (Array_Inst2_Small_Kit_Titles[0].trimEnd() != '') {\n    document.getElementById(\"div_Inst2_Small\").style.display = \"inline\";\n    Array_Small_Inst2_Bullets.forEach(function (BulletText) {\n      if (BulletText != '') {\n        var temp_li = document.createElement(\"li\");\n        temp_li.appendChild(document.createTextNode(BulletText.replace('\"\"', '\"')));\n        document.getElementById(\"ul_Small_Inst2_Bullets\").appendChild(temp_li);\n      }\n      document.getElementById(\"Inst2_Small_Kit_Title\").innerHTML = Array_Inst2_Small_Kit_Titles[0] + \"<br><sup>\" + Array_Inst2_Small_Kit_Titles[1] + \"</sup>\";\n    })\n  }\n  //Column 2\n  if (Array_Inst2_Medium_Kit_Titles[0].trimEnd() != '') {\n    document.getElementById(\"div_Inst2_Medium\").style.display = \"inline\";\n    Array_Medium_Inst2_Bullets.forEach(function (BulletText) {\n      if (BulletText != '') {\n        var temp_li = document.createElement(\"li\");\n        temp_li.appendChild(document.createTextNode(BulletText.replace('\"\"', '\"')));\n        document.getElementById(\"ul_Medium_Inst2_Bullets\").appendChild(temp_li);\n      }\n      document.getElementById(\"Inst2_Medium_Kit_Title\").innerHTML = Array_Inst2_Medium_Kit_Titles[0] + \"<br><sup>\" + Array_Inst2_Medium_Kit_Titles[1] + \"</sup>\";\n    })\n  }\n\n  //Column 3\n  if (Array_Inst2_Large_Kit_Titles[0].trimEnd() != '') {\n    document.getElementById(\"div_Inst2_Large\").style.display = \"inline\";\n    Array_Large_Inst2_Bullets.forEach(function (BulletText) {\n      if (BulletText != '') {\n        var temp_li = document.createElement(\"li\");\n        temp_li.appendChild(document.createTextNode(BulletText.replace('\"\"', '\"')));\n        document.getElementById(\"ul_Large_Inst2_Bullets\").appendChild(temp_li);\n      }\n      document.getElementById(\"Inst2_Large_Kit_Title\").innerHTML = Array_Inst2_Large_Kit_Titles[0] + \"<br><sup>\" + Array_Inst2_Large_Kit_Titles[1] + \"</sup>\";\n    })\n  }\n\n  //Column 4\n  if (Array_Inst2_4xLarge_Kit_Titles[0].trimEnd() != '') {\n    document.getElementById(\"div_Inst2_ExLarge\").style.display = \"inline\";\n    Array_ExLarge_Inst2_Bullets.forEach(function (BulletText) {\n      if (BulletText != '') {\n        var temp_li = document.createElement(\"li\");\n        temp_li.appendChild(document.createTextNode(BulletText.replace('\"\"', '\"')));\n        document.getElementById(\"ul_ExLarge_Inst2_Bullets\").appendChild(temp_li);\n      }\n      document.getElementById(\"Inst2_4xLarge_Kit_Title\").innerHTML = Array_Inst2_4xLarge_Kit_Titles[0] + \"<br><sup>\" + Array_Inst2_4xLarge_Kit_Titles[1] + \"</sup>\";\n    })\n  }\n\n  function get_size_from_URL() {\n    try {\n      var URL = window.location.href.split('?')[0].split('#')[0].split('/products/')[1];\n      return URL.split('_')[2];\n    } catch (error) {\n      alert(error);\n    }\n  }\n\n  function navigate_size(size) {\n    try {\n      var tempURL = window.location.href.split('?')[0].split('#')[0].split('/products/')[1];\n      tempURL += '_';\n      var URL_Array = tempURL.split('_');\n      tempURL = URL_Array[0] + \"_\" + URL_Array[1] + \"_\" + size + Add_Underscore_To_Sealer(URL_Array[3]);\n      tempURL = tempURL.replace(/\\s/g, ''); //Remove Spaces\n      window.location.href = tempURL;\n    } catch (error) {\n      alert('Navagate_Color: ' + error);\n    }\n  }\n\n  function Add_Underscore_To_Sealer(Sealer) {\n    try {\n      if (Sealer != \"\") {\n        Sealer = \"_\" + Sealer;\n      }\n      return Sealer;\n    } catch (error) {\n      alert('Add_Underscore_To_Sealer' + error);\n    }\n    return trim(Sealer);\n  }\n</script>",
    "img_ratio": "1:1",
    "row_height": 0,
    "fit_row": false,
    "margin_top": 0,
    "margin_bottom": 0,
    "collapsed": false,
    "show_more_text": "Show more",
    "show_less_text": "Show less",
    "row_toggle_border_style": "solid",
    "accordion": false,
    "accordion_marker": false,
    "accordion_title": "",
    "accordion_subheading": "",
    "accordion_hide_title_when_open": false,
    "accordion_hide_subheading_when_open": false,
    "accordion_title_center": false,
    "accordion_start_open": false,
    "accordion_allow_multiple": false,
    "accordion_bg_color": "#ffffff",
    "accordion_shadow_pct": 8,
    "accordion_shadow_style": "raised",
    "accordion_group": "",
    "accordion_always_open": false,
    "videos": []
  }
];

window.MEDIA_GALLERY_SETS["Help-WNP-Sizes"] = [
  {
    "heading": "<p>More Help on Sizes</p>",
    "subheading": "",
    "custom_template_id": "mg-custom-template--18365025648774__c_media_gallery_LjYKft-0",
    "custom_html": "<h4 style=\"text-align: center; font-weight: bold; font-size: 2em;\"><strong><span style=\"color: rgb(58, 108, 161);\">Let’s talk about picking the perfect amount of Retique It® for your project!</span></strong></h4>\n<p> </p>\n<p>Here’s the quick and dirty:</p>\n<ol>\n<li>Measure the <strong>width</strong> of your surface (in inches).</li>\n<li>Measure the <strong>height</strong> (also in inches).</li>\n<li>Multiply the two numbers.</li>\n<li>Then divide by 144 to get square feet.</li>\n</ol>\n<p><strong>🎯 Example:</strong><br>Your dresser is 48” wide and 30” tall.<br><code>48 x 30 = 1440 ÷ 144 = 10 sq ft.</code></p>\n<p>Need help crunching the numbers? Try the <a href=\"https://www.calculatorsoup.com/calculators/construction/square-footage-calculator.php\" rel=\"noopener\" target=\"_blank\"> Square Footage Calculator from CalculatorSoup </a> —perfect for estimating surface area for your Retique It® project.</p>\n<p><strong>Boom! You’re basically a mathlete now!</strong></p>\n<p>But hang on—don’t stop there. Since you're measuring <strong>surface area</strong>, you’ll want to repeat that process for <em>every side</em> or section of your project that needs product. Got a dresser? Measure the top, the front, the sides—even the drawer fronts if you’re doing those too.</p>\n<p>Once you’ve got your total surface square footage, multiply it by the number of coats you’ll need. Plan for <strong>at least two coats</strong>—sometimes three. Trust me, one coat rarely does the trick. Especially if you’re working with rough textures, lightening a dark surface, coating something extra porous, or want to practice your graining technique before you start your project.  (which is always a great idea)</p>\n<p>Still unsure? We've got a handy visual guide below to help you figure it out fast</p>\n<div style=\"text-align: center;\"><img style=\"margin-top: 20px; margin-bottom: 20px; float: none;\" src=\"https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Not_Sure_What_Size_to_Order_Presentation_43.png?v=1750278619\" alt=\"Visual guide to measuring square footage for DIY Retique It projects\" title=\"How to measure square footage for Retique It DIY refinishing projects\"></div>\n<div style=\"text-align: center;\">\n<p><img style=\"margin-top: 20px; margin-bottom: 20px; float: none;\" src=\"https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Not_Sure_What_Size_to_Order_Presentation_43_1_480x480.png?v=1750278782\" alt=\"How to account for extra coats with Retique It wood finish\" title=\"Why and how to apply multiple coats of Retique It for best results\"></p>\n<h2 style=\"font-size: 1.1em; letter-spacing: 0.5px; font-weight: bold;\">Choosing the Right Retique It Kit Size</h2>\n<p style=\"text-align: left;\">Now that you know the size of your project, you are ready to find your kit. Use the following illustrations as a guide to match it to the appropriate kit for your project.</p>\n<a href=\"https://retique.com/products/woodnfinish_pickled-oak_s\" rel=\"noopener\" target=\"_blank\">\n<p style=\"text-align: left;\"><img style=\"margin-top: 20px; margin-bottom: 20px; float: none;\" src=\"https://cdn.shopify.com/s/files/1/0066/5993/2278/files/2_2d8c06ad-1780-43d1-878d-ee0aac74ad63.png?v=1750278905\" alt=\"Retique It Small Wood Finish Kit coverage guide\" title=\"Approximate surface coverage with a Small Retique It kit\"></p>\n</a><a href=\"https://retique.com/products/woodnfinish_pickled-oak_m\" rel=\"noopener\" target=\"_blank\">\n<p style=\"text-align: left;\"><img style=\"margin-bottom: 20px; float: none;\" src=\"https://cdn.shopify.com/s/files/1/0066/5993/2278/files/3_a6640783-6ff8-482c-8bb6-4639294c72f8.png?v=1750278941\" alt=\"Medium Retique It Wood Finish Kit coverage\" title=\"Surface area covered by a Medium Retique It wood finish kit\"></p>\n</a><a href=\"https://retique.com/products/woodnfinish_pickled-oak_l\" rel=\"noopener\" target=\"_blank\">\n<p style=\"text-align: left;\"><img style=\"margin-bottom: 20px; float: none;\" src=\"https://cdn.shopify.com/s/files/1/0066/5993/2278/files/4_7f263bf0-042f-4823-9410-ac3160f3e94d.png?v=1750278975\" alt=\"Large Retique It Kit project coverage estimate\" title=\"Estimated coverage area for Large Retique It kit\"></p>\n</a><a href=\"https://retique.com/products/woodnfinish_pickled-oak_xl\" rel=\"noopener\" target=\"_blank\">\n<p style=\"text-align: left;\"><img style=\"margin-bottom: 20px; float: none;\" src=\"https://cdn.shopify.com/s/files/1/0066/5993/2278/files/5_e3633daa-36f4-4a54-8fc9-441794431856.png?v=1750279017\" alt=\"Coverage for 4x Large Retique It wood finish kit\" title=\"How much surface area a 4x Large Retique It kit can cover\"></p>\n</a>\n</div>",
    "custom_width_desktop_percent": 90,
    "custom_width_mobile_percent": 95,
    "custom_max_width_px": "0",
    "img_ratio": "1:1",
    "row_height": 0,
    "fit_row": false,
    "margin_top": 0,
    "margin_bottom": 0,
    "collapsed": false,
    "show_more_text": "Show more",
    "show_less_text": "Show less",
    "row_toggle_border_style": "solid",
    "accordion": false,
    "accordion_marker": false,
    "accordion_title": "",
    "accordion_subheading": "",
    "accordion_hide_title_when_open": false,
    "accordion_hide_subheading_when_open": false,
    "accordion_title_center": false,
    "accordion_start_open": false,
    "accordion_allow_multiple": false,
    "accordion_bg_color": "#ffffff",
    "accordion_shadow_pct": 8,
    "accordion_shadow_style": "raised",
    "accordion_width_mobile_percent": 100,
    "accordion_width_desktop_percent": 100,
    "accordion_max_width_px": 0,
    "accordion_group": "",
    "accordion_always_open": false,
    "videos": []
  }
];

window.MEDIA_GALLERY_SETS["Help-LW-Sizes"] = [
  {
    "heading": "<p>More Help on Sizes</p>",
    "subheading": "",
    "custom_template_id": "mg-custom-template--18365025648774__c_media_gallery_LjYKft-0",
    "custom_html": "<h4 style=\"text-align: center; font-weight: bold; font-size: 2em;\"><strong><span style=\"color: rgb(58, 108, 161);\">Let’s talk about picking the perfect amount of Retique It® for your project!</span></strong></h4>\n<p> </p>\n<p>Here’s the quick and dirty:</p>\n<ol>\n<li>Measure the <strong>width</strong> of your surface (in inches).</li>\n<li>Measure the <strong>height</strong> (also in inches).</li>\n<li>Multiply the two numbers.</li>\n<li>Then divide by 144 to get square feet.</li>\n</ol>\n<p><strong>🎯 Example:</strong><br>Your dresser is 48” wide and 30” tall.<br><code>48 x 30 = 1440 ÷ 144 = 10 sq ft.</code></p>\n<p>Need help crunching the numbers? Try the <a href=\"https://www.calculatorsoup.com/calculators/construction/square-footage-calculator.php\" rel=\"noopener\" target=\"_blank\"> Square Footage Calculator from CalculatorSoup </a> —perfect for estimating surface area for your Retique It® project.</p>\n<p><strong>Boom! You’re basically a mathlete now!</strong></p>\n<p>But hang on—don’t stop there. Since you're measuring <strong>surface area</strong>, you’ll want to repeat that process for <em>every side</em> or section of your project that needs product. Got a dresser? Measure the top, the front, the sides—even the drawer fronts if you’re doing those too.</p>\n<p>Once you’ve got your total surface square footage, multiply it by the number of coats you’ll need. Plan for <strong>at least two coats</strong>—sometimes three. Trust me, one coat rarely does the trick. Especially if you’re working with rough textures, lightening a dark surface, coating something extra porous, or want to practice your graining technique before you start your project.  (which is always a great idea)</p>\n<p>Still unsure? We've got a handy visual guide below to help you figure it out fast</p>\n<div style=\"text-align: center;\"><img style=\"margin-top: 20px; margin-bottom: 20px; float: none;\" src=\"https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Not_Sure_What_Size_to_Order_Presentation_43.png?v=1750278619\" alt=\"Visual guide to measuring square footage for DIY Retique It projects\" title=\"How to measure square footage for Retique It DIY refinishing projects\"></div>\n<div style=\"text-align: center;\">\n<p><img style=\"margin-top: 20px; margin-bottom: 20px; float: none;\" src=\"https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Not_Sure_What_Size_to_Order_Presentation_43_1_480x480.png?v=1750278782\" alt=\"How to account for extra coats with Retique It wood finish\" title=\"Why and how to apply multiple coats of Retique It for best results\"></p>\n<h2 style=\"font-size: 1.1em; letter-spacing: 0.5px; font-weight: bold;\">Choosing the Right Retique It Kit Size</h2>\n<p style=\"text-align: left;\">Now that you know the size of your project, you are ready to find your kit. Use the following illustrations as a guide to match it to the appropriate kit for your project.</p>\n<a href=\"https://retique.com/products/woodnfinish_pickled-oak_s\" rel=\"noopener\" target=\"_blank\">\n<p style=\"text-align: left;\"><img style=\"margin-top: 20px; margin-bottom: 20px; float: none;\" src=\"https://cdn.shopify.com/s/files/1/0066/5993/2278/files/2_2d8c06ad-1780-43d1-878d-ee0aac74ad63.png?v=1750278905\" alt=\"Retique It Small Wood Finish Kit coverage guide\" title=\"Approximate surface coverage with a Small Retique It kit\"></p>\n</a><a href=\"https://retique.com/products/woodnfinish_pickled-oak_m\" rel=\"noopener\" target=\"_blank\">\n<p style=\"text-align: left;\"><img style=\"margin-bottom: 20px; float: none;\" src=\"https://cdn.shopify.com/s/files/1/0066/5993/2278/files/3_a6640783-6ff8-482c-8bb6-4639294c72f8.png?v=1750278941\" alt=\"Medium Retique It Wood Finish Kit coverage\" title=\"Surface area covered by a Medium Retique It wood finish kit\"></p>\n</a><a href=\"https://retique.com/products/woodnfinish_pickled-oak_l\" rel=\"noopener\" target=\"_blank\">\n<p style=\"text-align: left;\"><img style=\"margin-bottom: 20px; float: none;\" src=\"https://cdn.shopify.com/s/files/1/0066/5993/2278/files/4_7f263bf0-042f-4823-9410-ac3160f3e94d.png?v=1750278975\" alt=\"Large Retique It Kit project coverage estimate\" title=\"Estimated coverage area for Large Retique It kit\"></p>\n</a><a href=\"https://retique.com/products/woodnfinish_pickled-oak_xl\" rel=\"noopener\" target=\"_blank\">\n<p style=\"text-align: left;\"><img style=\"margin-bottom: 20px; float: none;\" src=\"https://cdn.shopify.com/s/files/1/0066/5993/2278/files/5_e3633daa-36f4-4a54-8fc9-441794431856.png?v=1750279017\" alt=\"Coverage for 4x Large Retique It wood finish kit\" title=\"How much surface area a 4x Large Retique It kit can cover\"></p>\n</a>\n</div>",
    "custom_width_desktop_percent": 90,
    "custom_width_mobile_percent": 95,
    "custom_max_width_px": "0",
    "img_ratio": "1:1",
    "row_height": 0,
    "fit_row": false,
    "margin_top": 0,
    "margin_bottom": 0,
    "collapsed": false,
    "show_more_text": "Show more",
    "show_less_text": "Show less",
    "row_toggle_border_style": "solid",
    "accordion": false,
    "accordion_marker": false,
    "accordion_title": "",
    "accordion_subheading": "",
    "accordion_hide_title_when_open": false,
    "accordion_hide_subheading_when_open": false,
    "accordion_title_center": false,
    "accordion_start_open": false,
    "accordion_allow_multiple": false,
    "accordion_bg_color": "#ffffff",
    "accordion_shadow_pct": 8,
    "accordion_shadow_style": "raised",
    "accordion_width_mobile_percent": 100,
    "accordion_width_desktop_percent": 100,
    "accordion_max_width_px": 0,
    "accordion_group": "",
    "accordion_always_open": false,
    "videos": []
  }
];

window.MEDIA_GALLERY_SETS["Help-WNS-Sizes"] = [
  {
    "heading": "<p>More Help on Sizes</p>",
    "subheading": "",
    "heading_justify": "center",
    "custom_template_id": "mg-custom-template--18474791043206__c_media_gallery_9P4XVq-0",
    "custom_html": "<h4 style=\"text-align: center; font-weight: bold; font-size: 2em;\"><strong><span style=\"color: rgb(58, 108, 161);\">Let’s talk about picking the perfect amount of Retique It® for your project!</span></strong></h4>\n<p> </p>\n<p>Here’s the quick and dirty:</p>\n<ol>\n<li>Measure the <strong>width</strong> of your surface (in inches).</li>\n<li>Measure the <strong>height</strong> (also in inches).</li>\n<li>Multiply the two numbers.</li>\n<li>Then divide by 144 to get square feet.</li>\n</ol>\n<p><strong>🎯 Example:</strong><br>Your dresser is 48” wide and 30” tall.<br><code>48 x 30 = 1440 ÷ 144 = 10 sq ft.</code></p>\n<p>Need help crunching the numbers? Try the <a href=\"https://www.calculatorsoup.com/calculators/construction/square-footage-calculator.php\" rel=\"noopener\" target=\"_blank\"> Square Footage Calculator from CalculatorSoup </a> —perfect for estimating surface area for your Retique It® project.</p>\n<p><strong>Boom! You’re basically a mathlete now!</strong></p>\n<p>But hang on—don’t stop there. Since you're measuring <strong>surface area</strong>, you’ll want to repeat that process for <em>every side</em> or section of your project that needs product. Got a dresser? Measure the top, the front, the sides—even the drawer fronts if you’re doing those too.</p>\n<p>Once you’ve got your total surface square footage, multiply it by the number of coats you’ll need. Plan for <strong>at least two coats</strong>—sometimes three. Trust me, one coat rarely does the trick. Especially if you’re working with rough textures, lightening a dark surface, coating something extra porous, or want to practice your graining technique before you start your project.  (which is always a great idea)</p>\n<p>Still unsure? We've got a handy visual guide below to help you figure it out fast</p>\n<div style=\"text-align: center;\"><img style=\"margin-top: 20px; margin-bottom: 20px; float: none;\" src=\"https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Not_Sure_What_Size_to_Order_Presentation_43.png?v=1750278619\" alt=\"Visual guide to measuring square footage for DIY Retique It projects\" title=\"How to measure square footage for Retique It DIY refinishing projects\"></div>\n<div style=\"text-align: center;\">\n<p><img style=\"margin-top: 20px; margin-bottom: 20px; float: none;\" src=\"https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Not_Sure_What_Size_to_Order_Presentation_43_1_480x480.png?v=1750278782\" alt=\"How to account for extra coats with Retique It wood finish\" title=\"Why and how to apply multiple coats of Retique It for best results\"></p>\n<h2 style=\"font-size: 1.1em; letter-spacing: 0.5px; font-weight: bold;\">Choosing the Right Retique It Kit Size</h2>\n<p style=\"text-align: left;\">Now that you know the size of your project, you are ready to find your kit. Use the following illustrations as a guide to match it to the appropriate kit for your project.</p>\n<a href=\"https://retique.com/products/woodnfinish_pickled-oak_s\" rel=\"noopener\" target=\"_blank\">\n<p style=\"text-align: left;\"><img style=\"margin-top: 20px; margin-bottom: 20px; float: none;\" src=\"https://cdn.shopify.com/s/files/1/0066/5993/2278/files/2_2d8c06ad-1780-43d1-878d-ee0aac74ad63.png?v=1750278905\" alt=\"Retique It Small Wood Finish Kit coverage guide\" title=\"Approximate surface coverage with a Small Retique It kit\"></p>\n</a><a href=\"https://retique.com/products/woodnfinish_pickled-oak_m\" rel=\"noopener\" target=\"_blank\">\n<p style=\"text-align: left;\"><img style=\"margin-bottom: 20px; float: none;\" src=\"https://cdn.shopify.com/s/files/1/0066/5993/2278/files/3_a6640783-6ff8-482c-8bb6-4639294c72f8.png?v=1750278941\" alt=\"Medium Retique It Wood Finish Kit coverage\" title=\"Surface area covered by a Medium Retique It wood finish kit\"></p>\n</a><a href=\"https://retique.com/products/woodnfinish_pickled-oak_l\" rel=\"noopener\" target=\"_blank\">\n<p style=\"text-align: left;\"><img style=\"margin-bottom: 20px; float: none;\" src=\"https://cdn.shopify.com/s/files/1/0066/5993/2278/files/4_7f263bf0-042f-4823-9410-ac3160f3e94d.png?v=1750278975\" alt=\"Large Retique It Kit project coverage estimate\" title=\"Estimated coverage area for Large Retique It kit\"></p>\n</a><a href=\"https://retique.com/products/woodnfinish_pickled-oak_xl\" rel=\"noopener\" target=\"_blank\">\n<p style=\"text-align: left;\"><img style=\"margin-bottom: 20px; float: none;\" src=\"https://cdn.shopify.com/s/files/1/0066/5993/2278/files/5_e3633daa-36f4-4a54-8fc9-441794431856.png?v=1750279017\" alt=\"Coverage for 4x Large Retique It wood finish kit\" title=\"How much surface area a 4x Large Retique It kit can cover\"></p>\n</a>\n</div>",
    "custom_width_desktop_percent": 90,
    "custom_width_mobile_percent": 95,
    "custom_max_width_px": "0",
    "img_ratio": "1:1",
    "row_height": 0,
    "fit_row": false,
    "margin_top": 0,
    "margin_bottom": 0,
    "collapsed": false,
    "show_more_text": "Show more",
    "show_less_text": "Show less",
    "row_toggle_border_style": "solid",
    "accordion": false,
    "accordion_marker": false,
    "accordion_title": "",
    "accordion_subheading": "",
    "accordion_hide_title_when_open": false,
    "accordion_hide_subheading_when_open": false,
    "accordion_title_center": false,
    "accordion_start_open": false,
    "accordion_allow_multiple": false,
    "accordion_bg_color": "#ffffff",
    "accordion_shadow_pct": 8,
    "accordion_shadow_style": "raised",
    "accordion_width_mobile_percent": 100,
    "accordion_width_desktop_percent": 100,
    "accordion_max_width_px": 0,
    "accordion_group": "",
    "accordion_always_open": false,
    "videos": []
  }
];

window.MEDIA_GALLERY_SETS["Sizes-WNP-BLCH"] = [
  {
    "heading": "<h3>Bleached Wood Size Options</h3>",
    "subheading": "",
    "heading_justify": "center",
    "img_ratio": "1:1",
    "row_height": 0,
    "row_height_mobile": 0,
    "row_height_desktop": 0,
    "fit_row": true,
    "row_display_type": "scale_to_fit",
    "margin_top": 0,
    "margin_bottom": 0,
    "swatch_row": true,
    "row_justify": "center",
    "custom_html": "",
    "custom_template_id": "",
    "custom_width_desktop_percent": 100,
    "custom_width_mobile_percent": 100,
    "custom_max_width_px": 0,
    "preset_button": false,
    "preset_button_text": "<h3>Bleached Wood Size Options</h3>",
    "preset_modal_title": "",
    "preset_hide_modal_header": false,
    "preset_button_set": "",
    "preset_button_style": "dropdown_box",
    "preset_button_subtext": "",
    "preset_button_image": "",
    "preset_button_image_alt": "",
    "preset_button_width_percent": 0,
    "preset_button_max_width_px": 0,
    "collapsed": false,
    "show_more_text": "Show more",
    "show_less_text": "Show less",
    "row_toggle_border_style": "solid",
    "hide_cta_buttons": false,
    "end_behavior_override": "",
    "videos": [
      {
        "type": "product",
        "swatch_mode": true,
        "title": "8 oz (Bottle)",
        "alt": "8 oz (Bottle)",
        "thumbnail": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNP08-BLCH-2D.png?v=1774637593&width=2000",
        "thumb_mode": "default",
        "product_image_number": 0,
        "product_image_id": 29354614194310,
        "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNP08-BLCH-2D.png?v=1774637593&width=2000",
        "product_url": "/products/wnp_blch_s",
        "product_id": 7572896022662,
        "show_price": false,
        "show_reviews": false,
        "show_shop_button": false,
        "buttons_over_image": false,
        "price": "$24.99",
        "price_num": 24.99,
        "available": true,
        "scale": 85,
        "product_image_scale": 85,
        "vjust": "center",
        "html_desc": "",
        "desc_html": "",
        "margin_top": 0,
        "margin_bottom": 0,
        "open_set_key": "",
        "learn_more_text": "",
        "cta": {
          "href": "/products/wnp_blch_s",
          "text": "Shop"
        }
      },
      {
        "type": "product",
        "swatch_mode": true,
        "title": "16 oz (Pint)",
        "alt": "16 oz (Pint)",
        "thumbnail": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/S-WNP-BLCH-new-1.png?v=1773261175&width=2000",
        "thumb_mode": "default",
        "product_image_number": 0,
        "product_image_id": 29239401742470,
        "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/S-WNP-BLCH-new-1.png?v=1773261175&width=2000",
        "product_url": "/products/wnp_blch_m",
        "product_id": 7572896055430,
        "show_price": false,
        "show_reviews": false,
        "show_shop_button": false,
        "buttons_over_image": false,
        "price": "$34.99",
        "price_num": 34.99,
        "available": true,
        "scale": 55,
        "product_image_scale": 55,
        "vjust": "center",
        "html_desc": "",
        "desc_html": "",
        "margin_top": 0,
        "margin_bottom": 0,
        "open_set_key": "",
        "learn_more_text": "",
        "cta": {
          "href": "/products/wnp_blch_m",
          "text": "Shop"
        }
      },
      {
        "type": "product",
        "swatch_mode": true,
        "title": "32 oz (Quart)",
        "alt": "32 oz (Quart)",
        "thumbnail": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/L-WNP-BLCH-new-1_1e700a26-22db-4ca5-8c2d-09ca5fbee8fd.png?v=1774615696&width=2000",
        "thumb_mode": "default",
        "product_image_number": 0,
        "product_image_id": 29353367830662,
        "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/L-WNP-BLCH-new-1_1e700a26-22db-4ca5-8c2d-09ca5fbee8fd.png?v=1774615696&width=2000",
        "product_url": "/products/wnp_blch_l",
        "product_id": 7572896088198,
        "show_price": false,
        "show_reviews": false,
        "show_shop_button": false,
        "buttons_over_image": false,
        "price": "$59.99",
        "price_num": 59.99,
        "available": true,
        "scale": 100,
        "product_image_scale": 100,
        "vjust": "center",
        "html_desc": "",
        "desc_html": "",
        "margin_top": 0,
        "margin_bottom": 0,
        "open_set_key": "",
        "learn_more_text": "",
        "cta": {
          "href": "/products/wnp_blch_l",
          "text": "Shop"
        }
      },
      {
        "type": "product",
        "swatch_mode": true,
        "title": "128 oz (Gallon)",
        "alt": "128 oz (Gallon)",
        "thumbnail": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNP128-BLCH-1_cabc697c-6c0f-438d-8c2c-8cf004e567b6.png?v=1774616531&width=2000",
        "thumb_mode": "default",
        "product_image_number": 0,
        "product_image_id": 29353425338502,
        "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNP128-BLCH-1_cabc697c-6c0f-438d-8c2c-8cf004e567b6.png?v=1774616531&width=2000",
        "product_url": "/products/wnp_blch_xl",
        "product_id": 7572896120966,
        "show_price": false,
        "show_reviews": false,
        "show_shop_button": false,
        "buttons_over_image": false,
        "price": "$229.99",
        "price_num": 229.99,
        "available": false,
        "scale": 100,
        "product_image_scale": 100,
        "vjust": "center",
        "html_desc": "",
        "desc_html": "",
        "margin_top": 0,
        "margin_bottom": 0,
        "open_set_key": "",
        "learn_more_text": "",
        "cta": {
          "href": "/products/wnp_blch_xl",
          "text": "Shop"
        }
      }
    ]
  },
  {
    "heading": "<h3>Estimated Coverage by Size</h3>",
    "subheading": "",
    "heading_justify": "center",
    "img_ratio": "1:1",
    "row_height": 0,
    "row_height_mobile": 0,
    "row_height_desktop": 0,
    "fit_row": false,
    "row_display_type": "scrollable",
    "margin_top": 0,
    "margin_bottom": 0,
    "swatch_row": false,
    "row_justify": "center",
    "custom_html": "<div style=\"display: flex; justify-content: center;\">\n  <ul style=\"list-style-position: inside; text-align: left;\">\n    <li>8 oz – 25 square feet</li>\n    <li>16 oz – 50 square feet</li>\n    <li>32 oz – 100 square feet</li>\n    <li>Gallon – 400 square feet</li>\n  </ul>\n</div>\n<br>",
    "custom_template_id": "mgps-custom-template--18474791043206__mg_product_swatches_XJNHTA-0",
    "custom_width_desktop_percent": 100,
    "custom_width_mobile_percent": 100,
    "custom_max_width_px": 0,
    "preset_button": false,
    "preset_button_text": "<h3>Estimated Coverage by Size</h3>",
    "preset_modal_title": "",
    "preset_hide_modal_header": false,
    "preset_button_set": "",
    "preset_button_style": "dropdown_box",
    "preset_button_subtext": "",
    "preset_button_image": "",
    "preset_button_image_alt": "",
    "preset_button_width_percent": 0,
    "preset_button_max_width_px": 0,
    "collapsed": false,
    "show_more_text": "Show more",
    "show_less_text": "Show less",
    "row_toggle_border_style": "solid",
    "hide_cta_buttons": false,
    "end_behavior_override": "",
    "videos": []
  },
  {
    "heading": "<h3>More Help on Sizing</h3>",
    "subheading": "<p>Select</p>",
    "heading_justify": "center",
    "img_ratio": "1:1",
    "row_height": 0,
    "row_height_mobile": 0,
    "row_height_desktop": 0,
    "fit_row": false,
    "row_display_type": "scrollable",
    "margin_top": 0,
    "margin_bottom": 0,
    "swatch_row": false,
    "row_justify": "center",
    "custom_html": "",
    "custom_template_id": "",
    "custom_width_desktop_percent": 100,
    "custom_width_mobile_percent": 100,
    "custom_max_width_px": 0,
    "preset_button": true,
    "preset_button_text": "<h3>More Help on Sizing</h3>",
    "preset_modal_title": "",
    "preset_hide_modal_header": false,
    "preset_button_set": "Help-WNP-Sizes",
    "preset_button_style": "dropdown_box",
    "preset_button_subtext": "<p>Select</p>",
    "preset_button_image": "",
    "preset_button_image_alt": "",
    "preset_button_width_percent": 100,
    "preset_button_max_width_px": 0,
    "collapsed": false,
    "show_more_text": "Show more",
    "show_less_text": "Show less",
    "row_toggle_border_style": "solid",
    "hide_cta_buttons": false,
    "end_behavior_override": "",
    "videos": []
  }
];

window.MEDIA_GALLERY_SETS["Sizes-WNP-LITE"] = [
  {
    "heading": "<h3>Light Wood Size Options</h3>",
    "subheading": "",
    "heading_justify": "center",
    "img_ratio": "1:1",
    "row_height": 0,
    "row_height_mobile": 0,
    "row_height_desktop": 0,
    "fit_row": true,
    "row_display_type": "scale_to_fit",
    "margin_top": 0,
    "margin_bottom": 0,
    "swatch_row": true,
    "row_justify": "center",
    "custom_html": "",
    "custom_template_id": "",
    "custom_width_desktop_percent": 100,
    "custom_width_mobile_percent": 100,
    "custom_max_width_px": 0,
    "preset_button": false,
    "preset_button_text": "<h3>Light Wood Size Options</h3>",
    "preset_modal_title": "",
    "preset_hide_modal_header": false,
    "preset_button_set": "",
    "preset_button_style": "dropdown_box",
    "preset_button_subtext": "",
    "preset_button_image": "",
    "preset_button_image_alt": "",
    "preset_button_width_percent": 0,
    "preset_button_max_width_px": 0,
    "collapsed": false,
    "show_more_text": "Show more",
    "show_less_text": "Show less",
    "row_toggle_border_style": "solid",
    "hide_cta_buttons": false,
    "end_behavior_override": "",
    "videos": [
      {
        "type": "product",
        "swatch_mode": true,
        "title": "8 oz (Bottle)",
        "alt": "8 oz (Bottle)",
        "thumbnail": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNP08-LITE-3D.png?v=1774695981&width=2000",
        "thumb_mode": "default",
        "product_image_number": 0,
        "product_image_id": 29357683310726,
        "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNP08-LITE-3D.png?v=1774695981&width=2000",
        "product_url": "/products/wnp_lite_s",
        "product_id": 7573368045702,
        "show_price": false,
        "show_reviews": false,
        "show_shop_button": false,
        "buttons_over_image": false,
        "price": "$24.99",
        "price_num": 24.99,
        "available": true,
        "scale": 85,
        "product_image_scale": 85,
        "vjust": "center",
        "html_desc": "",
        "desc_html": "",
        "margin_top": 0,
        "margin_bottom": 0,
        "open_set_key": "",
        "learn_more_text": "",
        "cta": {
          "href": "/products/wnp_lite_s",
          "text": "Shop"
        }
      },
      {
        "type": "product",
        "swatch_mode": true,
        "title": "16 oz (Pint)",
        "alt": "16 oz (Pint)",
        "thumbnail": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNP16-DARK-3D_3ec458b1-8b0f-43b8-b00d-2e5d6456899a.png?v=1774696133&width=2000",
        "thumb_mode": "default",
        "product_image_number": 0,
        "product_image_id": 29357685768326,
        "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNP16-DARK-3D_3ec458b1-8b0f-43b8-b00d-2e5d6456899a.png?v=1774696133&width=2000",
        "product_url": "/products/wnp_lite_m",
        "product_id": 7573368078470,
        "show_price": false,
        "show_reviews": false,
        "show_shop_button": false,
        "buttons_over_image": false,
        "price": "$34.99",
        "price_num": 34.99,
        "available": true,
        "scale": 55,
        "product_image_scale": 55,
        "vjust": "center",
        "html_desc": "",
        "desc_html": "",
        "margin_top": 0,
        "margin_bottom": 0,
        "open_set_key": "",
        "learn_more_text": "",
        "cta": {
          "href": "/products/wnp_lite_m",
          "text": "Shop"
        }
      },
      {
        "type": "product",
        "swatch_mode": true,
        "title": "32 oz (Quart)",
        "alt": "32 oz (Quart)",
        "thumbnail": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNP32-LITE-3D.png?v=1774696204&width=2000",
        "thumb_mode": "default",
        "product_image_number": 0,
        "product_image_id": 29357686390918,
        "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNP32-LITE-3D.png?v=1774696204&width=2000",
        "product_url": "/products/wnp_lite_l",
        "product_id": 7573368144006,
        "show_price": false,
        "show_reviews": false,
        "show_shop_button": false,
        "buttons_over_image": false,
        "price": "$24.99",
        "price_num": 24.99,
        "available": true,
        "scale": 100,
        "product_image_scale": 100,
        "vjust": "center",
        "html_desc": "",
        "desc_html": "",
        "margin_top": 0,
        "margin_bottom": 0,
        "open_set_key": "",
        "learn_more_text": "",
        "cta": {
          "href": "/products/wnp_lite_l",
          "text": "Shop"
        }
      },
      {
        "type": "product",
        "swatch_mode": true,
        "title": "128 oz (Gallon)",
        "alt": "128 oz (Gallon)",
        "thumbnail": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNP128-2D.png?v=1774700579&width=2000",
        "thumb_mode": "default",
        "product_image_number": 9,
        "product_image_id": 29357687570566,
        "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNP128-2D.png?v=1774700579&width=2000",
        "product_url": "/products/wnp_lite_xl",
        "product_id": 7573368176774,
        "show_price": false,
        "show_reviews": false,
        "show_shop_button": false,
        "buttons_over_image": false,
        "price": "$229.99",
        "price_num": 229.99,
        "available": true,
        "scale": 100,
        "product_image_scale": 100,
        "vjust": "center",
        "html_desc": "",
        "desc_html": "",
        "margin_top": 0,
        "margin_bottom": 0,
        "open_set_key": "",
        "learn_more_text": "",
        "cta": {
          "href": "/products/wnp_lite_xl",
          "text": "Shop"
        }
      }
    ]
  },
  {
    "heading": "<h3>Estimated Coverage by Size</h3>",
    "subheading": "",
    "heading_justify": "center",
    "img_ratio": "1:1",
    "row_height": 0,
    "row_height_mobile": 0,
    "row_height_desktop": 0,
    "fit_row": false,
    "row_display_type": "scrollable",
    "margin_top": 0,
    "margin_bottom": 0,
    "swatch_row": false,
    "row_justify": "center",
    "custom_html": "<div style=\"display: flex; justify-content: center;\">\n  <ul style=\"list-style-position: inside; text-align: left;\">\n    <li>8 oz – 25 square feet</li>\n    <li>16 oz – 50 square feet</li>\n    <li>32 oz – 100 square feet</li>\n    <li>Gallon – 400 square feet</li>\n  </ul>\n</div>\n<br>",
    "custom_template_id": "mgps-custom-template--18474791043206__mg_product_swatches_VPJaLr-0",
    "custom_width_desktop_percent": 100,
    "custom_width_mobile_percent": 100,
    "custom_max_width_px": 0,
    "preset_button": false,
    "preset_button_text": "<h3>Estimated Coverage by Size</h3>",
    "preset_modal_title": "",
    "preset_hide_modal_header": false,
    "preset_button_set": "",
    "preset_button_style": "dropdown_box",
    "preset_button_subtext": "",
    "preset_button_image": "",
    "preset_button_image_alt": "",
    "preset_button_width_percent": 0,
    "preset_button_max_width_px": 0,
    "collapsed": false,
    "show_more_text": "Show more",
    "show_less_text": "Show less",
    "row_toggle_border_style": "solid",
    "hide_cta_buttons": false,
    "end_behavior_override": "",
    "videos": []
  },
  {
    "heading": "<h3>More Help on Sizing</h3>",
    "subheading": "",
    "heading_justify": "center",
    "img_ratio": "1:1",
    "row_height": 0,
    "row_height_mobile": 0,
    "row_height_desktop": 0,
    "fit_row": false,
    "row_display_type": "scrollable",
    "margin_top": 0,
    "margin_bottom": 0,
    "swatch_row": false,
    "row_justify": "center",
    "custom_html": "",
    "custom_template_id": "",
    "custom_width_desktop_percent": 100,
    "custom_width_mobile_percent": 100,
    "custom_max_width_px": 0,
    "preset_button": true,
    "preset_button_text": "<h3>More Help on Sizing</h3>",
    "preset_modal_title": "",
    "preset_hide_modal_header": false,
    "preset_button_set": "Help-WNP-Sizes",
    "preset_button_style": "dropdown_box",
    "preset_button_subtext": "",
    "preset_button_image": "",
    "preset_button_image_alt": "",
    "preset_button_width_percent": 100,
    "preset_button_max_width_px": 0,
    "collapsed": false,
    "show_more_text": "Show more",
    "show_less_text": "Show less",
    "row_toggle_border_style": "solid",
    "hide_cta_buttons": false,
    "end_behavior_override": "",
    "videos": []
  }
];

window.MEDIA_GALLERY_SETS["Sizes-WNP-DARK"] = [
  {
    "heading": "<h3>Dark Wood Size Options</h3>",
    "subheading": "",
    "heading_justify": "center",
    "img_ratio": "1:1",
    "row_height": 0,
    "row_height_mobile": 0,
    "row_height_desktop": 0,
    "fit_row": true,
    "row_display_type": "scale_to_fit",
    "margin_top": 0,
    "margin_bottom": 0,
    "swatch_row": true,
    "row_justify": "center",
    "custom_html": "",
    "custom_template_id": "",
    "custom_width_desktop_percent": 100,
    "custom_width_mobile_percent": 100,
    "custom_max_width_px": 0,
    "preset_button": false,
    "preset_button_text": "<h3>Dark Wood Size Options</h3>",
    "preset_modal_title": "",
    "preset_hide_modal_header": false,
    "preset_button_set": "",
    "preset_button_style": "dropdown_box",
    "preset_button_subtext": "",
    "preset_button_image": "",
    "preset_button_image_alt": "",
    "preset_button_width_percent": 0,
    "preset_button_max_width_px": 0,
    "collapsed": false,
    "show_more_text": "Show more",
    "show_less_text": "Show less",
    "row_toggle_border_style": "solid",
    "hide_cta_buttons": false,
    "end_behavior_override": "",
    "videos": [
      {
        "type": "product",
        "swatch_mode": true,
        "title": "8 oz (Bottle)",
        "alt": "8 oz (Bottle)",
        "thumbnail": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNP08-DARK-3D.png?v=1774652644&width=2000",
        "thumb_mode": "default",
        "product_image_number": 0,
        "product_image_id": 29355628101766,
        "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNP08-DARK-3D.png?v=1774652644&width=2000",
        "product_url": "/products/wnp_dark_s",
        "product_id": 7572906639494,
        "show_price": false,
        "show_reviews": false,
        "show_shop_button": false,
        "buttons_over_image": false,
        "price": "$24.99",
        "price_num": 24.99,
        "available": true,
        "scale": 85,
        "product_image_scale": 85,
        "vjust": "center",
        "html_desc": "",
        "desc_html": "",
        "margin_top": 0,
        "margin_bottom": 0,
        "open_set_key": "",
        "learn_more_text": "",
        "cta": {
          "href": "/products/wnp_dark_s",
          "text": "Shop"
        }
      },
      {
        "type": "product",
        "swatch_mode": true,
        "title": "16 oz (Pint)",
        "alt": "16 oz (Pint)",
        "thumbnail": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNP16-DARK-3D.png?v=1774631414&width=2000",
        "thumb_mode": "default",
        "product_image_number": 0,
        "product_image_id": 29354424729734,
        "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNP16-DARK-3D.png?v=1774631414&width=2000",
        "product_url": "/products/wnp_dark_m",
        "product_id": 7572906672262,
        "show_price": false,
        "show_reviews": false,
        "show_shop_button": false,
        "buttons_over_image": false,
        "price": "$34.99",
        "price_num": 34.99,
        "available": true,
        "scale": 55,
        "product_image_scale": 55,
        "vjust": "center",
        "html_desc": "",
        "desc_html": "",
        "margin_top": 0,
        "margin_bottom": 0,
        "open_set_key": "",
        "learn_more_text": "",
        "cta": {
          "href": "/products/wnp_dark_m",
          "text": "Shop"
        }
      },
      {
        "type": "product",
        "swatch_mode": true,
        "title": "32 oz (Quart)",
        "alt": "32 oz (Quart)",
        "thumbnail": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNP32-DARK-3D.png?v=1774651833&width=2000",
        "thumb_mode": "default",
        "product_image_number": 0,
        "product_image_id": 29354368499846,
        "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNP32-DARK-3D.png?v=1774651833&width=2000",
        "product_url": "/products/wnp_dark_l",
        "product_id": 7572906705030,
        "show_price": false,
        "show_reviews": false,
        "show_shop_button": false,
        "buttons_over_image": false,
        "price": "$59.99",
        "price_num": 59.99,
        "available": true,
        "scale": 100,
        "product_image_scale": 100,
        "vjust": "center",
        "html_desc": "",
        "desc_html": "",
        "margin_top": 0,
        "margin_bottom": 0,
        "open_set_key": "",
        "learn_more_text": "",
        "cta": {
          "href": "/products/wnp_dark_l",
          "text": "Shop"
        }
      },
      {
        "type": "product",
        "swatch_mode": true,
        "title": "128 oz (Gallon)",
        "alt": "128 oz (Gallon)",
        "thumbnail": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNP128-DARK-1_b4c7fc37-9cb7-4f3e-8999-5419feebf023.png?v=1774623890&width=2000",
        "thumb_mode": "default",
        "product_image_number": 9,
        "product_image_id": 29353827467398,
        "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNP128-DARK-1_b4c7fc37-9cb7-4f3e-8999-5419feebf023.png?v=1774623890&width=2000",
        "product_url": "/products/wnp_dark_xl",
        "product_id": 7572906770566,
        "show_price": false,
        "show_reviews": false,
        "show_shop_button": false,
        "buttons_over_image": false,
        "price": "$229.99",
        "price_num": 229.99,
        "available": true,
        "scale": 100,
        "product_image_scale": 100,
        "vjust": "center",
        "html_desc": "",
        "desc_html": "",
        "margin_top": 0,
        "margin_bottom": 0,
        "open_set_key": "",
        "learn_more_text": "",
        "cta": {
          "href": "/products/wnp_dark_xl",
          "text": "Shop"
        }
      }
    ]
  },
  {
    "heading": "<h3>Estimated Coverage by Size</h3>",
    "subheading": "",
    "heading_justify": "center",
    "img_ratio": "1:1",
    "row_height": 0,
    "row_height_mobile": 0,
    "row_height_desktop": 0,
    "fit_row": false,
    "row_display_type": "scrollable",
    "margin_top": 0,
    "margin_bottom": 0,
    "swatch_row": false,
    "row_justify": "center",
    "custom_html": "<div style=\"display: flex; justify-content: center;\">\n  <ul style=\"list-style-position: inside; text-align: left;\">\n    <li>8 oz – 25 square feet</li>\n    <li>16 oz – 50 square feet</li>\n    <li>32 oz – 100 square feet</li>\n    <li>Gallon – 400 square feet</li>\n  </ul>\n</div>\n<br>",
    "custom_template_id": "mgps-custom-template--18474791043206__mg_product_swatches_mMUtU9-0",
    "custom_width_desktop_percent": 100,
    "custom_width_mobile_percent": 100,
    "custom_max_width_px": 0,
    "preset_button": false,
    "preset_button_text": "<h3>Estimated Coverage by Size</h3>",
    "preset_modal_title": "",
    "preset_hide_modal_header": false,
    "preset_button_set": "",
    "preset_button_style": "dropdown_box",
    "preset_button_subtext": "",
    "preset_button_image": "",
    "preset_button_image_alt": "",
    "preset_button_width_percent": 0,
    "preset_button_max_width_px": 0,
    "collapsed": false,
    "show_more_text": "Show more",
    "show_less_text": "Show less",
    "row_toggle_border_style": "solid",
    "hide_cta_buttons": false,
    "end_behavior_override": "",
    "videos": []
  },
  {
    "heading": "<h3>More Help on Sizing</h3>",
    "subheading": "",
    "heading_justify": "center",
    "img_ratio": "1:1",
    "row_height": 0,
    "row_height_mobile": 0,
    "row_height_desktop": 0,
    "fit_row": false,
    "row_display_type": "scrollable",
    "margin_top": 0,
    "margin_bottom": 0,
    "swatch_row": false,
    "row_justify": "center",
    "custom_html": "",
    "custom_template_id": "",
    "custom_width_desktop_percent": 100,
    "custom_width_mobile_percent": 100,
    "custom_max_width_px": 0,
    "preset_button": true,
    "preset_button_text": "<h3>More Help on Sizing</h3>",
    "preset_modal_title": "",
    "preset_hide_modal_header": false,
    "preset_button_set": "Help-WNP-Sizes",
    "preset_button_style": "dropdown_box",
    "preset_button_subtext": "",
    "preset_button_image": "",
    "preset_button_image_alt": "",
    "preset_button_width_percent": 100,
    "preset_button_max_width_px": 0,
    "collapsed": false,
    "show_more_text": "Show more",
    "show_less_text": "Show less",
    "row_toggle_border_style": "solid",
    "hide_cta_buttons": false,
    "end_behavior_override": "",
    "videos": []
  }
];

window.MEDIA_GALLERY_SETS["Colors-WNP08"] = [
  {
    "heading": "<h3>Color Options</h3>",
    "subheading": "",
    "heading_justify": "center",
    "img_ratio": "1:1",
    "row_height": 0,
    "row_height_mobile": 0,
    "row_height_desktop": 0,
    "fit_row": true,
    "row_display_type_mobile": "scale_to_fit",
    "row_display_type_desktop": "scale_to_fit",
    "row_display_type": "scale_to_fit",
    "more_popup_text": "More",
    "margin_top": 0,
    "margin_bottom": 0,
    "swatch_row": true,
    "row_justify": "left",
    "custom_html": "",
    "custom_template_id": "",
    "custom_width_desktop_percent": 100,
    "custom_width_mobile_percent": 100,
    "custom_max_width_px": 0,
    "preset_button": false,
    "preset_button_text": "<h3>Color Options</h3>",
    "preset_modal_title": "",
    "preset_hide_modal_header": false,
    "preset_button_set": "",
    "preset_button_style": "dropdown_box",
    "preset_button_subtext": "",
    "preset_button_image": "",
    "preset_button_image_alt": "",
    "preset_button_width_percent": 0,
    "preset_button_max_width_px": 0,
    "collapsed": false,
    "show_more_text": "Show more",
    "show_less_text": "Show less",
    "row_toggle_border_style": "solid",
    "hide_cta_buttons": false,
    "end_behavior_override": "",
    "videos": [
      {
        "type": "product",
        "swatch_mode": true,
        "title": "Light Wood",
        "alt": "Light Wood",
        "thumbnail": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNP08-LITE-Swatch.png?v=1774696052&width=2000",
        "thumb_mode": "default",
        "product_image_id": 29357683409030,
        "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNP08-LITE-Swatch.png?v=1774696052&width=2000",
        "product_url": "/products/wnp_lite_s",
        "product_id": 7573368045702,
        "show_price": false,
        "show_reviews": false,
        "show_shop_button": false,
        "buttons_over_image": false,
        "price": "$24.99",
        "price_num": 24.99,
        "available": true,
        "scale": 100,
        "product_image_scale": 100,
        "vjust": "center",
        "html_desc": "",
        "desc_html": "",
        "margin_top": 0,
        "margin_bottom": 0,
        "open_set_key": "",
        "learn_more_text": "",
        "cta": {
          "href": "/products/wnp_lite_s",
          "text": "Shop"
        }
      },
      {
        "type": "product",
        "swatch_mode": true,
        "title": "Dark Wood",
        "alt": "Dark Wood",
        "thumbnail": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNP08-DARK-Swatch.png?v=1774696814&width=2000",
        "thumb_mode": "default",
        "product_image_id": 29355628200070,
        "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNP08-DARK-Swatch.png?v=1774696814&width=2000",
        "product_url": "/products/wnp_dark_s",
        "product_id": 7572906639494,
        "show_price": false,
        "show_reviews": false,
        "show_shop_button": false,
        "buttons_over_image": false,
        "price": "$24.99",
        "price_num": 24.99,
        "available": true,
        "scale": 100,
        "product_image_scale": 100,
        "vjust": "center",
        "html_desc": "",
        "desc_html": "",
        "margin_top": 0,
        "margin_bottom": 0,
        "open_set_key": "",
        "learn_more_text": "",
        "cta": {
          "href": "/products/wnp_dark_s",
          "text": "Shop"
        }
      },
      {
        "type": "product",
        "swatch_mode": true,
        "title": "Bleached Wood",
        "alt": "Bleached Wood",
        "thumbnail": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNP08-BLCH-Swatch.png?v=1774696620&width=2000",
        "thumb_mode": "default",
        "product_image_id": 29354614358150,
        "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNP08-BLCH-Swatch.png?v=1774696620&width=2000",
        "product_url": "/products/wnp_blch_s",
        "product_id": 7572896022662,
        "show_price": false,
        "show_reviews": false,
        "show_shop_button": false,
        "buttons_over_image": false,
        "price": "$24.99",
        "price_num": 24.99,
        "available": true,
        "scale": 100,
        "product_image_scale": 100,
        "vjust": "center",
        "html_desc": "",
        "desc_html": "",
        "margin_top": 0,
        "margin_bottom": 0,
        "open_set_key": "",
        "learn_more_text": "",
        "cta": {
          "href": "/products/wnp_blch_s",
          "text": "Shop"
        }
      }
    ]
  }
];

window.MEDIA_GALLERY_SETS["Colors-WNP16"] = [
  {
    "heading": "<h3>Color Options</h3>",
    "subheading": "",
    "heading_justify": "center",
    "img_ratio": "1:1",
    "row_height": 0,
    "row_height_mobile": 0,
    "row_height_desktop": 0,
    "fit_row": true,
    "row_display_type": "scale_to_fit",
    "margin_top": 0,
    "margin_bottom": 0,
    "swatch_row": true,
    "row_justify": "left",
    "custom_html": "",
    "custom_template_id": "",
    "custom_width_desktop_percent": 100,
    "custom_width_mobile_percent": 100,
    "custom_max_width_px": 0,
    "preset_button": false,
    "preset_button_text": "<h3>Color Options</h3>",
    "preset_button_set": "",
    "preset_button_style": "dropdown_box",
    "preset_button_subtext": "",
    "preset_button_image": "",
    "preset_button_image_alt": "",
    "preset_button_width_percent": 0,
    "preset_button_max_width_px": 0,
    "collapsed": false,
    "show_more_text": "Show more",
    "show_less_text": "Show less",
    "row_toggle_border_style": "solid",
    "hide_cta_buttons": false,
    "end_behavior_override": "",
    "videos": [
      {
        "type": "product",
        "swatch_mode": true,
        "title": "Light Wood",
        "alt": "Light Wood",
        "thumbnail": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNP16-LITE-Swatch.png?v=1774696133&width=2000",
        "thumb_mode": "default",
        "product_image_number": 2,
        "product_image_id": 29357685899398,
        "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNP16-LITE-Swatch.png?v=1774696133&width=2000",
        "product_url": "/products/wnp_lite_m",
        "product_id": 7573368078470,
        "show_price": false,
        "show_reviews": false,
        "show_shop_button": false,
        "buttons_over_image": false,
        "price": "$34.99",
        "price_num": 34.99,
        "available": true,
        "scale": 100,
        "product_image_scale": 100,
        "vjust": "center",
        "html_desc": "",
        "desc_html": "",
        "margin_top": 0,
        "margin_bottom": 0,
        "open_set_key": "",
        "learn_more_text": "",
        "cta": {
          "href": "/products/wnp_lite_m",
          "text": "Shop"
        }
      },
      {
        "type": "product",
        "swatch_mode": true,
        "title": "Dark Wood",
        "alt": "Dark Wood",
        "thumbnail": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK16-DARK-SWATCH_0ab62acd-b630-4ddf-a502-c9a8da46d945.png?v=1774696812&width=2000",
        "thumb_mode": "default",
        "product_image_number": 2,
        "product_image_id": 29354425942150,
        "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK16-DARK-SWATCH_0ab62acd-b630-4ddf-a502-c9a8da46d945.png?v=1774696812&width=2000",
        "product_url": "/products/wnp_dark_m",
        "product_id": 7572906672262,
        "show_price": false,
        "show_reviews": false,
        "show_shop_button": false,
        "buttons_over_image": false,
        "price": "$34.99",
        "price_num": 34.99,
        "available": true,
        "scale": 100,
        "product_image_scale": 100,
        "vjust": "center",
        "html_desc": "",
        "desc_html": "",
        "margin_top": 0,
        "margin_bottom": 0,
        "open_set_key": "",
        "learn_more_text": "",
        "cta": {
          "href": "/products/wnp_dark_m",
          "text": "Shop"
        }
      },
      {
        "type": "product",
        "swatch_mode": true,
        "title": "Bleached Wood",
        "alt": "Bleached Wood",
        "thumbnail": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNP16-BLCH-image5.png?v=1774696618&width=2000",
        "thumb_mode": "default",
        "product_image_number": 2,
        "product_image_id": 29353356066950,
        "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNP16-BLCH-image5.png?v=1774696618&width=2000",
        "product_url": "/products/wnp_blch_m",
        "product_id": 7572896055430,
        "show_price": false,
        "show_reviews": false,
        "show_shop_button": false,
        "buttons_over_image": false,
        "price": "$34.99",
        "price_num": 34.99,
        "available": true,
        "scale": 100,
        "product_image_scale": 100,
        "vjust": "center",
        "html_desc": "",
        "desc_html": "",
        "margin_top": 0,
        "margin_bottom": 0,
        "open_set_key": "",
        "learn_more_text": "",
        "cta": {
          "href": "/products/wnp_blch_m",
          "text": "Shop"
        }
      }
    ]
  }
];

window.MEDIA_GALLERY_SETS["Colors-WNP32"] = [
  {
    "heading": "<h3>Color Options</h3>",
    "subheading": "",
    "heading_justify": "center",
    "img_ratio": "1:1",
    "row_height": 0,
    "row_height_mobile": 0,
    "row_height_desktop": 0,
    "fit_row": true,
    "row_display_type_mobile": "scale_to_fit",
    "row_display_type_desktop": "scale_to_fit",
    "row_display_type": "scale_to_fit",
    "more_popup_text": "More",
    "margin_top": 0,
    "margin_bottom": 0,
    "swatch_row": true,
    "row_justify": "left",
    "custom_html": "",
    "custom_template_id": "",
    "custom_width_desktop_percent": 100,
    "custom_width_mobile_percent": 100,
    "custom_max_width_px": 0,
    "preset_button": false,
    "preset_button_text": "<h3>Color Options</h3>",
    "preset_modal_title": "",
    "preset_hide_modal_header": false,
    "preset_button_set": "",
    "preset_button_style": "dropdown_box",
    "preset_button_subtext": "",
    "preset_button_image": "",
    "preset_button_image_alt": "",
    "preset_button_width_percent": 0,
    "preset_button_max_width_px": 0,
    "collapsed": false,
    "show_more_text": "Show more",
    "show_less_text": "Show less",
    "row_toggle_border_style": "solid",
    "hide_cta_buttons": false,
    "end_behavior_override": "",
    "videos": [
      {
        "type": "product",
        "swatch_mode": true,
        "title": "Light Wood",
        "alt": "Light Wood",
        "thumbnail": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNP32-LITE-Swatch.png?v=1775298061&width=2000",
        "thumb_mode": "default",
        "product_image_id": 29404270821510,
        "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNP32-LITE-Swatch.png?v=1775298061&width=2000",
        "product_url": "/products/wnp_lite_l",
        "product_id": 7573368144006,
        "show_price": false,
        "show_reviews": false,
        "show_shop_button": false,
        "buttons_over_image": false,
        "price": "$59.99",
        "price_num": 59.99,
        "available": true,
        "scale": 100,
        "product_image_scale": 100,
        "vjust": "center",
        "html_desc": "",
        "desc_html": "",
        "margin_top": 0,
        "margin_bottom": 0,
        "open_set_key": "",
        "learn_more_text": "",
        "cta": {
          "href": "/products/wnp_lite_l",
          "text": "Shop"
        }
      },
      {
        "type": "product",
        "swatch_mode": true,
        "title": "Dark Wood",
        "alt": "Dark Wood",
        "thumbnail": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNP32-DARK-SWATCH.png?v=1774696817&width=2000",
        "thumb_mode": "default",
        "product_image_id": 29354368696454,
        "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNP32-DARK-SWATCH.png?v=1774696817&width=2000",
        "product_url": "/products/wnp_dark_l",
        "product_id": 7572906705030,
        "show_price": false,
        "show_reviews": false,
        "show_shop_button": false,
        "buttons_over_image": false,
        "price": "$59.99",
        "price_num": 59.99,
        "available": true,
        "scale": 100,
        "product_image_scale": 100,
        "vjust": "center",
        "html_desc": "",
        "desc_html": "",
        "margin_top": 0,
        "margin_bottom": 0,
        "open_set_key": "",
        "learn_more_text": "",
        "cta": {
          "href": "/products/wnp_dark_l",
          "text": "Shop"
        }
      },
      {
        "type": "product",
        "swatch_mode": true,
        "title": "Bleached Wood",
        "alt": "Bleached Wood",
        "thumbnail": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/L-WNP-BLCH-new-8.png?v=1774696616&width=2000",
        "thumb_mode": "default",
        "product_image_id": 29353367994502,
        "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/L-WNP-BLCH-new-8.png?v=1774696616&width=2000",
        "product_url": "/products/wnp_blch_l",
        "product_id": 7572896088198,
        "show_price": false,
        "show_reviews": false,
        "show_shop_button": false,
        "buttons_over_image": false,
        "price": "$59.99",
        "price_num": 59.99,
        "available": true,
        "scale": 100,
        "product_image_scale": 100,
        "vjust": "center",
        "html_desc": "",
        "desc_html": "",
        "margin_top": 0,
        "margin_bottom": 0,
        "open_set_key": "",
        "learn_more_text": "",
        "cta": {
          "href": "/products/wnp_blch_l",
          "text": "Shop"
        }
      }
    ]
  }
];

window.MEDIA_GALLERY_SETS["Colors-WNP128"] = [
  {
    "heading": "<h3>Color Options</h3>",
    "subheading": "",
    "heading_justify": "center",
    "img_ratio": "1:1",
    "row_height": 0,
    "row_height_mobile": 0,
    "row_height_desktop": 0,
    "fit_row": true,
    "row_display_type": "scale_to_fit",
    "margin_top": 0,
    "margin_bottom": 0,
    "swatch_row": true,
    "row_justify": "left",
    "custom_html": "",
    "custom_template_id": "",
    "custom_width_desktop_percent": 100,
    "custom_width_mobile_percent": 100,
    "custom_max_width_px": 0,
    "preset_button": false,
    "preset_button_text": "<h3>Color Options</h3>",
    "preset_button_set": "",
    "preset_button_style": "dropdown_box",
    "preset_button_subtext": "",
    "preset_button_image": "",
    "preset_button_image_alt": "",
    "preset_button_width_percent": 0,
    "preset_button_max_width_px": 0,
    "collapsed": false,
    "show_more_text": "Show more",
    "show_less_text": "Show less",
    "row_toggle_border_style": "solid",
    "hide_cta_buttons": false,
    "end_behavior_override": "",
    "videos": [
      {
        "type": "product",
        "swatch_mode": true,
        "title": "Light Wood",
        "alt": "Light Wood",
        "thumbnail": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNP128-Swatch.png?v=1774700579&width=2000",
        "thumb_mode": "default",
        "product_image_number": 2,
        "product_image_id": 29357687472262,
        "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNP128-Swatch.png?v=1774700579&width=2000",
        "product_url": "/products/wnp_lite_xl",
        "product_id": 7573368176774,
        "show_price": false,
        "show_reviews": false,
        "show_shop_button": false,
        "buttons_over_image": false,
        "price": "$229.99",
        "price_num": 229.99,
        "available": true,
        "scale": 100,
        "product_image_scale": 100,
        "vjust": "center",
        "html_desc": "",
        "desc_html": "",
        "margin_top": 0,
        "margin_bottom": 0,
        "open_set_key": "",
        "learn_more_text": "",
        "cta": {
          "href": "/products/wnp_lite_xl",
          "text": "Shop"
        }
      },
      {
        "type": "product",
        "swatch_mode": true,
        "title": "Dark Wood",
        "alt": "Dark Wood",
        "thumbnail": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNP128-DARK-SWATCH.png?v=1774696822&width=2000",
        "thumb_mode": "default",
        "product_image_number": 2,
        "product_image_id": 29353827598470,
        "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNP128-DARK-SWATCH.png?v=1774696822&width=2000",
        "product_url": "/products/wnp_dark_xl",
        "product_id": 7572906770566,
        "show_price": false,
        "show_reviews": false,
        "show_shop_button": false,
        "buttons_over_image": false,
        "price": "$229.99",
        "price_num": 229.99,
        "available": true,
        "scale": 100,
        "product_image_scale": 100,
        "vjust": "center",
        "html_desc": "",
        "desc_html": "",
        "margin_top": 0,
        "margin_bottom": 0,
        "open_set_key": "",
        "learn_more_text": "",
        "cta": {
          "href": "/products/wnp_dark_xl",
          "text": "Shop"
        }
      },
      {
        "type": "product",
        "swatch_mode": true,
        "title": "Bleached Wood",
        "alt": "Bleached Wood",
        "thumbnail": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNP128-BLCH-8.png?v=1774696614&width=2000",
        "thumb_mode": "default",
        "product_image_number": 2,
        "product_image_id": 29353425469574,
        "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNP128-BLCH-8.png?v=1774696614&width=2000",
        "product_url": "/products/wnp_blch_xl",
        "product_id": 7572896120966,
        "show_price": false,
        "show_reviews": false,
        "show_shop_button": false,
        "buttons_over_image": false,
        "price": "$229.99",
        "price_num": 229.99,
        "available": false,
        "scale": 100,
        "product_image_scale": 100,
        "vjust": "center",
        "html_desc": "",
        "desc_html": "",
        "margin_top": 0,
        "margin_bottom": 0,
        "open_set_key": "",
        "learn_more_text": "",
        "cta": {
          "href": "/products/wnp_blch_xl",
          "text": "Shop"
        }
      }
    ]
  }
];
window.MEDIA_GALLERY_SETS["SpringGuide"] = [
  {
    "heading": "",
    "subheading": "",
    "heading_justify": "center",
    "custom_template_id": "mg-custom-template--18627902537862__cmg_media_gallery_TGbVKF-0",
    "custom_html": "<a href=\"https://online.flippingbook.com/view/1051152244/\" class=\"fbo-embed\" data-fbo-id=\"859fa07bca\" data-fbo-ratio=\"3:2\" data-fbo-lightbox=\"yes\" data-fbo-width=\"100%\" data-fbo-height=\"auto\" data-fbo-version=\"1\" data-fbo-transparent style=\"max-width: 100%\">Retique It Spring Style Guide 2026</a><script async defer src=\"https://online.flippingbook.com/EmbedScriptUrl.aspx?m=redir&hid=1051152244\"></script>",
    "custom_width_desktop_percent": 100,
    "custom_width_mobile_percent": 100,
    "custom_max_width_px": "0",
    "img_ratio": "1:1",
    "row_height": 0,
    "fit_row": false,
    "margin_top": 0,
    "margin_bottom": 0,
    "collapsed": false,
    "show_more_text": "Show more",
    "show_less_text": "Show less",
    "row_toggle_border_style": "solid",
    "accordion": false,
    "accordion_marker": false,
    "accordion_title": "",
    "accordion_subheading": "",
    "accordion_hide_title_when_open": false,
    "accordion_hide_subheading_when_open": false,
    "accordion_title_center": false,
    "accordion_start_open": false,
    "accordion_allow_multiple": false,
    "accordion_bg_color": "#ffffff",
    "accordion_shadow_pct": 8,
    "accordion_shadow_style": "raised",
    "accordion_width_mobile_percent": 100,
    "accordion_width_desktop_percent": 100,
    "accordion_max_width_px": 0,
    "accordion_group": "",
    "accordion_always_open": false,
    "videos": []
  }
];

window.MEDIA_GALLERY_SETS["ShopLiquidWoodKits"] = [
  {
    "heading": "<h1>Real Wood Finishes</h1>",
    "subheading": "",
    "heading_justify": "center",
    "custom_template_id": "mg-custom-template--18541425229958__c_media_gallery_NVwHjH-0",
    "custom_html": "",
    "custom_width_desktop_percent": 100,
    "custom_width_mobile_percent": 100,
    "custom_max_width_px": "0",
    "img_ratio": "1:1",
    "row_height": 0,
    "fit_row": false,
    "margin_top": 0,
    "margin_bottom": 0,
    "collapsed": false,
    "show_more_text": "Show more",
    "show_less_text": "Show less",
    "row_toggle_border_style": "solid",
    "accordion": false,
    "accordion_marker": false,
    "accordion_title": "",
    "accordion_subheading": "",
    "accordion_hide_title_when_open": false,
    "accordion_hide_subheading_when_open": false,
    "accordion_title_center": true,
    "accordion_start_open": false,
    "accordion_allow_multiple": true,
    "accordion_bg_color": "#ffffff",
    "accordion_shadow_pct": 8,
    "accordion_shadow_style": "raised",
    "accordion_width_mobile_percent": 100,
    "accordion_width_desktop_percent": 100,
    "accordion_max_width_px": 0,
    "accordion_group": "",
    "accordion_always_open": false,
    "videos": []
  },
  {
    "heading": "",
    "subheading": "",
    "img_ratio": "1:1",
    "row_height": 0,
    "fit_row": false,
    "collapsed": false,
    "show_more_text": "Show more",
    "show_less_text": "Show less",
    "row_toggle_border_style": "solid",
    "accordion": true,
    "accordion_marker": true,
    "accordion_title": "<h2>Multi-purpose Kits</h2>",
    "accordion_subheading": "<p>Interior / Exterior</p>",
    "accordion_hide_title_when_open": false,
    "accordion_hide_subheading_when_open": false,
    "accordion_title_center": true,
    "accordion_start_open": true,
    "accordion_allow_multiple": true,
    "accordion_bg_color": "#ffffff",
    "accordion_shadow_pct": 8,
    "accordion_shadow_style": "raised",
    "accordion_width_mobile_percent": 100,
    "accordion_width_desktop_percent": 100,
    "accordion_max_width_px": 0,
    "accordion_group": "accordion_Q7mXYt",
    "accordion_always_open": true,
    "videos": []
  },
  {
    "heading": "",
    "subheading": "<h6>Interior / Exterior</h6>",
    "img_ratio": "4:5",
    "row_height": 0,
    "fit_row": true,
    "margin_top": 0,
    "margin_bottom": 0,
    "collapsed": false,
    "show_more_text": "Show more",
    "show_less_text": "Show less",
    "row_toggle_border_style": "solid",
    "swatch_row": false,
    "row_justify": "center",
    "heading_justify": "center",
    "accordion": false,
    "accordion_title": "<h2>Multi-purpose Kits</h2>",
    "accordion_subheading": "<p>Interior / Exterior</p>",
    "accordion_hide_title_when_open": false,
    "accordion_hide_subheading_when_open": false,
    "accordion_title_center": true,
    "accordion_start_open": true,
    "accordion_allow_multiple": true,
    "accordion_bg_color": "#ffffff",
    "accordion_shadow_pct": 8,
    "accordion_shadow_style": "raised",
    "accordion_width_mobile_percent": 100,
    "accordion_width_desktop_percent": 100,
    "accordion_max_width_px": 0,
    "accordion_group": "accordion_Q7mXYt",
    "accordion_always_open": true,
    "videos": [
      {
        "type": "product",
        "title": "Smooth Finishes",
        "alt": "Large Pecan wood finish kit by Retique It® with smooth finish and multiple application tools for versatile wood restoration.",
        "thumbnail": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/PECA-BPK32-Box-Hero.png?v=1774645225&width=720",
        "thumb_mode": "default",
        "product_image_number": 17,
        "product_url": "/products/smoothfinish_pecan_l",
        "product_id": 6877953818758,
        "lai_review_count_info": {
          "rate1": 15,
          "rate2": 5,
          "rate3": 8,
          "rate4": 8,
          "rate5": 266,
          "total": 302,
          "average": 4.7,
          "product_shopify_id": "6877953818758",
          "product_group_id": 835
        },
        "show_price": false,
        "show_reviews": true,
        "shop_button_cta_type": "title_top_button_bottom",
        "shop_button_style": "theme_default",
        "price": "$99.99",
        "price_num": 99.99,
        "available": true,
        "scale": 100,
        "vjust": "top",
        "html_desc": "",
        "desc_html": "",
        "margin_top": 0,
        "margin_bottom": 0,
        "open_set_key": "",
        "learn_more_text": "Learn More",
        "cta": {
          "href": null,
          "text": "Shop"
        }
      },
      {
        "type": "video",
        "title": "What's the Difference?",
        "alt": "What's the Difference?",
        "url": "https://vimeo.com/876765262?fl=pl&fe=sh",
        "start_time": "",
        "thumbnail": "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/77c46d3d-8adc-4233-aa92-6a1e9e722949.gif?ClientID=sulu&Date=1776851714&Signature=98e57b2015f2b8568abddfc8cb9816d3dfac9181",
        "scale": 100,
        "title_wrap": true,
        "ratio_override": "4:5",
        "vjust": "top",
        "html_desc": "",
        "desc_html": null,
        "end_behavior": "loop",
        "cta": {
          "href": null,
          "text": "Shop Now",
          "thumb_text": ""
        }
      },
      {
        "type": "product",
        "title": "Grained Finishes",
        "alt": "Large Retique It® Wood'n Kit in Pickled Oak finish, featuring brushes, applicators, and wood stain for multi-purpose woodworkin",
        "thumbnail": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK64-POAK-Box-Hero.png?v=1776956861&width=720",
        "thumb_mode": "default",
        "product_image_number": 17,
        "product_url": "/products/woodnfinish_pickled-oak_l",
        "product_id": 6829915701382,
        "lai_review_count_info": {
          "rate1": 3,
          "rate2": 5,
          "rate3": 12,
          "rate4": 14,
          "rate5": 485,
          "total": 519,
          "average": 4.9,
          "product_shopify_id": "6829915701382",
          "product_group_id": 558
        },
        "show_price": false,
        "show_reviews": true,
        "shop_button_cta_type": "title_top_button_bottom",
        "shop_button_style": "theme_default",
        "price": "$169.99",
        "price_num": 169.99,
        "available": true,
        "scale": 100,
        "vjust": "top",
        "html_desc": "",
        "desc_html": "",
        "margin_top": 0,
        "margin_bottom": 0,
        "open_set_key": "",
        "learn_more_text": "Learn More",
        "cta": {
          "href": null,
          "text": "Shop"
        }
      }
    ]
  },
  {
    "heading": "",
    "subheading": "",
    "img_ratio": "1:1",
    "row_height": 0,
    "fit_row": false,
    "collapsed": false,
    "show_more_text": "Show more",
    "show_less_text": "Show less",
    "row_toggle_border_style": "solid",
    "accordion": true,
    "accordion_marker": true,
    "accordion_title": "<h2>Interior Projects</h2>",
    "accordion_subheading": "",
    "accordion_hide_title_when_open": false,
    "accordion_hide_subheading_when_open": false,
    "accordion_title_center": true,
    "accordion_start_open": true,
    "accordion_allow_multiple": true,
    "accordion_bg_color": "#ffffff",
    "accordion_shadow_pct": 8,
    "accordion_shadow_style": "raised",
    "accordion_width_mobile_percent": 100,
    "accordion_width_desktop_percent": 100,
    "accordion_max_width_px": 0,
    "accordion_group": "accordion_3xT78V",
    "accordion_always_open": true,
    "videos": []
  },
  {
    "heading": "",
    "subheading": "",
    "img_ratio": "1:1",
    "row_height": 0,
    "fit_row": true,
    "margin_top": 0,
    "margin_bottom": 0,
    "collapsed": false,
    "show_more_text": "Show more",
    "show_less_text": "Show less",
    "row_toggle_border_style": "solid",
    "swatch_row": false,
    "row_justify": "center",
    "heading_justify": "center",
    "accordion": false,
    "accordion_title": "<h2>Interior Projects</h2>",
    "accordion_subheading": "",
    "accordion_hide_title_when_open": false,
    "accordion_hide_subheading_when_open": false,
    "accordion_title_center": true,
    "accordion_start_open": true,
    "accordion_allow_multiple": true,
    "accordion_bg_color": "#ffffff",
    "accordion_shadow_pct": 8,
    "accordion_shadow_style": "raised",
    "accordion_width_mobile_percent": 100,
    "accordion_width_desktop_percent": 100,
    "accordion_max_width_px": 0,
    "accordion_group": "accordion_3xT78V",
    "accordion_always_open": true,
    "videos": [
      {
        "type": "product",
        "title": "Countertops",
        "alt": "Modern walnut countertop kit from Retique It® featuring stain application for full kitchen renovation, shown on a countertop su",
        "thumbnail": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK32-BARN-Hero-Countertop_74f4ae7b-742f-4898-98ee-1305b70b6f9e.png?v=1774448659&width=720",
        "thumb_mode": "default",
        "product_image_number": 12,
        "product_url": "/products/countertopkit_barn-wood_l_tripletique",
        "product_id": 6832718348422,
        "lai_review_count_info": {
          "rate1": 0,
          "rate2": 0,
          "rate3": 3,
          "rate4": 16,
          "rate5": 198,
          "total": 217,
          "average": 4.9,
          "product_shopify_id": "6832718348422",
          "product_group_id": 320
        },
        "show_price": false,
        "show_reviews": true,
        "shop_button_cta_type": "title_top_button_bottom",
        "shop_button_style": "theme_default",
        "price": "$229.99",
        "price_num": 229.99,
        "available": true,
        "scale": 100,
        "vjust": "top",
        "html_desc": "",
        "desc_html": "",
        "margin_top": 0,
        "margin_bottom": 0,
        "open_set_key": "",
        "learn_more_text": "Learn More",
        "cta": {
          "href": null,
          "text": "Shop"
        }
      },
      {
        "type": "product",
        "title": "Cabinets",
        "alt": "Retique It® Wood'n Cabinet Kit with 24 grained white oak doors, showcasing stained wood grain for a natural cabinet finish.",
        "thumbnail": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK64-WOAK-Hero-Cabinets_b89fa14c-b35d-482e-b640-76d530966f47.png?v=1778700305&width=720",
        "thumb_mode": "default",
        "product_image_number": 14,
        "product_url": "/products/cabinetkit_white-oak_m",
        "product_id": 6982979551366,
        "lai_review_count_info": {
          "rate1": 1,
          "rate2": 4,
          "rate3": 6,
          "rate4": 4,
          "rate5": 78,
          "total": 93,
          "average": 4.7,
          "product_shopify_id": "6982979551366",
          "product_group_id": 356
        },
        "show_price": false,
        "show_reviews": true,
        "shop_button_cta_type": "title_top_button_bottom",
        "shop_button_style": "theme_default",
        "price": "$299.99",
        "price_num": 299.99,
        "available": true,
        "scale": 100,
        "vjust": "top",
        "html_desc": "",
        "desc_html": "",
        "margin_top": 0,
        "margin_bottom": 0,
        "open_set_key": "",
        "learn_more_text": "Learn More",
        "cta": {
          "href": null,
          "text": "Shop"
        }
      }
    ]
  },
  {
    "heading": "",
    "subheading": "",
    "img_ratio": "1:1",
    "row_height": 0,
    "fit_row": true,
    "margin_top": 0,
    "margin_bottom": 0,
    "collapsed": false,
    "show_more_text": "Show more",
    "show_less_text": "Show less",
    "row_toggle_border_style": "solid",
    "swatch_row": false,
    "row_justify": "center",
    "heading_justify": "center",
    "accordion": false,
    "accordion_title": "<h2>Interior Projects</h2>",
    "accordion_subheading": "",
    "accordion_hide_title_when_open": false,
    "accordion_hide_subheading_when_open": false,
    "accordion_title_center": true,
    "accordion_start_open": true,
    "accordion_allow_multiple": true,
    "accordion_bg_color": "#ffffff",
    "accordion_shadow_pct": 8,
    "accordion_shadow_style": "raised",
    "accordion_width_mobile_percent": 100,
    "accordion_width_desktop_percent": 100,
    "accordion_max_width_px": 0,
    "accordion_group": "accordion_3xT78V",
    "accordion_always_open": true,
    "videos": [
      {
        "type": "product",
        "title": "Tabletops",
        "alt": "Retique It® Wood'n Finish Kit in Dark Oak stain, featuring a wooden box with staining supplies for furniture finishing.",
        "thumbnail": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK08-DOAK-Box-Hero-Tabletop_987cfd79-fc68-4552-9926-95a3f7b9c49d.png?v=1778525851&width=720",
        "thumb_mode": "default",
        "product_image_number": 11,
        "product_url": "/products/tabletopkit_dark-oak_s_tripletique",
        "product_id": 6745763217542,
        "lai_review_count_info": {
          "rate1": 0,
          "rate2": 2,
          "rate3": 5,
          "rate4": 2,
          "rate5": 100,
          "total": 109,
          "average": 4.8,
          "product_shopify_id": "6745763217542",
          "product_group_id": 355
        },
        "show_price": false,
        "show_reviews": true,
        "shop_button_cta_type": "title_top_button_bottom",
        "shop_button_style": "theme_default",
        "price": "$109.99",
        "price_num": 109.99,
        "available": true,
        "scale": 100,
        "vjust": "top",
        "html_desc": "",
        "desc_html": "",
        "margin_top": 0,
        "margin_bottom": 0,
        "open_set_key": "",
        "learn_more_text": "Learn More",
        "cta": {
          "href": null,
          "text": "Shop"
        }
      },
      {
        "type": "product",
        "title": "Fireplaces",
        "alt": "Retique It® Fireplace Wood'n Finish Kit in French Oak stain, full fireplace application, showcasing wood stain and finishing to",
        "thumbnail": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK16-FOAK-Box-Hero-Fireplace_0d7b0b0f-e333-461f-ba95-c2d18330594b.png?v=1777484124&width=720",
        "thumb_mode": "default",
        "product_image_number": 9,
        "product_url": "/products/fireplacekit_french-oak_m",
        "product_id": 6834210799750,
        "lai_review_count_info": {
          "rate1": 0,
          "rate2": 0,
          "rate3": 0,
          "rate4": 0,
          "rate5": 38,
          "total": 38,
          "average": 5,
          "product_shopify_id": "6834210799750",
          "product_group_id": 569
        },
        "show_price": false,
        "show_reviews": true,
        "shop_button_cta_type": "title_top_button_bottom",
        "shop_button_style": "theme_default",
        "price": "$109.99",
        "price_num": 109.99,
        "available": true,
        "scale": 100,
        "vjust": "top",
        "html_desc": "",
        "desc_html": "",
        "margin_top": 0,
        "margin_bottom": 0,
        "open_set_key": "",
        "learn_more_text": "Learn More",
        "cta": {
          "href": null,
          "text": "Shop"
        }
      }
    ]
  },
  {
    "heading": "",
    "subheading": "",
    "img_ratio": "1:1",
    "row_height": 0,
    "fit_row": false,
    "collapsed": false,
    "show_more_text": "Show more",
    "show_less_text": "Show less",
    "row_toggle_border_style": "solid",
    "accordion": true,
    "accordion_marker": true,
    "accordion_title": "<h2>Exterior Projects</h2>",
    "accordion_subheading": "",
    "accordion_hide_title_when_open": false,
    "accordion_hide_subheading_when_open": false,
    "accordion_title_center": true,
    "accordion_start_open": true,
    "accordion_allow_multiple": true,
    "accordion_bg_color": "#ffffff",
    "accordion_shadow_pct": 8,
    "accordion_shadow_style": "raised",
    "accordion_width_mobile_percent": 100,
    "accordion_width_desktop_percent": 100,
    "accordion_max_width_px": 0,
    "accordion_group": "accordion_PJEM6q",
    "accordion_always_open": true,
    "videos": []
  },
  {
    "heading": "",
    "subheading": "",
    "img_ratio": "1:1",
    "row_height": 0,
    "fit_row": true,
    "margin_top": 0,
    "margin_bottom": 0,
    "collapsed": false,
    "show_more_text": "Show more",
    "show_less_text": "Show less",
    "row_toggle_border_style": "solid",
    "swatch_row": false,
    "row_justify": "center",
    "heading_justify": "center",
    "accordion": false,
    "accordion_title": "<h2>Exterior Projects</h2>",
    "accordion_subheading": "",
    "accordion_hide_title_when_open": false,
    "accordion_hide_subheading_when_open": false,
    "accordion_title_center": true,
    "accordion_start_open": true,
    "accordion_allow_multiple": true,
    "accordion_bg_color": "#ffffff",
    "accordion_shadow_pct": 8,
    "accordion_shadow_style": "raised",
    "accordion_width_mobile_percent": 100,
    "accordion_width_desktop_percent": 100,
    "accordion_max_width_px": 0,
    "accordion_group": "accordion_PJEM6q",
    "accordion_always_open": true,
    "videos": [
      {
        "type": "product",
        "title": "Front Doors",
        "alt": "Retique It® Wood'n Finish Front Door Kit in Black Walnut stain, showing a double front door with wood grain details and finish.",
        "thumbnail": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/3DBox-RQ-FDK32_aaadbb9a-4394-4c4b-a3d6-9c21f85e708f.jpg?v=1752291167&width=720",
        "thumb_mode": "default",
        "product_image_number": 10,
        "product_url": "/products/doorkit_black-walnut_m",
        "product_id": 6833301127302,
        "lai_review_count_info": {
          "rate1": 2,
          "rate2": 0,
          "rate3": 1,
          "rate4": 1,
          "rate5": 37,
          "total": 41,
          "average": 4.7,
          "product_shopify_id": "6833301127302",
          "product_group_id": 321
        },
        "show_price": false,
        "show_reviews": true,
        "shop_button_cta_type": "title_top_button_bottom",
        "shop_button_style": "theme_default",
        "price": "$169.99",
        "price_num": 169.99,
        "available": true,
        "scale": 100,
        "vjust": "top",
        "html_desc": "",
        "desc_html": "",
        "margin_top": 0,
        "margin_bottom": 0,
        "open_set_key": "",
        "learn_more_text": "Learn More",
        "cta": {
          "href": null,
          "text": "Shop"
        }
      },
      {
        "type": "product",
        "title": "Garage Doors",
        "alt": "Retique It® Wood'n Door Kit stain set for front and garage barn wood doors, featuring natural wood finish options.",
        "thumbnail": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/3DBox-RQ-GDK64_86e8718b-e0a3-413d-bdd0-28f75036eeaa.jpg?v=1752096427&width=720",
        "thumb_mode": "default",
        "product_image_number": 0,
        "product_url": "/products/doorkit_barn-wood_xl",
        "product_id": 6833300471942,
        "lai_review_count_info": null,
        "show_price": false,
        "show_reviews": true,
        "shop_button_cta_type": "title_top_button_bottom",
        "shop_button_style": "theme_default",
        "price": "$269.99",
        "price_num": 269.99,
        "available": true,
        "scale": 100,
        "vjust": "top",
        "html_desc": "",
        "desc_html": "",
        "margin_top": 0,
        "margin_bottom": 0,
        "open_set_key": "",
        "learn_more_text": "Learn More",
        "cta": {
          "href": null,
          "text": "Shop"
        }
      },
      {
        "type": "product",
        "title": "Decks",
        "alt": "Retique It® Decking Wood'n Kit in Drift Wood stain showing a natural wood deck with rich, weathered driftwood finish.",
        "thumbnail": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK128-DRIW-Hero-Decking.png?v=1778696367&width=720",
        "thumb_mode": "default",
        "product_image_number": 7,
        "product_url": "/products/decking-woodnfinish-kit_drift-wood_polytiqueit",
        "product_id": 6827240980614,
        "lai_review_count_info": null,
        "show_price": false,
        "show_reviews": false,
        "shop_button_cta_type": "title_top_button_bottom",
        "shop_button_style": "theme_default",
        "price": "$749.99",
        "price_num": 749.99,
        "available": true,
        "scale": 100,
        "vjust": "center",
        "html_desc": "",
        "desc_html": "",
        "margin_top": 0,
        "margin_bottom": 0,
        "open_set_key": "",
        "learn_more_text": "Learn More",
        "cta": {
          "href": null,
          "text": "Shop"
        }
      }
    ]
  }
];
window.MEDIA_GALLERY_SETS["ShopLiquidWoodSingles"] = [
  {
    "heading": "",
    "subheading": "",
    "img_ratio": "1:1",
    "row_height": 0,
    "fit_row": false,
    "collapsed": false,
    "show_more_text": "Show more",
    "show_less_text": "Show less",
    "row_toggle_border_style": "solid",
    "accordion": true,
    "accordion_marker": true,
    "accordion_title": "<h1>Liquid Wood Primers</h1>",
    "accordion_subheading": "",
    "accordion_hide_title_when_open": false,
    "accordion_hide_subheading_when_open": false,
    "accordion_title_center": true,
    "accordion_start_open": true,
    "accordion_allow_multiple": true,
    "accordion_bg_color": "#ffffff",
    "accordion_shadow_pct": 8,
    "accordion_shadow_style": "raised",
    "accordion_width_mobile_percent": 100,
    "accordion_width_desktop_percent": 100,
    "accordion_max_width_px": 0,
    "accordion_group": "accordion_3yNwTf",
    "accordion_always_open": true,
    "videos": []
  },
  {
    "heading": "",
    "subheading": "<p>Real Wood in Every Brushstroke</p>",
    "img_ratio": "9:16",
    "row_height": 0,
    "fit_row": true,
    "margin_top": 0,
    "margin_bottom": 0,
    "collapsed": false,
    "show_more_text": "Show more",
    "show_less_text": "Show less",
    "row_toggle_border_style": "solid",
    "swatch_row": false,
    "row_justify": "center",
    "heading_justify": "center",
    "accordion": false,
    "accordion_title": "<h1>Liquid Wood Primers</h1>",
    "accordion_subheading": "",
    "accordion_hide_title_when_open": false,
    "accordion_hide_subheading_when_open": false,
    "accordion_title_center": true,
    "accordion_start_open": true,
    "accordion_allow_multiple": true,
    "accordion_bg_color": "#ffffff",
    "accordion_shadow_pct": 8,
    "accordion_shadow_style": "raised",
    "accordion_width_mobile_percent": 100,
    "accordion_width_desktop_percent": 100,
    "accordion_max_width_px": 0,
    "accordion_group": "accordion_3yNwTf",
    "accordion_always_open": true,
    "videos": [
      {
        "type": "product",
        "title": "Wood'n Primer",
        "alt": "Retique It Liquid Wood Wood'n Primer in Light Wood, 32 fl oz, showing the primer's smooth application on wood surface",
        "thumbnail": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNP32-LITE-3D.png?v=1778773250&width=720",
        "thumb_mode": "default",
        "product_image_number": 0,
        "product_url": "/products/wnp_lite_l",
        "product_id": 7573368144006,
        "lai_review_count_info": {
          "rate1": 1,
          "rate2": 2,
          "rate3": 4,
          "rate4": 3,
          "rate5": 124,
          "total": 134,
          "average": 4.8,
          "product_shopify_id": "7573368144006",
          "product_group_id": 3470
        },
        "show_price": false,
        "show_reviews": true,
        "shop_button_cta_type": "title_top_button_bottom",
        "shop_button_style": "theme_default",
        "price": "$59.99",
        "price_num": 59.99,
        "available": true,
        "scale": 100,
        "vjust": "top",
        "html_desc": "",
        "desc_html": "",
        "margin_top": 0,
        "margin_bottom": 0,
        "open_set_key": "",
        "learn_more_text": "Learn More",
        "cta": {
          "href": null,
          "text": "Shop"
        }
      },
      {
        "type": "video",
        "title": "What's the Difference?",
        "alt": "What's the Difference?",
        "url": "https://vimeo.com/1192295629",
        "start_time": "",
        "thumbnail": "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/431c0c07-da3b-472b-836d-9abb7d6d0ff3.gif?ClientID=sulu&Date=1778780695&Signature=90981047409b367caeb4b9e0be7b15087a79a867",
        "scale": 100,
        "title_wrap": false,
        "ratio_override": "",
        "vjust": "top",
        "html_desc": "",
        "desc_html": null,
        "end_behavior": "loop",
        "cta": {
          "href": null,
          "text": "Shop Now",
          "thumb_text": ""
        }
      },
      {
        "type": "product",
        "title": "Liquid Wood",
        "alt": "Retique It® Liquid Wood interior paint in 32oz Light finish, showing a smooth application on a wooden surface.",
        "thumbnail": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/LW32-LITE-1_eb1da2e4-02f9-4be5-9779-9ef9382124bb.png?v=1774459466&width=720",
        "thumb_mode": "default",
        "product_image_number": 0,
        "product_url": "/products/lw_lite_l",
        "product_id": 7572124762246,
        "lai_review_count_info": {
          "rate1": 5,
          "rate2": 1,
          "rate3": 9,
          "rate4": 11,
          "rate5": 202,
          "total": 228,
          "average": 4.8,
          "product_shopify_id": "7572124762246",
          "product_group_id": 311
        },
        "show_price": false,
        "show_reviews": true,
        "shop_button_cta_type": "title_top_button_bottom",
        "shop_button_style": "theme_default",
        "price": "$39.99",
        "price_num": 39.99,
        "available": true,
        "scale": 100,
        "vjust": "top",
        "html_desc": "",
        "desc_html": "",
        "margin_top": 0,
        "margin_bottom": 0,
        "open_set_key": "",
        "learn_more_text": "Learn More",
        "cta": {
          "href": null,
          "text": "Shop"
        }
      }
    ]
  },
  {
    "heading": "",
    "subheading": "",
    "img_ratio": "1:1",
    "row_height": 0,
    "fit_row": false,
    "collapsed": false,
    "show_more_text": "Show more",
    "show_less_text": "Show less",
    "row_toggle_border_style": "solid",
    "accordion": true,
    "accordion_marker": true,
    "accordion_title": "<h1>Wood Stains</h1>",
    "accordion_subheading": "",
    "accordion_hide_title_when_open": false,
    "accordion_hide_subheading_when_open": false,
    "accordion_title_center": true,
    "accordion_start_open": true,
    "accordion_allow_multiple": true,
    "accordion_bg_color": "#ffffff",
    "accordion_shadow_pct": 8,
    "accordion_shadow_style": "raised",
    "accordion_width_mobile_percent": 100,
    "accordion_width_desktop_percent": 100,
    "accordion_max_width_px": 0,
    "accordion_group": "accordion_w6Qfgn",
    "accordion_always_open": true,
    "videos": []
  },
  {
    "heading": "",
    "subheading": "",
    "img_ratio": "9:16",
    "row_height": 0,
    "fit_row": true,
    "margin_top": 0,
    "margin_bottom": 0,
    "collapsed": false,
    "show_more_text": "Show more",
    "show_less_text": "Show less",
    "row_toggle_border_style": "solid",
    "swatch_row": false,
    "row_justify": "center",
    "heading_justify": "center",
    "accordion": false,
    "accordion_title": "<h1>Wood Stains</h1>",
    "accordion_subheading": "",
    "accordion_hide_title_when_open": false,
    "accordion_hide_subheading_when_open": false,
    "accordion_title_center": true,
    "accordion_start_open": true,
    "accordion_allow_multiple": true,
    "accordion_bg_color": "#ffffff",
    "accordion_shadow_pct": 8,
    "accordion_shadow_style": "raised",
    "accordion_width_mobile_percent": 100,
    "accordion_width_desktop_percent": 100,
    "accordion_max_width_px": 0,
    "accordion_group": "accordion_w6Qfgn",
    "accordion_always_open": true,
    "videos": [
      {
        "type": "product",
        "title": "Wood'n Stain",
        "alt": "Liquid Wood Wood'n Stain by Retique It in barn wood color, 32 oz bottle, showcasing the stain's rich, natural wood finish.",
        "thumbnail": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/BARN-WNS32-1.png?v=1775160118&width=720",
        "thumb_mode": "default",
        "product_image_number": 1,
        "product_url": "/products/wns-barn-l",
        "product_id": 7577011421318,
        "lai_review_count_info": {
          "rate1": 3,
          "rate2": 2,
          "rate3": 2,
          "rate4": 6,
          "rate5": 123,
          "total": 136,
          "average": 4.8,
          "product_shopify_id": "7577011421318",
          "product_group_id": 845
        },
        "show_price": false,
        "show_reviews": true,
        "shop_button_cta_type": "title_top_button_bottom",
        "shop_button_style": "theme_default",
        "price": "$59.99",
        "price_num": 59.99,
        "available": true,
        "scale": 100,
        "vjust": "top",
        "html_desc": "",
        "desc_html": "",
        "margin_top": 0,
        "margin_bottom": 0,
        "open_set_key": "",
        "learn_more_text": "Learn More",
        "cta": {
          "href": null,
          "text": "Shop"
        }
      },
      {
        "type": "video",
        "title": "What's the difference?",
        "alt": "What's the difference?",
        "url": "https://vimeo.com/929600695?fl=pl&fe=sh",
        "start_time": "",
        "thumbnail": "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/be607482-0fb0-4bb9-8b38-0381da55d004.gif?ClientID=sulu&Date=1776864350&Signature=dded68b0fe6a1a0df3615bf933ef0133532b0169",
        "scale": 100,
        "title_wrap": true,
        "ratio_override": "",
        "vjust": "top",
        "html_desc": "",
        "desc_html": null,
        "end_behavior": "next",
        "cta": {
          "href": null,
          "text": "Shop Now",
          "thumb_text": ""
        }
      },
      {
        "type": "product",
        "title": "Gel Stain Alternative",
        "alt": "Retique It® Black Walnut gel stain applied to wood surface, showcasing deep brown color and smooth finish for furniture or craf",
        "thumbnail": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/image-2_d6f24b4c-f8e2-452e-abb0-728d1bead61e.png?v=1778773114&width=720",
        "thumb_mode": "default",
        "product_image_number": 11,
        "product_url": "/products/gel-stain-black-walnut",
        "product_id": 6546237456518,
        "lai_review_count_info": {
          "rate1": 2,
          "rate2": 3,
          "rate3": 3,
          "rate4": 5,
          "rate5": 99,
          "total": 112,
          "average": 4.8,
          "product_shopify_id": "6546237456518",
          "product_group_id": 317
        },
        "show_price": false,
        "show_reviews": true,
        "shop_button_cta_type": "title_top_button_bottom",
        "shop_button_style": "theme_default",
        "price": "$22.99",
        "price_num": 22.99,
        "available": true,
        "scale": 100,
        "vjust": "top",
        "html_desc": "",
        "desc_html": "",
        "margin_top": 0,
        "margin_bottom": 0,
        "open_set_key": "",
        "learn_more_text": "Learn More",
        "cta": {
          "href": null,
          "text": "Shop"
        }
      }
    ]
  }
];
window.MEDIA_GALLERY_SETS["RQ-WNP-Bullets"] = [
  {
    "heading": "",
    "subheading": "",
    "img_ratio": "1:1",
    "row_height": 0,
    "fit_row": false,
    "collapsed": false,
    "show_more_text": "Show more",
    "show_less_text": "Show less",
    "row_toggle_border_style": "solid",
    "accordion": false,
    "accordion_marker": false,
    "bullet_points_heading": true,
    "bullet_heading": "<h1>Real Liquid Wood</h1>",
    "bullet_subheading": "",
    "bullet_width_desktop_percent": 100,
    "bullet_width_mobile_percent": 90,
    "bullet_max_width_px": 0,
    "videos": []
  },
  {
    "heading": "",
    "subheading": "",
    "img_ratio": "1:1",
    "row_height": 0,
    "fit_row": false,
    "collapsed": false,
    "show_more_text": "Show more",
    "show_less_text": "Show less",
    "row_toggle_border_style": "solid",
    "accordion": false,
    "accordion_marker": false,
    "bullet_point": true,
    "bullet_marker": true,
    "bullet_group": "bullet-points-template--18637804470406__cmg_bullet_points_4KCpA4",
    "bullet_more_enabled": true,
    "bullet_more_text": "Video",
    "bullet_popup": true,
    "bullet_preset_set": "Expand-AthenticWoodFinish",
    "bullet_padding_top": 2,
    "bullet_padding_bottom": 2,
    "bullet_width_desktop_percent": 100,
    "bullet_width_mobile_percent": 90,
    "bullet_max_width_px": 0,
    "accordion_start_open": false,
    "bullet_text": "<p><strong>Authentic Wood Finish</strong> with over 60% real wood.</p>",
    "bullet_content": "",
    "videos": []
  },
  {
    "heading": "",
    "subheading": "",
    "img_ratio": "1:1",
    "row_height": 0,
    "fit_row": false,
    "collapsed": false,
    "show_more_text": "Show more",
    "show_less_text": "Show less",
    "row_toggle_border_style": "solid",
    "accordion": false,
    "accordion_marker": false,
    "bullet_point": true,
    "bullet_marker": true,
    "bullet_group": "bullet-points-template--18637804470406__cmg_bullet_points_4KCpA4",
    "bullet_more_enabled": true,
    "bullet_more_text": "Video",
    "bullet_popup": true,
    "bullet_preset_set": "Expand-FeelsLikeWood",
    "bullet_padding_top": 2,
    "bullet_padding_bottom": 2,
    "bullet_width_desktop_percent": 100,
    "bullet_width_mobile_percent": 90,
    "bullet_max_width_px": 0,
    "accordion_start_open": false,
    "bullet_text": "<p><strong>Looks & Feels Like Wood</strong> even up close.</p>",
    "bullet_content": "",
    "videos": []
  },
  {
    "heading": "",
    "subheading": "",
    "img_ratio": "1:1",
    "row_height": 0,
    "fit_row": false,
    "collapsed": false,
    "show_more_text": "Show more",
    "show_less_text": "Show less",
    "row_toggle_border_style": "solid",
    "accordion": false,
    "accordion_marker": false,
    "bullet_point": true,
    "bullet_marker": true,
    "bullet_group": "bullet-points-template--18637804470406__cmg_bullet_points_4KCpA4",
    "bullet_more_enabled": true,
    "bullet_more_text": "more",
    "bullet_popup": false,
    "bullet_preset_set": "",
    "bullet_padding_top": 2,
    "bullet_padding_bottom": 2,
    "bullet_width_desktop_percent": 100,
    "bullet_width_mobile_percent": 90,
    "bullet_max_width_px": 0,
    "accordion_start_open": false,
    "bullet_text": "<p><strong>Interior / Exterior</strong> - From furniture to decking</p>",
    "bullet_content": "<p>Wood'n Primer was developed to be durable enough for decking but since it is water-based and low odor it works great on any project, inside or out!</p>",
    "videos": []
  },
  {
    "heading": "",
    "subheading": "",
    "img_ratio": "1:1",
    "row_height": 0,
    "fit_row": false,
    "collapsed": false,
    "show_more_text": "Show more",
    "show_less_text": "Show less",
    "row_toggle_border_style": "solid",
    "accordion": false,
    "accordion_marker": false,
    "bullet_point": true,
    "bullet_marker": true,
    "bullet_group": "bullet-points-template--18637804470406__cmg_bullet_points_4KCpA4",
    "bullet_more_enabled": true,
    "bullet_more_text": "Video",
    "bullet_popup": true,
    "bullet_preset_set": "Expand-NoSandingOrStripping",
    "bullet_padding_top": 2,
    "bullet_padding_bottom": 2,
    "bullet_width_desktop_percent": 100,
    "bullet_width_mobile_percent": 90,
    "bullet_max_width_px": 0,
    "accordion_start_open": false,
    "bullet_text": "<p><strong>No sanding or stripping</strong> off the old finish.</p>",
    "bullet_content": "",
    "videos": []
  },
  {
    "heading": "",
    "subheading": "",
    "img_ratio": "1:1",
    "row_height": 0,
    "fit_row": false,
    "collapsed": false,
    "show_more_text": "Show more",
    "show_less_text": "Show less",
    "row_toggle_border_style": "solid",
    "accordion": false,
    "accordion_marker": false,
    "bullet_point": true,
    "bullet_marker": true,
    "bullet_group": "bullet-points-template--18637804470406__cmg_bullet_points_4KCpA4",
    "bullet_more_enabled": false,
    "bullet_more_text": "",
    "bullet_popup": false,
    "bullet_preset_set": "",
    "bullet_padding_top": 2,
    "bullet_padding_bottom": 2,
    "bullet_width_desktop_percent": 100,
    "bullet_width_mobile_percent": 90,
    "bullet_max_width_px": 0,
    "accordion_start_open": false,
    "bullet_text": "<p><strong>Eco-Friendly & Safe</strong> - Water-based, low VOC, low odor.</p>",
    "bullet_content": "",
    "videos": []
  },
  {
    "heading": "",
    "subheading": "",
    "img_ratio": "1:1",
    "row_height": 0,
    "fit_row": false,
    "collapsed": false,
    "show_more_text": "Show more",
    "show_less_text": "Show less",
    "row_toggle_border_style": "solid",
    "accordion": false,
    "accordion_marker": false,
    "bullet_point": true,
    "bullet_marker": true,
    "bullet_group": "bullet-points-template--18637804470406__cmg_bullet_points_4KCpA4",
    "bullet_more_enabled": true,
    "bullet_more_text": "Videos",
    "bullet_popup": true,
    "bullet_preset_set": "Highlighted",
    "bullet_padding_top": 2,
    "bullet_padding_bottom": 2,
    "bullet_width_desktop_percent": 100,
    "bullet_width_mobile_percent": 90,
    "bullet_max_width_px": 0,
    "accordion_start_open": false,
    "bullet_text": "<p><strong>Any Hard Surface</strong> - Transform furniture, cabinets, floors, doors, window frames, mantels, wainscoting, drywall, and painted surfaces with a beautiful wood finish.</p>",
    "bullet_content": "",
    "videos": []
  },
  {
    "heading": "",
    "subheading": "",
    "img_ratio": "1:1",
    "row_height": 0,
    "fit_row": false,
    "collapsed": false,
    "show_more_text": "Show more",
    "show_less_text": "Show less",
    "row_toggle_border_style": "solid",
    "accordion": false,
    "accordion_marker": false,
    "bullet_point": true,
    "bullet_marker": true,
    "bullet_group": "bullet-points-template--18637804470406__cmg_bullet_points_4KCpA4",
    "bullet_more_enabled": true,
    "bullet_more_text": "Video",
    "bullet_popup": true,
    "bullet_preset_set": "Expand-WoodFiller",
    "bullet_padding_top": 2,
    "bullet_padding_bottom": 2,
    "bullet_width_desktop_percent": 100,
    "bullet_width_mobile_percent": 90,
    "bullet_max_width_px": 0,
    "accordion_start_open": false,
    "bullet_text": "<p><strong>Wood Filler</strong> - Get a real wood finish over wood filler.</p>",
    "bullet_content": "",
    "videos": []
  }
];
window.MEDIA_GALLERY_SETS["RQ-LW-Bullets"] = [
  {
    "heading": "",
    "subheading": "",
    "img_ratio": "1:1",
    "row_height": 0,
    "fit_row": false,
    "collapsed": false,
    "show_more_text": "Show more",
    "show_less_text": "Show less",
    "row_toggle_border_style": "solid",
    "accordion": false,
    "accordion_marker": false,
    "bullet_points_heading": true,
    "bullet_heading": "<h1>Real Liquid Wood</h1>",
    "bullet_subheading": "",
    "bullet_width_desktop_percent": 100,
    "bullet_width_mobile_percent": 90,
    "bullet_max_width_px": 0,
    "videos": []
  },
  {
    "heading": "",
    "subheading": "",
    "img_ratio": "1:1",
    "row_height": 0,
    "fit_row": false,
    "collapsed": false,
    "show_more_text": "Show more",
    "show_less_text": "Show less",
    "row_toggle_border_style": "solid",
    "accordion": false,
    "accordion_marker": false,
    "bullet_point": true,
    "bullet_marker": true,
    "bullet_group": "bullet-points-template--18637804470406__cmg_bullet_points_qFpxbY",
    "bullet_more_enabled": true,
    "bullet_more_text": "Video",
    "bullet_popup": true,
    "bullet_preset_set": "Expand-AthenticWoodFinish",
    "bullet_padding_top": 2,
    "bullet_padding_bottom": 2,
    "bullet_width_desktop_percent": 100,
    "bullet_width_mobile_percent": 90,
    "bullet_max_width_px": 0,
    "accordion_start_open": false,
    "bullet_text": "<p><strong>Authentic Wood Finish</strong> with over 60% real wood.</p>",
    "bullet_content": "",
    "videos": []
  },
  {
    "heading": "",
    "subheading": "",
    "img_ratio": "1:1",
    "row_height": 0,
    "fit_row": false,
    "collapsed": false,
    "show_more_text": "Show more",
    "show_less_text": "Show less",
    "row_toggle_border_style": "solid",
    "accordion": false,
    "accordion_marker": false,
    "bullet_point": true,
    "bullet_marker": true,
    "bullet_group": "bullet-points-template--18637804470406__cmg_bullet_points_qFpxbY",
    "bullet_more_enabled": true,
    "bullet_more_text": "Video",
    "bullet_popup": true,
    "bullet_preset_set": "Expand-FeelsLikeWood",
    "bullet_padding_top": 2,
    "bullet_padding_bottom": 2,
    "bullet_width_desktop_percent": 100,
    "bullet_width_mobile_percent": 90,
    "bullet_max_width_px": 0,
    "accordion_start_open": false,
    "bullet_text": "<p><strong>Looks & Feels Like Wood</strong> even up close.</p>",
    "bullet_content": "",
    "videos": []
  },
  {
    "heading": "",
    "subheading": "",
    "img_ratio": "1:1",
    "row_height": 0,
    "fit_row": false,
    "collapsed": false,
    "show_more_text": "Show more",
    "show_less_text": "Show less",
    "row_toggle_border_style": "solid",
    "accordion": false,
    "accordion_marker": false,
    "bullet_point": true,
    "bullet_marker": true,
    "bullet_group": "bullet-points-template--18637804470406__cmg_bullet_points_qFpxbY",
    "bullet_more_enabled": true,
    "bullet_more_text": "Video",
    "bullet_popup": true,
    "bullet_preset_set": "Expand-NoSandingOrStripping",
    "bullet_padding_top": 2,
    "bullet_padding_bottom": 2,
    "bullet_width_desktop_percent": 100,
    "bullet_width_mobile_percent": 90,
    "bullet_max_width_px": 0,
    "accordion_start_open": false,
    "bullet_text": "<p><strong>No sanding or stripping</strong> off the old finish.</p>",
    "bullet_content": "",
    "videos": []
  },
  {
    "heading": "",
    "subheading": "",
    "img_ratio": "1:1",
    "row_height": 0,
    "fit_row": false,
    "collapsed": false,
    "show_more_text": "Show more",
    "show_less_text": "Show less",
    "row_toggle_border_style": "solid",
    "accordion": false,
    "accordion_marker": false,
    "bullet_point": true,
    "bullet_marker": true,
    "bullet_group": "bullet-points-template--18637804470406__cmg_bullet_points_qFpxbY",
    "bullet_more_enabled": false,
    "bullet_more_text": "",
    "bullet_popup": false,
    "bullet_preset_set": "",
    "bullet_padding_top": 2,
    "bullet_padding_bottom": 2,
    "bullet_width_desktop_percent": 100,
    "bullet_width_mobile_percent": 90,
    "bullet_max_width_px": 0,
    "accordion_start_open": false,
    "bullet_text": "<p><strong>Eco-Friendly & Safe</strong> - Water-based, low VOC, low odor.</p>",
    "bullet_content": "",
    "videos": []
  },
  {
    "heading": "",
    "subheading": "",
    "img_ratio": "1:1",
    "row_height": 0,
    "fit_row": false,
    "collapsed": false,
    "show_more_text": "Show more",
    "show_less_text": "Show less",
    "row_toggle_border_style": "solid",
    "accordion": false,
    "accordion_marker": false,
    "bullet_point": true,
    "bullet_marker": true,
    "bullet_group": "bullet-points-template--18637804470406__cmg_bullet_points_qFpxbY",
    "bullet_more_enabled": true,
    "bullet_more_text": "Videos",
    "bullet_popup": true,
    "bullet_preset_set": "Highlighted",
    "bullet_padding_top": 2,
    "bullet_padding_bottom": 2,
    "bullet_width_desktop_percent": 100,
    "bullet_width_mobile_percent": 90,
    "bullet_max_width_px": 0,
    "accordion_start_open": false,
    "bullet_text": "<p><strong>Any Hard Surface</strong> - Transform furniture, cabinets, and more.</p>",
    "bullet_content": "",
    "videos": []
  },
  {
    "heading": "",
    "subheading": "",
    "img_ratio": "1:1",
    "row_height": 0,
    "fit_row": false,
    "collapsed": false,
    "show_more_text": "Show more",
    "show_less_text": "Show less",
    "row_toggle_border_style": "solid",
    "accordion": false,
    "accordion_marker": false,
    "bullet_point": true,
    "bullet_marker": true,
    "bullet_group": "bullet-points-template--18637804470406__cmg_bullet_points_qFpxbY",
    "bullet_more_enabled": true,
    "bullet_more_text": "Video",
    "bullet_popup": true,
    "bullet_preset_set": "Expand-WoodFiller",
    "bullet_padding_top": 2,
    "bullet_padding_bottom": 2,
    "bullet_width_desktop_percent": 100,
    "bullet_width_mobile_percent": 90,
    "bullet_max_width_px": 0,
    "accordion_start_open": false,
    "bullet_text": "<p><strong>Wood Filler</strong> - Get a real wood finish over wood filler.</p>",
    "bullet_content": "",
    "videos": []
  }
];
window.MEDIA_GALLERY_SETS["Expand-FeelsLikeWood"] = [
  {
    "heading": "",
    "subheading": "",
    "img_ratio": "1:1",
    "row_height": 0,
    "fit_row": false,
    "margin_top": 0,
    "margin_bottom": 0,
    "collapsed": false,
    "show_more_text": "Show more",
    "show_less_text": "Show less",
    "row_toggle_border_style": "solid",
    "swatch_row": false,
    "row_justify": "center",
    "heading_justify": "center",
    "accordion": false,
    "accordion_title": "",
    "accordion_subheading": "",
    "accordion_content": "",
    "accordion_hide_title_when_open": false,
    "accordion_hide_subheading_when_open": false,
    "accordion_hide_subheading_when_closed": false,
    "accordion_title_center": false,
    "accordion_start_open": false,
    "accordion_allow_multiple": false,
    "accordion_bg_color": "#ffffff",
    "accordion_shadow_pct": 8,
    "accordion_shadow_style": "raised",
    "accordion_width_mobile_percent": 100,
    "accordion_width_desktop_percent": 100,
    "accordion_max_width_px": 0,
    "accordion_panel_width_override_percent": 0,
    "accordion_panel_max_width_override_px": 0,
    "accordion_group": "",
    "accordion_always_open": false,
    "__import_set": "",
    "__import_mode": "flatten",
    "videos": [
      {
        "type": "video",
        "title": "",
        "alt": "",
        "url": "https://vimeo.com/935133272",
        "start_time": "",
        "autoplay_with_sound": true,
        "thumbnail": "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/49e3e636-2563-4813-a2e2-9b245786cd5d.gif?ClientID=sulu&Date=1779287774&Signature=c7d2bbe8b43d575dbd83a8ba22de8ab36916abb5",
        "scale": 100,
        "title_wrap": false,
        "ratio_override": "4:5",
        "vjust": "top",
        "html_desc": "",
        "desc_html": null,
        "end_behavior": "next",
        "cta": {
          "href": null,
          "text": "Shop Now",
          "thumb_text": ""
        }
      }
    ]
  }
];

window.MEDIA_GALLERY_SETS["Expand-NoSandingOrStripping"] = [
  {
    "heading": "",
    "subheading": "",
    "img_ratio": "1:1",
    "row_height": 0,
    "fit_row": false,
    "margin_top": 0,
    "margin_bottom": 0,
    "collapsed": false,
    "show_more_text": "Show more",
    "show_less_text": "Show less",
    "row_toggle_border_style": "solid",
    "swatch_row": false,
    "row_justify": "center",
    "heading_justify": "center",
    "accordion": false,
    "accordion_title": "",
    "accordion_subheading": "",
    "accordion_content": "",
    "accordion_hide_title_when_open": false,
    "accordion_hide_subheading_when_open": false,
    "accordion_hide_subheading_when_closed": false,
    "accordion_title_center": false,
    "accordion_start_open": false,
    "accordion_allow_multiple": false,
    "accordion_bg_color": "#ffffff",
    "accordion_shadow_pct": 8,
    "accordion_shadow_style": "raised",
    "accordion_width_mobile_percent": 100,
    "accordion_width_desktop_percent": 100,
    "accordion_max_width_px": 0,
    "accordion_panel_width_override_percent": 0,
    "accordion_panel_max_width_override_px": 0,
    "accordion_group": "",
    "accordion_always_open": false,
    "__import_set": "",
    "__import_mode": "flatten",
    "videos": [
      {
        "type": "video",
        "title": "No need to sand or strip off the old finish",
        "alt": "No need to sand or strip off the old finish",
        "url": "https://vimeo.com/1010174265?fl=pl&fe=sh",
        "start_time": "",
        "autoplay_with_sound": true,
        "thumbnail": "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/87e93e33-da79-4654-96a8-be6563a6f1db.gif?ClientID=sulu&Date=1779288880&Signature=b3605a301825a1a300ee23eea7a69fd67058fd85",
        "scale": 100,
        "title_wrap": false,
        "ratio_override": "4:5",
        "vjust": "top",
        "html_desc": "",
        "desc_html": null,
        "end_behavior": "loop",
        "cta": {
          "href": null,
          "text": "Shop Now",
          "thumb_text": ""
        }
      }
    ]
  }
];

window.MEDIA_GALLERY_SETS["Expand-AthenticWoodFinish"] = [
  {
    "heading": "",
    "subheading": "",
    "img_ratio": "1:1",
    "row_height": 0,
    "fit_row": false,
    "margin_top": 0,
    "margin_bottom": 0,
    "collapsed": false,
    "show_more_text": "Show more",
    "show_less_text": "Show less",
    "row_toggle_border_style": "solid",
    "swatch_row": false,
    "row_justify": "center",
    "heading_justify": "center",
    "accordion": false,
    "accordion_title": "",
    "accordion_subheading": "",
    "accordion_content": "",
    "accordion_hide_title_when_open": false,
    "accordion_hide_subheading_when_open": false,
    "accordion_hide_subheading_when_closed": false,
    "accordion_title_center": false,
    "accordion_start_open": false,
    "accordion_allow_multiple": false,
    "accordion_bg_color": "#ffffff",
    "accordion_shadow_pct": 8,
    "accordion_shadow_style": "raised",
    "accordion_width_mobile_percent": 100,
    "accordion_width_desktop_percent": 100,
    "accordion_max_width_px": 0,
    "accordion_panel_width_override_percent": 0,
    "accordion_panel_max_width_override_px": 0,
    "accordion_group": "",
    "accordion_always_open": false,
    "__import_set": "",
    "__import_mode": "flatten",
    "videos": [
      {
        "type": "video",
        "title": "",
        "alt": "",
        "url": "https://vimeo.com/1194099987",
        "desktop_video_url": "https://vimeo.com/1194337605",
        "start_time": "",
        "autoplay_with_sound": true,
        "thumbnail": "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/48f6fac5-6389-49de-ab29-d2dcfff95b05.gif?ClientID=sulu&Date=1779362305&Signature=9bdaef6f879033b66fa93f340d5b96a935f0b93f",
        "scale": 100,
        "title_wrap": false,
        "ratio_override": "1:1",
        "vjust": "top",
        "html_desc": "",
        "desc_html": null,
        "end_behavior": "next",
        "cta": {
          "href": null,
          "text": "Shop Now",
          "thumb_text": ""
        }
      }
    ]
  }
];


window.MEDIA_GALLERY_SETS["Expand-WoodFiller"] = [
  {
    "heading": "",
    "subheading": "",
    "img_ratio": "1:1",
    "row_height": 0,
    "fit_row": false,
    "margin_top": 0,
    "margin_bottom": 0,
    "collapsed": false,
    "show_more_text": "Show more",
    "show_less_text": "Show less",
    "row_toggle_border_style": "solid",
    "swatch_row": false,
    "row_justify": "center",
    "heading_justify": "center",
    "accordion": false,
    "accordion_title": "",
    "accordion_subheading": "",
    "accordion_content": "",
    "accordion_hide_title_when_open": false,
    "accordion_hide_subheading_when_open": false,
    "accordion_hide_subheading_when_closed": false,
    "accordion_title_center": false,
    "accordion_start_open": false,
    "accordion_allow_multiple": false,
    "accordion_bg_color": "#ffffff",
    "accordion_shadow_pct": 8,
    "accordion_shadow_style": "raised",
    "accordion_width_mobile_percent": 100,
    "accordion_width_desktop_percent": 100,
    "accordion_max_width_px": 0,
    "accordion_panel_width_override_percent": 0,
    "accordion_panel_max_width_override_px": 0,
    "accordion_group": "",
    "accordion_always_open": false,
    "__import_set": "",
    "__import_mode": "flatten",
    "videos": [
      {
        "type": "video",
        "title": "",
        "alt": "",
        "url": "https://vimeo.com/1167692291",
        "start_time": "",
        "autoplay_with_sound": true,
        "thumbnail": "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/e9d14ad3-100b-4df1-9f4f-cef8c87af38f.gif?ClientID=sulu&Date=1779290135&Signature=6e9542dd5d3b9d64226cf11ac68d90d994322c2f",
        "scale": 100,
        "title_wrap": false,
        "ratio_override": "",
        "vjust": "top",
        "html_desc": "",
        "desc_html": null,
        "end_behavior": "next",
        "cta": {
          "href": null,
          "text": "Shop Now",
          "thumb_text": ""
        }
      }
    ]
  }
];

window.MEDIA_GALLERY_SETS["Expand-AnyHardSurface"] = [
  {
    "heading": "",
    "subheading": "",
    "img_ratio": "4:5",
    "row_height": 0,
    "fit_row": false,
    "margin_top": 0,
    "margin_bottom": 0,
    "collapsed": false,
    "show_more_text": "Show more",
    "show_less_text": "Show less",
    "row_toggle_border_style": "solid",
    "accordion": false,
    "accordion_title": "",
    "accordion_subheading": "",
    "accordion_content": "",
    "accordion_hide_title_when_open": false,
    "accordion_hide_subheading_when_open": false,
    "accordion_hide_subheading_when_closed": false,
    "accordion_title_center": false,
    "accordion_start_open": false,
    "accordion_allow_multiple": false,
    "accordion_bg_color": "#ffffff",
    "accordion_shadow_pct": 8,
    "accordion_shadow_style": "raised",
    "accordion_width_mobile_percent": 100,
    "accordion_width_desktop_percent": 100,
    "accordion_max_width_px": 0,
    "accordion_panel_width_override_percent": 0,
    "accordion_panel_max_width_override_px": 0,
    "accordion_group": "",
    "accordion_always_open": false,
    "__import_set": "",
    "__import_mode": "flatten",
    "videos": []
  },
  {
    "__import_set": "Highlighted",
    "__import_mode": "preserve",
    "__import_passthrough": true,
    "hide_cta_buttons": false,
    "end_behavior_override": "next",
    "margin_top": 0,
    "margin_bottom": 0,
    "heading_justify": "center",
    "collapsed": false,
    "show_more_text": "Show more",
    "show_less_text": "Show less",
    "row_toggle_border_style": "solid",
    "accordion": false,
    "accordion_marker": false,
    "accordion_title": "",
    "accordion_subheading": "",
    "accordion_content": "",
    "accordion_hide_title_when_open": false,
    "accordion_hide_subheading_when_open": false,
    "accordion_hide_subheading_when_closed": false,
    "accordion_title_center": false,
    "accordion_start_open": false,
    "accordion_allow_multiple": false,
    "accordion_bg_color": "#ffffff",
    "accordion_shadow_pct": 8,
    "accordion_shadow_style": "raised",
    "accordion_width_mobile_percent": 100,
    "accordion_width_desktop_percent": 100,
    "accordion_max_width_px": 0,
    "accordion_panel_width_override_percent": 0,
    "accordion_panel_max_width_override_px": 0,
    "accordion_group": "",
    "accordion_always_open": false,
    "videos": []
  }
];

// ✅ OPTIONAL: paste these ONCE after adding/updating one or more sets (helps previews refresh):
document.dispatchEvent(new CustomEvent("media_gallery_sets_ready"));
document.dispatchEvent(new CustomEvent("vimeo_sets_ready"));



// 2 oz Wood'n Primer sample color selector.
window.MEDIA_GALLERY_SETS["Colors-WNP02"] = {
  "meta": {
    "appearance": {
      "border_color": "#767676",
      "border_size": 1,
      "shadow_size": 0,
      "border_scope": "image_text",
      "border_radius_px": 4,
      "image_radius_px": 4,
      "product_image_padding": 2,
      "text_size_mobile": 20,
      "text_size_desktop": 26,
      "text_behavior": "truncate_text",
      "text_style": "normal"
    },
    "selected_appearance": {
      "border_color": "#12316f",
      "border_size": 3,
      "shadow_size": 0,
      "border_scope": "image_text",
      "border_radius_px": 4,
      "image_radius_px": 4,
      "product_image_padding": 0,
      "text_size_mobile": 20,
      "text_size_desktop": 26,
      "text_behavior": "truncate_text",
      "text_style": "normal"
    },
    "corner_radius_px": 4
  },
  "rows": [
    {
      "heading": "",
      "subheading": "",
      "heading_justify": "center",
      "img_ratio": "1:1",
      "row_height": 0,
      "row_height_mobile": 0,
      "row_height_desktop": 0,
      "fit_row": true,
      "row_display_type_mobile": "scale_to_fit",
      "row_display_type_desktop": "scale_to_fit",
      "row_display_type": "scale_to_fit",
      "more_popup_text": "More",
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": true,
      "row_justify": "left",
      "custom_html": "",
      "custom_template_id": "",
      "custom_width_desktop_percent": 100,
      "custom_width_mobile_percent": 100,
      "custom_max_width_px": 0,
      "preset_button": false,
      "preset_button_text": "",
      "preset_modal_title": "",
      "preset_hide_modal_header": false,
      "preset_button_set": "",
      "preset_button_style": "dropdown_box",
      "preset_button_subtext": "",
      "preset_button_image": "",
      "preset_button_image_alt": "",
      "preset_button_width_percent": 0,
      "preset_button_max_width_px": 0,
      "collapsed": false,
      "show_more_text": "Show more",
      "show_less_text": "Show less",
      "row_toggle_border_style": "solid",
      "hide_cta_buttons": false,
      "end_behavior_override": "",
      "videos": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Light",
          "alt": "Light Wood color swatch",
          "thumbnail": "//retique.com/cdn/shop/files/InFrontOfSwatch_79c77b88-c4b7-46f5-a14f-7f72c13cc8af_1000x.png?v=1791580575",
          "thumb_mode": "default",
          "product_image_url": "//retique.com/cdn/shop/files/InFrontOfSwatch_79c77b88-c4b7-46f5-a14f-7f72c13cc8af_1000x.png?v=1791580575",
          "product_url": "/products/wnp_lite_xxs",
          "product_id": 15407122710662,
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "available": true,
          "scale": 100,
          "product_image_scale": 100,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/wnp_lite_xxs",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Bleached",
          "alt": "Bleached Wood color swatch",
          "thumbnail": "//retique.com/cdn/shop/files/InFrontOfSwatch_1000x.png?v=1791580432",
          "thumb_mode": "default",
          "product_image_url": "//retique.com/cdn/shop/files/InFrontOfSwatch_1000x.png?v=1791580432",
          "product_url": "/products/wnp_blch_xxs",
          "product_id": 15407128084614,
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "available": true,
          "scale": 100,
          "product_image_scale": 100,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/wnp_blch_xxs",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Dark",
          "alt": "Dark Wood color swatch",
          "thumbnail": "//retique.com/cdn/shop/files/InFrontOfSwatch_3cb78162-1145-40b3-bef4-2e2aa076d80d_1000x.png?v=1791580502",
          "thumb_mode": "default",
          "product_image_url": "//retique.com/cdn/shop/files/InFrontOfSwatch_3cb78162-1145-40b3-bef4-2e2aa076d80d_1000x.png?v=1791580502",
          "product_url": "/products/wnp_dark_xxs",
          "product_id": 15407128019078,
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "available": true,
          "scale": 100,
          "product_image_scale": 100,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/wnp_dark_xxs",
            "text": "Shop"
          }
        }
      ]
    }
  ]
};
window.MG_SWATCH_SETS = window.MG_SWATCH_SETS || Object.assign(Object.create(null), window.MEDIA_GALLERY_SETS);
window.MG_SWATCH_SETS["Colors-WNP02"] = window.MEDIA_GALLERY_SETS["Colors-WNP02"];
document.dispatchEvent(new CustomEvent("media_gallery_sets_ready"));
